var Fi = Object.create;
var rn = Object.defineProperty;
var Ii = Object.getOwnPropertyDescriptor;
var pa = (e, r) => (r = Symbol[e]) ? r : Symbol.for("Symbol." + e), Xr = (e) => {
  throw TypeError(e);
};
var fa = (e, r, t) => r in e ? rn(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var ua = (e, r) => rn(e, "name", { value: r, configurable: !0 });
var ma = (e) => [, , , Fi((e == null ? void 0 : e[pa("metadata")]) ?? null)], ha = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], Gr = (e) => e !== void 0 && typeof e != "function" ? Xr("Function expected") : e, Ti = (e, r, t, n, a) => ({ kind: ha[e], name: r, metadata: n, addInitializer: (o) => t._ ? Xr("Already initialized") : a.push(Gr(o || null)) }), tn = (e, r) => fa(r, pa("metadata"), e[3]), ga = (e, r, t, n) => {
  for (var a = 0, o = e[r >> 1], i = o && o.length; a < i; a++) r & 1 ? o[a].call(t) : n = o[a].call(t, n);
  return n;
}, ya = (e, r, t, n, a, o) => {
  var i, s, l, c, d, u = r & 7, p = !!(r & 8), _ = !!(r & 16), m = u > 3 ? e.length + 1 : u ? p ? 1 : 2 : 0, h = ha[u + 5], b = u > 3 && (e[m - 1] = []), y = e[m] || (e[m] = []), g = u && (!_ && !p && (a = a.prototype), u < 5 && (u > 3 || !_) && Ii(u < 4 ? a : { get [t]() {
    return da(this, o);
  }, set [t](w) {
    return _a(this, o, w);
  } }, t));
  u ? _ && u < 4 && ua(o, (u > 2 ? "set " : u > 1 ? "get " : "") + t) : ua(a, t);
  for (var k = n.length - 1; k >= 0; k--)
    c = Ti(u, t, l = {}, e[3], y), u && (c.static = p, c.private = _, d = c.access = { has: _ ? (w) => Di(a, w) : (w) => t in w }, u ^ 3 && (d.get = _ ? (w) => (u ^ 1 ? da : Ai)(w, a, u ^ 4 ? o : g.get) : (w) => w[t]), u > 2 && (d.set = _ ? (w, x) => _a(w, a, x, u ^ 4 ? o : g.set) : (w, x) => w[t] = x)), s = (0, n[k])(u ? u < 4 ? _ ? o : g[h] : u > 4 ? void 0 : { get: g.get, set: g.set } : a, c), l._ = 1, u ^ 4 || s === void 0 ? Gr(s) && (u > 4 ? b.unshift(s) : u ? _ ? o = s : g[h] = s : a = s) : typeof s != "object" || s === null ? Xr("Object expected") : (Gr(i = s.get) && (g.get = i), Gr(i = s.set) && (g.set = i), Gr(i = s.init) && b.unshift(i));
  return u || tn(e, a), g && rn(a, t, g), _ ? u ^ 4 ? o : g : a;
}, q = (e, r, t) => fa(e, typeof r != "symbol" ? r + "" : r, t), nn = (e, r, t) => r.has(e) || Xr("Cannot " + t), Di = (e, r) => Object(r) !== r ? Xr('Cannot use the "in" operator on this value') : e.has(r), da = (e, r, t) => (nn(e, r, "read from private field"), t ? t.call(e) : r.get(e));
var _a = (e, r, t, n) => (nn(e, r, "write to private field"), n ? n.call(e, t) : r.set(e, t), t), Ai = (e, r, t) => (nn(e, r, "access private method"), t);
const Ci = "5";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Ci);
let zr = !1, Mi = !1;
function ji() {
  zr = !0;
}
ji();
const Mn = 1, jn = 2, eo = 4, Ni = 8, Oi = 16, Ri = 1, Li = 2, zi = 4, Ui = 8, Bi = 16, Vi = 1, Wi = 2, Yi = 4, Hi = 1, Gi = 2, ke = Symbol(), nt = "http://www.w3.org/2000/svg";
function Xi(e) {
  return e.endsWith("capture") && e !== "gotpointercapture" && e !== "lostpointercapture";
}
const Ji = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function Qi(e) {
  return Ji.includes(e);
}
const Zi = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject"
};
function Ki(e) {
  return e = e.toLowerCase(), Zi[e] ?? e;
}
const $i = ["touchstart", "touchmove"];
function es(e) {
  return $i.includes(e);
}
const ba = !1;
var Ut = Array.isArray, rs = Array.prototype.indexOf, Nn = Array.from, ts = Object.defineProperty, lr = Object.getOwnPropertyDescriptor, ro = Object.getOwnPropertyDescriptors, ns = Object.prototype, as = Array.prototype, On = Object.getPrototypeOf;
function Mr(e) {
  return typeof e == "function";
}
const se = () => {
};
function os(e) {
  return e();
}
function fn(e) {
  for (var r = 0; r < e.length; r++)
    e[r]();
}
const Le = 2, to = 4, st = 8, Bt = 16, ze = 32, lt = 64, qt = 128, Fr = 256, Ft = 512, Pe = 1024, dr = 2048, ct = 4096, Be = 8192, Ur = 16384, no = 32768, pr = 65536, is = 1 << 17, ss = 1 << 19, ao = 1 << 20, kr = Symbol("$state"), oo = Symbol("legacy props"), ls = Symbol("");
function io(e) {
  return e === this.v;
}
function so(e, r) {
  return e != e ? r == r : e !== r || e !== null && typeof e == "object" || typeof e == "function";
}
function Rn(e) {
  return !so(e, this.v);
}
function cs(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function us() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function ds(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function _s() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function ps(e) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function fs() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function ms() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function hs() {
  throw new Error("https://svelte.dev/e/state_unsafe_local_read");
}
function gs() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
function Ie(e, r) {
  var t = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: io,
    rv: 0,
    wv: 0
  };
  return t;
}
function ys(e) {
  return /* @__PURE__ */ lo(Ie(e));
}
// @__NO_SIDE_EFFECTS__
function Vt(e, r = !1) {
  var n;
  const t = Ie(e);
  return r || (t.equals = Rn), zr && Q !== null && Q.l !== null && ((n = Q.l).s ?? (n.s = [])).push(t), t;
}
function ie(e, r = !1) {
  return /* @__PURE__ */ lo(/* @__PURE__ */ Vt(e, r));
}
// @__NO_SIDE_EFFECTS__
function lo(e) {
  return $ !== null && $.f & Le && (Ve === null ? qs([e]) : Ve.push(e)), e;
}
function A(e, r) {
  return $ !== null && Ht() && $.f & (Le | Bt) && // If the source was created locally within the current derived, then
  // we allow the mutation.
  (Ve === null || !Ve.includes(e)) && gs(), mn(e, r);
}
function mn(e, r) {
  return e.equals(r) || (e.v, e.v = r, e.wv = So(), co(e, dr), Ht() && B !== null && B.f & Pe && !(B.f & ze) && (ge !== null && ge.includes(e) ? (Ue(B, dr), Gt(B)) : cr === null ? Fs([e]) : cr.push(e))), r;
}
function co(e, r) {
  var t = e.reactions;
  if (t !== null)
    for (var n = Ht(), a = t.length, o = 0; o < a; o++) {
      var i = t[o], s = i.f;
      s & dr || !n && i === B || (Ue(i, r), s & (Pe | Fr) && (s & Le ? co(
        /** @type {Derived} */
        i,
        ct
      ) : Gt(
        /** @type {Effect} */
        i
      )));
    }
}
let Ln = !1;
function Ke(e, r = null, t) {
  if (typeof e != "object" || e === null || kr in e)
    return e;
  const n = On(e);
  if (n !== ns && n !== as)
    return e;
  var a = /* @__PURE__ */ new Map(), o = Ut(e), i = Ie(0);
  o && a.set("length", Ie(
    /** @type {any[]} */
    e.length
  ));
  var s;
  return new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(l, c, d) {
        (!("value" in d) || d.configurable === !1 || d.enumerable === !1 || d.writable === !1) && fs();
        var u = a.get(c);
        return u === void 0 ? (u = Ie(d.value), a.set(c, u)) : A(u, Ke(d.value, s)), !0;
      },
      deleteProperty(l, c) {
        var d = a.get(c);
        if (d === void 0)
          c in l && a.set(c, Ie(ke));
        else {
          if (o && typeof c == "string") {
            var u = (
              /** @type {Source<number>} */
              a.get("length")
            ), p = Number(c);
            Number.isInteger(p) && p < u.v && A(u, p);
          }
          A(d, ke), va(i);
        }
        return !0;
      },
      get(l, c, d) {
        var m;
        if (c === kr)
          return e;
        var u = a.get(c), p = c in l;
        if (u === void 0 && (!p || (m = lr(l, c)) != null && m.writable) && (u = Ie(Ke(p ? l[c] : ke, s)), a.set(c, u)), u !== void 0) {
          var _ = f(u);
          return _ === ke ? void 0 : _;
        }
        return Reflect.get(l, c, d);
      },
      getOwnPropertyDescriptor(l, c) {
        var d = Reflect.getOwnPropertyDescriptor(l, c);
        if (d && "value" in d) {
          var u = a.get(c);
          u && (d.value = f(u));
        } else if (d === void 0) {
          var p = a.get(c), _ = p == null ? void 0 : p.v;
          if (p !== void 0 && _ !== ke)
            return {
              enumerable: !0,
              configurable: !0,
              value: _,
              writable: !0
            };
        }
        return d;
      },
      has(l, c) {
        var _;
        if (c === kr)
          return !0;
        var d = a.get(c), u = d !== void 0 && d.v !== ke || Reflect.has(l, c);
        if (d !== void 0 || B !== null && (!u || (_ = lr(l, c)) != null && _.writable)) {
          d === void 0 && (d = Ie(u ? Ke(l[c], s) : ke), a.set(c, d));
          var p = f(d);
          if (p === ke)
            return !1;
        }
        return u;
      },
      set(l, c, d, u) {
        var k;
        var p = a.get(c), _ = c in l;
        if (o && c === "length")
          for (var m = d; m < /** @type {Source<number>} */
          p.v; m += 1) {
            var h = a.get(m + "");
            h !== void 0 ? A(h, ke) : m in l && (h = Ie(ke), a.set(m + "", h));
          }
        p === void 0 ? (!_ || (k = lr(l, c)) != null && k.writable) && (p = Ie(void 0), A(p, Ke(d, s)), a.set(c, p)) : (_ = p.v !== ke, A(p, Ke(d, s)));
        var b = Reflect.getOwnPropertyDescriptor(l, c);
        if (b != null && b.set && b.set.call(u, d), !_) {
          if (o && typeof c == "string") {
            var y = (
              /** @type {Source<number>} */
              a.get("length")
            ), g = Number(c);
            Number.isInteger(g) && g >= y.v && A(y, g + 1);
          }
          va(i);
        }
        return !0;
      },
      ownKeys(l) {
        f(i);
        var c = Reflect.ownKeys(l).filter((p) => {
          var _ = a.get(p);
          return _ === void 0 || _.v !== ke;
        });
        for (var [d, u] of a)
          u.v !== ke && !(d in l) && c.push(d);
        return c;
      },
      setPrototypeOf() {
        ms();
      }
    }
  );
}
function va(e, r = 1) {
  A(e, e.v + r);
}
var ka, uo, _o;
function bs() {
  if (ka === void 0) {
    ka = window;
    var e = Element.prototype, r = Node.prototype;
    uo = lr(r, "firstChild").get, _o = lr(r, "nextSibling").get, e.__click = void 0, e.__className = "", e.__attributes = null, e.__styles = null, e.__e = void 0, Text.prototype.__t = void 0;
  }
}
function ut(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function wr(e) {
  return uo.call(e);
}
// @__NO_SIDE_EFFECTS__
function Wt(e) {
  return _o.call(e);
}
function E(e, r) {
  return /* @__PURE__ */ wr(e);
}
function J(e, r) {
  {
    var t = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ wr(
        /** @type {Node} */
        e
      )
    );
    return t instanceof Comment && t.data === "" ? /* @__PURE__ */ Wt(t) : t;
  }
}
function M(e, r = 1, t = !1) {
  let n = e;
  for (; r--; )
    n = /** @type {TemplateNode} */
    /* @__PURE__ */ Wt(n);
  return n;
}
function vs(e) {
  e.textContent = "";
}
// @__NO_SIDE_EFFECTS__
function O(e) {
  var r = Le | dr;
  B === null ? r |= Fr : B.f |= ao;
  var t = $ !== null && $.f & Le ? (
    /** @type {Derived} */
    $
  ) : null;
  const n = {
    children: null,
    ctx: Q,
    deps: null,
    equals: io,
    f: r,
    fn: e,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      null
    ),
    wv: 0,
    parent: t ?? B
  };
  return t !== null && (t.children ?? (t.children = [])).push(n), n;
}
// @__NO_SIDE_EFFECTS__
function te(e) {
  const r = /* @__PURE__ */ O(e);
  return r.equals = Rn, r;
}
function po(e) {
  var r = e.children;
  if (r !== null) {
    e.children = null;
    for (var t = 0; t < r.length; t += 1) {
      var n = r[t];
      n.f & Le ? zn(
        /** @type {Derived} */
        n
      ) : Ce(
        /** @type {Effect} */
        n
      );
    }
  }
}
function ks(e) {
  for (var r = e.parent; r !== null; ) {
    if (!(r.f & Le))
      return (
        /** @type {Effect} */
        r
      );
    r = r.parent;
  }
  return null;
}
function fo(e) {
  var r, t = B;
  xe(ks(e));
  try {
    po(e), r = Eo(e);
  } finally {
    xe(t);
  }
  return r;
}
function mo(e) {
  var r = fo(e), t = (vr || e.f & Fr) && e.deps !== null ? ct : Pe;
  Ue(e, t), e.equals(r) || (e.v = r, e.wv = So());
}
function zn(e) {
  po(e), ot(e, 0), Ue(e, Ur), e.v = e.children = e.deps = e.ctx = e.reactions = null;
}
function ho(e) {
  B === null && $ === null && ds(), $ !== null && $.f & Fr && us(), Wn && cs();
}
function ws(e, r) {
  var t = r.last;
  t === null ? r.last = r.first = e : (t.next = e, e.prev = t, r.last = e);
}
function Br(e, r, t, n = !0) {
  var a = (e & lt) !== 0, o = B, i = {
    ctx: Q,
    deps: null,
    deriveds: null,
    nodes_start: null,
    nodes_end: null,
    f: e | dr,
    first: null,
    fn: r,
    last: null,
    next: null,
    parent: a ? null : o,
    prev: null,
    teardown: null,
    transitions: null,
    wv: 0
  };
  if (t) {
    var s = Or;
    try {
      wa(!0), pt(i), i.f |= no;
    } catch (d) {
      throw Ce(i), d;
    } finally {
      wa(s);
    }
  } else r !== null && Gt(i);
  var l = t && i.deps === null && i.first === null && i.nodes_start === null && i.teardown === null && (i.f & ao) === 0;
  if (!l && !a && n && (o !== null && ws(i, o), $ !== null && $.f & Le)) {
    var c = (
      /** @type {Derived} */
      $
    );
    (c.children ?? (c.children = [])).push(i);
  }
  return i;
}
function go(e) {
  const r = Br(st, null, !1);
  return Ue(r, Pe), r.teardown = e, r;
}
function hn(e) {
  ho();
  var r = B !== null && (B.f & ze) !== 0 && Q !== null && !Q.m;
  if (r) {
    var t = (
      /** @type {ComponentContext} */
      Q
    );
    (t.e ?? (t.e = [])).push({
      fn: e,
      effect: B,
      reaction: $
    });
  } else {
    var n = Un(e);
    return n;
  }
}
function Ps(e) {
  return ho(), Yt(e);
}
function xs(e) {
  const r = Br(lt, e, !0);
  return (t = {}) => new Promise((n) => {
    t.outro ? Pr(r, () => {
      Ce(r), n(void 0);
    }) : (Ce(r), n(void 0));
  });
}
function Un(e) {
  return Br(to, e, !1);
}
function Oe(e, r) {
  var t = (
    /** @type {ComponentContextLegacy} */
    Q
  ), n = { effect: null, ran: !1 };
  t.l.r1.push(n), n.effect = Yt(() => {
    e(), !n.ran && (n.ran = !0, A(t.l.r2, !0), rr(r));
  });
}
function dt() {
  var e = (
    /** @type {ComponentContextLegacy} */
    Q
  );
  Yt(() => {
    if (f(e.l.r2)) {
      for (var r of e.l.r1) {
        var t = r.effect;
        t.f & Pe && Ue(t, ct), Wr(t) && pt(t), r.ran = !1;
      }
      e.l.r2.v = !1;
    }
  });
}
function Yt(e) {
  return Br(st, e, !0);
}
function N(e) {
  return fr(e);
}
function fr(e, r = 0) {
  return Br(st | Bt | r, e, !0);
}
function Ae(e, r = !0) {
  return Br(st | ze, e, !0, r);
}
function yo(e) {
  var r = e.teardown;
  if (r !== null) {
    const t = Wn, n = $;
    Pa(!0), Me(null);
    try {
      r.call(null);
    } finally {
      Pa(t), Me(n);
    }
  }
}
function bo(e) {
  var r = e.deriveds;
  if (r !== null) {
    e.deriveds = null;
    for (var t = 0; t < r.length; t += 1)
      zn(r[t]);
  }
}
function vo(e, r = !1) {
  var t = e.first;
  for (e.first = e.last = null; t !== null; ) {
    var n = t.next;
    Ce(t, r), t = n;
  }
}
function Ss(e) {
  for (var r = e.first; r !== null; ) {
    var t = r.next;
    r.f & ze || Ce(r), r = t;
  }
}
function Ce(e, r = !0) {
  var t = !1;
  if ((r || e.f & ss) && e.nodes_start !== null) {
    for (var n = e.nodes_start, a = e.nodes_end; n !== null; ) {
      var o = n === a ? null : (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Wt(n)
      );
      n.remove(), n = o;
    }
    t = !0;
  }
  vo(e, r && !t), bo(e), ot(e, 0), Ue(e, Ur);
  var i = e.transitions;
  if (i !== null)
    for (const l of i)
      l.stop();
  yo(e);
  var s = e.parent;
  s !== null && s.first !== null && ko(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes_start = e.nodes_end = null;
}
function ko(e) {
  var r = e.parent, t = e.prev, n = e.next;
  t !== null && (t.next = n), n !== null && (n.prev = t), r !== null && (r.first === e && (r.first = n), r.last === e && (r.last = t));
}
function Pr(e, r) {
  var t = [];
  Bn(e, t, !0), wo(t, () => {
    Ce(e), r && r();
  });
}
function wo(e, r) {
  var t = e.length;
  if (t > 0) {
    var n = () => --t || r();
    for (var a of e)
      a.out(n);
  } else
    r();
}
function Bn(e, r, t) {
  if (!(e.f & Be)) {
    if (e.f ^= Be, e.transitions !== null)
      for (const i of e.transitions)
        (i.is_global || t) && r.push(i);
    for (var n = e.first; n !== null; ) {
      var a = n.next, o = (n.f & pr) !== 0 || (n.f & ze) !== 0;
      Bn(n, r, o ? t : !1), n = a;
    }
  }
}
function at(e) {
  Po(e, !0);
}
function Po(e, r) {
  if (e.f & Be) {
    Wr(e) && pt(e), e.f ^= Be;
    for (var t = e.first; t !== null; ) {
      var n = t.next, a = (t.f & pr) !== 0 || (t.f & ze) !== 0;
      Po(t, a ? r : !1), t = n;
    }
    if (e.transitions !== null)
      for (const o of e.transitions)
        (o.is_global || r) && o.in();
  }
}
let gn = !1, yn = [];
function Es() {
  gn = !1;
  const e = yn.slice();
  yn = [], fn(e);
}
function Vr(e) {
  gn || (gn = !0, queueMicrotask(Es)), yn.push(e);
}
function Vn(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
let $r = !1, It = !1, Tt = null, Or = !1, Wn = !1;
function wa(e) {
  Or = e;
}
function Pa(e) {
  Wn = e;
}
let bn = [], et = 0;
let $ = null;
function Me(e) {
  $ = e;
}
let B = null;
function xe(e) {
  B = e;
}
let Ve = null;
function qs(e) {
  Ve = e;
}
let ge = null, Fe = 0, cr = null;
function Fs(e) {
  cr = e;
}
let xo = 1, vn = 0, vr = !1, Q = null;
function xa(e) {
  Q = e;
}
function So() {
  return ++xo;
}
function Ht() {
  return !zr || Q !== null && Q.l === null;
}
function Wr(e) {
  var c;
  var r = e.f;
  if (r & dr)
    return !0;
  if (r & ct) {
    var t = e.deps, n = (r & Fr) !== 0;
    if (t !== null) {
      var a, o, i = (r & Ft) !== 0, s = n && B !== null && !vr, l = t.length;
      if (i || s) {
        for (a = 0; a < l; a++)
          o = t[a], (i || !((c = o == null ? void 0 : o.reactions) != null && c.includes(e))) && (o.reactions ?? (o.reactions = [])).push(e);
        i && (e.f ^= Ft);
      }
      for (a = 0; a < l; a++)
        if (o = t[a], Wr(
          /** @type {Derived} */
          o
        ) && mo(
          /** @type {Derived} */
          o
        ), o.wv > e.wv)
          return !0;
    }
    (!n || B !== null && !vr) && Ue(e, Pe);
  }
  return !1;
}
function Is(e, r) {
  for (var t = r; t !== null; ) {
    if (t.f & qt)
      try {
        t.fn(e);
        return;
      } catch {
        t.f ^= qt;
      }
    t = t.parent;
  }
  throw $r = !1, e;
}
function Ts(e) {
  return (e.f & Ur) === 0 && (e.parent === null || (e.parent.f & qt) === 0);
}
function an() {
  $r = !1;
}
function _t(e, r, t, n) {
  if ($r) {
    if (t === null && ($r = !1), Ts(r))
      throw e;
    return;
  }
  t !== null && ($r = !0);
  {
    Is(e, r);
    return;
  }
}
function Eo(e) {
  var p;
  var r = ge, t = Fe, n = cr, a = $, o = vr, i = Ve, s = Q, l = e.f;
  ge = /** @type {null | Value[]} */
  null, Fe = 0, cr = null, $ = l & (ze | lt) ? null : e, vr = !Or && (l & Fr) !== 0, Ve = null, Q = e.ctx, vn++;
  try {
    var c = (
      /** @type {Function} */
      (0, e.fn)()
    ), d = e.deps;
    if (ge !== null) {
      var u;
      if (ot(e, Fe), d !== null && Fe > 0)
        for (d.length = Fe + ge.length, u = 0; u < ge.length; u++)
          d[Fe + u] = ge[u];
      else
        e.deps = d = ge;
      if (!vr)
        for (u = Fe; u < d.length; u++)
          ((p = d[u]).reactions ?? (p.reactions = [])).push(e);
    } else d !== null && Fe < d.length && (ot(e, Fe), d.length = Fe);
    return c;
  } finally {
    ge = r, Fe = t, cr = n, $ = a, vr = o, Ve = i, Q = s;
  }
}
function Ds(e, r) {
  let t = r.reactions;
  if (t !== null) {
    var n = rs.call(t, e);
    if (n !== -1) {
      var a = t.length - 1;
      a === 0 ? t = r.reactions = null : (t[n] = t[a], t.pop());
    }
  }
  t === null && r.f & Le && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (ge === null || !ge.includes(r)) && (Ue(r, ct), r.f & (Fr | Ft) || (r.f ^= Ft), ot(
    /** @type {Derived} **/
    r,
    0
  ));
}
function ot(e, r) {
  var t = e.deps;
  if (t !== null)
    for (var n = r; n < t.length; n++)
      Ds(e, t[n]);
}
function pt(e) {
  var r = e.f;
  if (!(r & Ur)) {
    Ue(e, Pe);
    var t = B, n = Q;
    B = e;
    try {
      r & Bt ? Ss(e) : vo(e), bo(e), yo(e);
      var a = Eo(e);
      e.teardown = typeof a == "function" ? a : null, e.wv = xo;
      var o = e.deps, i;
      ba && Mi && e.f & dr;
    } catch (s) {
      _t(s, e, t, n || e.ctx);
    } finally {
      B = t;
    }
  }
}
function As() {
  if (et > 1e3) {
    et = 0;
    try {
      _s();
    } catch (e) {
      if (Tt !== null)
        _t(e, Tt, null);
      else
        throw e;
    }
  }
  et++;
}
function Cs(e) {
  var r = e.length;
  if (r !== 0) {
    As();
    var t = Or;
    Or = !0;
    try {
      for (var n = 0; n < r; n++) {
        var a = e[n];
        a.f & Pe || (a.f ^= Pe);
        var o = [];
        qo(a, o), Ms(o);
      }
    } finally {
      Or = t;
    }
  }
}
function Ms(e) {
  var r = e.length;
  if (r !== 0)
    for (var t = 0; t < r; t++) {
      var n = e[t];
      if (!(n.f & (Ur | Be)))
        try {
          Wr(n) && (pt(n), n.deps === null && n.first === null && n.nodes_start === null && (n.teardown === null ? ko(n) : n.fn = null));
        } catch (a) {
          _t(a, n, null, n.ctx);
        }
    }
}
function js() {
  if (It = !1, et > 1001)
    return;
  const e = bn;
  bn = [], Cs(e), It || (et = 0, Tt = null);
}
function Gt(e) {
  It || (It = !0, queueMicrotask(js)), Tt = e;
  for (var r = e; r.parent !== null; ) {
    r = r.parent;
    var t = r.f;
    if (t & (lt | ze)) {
      if (!(t & Pe)) return;
      r.f ^= Pe;
    }
  }
  bn.push(r);
}
function qo(e, r) {
  var t = e.first, n = [];
  e: for (; t !== null; ) {
    var a = t.f, o = (a & ze) !== 0, i = o && (a & Pe) !== 0, s = t.next;
    if (!i && !(a & Be))
      if (a & st) {
        if (o)
          t.f ^= Pe;
        else
          try {
            Wr(t) && pt(t);
          } catch (u) {
            _t(u, t, null, t.ctx);
          }
        var l = t.first;
        if (l !== null) {
          t = l;
          continue;
        }
      } else a & to && n.push(t);
    if (s === null) {
      let u = t.parent;
      for (; u !== null; ) {
        if (e === u)
          break e;
        var c = u.next;
        if (c !== null) {
          t = c;
          continue e;
        }
        u = u.parent;
      }
    }
    t = s;
  }
  for (var d = 0; d < n.length; d++)
    l = n[d], r.push(l), qo(l, r);
}
function f(e) {
  var d;
  var r = e.f, t = (r & Le) !== 0;
  if (t && r & Ur) {
    var n = fo(
      /** @type {Derived} */
      e
    );
    return zn(
      /** @type {Derived} */
      e
    ), n;
  }
  if ($ !== null) {
    Ve !== null && Ve.includes(e) && hs();
    var a = $.deps;
    e.rv < vn && (e.rv = vn, ge === null && a !== null && a[Fe] === e ? Fe++ : ge === null ? ge = [e] : ge.push(e), cr !== null && B !== null && B.f & Pe && !(B.f & ze) && cr.includes(e) && (Ue(B, dr), Gt(B)));
  } else if (t && /** @type {Derived} */
  e.deps === null)
    for (var o = (
      /** @type {Derived} */
      e
    ), i = o.parent, s = o; i !== null; )
      if (i.f & Le) {
        var l = (
          /** @type {Derived} */
          i
        );
        s = l, i = l.parent;
      } else {
        var c = (
          /** @type {Effect} */
          i
        );
        (d = c.deriveds) != null && d.includes(s) || (c.deriveds ?? (c.deriveds = [])).push(s);
        break;
      }
  return t && (o = /** @type {Derived} */
  e, Wr(o) && mo(o)), e.v;
}
function rr(e) {
  const r = $;
  try {
    return $ = null, e();
  } finally {
    $ = r;
  }
}
const Ns = -7169;
function Ue(e, r) {
  e.f = e.f & Ns | r;
}
function We(e) {
  return (
    /** @type {T} */
    Fo().get(e)
  );
}
function Sa(e, r) {
  return Fo().set(e, r), r;
}
function Fo(e) {
  return Q === null && Vn(), Q.c ?? (Q.c = new Map(Os(Q) || void 0));
}
function Os(e) {
  let r = e.p;
  for (; r !== null; ) {
    const t = r.c;
    if (t !== null)
      return t;
    r = r.p;
  }
  return null;
}
function V(e, r = !1, t) {
  Q = {
    p: Q,
    c: null,
    e: null,
    m: !1,
    s: e,
    x: null,
    l: null
  }, zr && !r && (Q.l = {
    s: null,
    u: null,
    r1: [],
    r2: Ie(!1)
  });
}
function W(e) {
  const r = Q;
  if (r !== null) {
    e !== void 0 && (r.x = e);
    const i = r.e;
    if (i !== null) {
      var t = B, n = $;
      r.e = null;
      try {
        for (var a = 0; a < i.length; a++) {
          var o = i[a];
          xe(o.effect), Me(o.reaction), Un(o.fn);
        }
      } finally {
        xe(t), Me(n);
      }
    }
    Q = r.p, r.m = !0;
  }
  return e || /** @type {T} */
  {};
}
function xr(e) {
  if (!(typeof e != "object" || !e || e instanceof EventTarget)) {
    if (kr in e)
      kn(e);
    else if (!Array.isArray(e))
      for (let r in e) {
        const t = e[r];
        typeof t == "object" && t && kr in t && kn(t);
      }
  }
}
function kn(e, r = /* @__PURE__ */ new Set()) {
  if (typeof e == "object" && e !== null && // We don't want to traverse DOM elements
  !(e instanceof EventTarget) && !r.has(e)) {
    r.add(e), e instanceof Date && e.getTime();
    for (let n in e)
      try {
        kn(e[n], r);
      } catch {
      }
    const t = On(e);
    if (t !== Object.prototype && t !== Array.prototype && t !== Map.prototype && t !== Set.prototype && t !== Date.prototype) {
      const n = ro(t);
      for (let a in n) {
        const o = n[a].get;
        if (o)
          try {
            o.call(e);
          } catch {
          }
      }
    }
  }
}
function Rs(e, r) {
  if (r) {
    const t = document.body;
    e.autofocus = !0, Vr(() => {
      document.activeElement === t && e.focus();
    });
  }
}
let Ea = !1;
function Ls() {
  Ea || (Ea = !0, document.addEventListener(
    "reset",
    (e) => {
      Promise.resolve().then(() => {
        var r;
        if (!e.defaultPrevented)
          for (
            const t of
            /**@type {HTMLFormElement} */
            e.target.elements
          )
            (r = t.__on_r) == null || r.call(t);
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possiblity of stopPropagation)
    { capture: !0 }
  ));
}
function Io(e) {
  var r = $, t = B;
  Me(null), xe(null);
  try {
    return e();
  } finally {
    Me(r), xe(t);
  }
}
function zs(e, r, t, n = t) {
  e.addEventListener(r, () => Io(t));
  const a = e.__on_r;
  a ? e.__on_r = () => {
    a(), n(!0);
  } : e.__on_r = () => n(!0), Ls();
}
const To = /* @__PURE__ */ new Set(), wn = /* @__PURE__ */ new Set();
function Do(e, r, t, n) {
  function a(o) {
    if (n.capture || Zr.call(r, o), !o.cancelBubble)
      return Io(() => t.call(this, o));
  }
  return e.startsWith("pointer") || e.startsWith("touch") || e === "wheel" ? Vr(() => {
    r.addEventListener(e, a, n);
  }) : r.addEventListener(e, a, n), a;
}
function Sr(e, r, t, n, a) {
  var o = { capture: n, passive: a }, i = Do(e, r, t, o);
  (r === document.body || r === window || r === document) && go(() => {
    r.removeEventListener(e, i, o);
  });
}
function Yn(e) {
  for (var r = 0; r < e.length; r++)
    To.add(e[r]);
  for (var t of wn)
    t(e);
}
function Zr(e) {
  var g;
  var r = this, t = (
    /** @type {Node} */
    r.ownerDocument
  ), n = e.type, a = ((g = e.composedPath) == null ? void 0 : g.call(e)) || [], o = (
    /** @type {null | Element} */
    a[0] || e.target
  ), i = 0, s = e.__root;
  if (s) {
    var l = a.indexOf(s);
    if (l !== -1 && (r === document || r === /** @type {any} */
    window)) {
      e.__root = r;
      return;
    }
    var c = a.indexOf(r);
    if (c === -1)
      return;
    l <= c && (i = l);
  }
  if (o = /** @type {Element} */
  a[i] || e.target, o !== r) {
    ts(e, "currentTarget", {
      configurable: !0,
      get() {
        return o || t;
      }
    });
    var d = $, u = B;
    Me(null), xe(null);
    try {
      for (var p, _ = []; o !== null; ) {
        var m = o.assignedSlot || o.parentNode || /** @type {any} */
        o.host || null;
        try {
          var h = o["__" + n];
          if (h !== void 0 && !/** @type {any} */
          o.disabled)
            if (Ut(h)) {
              var [b, ...y] = h;
              b.apply(o, [e, ...y]);
            } else
              h.call(o, e);
        } catch (k) {
          p ? _.push(k) : p = k;
        }
        if (e.cancelBubble || m === r || m === null)
          break;
        o = m;
      }
      if (p) {
        for (let k of _)
          queueMicrotask(() => {
            throw k;
          });
        throw p;
      }
    } finally {
      e.__root = r, delete e.currentTarget, Me(d), xe(u);
    }
  }
}
function Hn(e) {
  var r = document.createElement("template");
  return r.innerHTML = e, r.content;
}
function Er(e, r) {
  var t = (
    /** @type {Effect} */
    B
  );
  t.nodes_start === null && (t.nodes_start = e, t.nodes_end = r);
}
// @__NO_SIDE_EFFECTS__
function F(e, r) {
  var t = (r & Hi) !== 0, n = (r & Gi) !== 0, a, o = !e.startsWith("<!>");
  return () => {
    a === void 0 && (a = Hn(o ? e : "<!>" + e), t || (a = /** @type {Node} */
    /* @__PURE__ */ wr(a)));
    var i = (
      /** @type {TemplateNode} */
      n ? document.importNode(a, !0) : a.cloneNode(!0)
    );
    if (t) {
      var s = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ wr(i)
      ), l = (
        /** @type {TemplateNode} */
        i.lastChild
      );
      Er(s, l);
    } else
      Er(i, i);
    return i;
  };
}
// @__NO_SIDE_EFFECTS__
function Us(e, r, t = "svg") {
  var n = !e.startsWith("<!>"), a = `<${t}>${n ? e : "<!>" + e}</${t}>`, o;
  return () => {
    if (!o) {
      var i = (
        /** @type {DocumentFragment} */
        Hn(a)
      ), s = (
        /** @type {Element} */
        /* @__PURE__ */ wr(i)
      );
      o = /** @type {Element} */
      /* @__PURE__ */ wr(s);
    }
    var l = (
      /** @type {TemplateNode} */
      o.cloneNode(!0)
    );
    return Er(l, l), l;
  };
}
function Rr(e = "") {
  {
    var r = ut(e + "");
    return Er(r, r), r;
  }
}
function ae() {
  var e = document.createDocumentFragment(), r = document.createComment(""), t = ut();
  return e.append(r, t), Er(r, t), e;
}
function P(e, r) {
  e !== null && e.before(
    /** @type {Node} */
    r
  );
}
let Dt = !0;
function qa(e) {
  Dt = e;
}
function Se(e, r) {
  var t = r == null ? "" : typeof r == "object" ? r + "" : r;
  t !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = t, e.nodeValue = t == null ? "" : t + "");
}
function Fa(e, r) {
  return Bs(e, r);
}
const Ar = /* @__PURE__ */ new Map();
function Bs(e, { target: r, anchor: t, props: n = {}, events: a, context: o, intro: i = !0 }) {
  bs();
  var s = /* @__PURE__ */ new Set(), l = (u) => {
    for (var p = 0; p < u.length; p++) {
      var _ = u[p];
      if (!s.has(_)) {
        s.add(_);
        var m = es(_);
        r.addEventListener(_, Zr, { passive: m });
        var h = Ar.get(_);
        h === void 0 ? (document.addEventListener(_, Zr, { passive: m }), Ar.set(_, 1)) : Ar.set(_, h + 1);
      }
    }
  };
  l(Nn(To)), wn.add(l);
  var c = void 0, d = xs(() => {
    var u = t ?? r.appendChild(ut());
    return Ae(() => {
      if (o) {
        V({});
        var p = (
          /** @type {ComponentContext} */
          Q
        );
        p.c = o;
      }
      a && (n.$$events = a), Dt = i, c = e(u, n) || {}, Dt = !0, o && W();
    }), () => {
      var m;
      for (var p of s) {
        r.removeEventListener(p, Zr);
        var _ = (
          /** @type {number} */
          Ar.get(p)
        );
        --_ === 0 ? (document.removeEventListener(p, Zr), Ar.delete(p)) : Ar.set(p, _);
      }
      wn.delete(l), u !== t && ((m = u.parentNode) == null || m.removeChild(u));
    };
  });
  return Pn.set(c, d), c;
}
let Pn = /* @__PURE__ */ new WeakMap();
function on(e, r) {
  const t = Pn.get(e);
  return t ? (Pn.delete(e), t(r)) : Promise.resolve();
}
function j(e, r, t = !1) {
  var n = e, a = null, o = null, i = ke, s = t ? pr : 0, l = !1;
  const c = (u, p = !0) => {
    l = !0, d(p, u);
  }, d = (u, p) => {
    i !== (i = u) && (i ? (a ? at(a) : p && (a = Ae(() => p(n))), o && Pr(o, () => {
      o = null;
    })) : (o ? at(o) : p && (o = Ae(() => p(n))), a && Pr(a, () => {
      a = null;
    })));
  };
  fr(() => {
    l = !1, r(c), l || d(null, null);
  }, s);
}
function Gn(e, r) {
  return r;
}
function Vs(e, r, t, n) {
  for (var a = [], o = r.length, i = 0; i < o; i++)
    Bn(r[i].e, a, !0);
  var s = o > 0 && a.length === 0 && t !== null;
  if (s) {
    var l = (
      /** @type {Element} */
      /** @type {Element} */
      t.parentNode
    );
    vs(l), l.append(
      /** @type {Element} */
      t
    ), n.clear(), ir(e, r[0].prev, r[o - 1].next);
  }
  wo(a, () => {
    for (var c = 0; c < o; c++) {
      var d = r[c];
      s || (n.delete(d.k), ir(e, d.prev, d.next)), Ce(d.e, !s);
    }
  });
}
function Xn(e, r, t, n, a, o = null) {
  var i = e, s = { flags: r, items: /* @__PURE__ */ new Map(), first: null }, l = (r & eo) !== 0;
  if (l) {
    var c = (
      /** @type {Element} */
      e
    );
    i = c.appendChild(ut());
  }
  var d = null, u = !1;
  fr(() => {
    var p = t(), _ = Ut(p) ? p : p == null ? [] : Nn(p), m = _.length;
    if (!(u && m === 0)) {
      u = m === 0;
      {
        var h = (
          /** @type {Effect} */
          $
        );
        Ws(
          _,
          s,
          i,
          a,
          r,
          (h.f & Be) !== 0,
          n
        );
      }
      o !== null && (m === 0 ? d ? at(d) : d = Ae(() => o(i)) : d !== null && Pr(d, () => {
        d = null;
      })), t();
    }
  });
}
function Ws(e, r, t, n, a, o, i, s) {
  var C, G, L, _e;
  var l = (a & Ni) !== 0, c = (a & (Mn | jn)) !== 0, d = e.length, u = r.items, p = r.first, _ = p, m, h = null, b, y = [], g = [], k, w, x, S;
  if (l)
    for (S = 0; S < d; S += 1)
      k = e[S], w = i(k, S), x = u.get(w), x !== void 0 && ((C = x.a) == null || C.measure(), (b ?? (b = /* @__PURE__ */ new Set())).add(x));
  for (S = 0; S < d; S += 1) {
    if (k = e[S], w = i(k, S), x = u.get(w), x === void 0) {
      var D = _ ? (
        /** @type {TemplateNode} */
        _.e.nodes_start
      ) : t;
      h = Hs(
        D,
        r,
        h,
        h === null ? r.first : h.next,
        k,
        w,
        S,
        n,
        a
      ), u.set(w, h), y = [], g = [], _ = h.next;
      continue;
    }
    if (c && Ys(x, k, S, a), x.e.f & Be && (at(x.e), l && ((G = x.a) == null || G.unfix(), (b ?? (b = /* @__PURE__ */ new Set())).delete(x))), x !== _) {
      if (m !== void 0 && m.has(x)) {
        if (y.length < g.length) {
          var I = g[0], T;
          h = I.prev;
          var Y = y[0], K = y[y.length - 1];
          for (T = 0; T < y.length; T += 1)
            Ia(y[T], I, t);
          for (T = 0; T < g.length; T += 1)
            m.delete(g[T]);
          ir(r, Y.prev, K.next), ir(r, h, Y), ir(r, K, I), _ = I, h = K, S -= 1, y = [], g = [];
        } else
          m.delete(x), Ia(x, _, t), ir(r, x.prev, x.next), ir(r, x, h === null ? r.first : h.next), ir(r, h, x), h = x;
        continue;
      }
      for (y = [], g = []; _ !== null && _.k !== w; )
        (o || !(_.e.f & Be)) && (m ?? (m = /* @__PURE__ */ new Set())).add(_), g.push(_), _ = _.next;
      if (_ === null)
        continue;
      x = _;
    }
    y.push(x), h = x, _ = x.next;
  }
  if (_ !== null || m !== void 0) {
    for (var ne = m === void 0 ? [] : Nn(m); _ !== null; )
      (o || !(_.e.f & Be)) && ne.push(_), _ = _.next;
    var le = ne.length;
    if (le > 0) {
      var X = a & eo && d === 0 ? t : null;
      if (l) {
        for (S = 0; S < le; S += 1)
          (L = ne[S].a) == null || L.measure();
        for (S = 0; S < le; S += 1)
          (_e = ne[S].a) == null || _e.fix();
      }
      Vs(r, ne, X, u);
    }
  }
  l && Vr(() => {
    var Ye;
    if (b !== void 0)
      for (x of b)
        (Ye = x.a) == null || Ye.apply();
  }), B.first = r.first && r.first.e, B.last = h && h.e;
}
function Ys(e, r, t, n) {
  n & Mn && mn(e.v, r), n & jn ? mn(
    /** @type {Value<number>} */
    e.i,
    t
  ) : e.i = t;
}
function Hs(e, r, t, n, a, o, i, s, l, c) {
  var d = (l & Mn) !== 0, u = (l & Oi) === 0, p = d ? u ? /* @__PURE__ */ Vt(a) : Ie(a) : a, _ = l & jn ? Ie(i) : i, m = {
    i: _,
    v: p,
    k: o,
    a: null,
    // @ts-expect-error
    e: null,
    prev: t,
    next: n
  };
  try {
    return m.e = Ae(() => s(e, p, _), Ln), m.e.prev = t && t.e, m.e.next = n && n.e, t === null ? r.first = m : (t.next = m, t.e.next = m.e), n !== null && (n.prev = m, n.e.prev = m.e), m;
  } finally {
  }
}
function Ia(e, r, t) {
  for (var n = e.next ? (
    /** @type {TemplateNode} */
    e.next.e.nodes_start
  ) : t, a = r ? (
    /** @type {TemplateNode} */
    r.e.nodes_start
  ) : t, o = (
    /** @type {TemplateNode} */
    e.e.nodes_start
  ); o !== n; ) {
    var i = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ Wt(o)
    );
    a.before(o), o = i;
  }
}
function ir(e, r, t) {
  r === null ? e.first = t : (r.next = t, r.e.next = t && t.e), t !== null && (t.prev = r, t.e.prev = r && r.e);
}
function ft(e, r, t, n, a) {
  var o = e, i = "", s;
  fr(() => {
    i !== (i = r() ?? "") && (s !== void 0 && (Ce(s), s = void 0), i !== "" && (s = Ae(() => {
      var l = i + "", c = Hn(l);
      Er(
        /** @type {TemplateNode} */
        /* @__PURE__ */ wr(c),
        /** @type {TemplateNode} */
        c.lastChild
      ), o.before(c);
    })));
  });
}
function be(e, r, ...t) {
  var n = e, a = se, o;
  fr(() => {
    a !== (a = r()) && (o && (Ce(o), o = null), o = Ae(() => (
      /** @type {SnippetFn} */
      a(n, ...t)
    )));
  }, pr);
}
function Gs(e, r, t) {
  var n = e, a, o;
  fr(() => {
    a !== (a = r()) && (o && (Pr(o), o = null), a && (o = Ae(() => t(n, a))));
  }, pr);
}
function At(e, r, t, n, a, o) {
  var i, s, l = null, c = (
    /** @type {TemplateNode} */
    e
  ), d;
  fr(() => {
    const u = r() || null;
    var p = u === "svg" ? nt : null;
    u !== i && (d && (u === null ? Pr(d, () => {
      d = null, s = null;
    }) : u === s ? at(d) : (Ce(d), qa(!1))), u && u !== s && (d = Ae(() => {
      if (l = p ? document.createElementNS(p, u) : document.createElement(u), Er(l, l), n) {
        var _ = (
          /** @type {TemplateNode} */
          l.appendChild(ut())
        );
        n(l, _);
      }
      B.nodes_end = l, c.before(l);
    })), i = u, i && (s = i), qa(!0));
  }, pr);
}
function U(e, r) {
  Vr(() => {
    var t = e.getRootNode(), n = (
      /** @type {ShadowRoot} */
      t.host ? (
        /** @type {ShadowRoot} */
        t
      ) : (
        /** @type {Document} */
        t.head ?? /** @type {Document} */
        t.ownerDocument.head
      )
    );
    if (!n.querySelector("#" + r.hash)) {
      const a = document.createElement("style");
      a.id = r.hash, a.textContent = r.code, n.appendChild(a);
    }
  });
}
function Ao(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (r = 0; r < a; r++) e[r] && (t = Ao(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function Xs() {
  for (var e, r, t = 0, n = "", a = arguments.length; t < a; t++) (e = arguments[t]) && (r = Ao(e)) && (n && (n += " "), n += r);
  return n;
}
function Co(e) {
  return typeof e == "object" ? Xs(e) : e ?? "";
}
function Js(e, r) {
  r ? e.hasAttribute("selected") || e.setAttribute("selected", "") : e.removeAttribute("selected");
}
function Z(e, r, t, n) {
  var a = e.__attributes ?? (e.__attributes = {});
  a[r] !== (a[r] = t) && (r === "style" && "__styles" in e && (e.__styles = {}), r === "loading" && (e[ls] = t), t == null ? e.removeAttribute(r) : typeof t != "string" && Mo(e).includes(r) ? e[r] = t : e.setAttribute(r, t));
}
function Ct(e, r, t, n, a = !1, o = !1, i = !1) {
  var s = r || {}, l = e.tagName === "OPTION";
  for (var c in r)
    c in t || (t[c] = null);
  t.class && (t.class = Co(t.class)), n !== void 0 && (t.class = t.class ? t.class + " " + n : n);
  var d = Mo(e), u = (
    /** @type {Record<string, unknown>} **/
    e.__attributes ?? (e.__attributes = {})
  );
  for (const y in t) {
    let g = t[y];
    if (l && y === "value" && g == null) {
      e.value = e.__value = "", s[y] = g;
      continue;
    }
    var p = s[y];
    if (g !== p) {
      s[y] = g;
      var _ = y[0] + y[1];
      if (_ !== "$$") {
        if (_ === "on") {
          const k = {}, w = "$$" + y;
          let x = y.slice(2);
          var m = Qi(x);
          if (Xi(x) && (x = x.slice(0, -7), k.capture = !0), !m && p) {
            if (g != null) continue;
            e.removeEventListener(x, s[w], k), s[w] = null;
          }
          if (g != null)
            if (m)
              e[`__${x}`] = g, Yn([x]);
            else {
              let S = function(D) {
                s[y].call(this, D);
              };
              s[w] = Do(x, e, S, k);
            }
          else m && (e[`__${x}`] = void 0);
        } else if (y === "style" && g != null)
          e.style.cssText = g + "";
        else if (y === "autofocus")
          Rs(
            /** @type {HTMLElement} */
            e,
            !!g
          );
        else if (y === "__value" || y === "value" && g != null)
          e.value = e[y] = e.__value = g;
        else if (y === "selected" && l)
          Js(
            /** @type {HTMLOptionElement} */
            e,
            g
          );
        else {
          var h = y;
          a || (h = Ki(h));
          var b = h === "defaultValue" || h === "defaultChecked";
          if (g == null && !o && !b)
            if (u[y] = null, h === "value" || h === "checked") {
              let k = (
                /** @type {HTMLInputElement} */
                e
              );
              if (h === "value") {
                let w = k.defaultValue;
                k.removeAttribute(h), k.defaultValue = w;
              } else {
                let w = k.defaultChecked;
                k.removeAttribute(h), k.defaultChecked = w;
              }
            } else
              e.removeAttribute(y);
          else b || d.includes(h) && (o || typeof g != "string") ? e[h] = g : typeof g != "function" && Z(e, h, g);
        }
        y === "style" && "__styles" in e && (e.__styles = {});
      }
    }
  }
  return s;
}
var Ta = /* @__PURE__ */ new Map();
function Mo(e) {
  var r = Ta.get(e.nodeName);
  if (r) return r;
  Ta.set(e.nodeName, r = []);
  for (var t, n = e, a = Element.prototype; a !== n; ) {
    t = ro(n);
    for (var o in t)
      t[o].set && r.push(o);
    n = On(n);
  }
  return r;
}
function Qs(e, r, t) {
  var n = e.__className, a = jo(r);
  (n !== a || Ln) && (a === "" ? e.removeAttribute("class") : e.setAttribute("class", a), e.__className = a);
}
function Xt(e, r, t) {
  var n = e.__className, a = jo(r);
  (n !== a || Ln) && (r == null ? e.removeAttribute("class") : e.className = a, e.__className = a);
}
function jo(e, r) {
  return (e ?? "") + "";
}
function qr(e, r, t) {
  if (t) {
    if (e.classList.contains(r)) return;
    e.classList.add(r);
  } else {
    if (!e.classList.contains(r)) return;
    e.classList.remove(r);
  }
}
const Zs = () => performance.now(), $e = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (e) => requestAnimationFrame(e)
  ),
  now: () => Zs(),
  tasks: /* @__PURE__ */ new Set()
};
function No() {
  const e = $e.now();
  $e.tasks.forEach((r) => {
    r.c(e) || ($e.tasks.delete(r), r.f());
  }), $e.tasks.size !== 0 && $e.tick(No);
}
function Ks(e) {
  let r;
  return $e.tasks.size === 0 && $e.tick(No), {
    promise: new Promise((t) => {
      $e.tasks.add(r = { c: e, f: t });
    }),
    abort() {
      $e.tasks.delete(r);
    }
  };
}
function bt(e, r) {
  e.dispatchEvent(new CustomEvent(r));
}
function $s(e) {
  if (e === "float") return "cssFloat";
  if (e === "offset") return "cssOffset";
  if (e.startsWith("--")) return e;
  const r = e.split("-");
  return r.length === 1 ? r[0] : r[0] + r.slice(1).map(
    /** @param {any} word */
    (t) => t[0].toUpperCase() + t.slice(1)
  ).join("");
}
function Da(e) {
  const r = {}, t = e.split(";");
  for (const n of t) {
    const [a, o] = n.split(":");
    if (!a || o === void 0) break;
    const i = $s(a.trim());
    r[i] = o.trim();
  }
  return r;
}
const el = (e) => e;
function Oo(e, r, t, n) {
  var a = (e & Vi) !== 0, o = (e & Wi) !== 0, i = a && o, s = (e & Yi) !== 0, l = i ? "both" : a ? "in" : "out", c, d = r.inert, u, p;
  function _() {
    var g = $, k = B;
    Me(null), xe(null);
    try {
      return c ?? (c = t()(r, (n == null ? void 0 : n()) ?? /** @type {P} */
      {}, {
        direction: l
      }));
    } finally {
      Me(g), xe(k);
    }
  }
  var m = {
    is_global: s,
    in() {
      var g;
      if (r.inert = d, !a) {
        p == null || p.abort(), (g = p == null ? void 0 : p.reset) == null || g.call(p);
        return;
      }
      o || u == null || u.abort(), bt(r, "introstart"), u = xn(r, _(), p, 1, () => {
        bt(r, "introend"), u == null || u.abort(), u = c = void 0;
      });
    },
    out(g) {
      if (!o) {
        g == null || g(), c = void 0;
        return;
      }
      r.inert = !0, bt(r, "outrostart"), p = xn(r, _(), u, 0, () => {
        bt(r, "outroend"), g == null || g();
      });
    },
    stop: () => {
      u == null || u.abort(), p == null || p.abort();
    }
  }, h = (
    /** @type {Effect} */
    B
  );
  if ((h.transitions ?? (h.transitions = [])).push(m), a && Dt) {
    var b = s;
    if (!b) {
      for (var y = (
        /** @type {Effect | null} */
        h.parent
      ); y && y.f & pr; )
        for (; (y = y.parent) && !(y.f & Bt); )
          ;
      b = !y || (y.f & no) !== 0;
    }
    b && Un(() => {
      rr(() => m.in());
    });
  }
}
function xn(e, r, t, n, a) {
  var o = n === 1;
  if (Mr(r)) {
    var i, s = !1;
    return Vr(() => {
      if (!s) {
        var b = r({ direction: o ? "in" : "out" });
        i = xn(e, b, t, n, a);
      }
    }), {
      abort: () => {
        s = !0, i == null || i.abort();
      },
      deactivate: () => i.deactivate(),
      reset: () => i.reset(),
      t: () => i.t()
    };
  }
  if (t == null || t.deactivate(), !(r != null && r.duration))
    return a(), {
      abort: se,
      deactivate: se,
      reset: se,
      t: () => n
    };
  const { delay: l = 0, css: c, tick: d, easing: u = el } = r;
  var p = [];
  if (o && t === void 0 && (d && d(0, 1), c)) {
    var _ = Da(c(0, 1));
    p.push(_, _);
  }
  var m = () => 1 - n, h = e.animate(p, { duration: l });
  return h.onfinish = () => {
    var b = (t == null ? void 0 : t.t()) ?? 1 - n;
    t == null || t.abort();
    var y = n - b, g = (
      /** @type {number} */
      r.duration * Math.abs(y)
    ), k = [];
    if (g > 0) {
      if (c)
        for (var w = Math.ceil(g / 16.666666666666668), x = 0; x <= w; x += 1) {
          var S = b + y * u(x / w), D = c(S, 1 - S);
          k.push(Da(D));
        }
      m = () => {
        var I = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          h.currentTime
        );
        return b + y * u(I / g);
      }, d && Ks(() => {
        if (h.playState !== "running") return !1;
        var I = m();
        return d(I, 1 - I), !0;
      });
    }
    h = e.animate(k, { duration: g, fill: "forwards" }), h.onfinish = () => {
      m = () => n, d == null || d(n, 1 - n), a();
    };
  }, {
    abort: () => {
      h && (h.cancel(), h.effect = null, h.onfinish = se);
    },
    deactivate: () => {
      a = se;
    },
    reset: () => {
      n === 0 && (d == null || d(1, 0));
    },
    t: () => m()
  };
}
function rl(e, r, t = r) {
  var n = Ht();
  zs(e, "input", (a) => {
    var o = a ? e.defaultValue : e.value;
    if (o = sn(e) ? ln(o) : o, t(o), n && o !== (o = r())) {
      var i = e.selectionStart, s = e.selectionEnd;
      e.value = o ?? "", s !== null && (e.selectionStart = i, e.selectionEnd = Math.min(s, e.value.length));
    }
  }), // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  rr(r) == null && e.value && t(sn(e) ? ln(e.value) : e.value), Yt(() => {
    var a = r();
    sn(e) && a === ln(e.value) || e.type === "date" && !a && !e.value || a !== e.value && (e.value = a ?? "");
  });
}
function sn(e) {
  var r = e.type;
  return r === "number" || r === "range";
}
function ln(e) {
  return e === "" ? null : +e;
}
function Ro(e) {
  return function(...r) {
    var t = (
      /** @type {Event} */
      r[0]
    );
    return t.preventDefault(), e == null ? void 0 : e.apply(this, r);
  };
}
function oe(e = !1) {
  const r = (
    /** @type {ComponentContextLegacy} */
    Q
  ), t = r.l.u;
  if (!t) return;
  let n = () => xr(r.s);
  if (e) {
    let a = 0, o = (
      /** @type {Record<string, any>} */
      {}
    );
    const i = /* @__PURE__ */ O(() => {
      let s = !1;
      const l = r.s;
      for (const c in l)
        l[c] !== o[c] && (o[c] = l[c], s = !0);
      return s && a++, a;
    });
    n = () => f(i);
  }
  t.b.length && Ps(() => {
    Aa(r, n), fn(t.b);
  }), hn(() => {
    const a = rr(() => t.m.map(os));
    return () => {
      for (const o of a)
        typeof o == "function" && o();
    };
  }), t.a.length && hn(() => {
    Aa(r, n), fn(t.a);
  });
}
function Aa(e, r) {
  if (e.l.s)
    for (const t of e.l.s) f(t);
  r();
}
function Jn(e, r) {
  var o;
  var t = (
    /** @type {Record<string, Function[] | Function>} */
    (o = e.$$events) == null ? void 0 : o[r.type]
  ), n = Ut(t) ? t.slice() : t == null ? [] : [t];
  for (var a of n)
    a.call(this, r);
}
function tr(e) {
  Q === null && Vn(), zr && Q.l !== null ? nl(Q).m.push(e) : hn(() => {
    const r = rr(e);
    if (typeof r == "function") return (
      /** @type {() => void} */
      r
    );
  });
}
function tl(e) {
  Q === null && Vn(), tr(() => () => rr(e));
}
function nl(e) {
  var r = (
    /** @type {ComponentContextLegacy} */
    e.l
  );
  return r.u ?? (r.u = { a: [], b: [], m: [] });
}
function al(e, r, t) {
  if (e == null)
    return r(void 0), se;
  const n = rr(
    () => e.subscribe(
      r,
      // @ts-expect-error
      t
    )
  );
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
let vt = !1;
function nr(e, r, t) {
  const n = t[r] ?? (t[r] = {
    store: null,
    source: /* @__PURE__ */ Vt(void 0),
    unsubscribe: se
  });
  if (n.store !== e)
    if (n.unsubscribe(), n.store = e ?? null, e == null)
      n.source.v = void 0, n.unsubscribe = se;
    else {
      var a = !0;
      n.unsubscribe = al(e, (o) => {
        a ? n.source.v = o : A(n.source, o);
      }), a = !1;
    }
  return f(n.source);
}
function ar() {
  const e = {};
  return go(() => {
    for (var r in e)
      e[r].unsubscribe();
  }), e;
}
function ol(e) {
  var r = vt;
  try {
    return vt = !1, [e(), vt];
  } finally {
    vt = r;
  }
}
const il = {
  get(e, r) {
    if (!e.exclude.includes(r))
      return e.props[r];
  },
  set(e, r) {
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    if (!e.exclude.includes(r) && r in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[r]
      };
  },
  has(e, r) {
    return e.exclude.includes(r) ? !1 : r in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((r) => !e.exclude.includes(r));
  }
};
// @__NO_SIDE_EFFECTS__
function mr(e, r, t) {
  return new Proxy(
    { props: e, exclude: r },
    il
  );
}
const sl = {
  get(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let n = e.props[t];
      if (Mr(n) && (n = n()), typeof n == "object" && n !== null && r in n) return n[r];
    }
  },
  set(e, r, t) {
    let n = e.props.length;
    for (; n--; ) {
      let a = e.props[n];
      Mr(a) && (a = a());
      const o = lr(a, r);
      if (o && o.set)
        return o.set(t), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let n = e.props[t];
      if (Mr(n) && (n = n()), typeof n == "object" && n !== null && r in n) {
        const a = lr(n, r);
        return a && !a.configurable && (a.configurable = !0), a;
      }
    }
  },
  has(e, r) {
    if (r === kr || r === oo) return !1;
    for (let t of e.props)
      if (Mr(t) && (t = t()), t != null && r in t) return !0;
    return !1;
  },
  ownKeys(e) {
    const r = [];
    for (let t of e.props) {
      Mr(t) && (t = t());
      for (const n in t)
        r.includes(n) || r.push(n);
    }
    return r;
  }
};
function _r(...e) {
  return new Proxy({ props: e }, sl);
}
function Ca(e) {
  for (var r = B, t = B; r !== null && !(r.f & (ze | lt)); )
    r = r.parent;
  try {
    return xe(r), e();
  } finally {
    xe(t);
  }
}
function v(e, r, t, n) {
  var D;
  var a = (t & Ri) !== 0, o = !zr || (t & Li) !== 0, i = (t & Ui) !== 0, s = (t & Bi) !== 0, l = !1, c;
  i ? [c, l] = ol(() => (
    /** @type {V} */
    e[r]
  )) : c = /** @type {V} */
  e[r];
  var d = kr in e || oo in e, u = ((D = lr(e, r)) == null ? void 0 : D.set) ?? (d && i && r in e ? (I) => e[r] = I : void 0), p = (
    /** @type {V} */
    n
  ), _ = !0, m = !1, h = () => (m = !0, _ && (_ = !1, s ? p = rr(
    /** @type {() => V} */
    n
  ) : p = /** @type {V} */
  n), p);
  c === void 0 && n !== void 0 && (u && o && ps(), c = h(), u && u(c));
  var b;
  if (o)
    b = () => {
      var I = (
        /** @type {V} */
        e[r]
      );
      return I === void 0 ? h() : (_ = !0, m = !1, I);
    };
  else {
    var y = Ca(
      () => (a ? O : te)(() => (
        /** @type {V} */
        e[r]
      ))
    );
    y.f |= is, b = () => {
      var I = f(y);
      return I !== void 0 && (p = /** @type {V} */
      void 0), I === void 0 ? p : I;
    };
  }
  if (!(t & zi))
    return b;
  if (u) {
    var g = e.$$legacy;
    return function(I, T) {
      return arguments.length > 0 ? ((!o || !T || g || l) && u(T ? b() : I), I) : b();
    };
  }
  var k = !1, w = !1, x = /* @__PURE__ */ Vt(c), S = Ca(
    () => /* @__PURE__ */ O(() => {
      var I = b(), T = f(x);
      return k ? (k = !1, w = !0, T) : (w = !1, x.v = I);
    })
  );
  return a || (S.equals = Rn), function(I, T) {
    if (arguments.length > 0) {
      const Y = T ? f(S) : o && i ? Ke(I) : I;
      return S.equals(Y) || (k = !0, A(x, Y), m && p !== void 0 && (p = Y), rr(() => f(S))), I;
    }
    return f(S);
  };
}
function Ma(e, r) {
  var t = B, n = $, a = Q;
  xe(e), Me(e), xa(e.ctx);
  try {
    r();
  } finally {
    xe(t), Me(n), xa(a);
  }
}
function ll(e, r, t) {
  var n = e, a;
  fr(() => {
    var o = (
      /** @type {Effect} */
      B
    ), i = !1;
    o.fn = (s) => {
      var l = r.onerror;
      let c = r.failed;
      if (!l && !c || i)
        throw s;
      var d = () => {
        Pr(a), Ma(o, () => {
          i = !1, a = Ae(() => t(n)), an();
        });
      };
      l == null || l(s, d), a && Ce(a), c && Vr(() => {
        Ma(o, () => {
          i = !0;
          try {
            a = Ae(() => {
              c(
                n,
                () => s,
                () => d
              );
            });
          } catch (u) {
            _t(u, o, null, o.ctx);
          }
          an(), i = !1;
        });
      });
    }, a = Ae(() => t(n)), an();
  }, pr | qt);
}
var ye = /* @__PURE__ */ ((e) => (e[e.UnknownError = 0] = "UnknownError", e[e.UserCancelledError = 1] = "UserCancelledError", e[e.StoreProblemError = 2] = "StoreProblemError", e[e.PurchaseNotAllowedError = 3] = "PurchaseNotAllowedError", e[e.PurchaseInvalidError = 4] = "PurchaseInvalidError", e[e.ProductNotAvailableForPurchaseError = 5] = "ProductNotAvailableForPurchaseError", e[e.ProductAlreadyPurchasedError = 6] = "ProductAlreadyPurchasedError", e[e.ReceiptAlreadyInUseError = 7] = "ReceiptAlreadyInUseError", e[e.InvalidReceiptError = 8] = "InvalidReceiptError", e[e.MissingReceiptFileError = 9] = "MissingReceiptFileError", e[e.NetworkError = 10] = "NetworkError", e[e.InvalidCredentialsError = 11] = "InvalidCredentialsError", e[e.UnexpectedBackendResponseError = 12] = "UnexpectedBackendResponseError", e[e.InvalidAppUserIdError = 14] = "InvalidAppUserIdError", e[e.OperationAlreadyInProgressError = 15] = "OperationAlreadyInProgressError", e[e.UnknownBackendError = 16] = "UnknownBackendError", e[e.InvalidAppleSubscriptionKeyError = 17] = "InvalidAppleSubscriptionKeyError", e[e.IneligibleError = 18] = "IneligibleError", e[e.InsufficientPermissionsError = 19] = "InsufficientPermissionsError", e[e.PaymentPendingError = 20] = "PaymentPendingError", e[e.InvalidSubscriberAttributesError = 21] = "InvalidSubscriberAttributesError", e[e.LogOutWithAnonymousUserError = 22] = "LogOutWithAnonymousUserError", e[e.ConfigurationError = 23] = "ConfigurationError", e[e.UnsupportedError = 24] = "UnsupportedError", e[e.EmptySubscriberAttributesError = 25] = "EmptySubscriberAttributesError", e[e.CustomerInfoError = 28] = "CustomerInfoError", e[e.SignatureVerificationError = 36] = "SignatureVerificationError", e[e.InvalidEmailError = 38] = "InvalidEmailError", e))(ye || {});
class rt {
  static getPublicMessage(r) {
    switch (r) {
      case 0:
        return "Unknown error.";
      case 1:
        return "Purchase was cancelled.";
      case 2:
        return "There was a problem with the store.";
      case 3:
        return "The device or user is not allowed to make the purchase.";
      case 4:
        return "One or more of the arguments provided are invalid.";
      case 5:
        return "The product is not available for purchase.";
      case 6:
        return "This product is already active for the user.";
      case 7:
        return "There is already another active subscriber using the same receipt.";
      case 8:
        return "The receipt is not valid.";
      case 9:
        return "The receipt is missing.";
      case 10:
        return "Error performing request. Please check your network connection and try again.";
      case 11:
        return "There was a credentials issue. Check the underlying error for more details.";
      case 12:
        return "Received unexpected response from the backend.";
      case 14:
        return "The app user id is not valid.";
      case 15:
        return "The operation is already in progress.";
      case 16:
        return "There was an unknown backend error.";
      case 17:
        return "Apple Subscription Key is invalid or not present. In order to provide subscription offers, you must first generate a subscription key. Please see https://docs.revenuecat.com/docs/ios-subscription-offers for more info.";
      case 18:
        return "The User is ineligible for that action.";
      case 19:
        return "App does not have sufficient permissions to make purchases.";
      case 20:
        return "The payment is pending.";
      case 21:
        return "One or more of the attributes sent could not be saved.";
      case 22:
        return "Called logOut but the current user is anonymous.";
      case 23:
        return "There is an issue with your configuration. Check the underlying error for more details.";
      case 24:
        return "There was a problem with the operation. Looks like we doesn't support that yet. Check the underlying error for more details.";
      case 25:
        return "A request for subscriber attributes returned none.";
      case 28:
        return "There was a problem related to the customer info.";
      case 36:
        return "Request failed signature verification. Please see https://rev.cat/trusted-entitlements for more info.";
      case 38:
        return "Email is not valid. Please provide a valid email address.";
    }
  }
  static getErrorCodeForBackendErrorCode(r) {
    switch (r) {
      case 7101:
      case 7773:
        return 2;
      case 7102:
        return 7;
      case 7103:
        return 8;
      case 7107:
      case 7224:
      case 7225:
        return 11;
      case 7105:
      case 7106:
      case 7814:
      case 7877:
      case 7878:
        return 4;
      case 7772:
        return 6;
      case 7220:
        return 14;
      case 7229:
        return 2;
      case 7230:
      case 7e3:
        return 23;
      case 7231:
        return 2;
      case 7232:
        return 18;
      case 7263:
      case 7264:
        return 21;
      case 7104:
      case 7234:
      case 7226:
      case 7110:
        return 12;
      case 7662:
        return 24;
      case 7012:
      case 7834:
      case 7879:
        return 38;
    }
  }
  static convertCodeToBackendErrorCode(r) {
    return r in Lo ? r : null;
  }
  static convertPurchaseFlowErrorCodeToErrorCode(r) {
    switch (r) {
      case de.ErrorSettingUpPurchase:
        return 2;
      case de.ErrorChargingPayment:
        return 20;
      case de.NetworkError:
        return 10;
      case de.MissingEmailError:
        return 4;
      case de.UnknownError:
        return 0;
      case de.AlreadyPurchasedError:
        return 6;
    }
  }
}
var Lo = /* @__PURE__ */ ((e) => (e[e.BackendInvalidPlatform = 7e3] = "BackendInvalidPlatform", e[e.BackendInvalidEmail = 7012] = "BackendInvalidEmail", e[e.BackendStoreProblem = 7101] = "BackendStoreProblem", e[e.BackendCannotTransferPurchase = 7102] = "BackendCannotTransferPurchase", e[e.BackendInvalidReceiptToken = 7103] = "BackendInvalidReceiptToken", e[e.BackendInvalidAppStoreSharedSecret = 7104] = "BackendInvalidAppStoreSharedSecret", e[e.BackendInvalidPaymentModeOrIntroPriceNotProvided = 7105] = "BackendInvalidPaymentModeOrIntroPriceNotProvided", e[e.BackendProductIdForGoogleReceiptNotProvided = 7106] = "BackendProductIdForGoogleReceiptNotProvided", e[e.BackendInvalidPlayStoreCredentials = 7107] = "BackendInvalidPlayStoreCredentials", e[e.BackendInternalServerError = 7110] = "BackendInternalServerError", e[e.BackendEmptyAppUserId = 7220] = "BackendEmptyAppUserId", e[e.BackendInvalidAuthToken = 7224] = "BackendInvalidAuthToken", e[e.BackendInvalidAPIKey = 7225] = "BackendInvalidAPIKey", e[e.BackendBadRequest = 7226] = "BackendBadRequest", e[e.BackendPlayStoreQuotaExceeded = 7229] = "BackendPlayStoreQuotaExceeded", e[e.BackendPlayStoreInvalidPackageName = 7230] = "BackendPlayStoreInvalidPackageName", e[e.BackendPlayStoreGenericError = 7231] = "BackendPlayStoreGenericError", e[e.BackendUserIneligibleForPromoOffer = 7232] = "BackendUserIneligibleForPromoOffer", e[e.BackendInvalidAppleSubscriptionKey = 7234] = "BackendInvalidAppleSubscriptionKey", e[e.BackendInvalidSubscriberAttributes = 7263] = "BackendInvalidSubscriberAttributes", e[e.BackendInvalidSubscriberAttributesBody = 7264] = "BackendInvalidSubscriberAttributesBody", e[e.BackendProductIDsMalformed = 7662] = "BackendProductIDsMalformed", e[e.BackendAlreadySubscribedError = 7772] = "BackendAlreadySubscribedError", e[e.BackendPaymentGatewayGenericError = 7773] = "BackendPaymentGatewayGenericError", e[e.BackendOfferNotFound = 7814] = "BackendOfferNotFound", e[e.BackendNoMXRecordsFound = 7834] = "BackendNoMXRecordsFound", e[e.BackendInvalidOperationSession = 7877] = "BackendInvalidOperationSession", e[e.BackendPurchaseCannotBeCompleted = 7878] = "BackendPurchaseCannotBeCompleted", e[e.BackendEmailIsRequired = 7879] = "BackendEmailIsRequired", e))(Lo || {});
class pe extends Error {
  constructor(t, n, a, o) {
    super(n);
    q(this, "toString", () => `PurchasesError(code: ${ye[this.errorCode]}, message: ${this.message})`);
    this.errorCode = t, this.underlyingErrorMessage = a, this.extra = o;
  }
  /** @internal */
  static getForBackendError(t, n) {
    const a = rt.getErrorCodeForBackendErrorCode(t);
    return new pe(
      a,
      rt.getPublicMessage(a),
      n,
      { backendErrorCode: t }
    );
  }
  /** @internal */
  static getForPurchasesFlowError(t) {
    return new pe(
      rt.convertPurchaseFlowErrorCodeToErrorCode(
        t.errorCode
      ),
      t.message,
      t.underlyingErrorMessage
    );
  }
}
class cl extends Error {
  constructor() {
    super("Purchases must be configured before calling getInstance");
  }
}
var Kr = /* @__PURE__ */ ((e) => (e.Started = "started", e.InProgress = "in_progress", e.Succeeded = "succeeded", e.Failed = "failed", e))(Kr || {}), jr = /* @__PURE__ */ ((e) => (e[e.SetupIntentCreationFailed = 1] = "SetupIntentCreationFailed", e[e.PaymentMethodCreationFailed = 2] = "PaymentMethodCreationFailed", e[e.PaymentChargeFailed = 3] = "PaymentChargeFailed", e[e.SetupIntentCompletionFailed = 4] = "SetupIntentCompletionFailed", e[e.AlreadyPurchased = 5] = "AlreadyPurchased", e))(jr || {});
function ul(e) {
  return e != null;
}
var qe = /* @__PURE__ */ ((e) => (e[e.Silent = 0] = "Silent", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Info = 3] = "Info", e[e.Debug = 4] = "Debug", e[e.Verbose = 5] = "Verbose", e))(qe || {});
class H {
  static setLogLevel(r) {
    this.logLevel = r;
  }
  static log(r, t = this.logLevel) {
    const n = `[Purchases] ${r}`;
    if (!(this.logLevel < t || t === qe.Silent))
      switch (t) {
        case qe.Error:
          console.error(n);
          break;
        case qe.Warn:
          console.warn(n);
          break;
        case qe.Info:
          console.info(n);
          break;
        case qe.Debug:
          console.debug(n);
          break;
        case qe.Verbose:
          console.debug(n);
          break;
      }
  }
  static errorLog(r) {
    this.log(r, qe.Error);
  }
  static warnLog(r) {
    this.log(r, qe.Warn);
  }
  static infoLog(r) {
    this.log(r, qe.Info);
  }
  static debugLog(r) {
    this.log(r, qe.Debug);
  }
  static verboseLog(r) {
    this.log(r, qe.Verbose);
  }
}
q(H, "logLevel", qe.Silent);
var sr = /* @__PURE__ */ ((e) => (e.Year = "year", e.Month = "month", e.Week = "week", e.Day = "day", e))(sr || {});
function zo(e) {
  const r = e.match(/^PT?([0-9]+)([MDYW])$/);
  if (!r || r.length < 3)
    return H.errorLog(`Invalid ISO 8601 duration format: ${e}`), null;
  const t = parseInt(r[1]);
  switch (r[2]) {
    case "Y":
      return {
        number: t,
        unit: "year"
        /* Year */
      };
    case "M":
      return {
        number: t,
        unit: "month"
        /* Month */
      };
    case "W":
      return {
        number: t,
        unit: "week"
        /* Week */
      };
    case "D":
      return {
        number: t,
        unit: "day"
        /* Day */
      };
    default:
      return H.errorLog(`Invalid ISO 8601 unit duration format: ${e}`), null;
  }
}
function Uo(e, r, t) {
  let n = new Date(e);
  switch (r.unit) {
    case "year":
      n.getDate() === 29 && n.getMonth() === 1 && r.number !== 4 ? n.setFullYear(
        n.getFullYear() + r.number,
        n.getMonth(),
        28
      ) : n.setFullYear(
        n.getFullYear() + r.number,
        n.getMonth(),
        n.getDate()
      );
      break;
    case "month":
      n.setMonth(n.getMonth() + r.number, n.getDate()), n.getDate() !== e.getDate() && (n = new Date(e), n.setMonth(n.getMonth() + r.number + 1, 0));
      break;
    case "week":
      n.setDate(n.getDate() + r.number * 7);
      break;
    case "day":
      n.setDate(n.getDate() + r.number);
      break;
  }
  return n;
}
const dl = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} month",
  "periods.year": "{{amount}} year",
  "periods.day": "{{amount}} day",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "lifetime",
  "periods.weekPlural": "{{amount}} weeks",
  "periods.monthPlural": "{{amount}} months",
  "periods.yearPlural": "{{amount}} years",
  "periods.dayPlural": "{{amount}} days",
  "periods.weekFrequency": "weekly",
  "periods.monthFrequency": "monthly",
  "periods.yearFrequency": "yearly",
  "periods.dayFrequency": "daily",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per month",
  "periods.perYearFrequency": "per year",
  "periods.perDayFrequency": "per day",
  "periods.unknownFrequency": "unknown",
  "periods.weekFrequencyPlural": "every {{amount}} weeks",
  "periods.monthFrequencyPlural": "every {{amount}} months",
  "periods.yearFrequencyPlural": "every {{amount}} years",
  "periods.dayFrequencyPlural": "every {{amount}} days",
  "state_present_offer.subscribe_to": "Subscribe to",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "Free for {{trialDuration}}",
  "state_present_offer.price_after_free_trial": "After trial ends, on {{renewalDate}}",
  "state_present_offer.total_due_today": "Total due today",
  "state_present_offer.renewal_frequency": "Renews {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Continues until cancelled",
  "state_present_offer.cancel_anytime": "Cancel anytime",
  "state_needs_auth_info.email_step_title": "What's your email?",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Continue",
  "state_needs_payment_info.payment_step_title": "Secure checkout by RevenueCat",
  "state_needs_payment_info.terms_info": "By providing your card information you allow {{appName}} to charge your card for future payments in accordance with their terms.",
  "state_needs_payment_info.trial_info": "After your trial ends, you will be charged {{price}} {{perFrequency}} starting {{renewalDate}}. You can always cancel before then.",
  "state_needs_payment_info.button_pay": "Pay now",
  "state_needs_payment_info.button_start_trial": "Start trial",
  "state_success.purchase_successful": "Payment complete",
  "state_success.subscription_now_active": "Your subscription is now active",
  "state_success.button_close": "Continue",
  "state_error.if_error_persists": "If the error persists, please contact ",
  "state_error.error_title_already_subscribed": "Already Subscribed",
  "state_error.error_title_already_purchased": "Already Purchased",
  "state_error.error_title_other_errors": "Something went wrong",
  "state_error.error_message_already_subscribed": "You are already subscribed to this product.",
  "state_error.error_message_already_purchased": "You have already purchased this product.",
  "state_error.error_message_missing_email_error": "Email is required to complete the purchase.",
  "state_error.error_message_network_error": "Network error. Please check your internet connection.",
  "state_error.error_message_error_charging_payment": "Payment failed.",
  "state_error.error_message_error_setting_up_purchase": "Purchase not started due to an error. Error code: {{errorCode}}",
  "state_error.error_message_unknown_error": "An unknown error occurred. Error code: {{errorCode}}",
  "state_error.button_try_again": "Try again",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% off",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Back"
}, _l = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} año",
  "periods.day": "{{amount}} día",
  "periods.weekShort": "{{amount}} sem",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}año",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de por vida",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} años",
  "periods.dayPlural": "{{amount}} días",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diaria",
  "periods.unknownFrequency": "desconocida",
  "periods.weekFrequencyPlural": "cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "cada {{amount}} meses",
  "periods.yearFrequencyPlural": "cada {{amount}} años",
  "periods.dayFrequencyPlural": "cada {{amount}} días",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} prueba gratuita",
  "state_present_offer.price_after_free_trial": "Después de que termine el periodo de prueba, el {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Se renueva {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Continua hasta que se cancele",
  "state_present_offer.cancel_anytime": "Cancelar en cualquier momento",
  "state_needs_auth_info.email_step_title": "¿Cuál es tu correo electrónico?",
  "state_needs_auth_info.email_input_label": "Correo electrónico",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Continuar",
  "state_needs_payment_info.payment_step_title": "Pago seguro mediante RevenueCat",
  "state_needs_payment_info.terms_info": "Al proporcionar la información de tu tarjeta, permites que {{appName}} cobre en tu tarjeta por pagos futuros de acuerdo con sus términos.",
  "state_needs_payment_info.button_pay": "Pagar ahora",
  "state_needs_payment_info.button_start_trial": "Comenzar prueba",
  "state_success.purchase_successful": "Pago completado",
  "state_success.subscription_now_active": "Tu suscripción está ahora activa",
  "state_success.button_close": "Continuar",
  "state_error.if_error_persists": "Si el error persiste, contacta con ",
  "state_error.error_title_already_subscribed": "Ya suscrito",
  "state_error.error_title_already_purchased": "Ya comprado",
  "state_error.error_title_other_errors": "Algo salió mal",
  "state_error.error_message_already_subscribed": "Ya estás suscrito a este producto.",
  "state_error.error_message_already_purchased": "Ya has comprado este producto.",
  "state_error.error_message_missing_email_error": "Se requiere un correo electrónico para completar la compra.",
  "state_error.error_message_network_error": "Error de red. Por favor, comprueba tu conexión a internet.",
  "state_error.error_message_error_charging_payment": "Pago fallido.",
  "state_error.error_message_error_setting_up_purchase": "La compra no se inició debido a un error. Código de error: {{errorCode}}",
  "state_error.error_message_unknown_error": "Se produjo un error desconocido. Código de error: {{errorCode}}",
  "state_error.button_try_again": "Intentar de nuevo",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de descuento",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Total a pagar hoy",
  "state_present_offer.subscribe_to": "Suscribirse a",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mes",
  "periods.perYearFrequency": "por año",
  "periods.perDayFrequency": "por día",
  "state_needs_payment_info.trial_info": "Una vez finalizado el período de prueba, se le cobrará {{price}} {{perFrequency}} a partir del {{renewalDate}}. Puede cancelar en cualquier momento antes de esa fecha.",
  "navbar_header.details": "Detalles",
  "navbar_header.back_button": "Atrás"
}, pl = {
  "periods.week": "{{amount}} settimana",
  "periods.month": "{{amount}} mese",
  "periods.year": "{{amount}} anno",
  "periods.day": "{{amount}} giorno",
  "periods.weekShort": "{{amount}}sett",
  "periods.monthShort": "{{amount}}mese",
  "periods.yearShort": "{{amount}}anno",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "a vita",
  "periods.weekPlural": "{{amount}} settimane",
  "periods.monthPlural": "{{amount}} mesi",
  "periods.yearPlural": "{{amount}} anni",
  "periods.dayPlural": "{{amount}} giorni",
  "periods.weekFrequency": "settimanale",
  "periods.monthFrequency": "mensile",
  "periods.yearFrequency": "annuale",
  "periods.dayFrequency": "giornaliero",
  "periods.unknownFrequency": "sconosciuto",
  "periods.weekFrequencyPlural": "ogni {{amount}} settimane",
  "periods.monthFrequencyPlural": "ogni {{amount}} mesi",
  "periods.yearFrequencyPlural": "ogni {{amount}} anni",
  "periods.dayFrequencyPlural": "ogni {{amount}} giorni",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} prova gratuita",
  "state_present_offer.price_after_free_trial": "Dopo la fine della prova, il {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Si rinnova {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Continua fino a disdetta",
  "state_present_offer.cancel_anytime": "Disdici in qualsiasi momento",
  "state_needs_auth_info.email_step_title": "Qual è la tua email?",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Continua",
  "state_needs_payment_info.payment_step_title": "Pagamento sicuro tramite RevenueCat",
  "state_needs_payment_info.terms_info": "Fornendo i dati della tua carta, autorizzi {{appName}} ad addebitare sulla tua carta i pagamenti futuri in conformità con i suoi termini.",
  "state_needs_payment_info.button_pay": "Paga ora",
  "state_needs_payment_info.button_start_trial": "Inizia la prova",
  "state_success.purchase_successful": "Pagamento completato",
  "state_success.subscription_now_active": "L'abbonamento è ora attivo",
  "state_success.button_close": "Continua",
  "state_error.if_error_persists": "Se l'errore persiste, contatta ",
  "state_error.error_title_already_subscribed": "Già iscritto",
  "state_error.error_title_already_purchased": "Già acquistato",
  "state_error.error_title_other_errors": "Qualcosa è andato storto",
  "state_error.error_message_already_subscribed": "Sei già iscritto a questo prodotto.",
  "state_error.error_message_already_purchased": "Hai già acquistato questo prodotto.",
  "state_error.error_message_missing_email_error": "L'email è necessaria per completare l'acquisto.",
  "state_error.error_message_network_error": "Errore di rete. Verifica la connessione internet.",
  "state_error.error_message_error_charging_payment": "Pagamento fallito.",
  "state_error.error_message_error_setting_up_purchase": "Acquisto non avviato a causa di un errore. Codice errore: {{errorCode}}",
  "state_error.error_message_unknown_error": "Si è verificato un errore sconosciuto. Codice errore: {{errorCode}}",
  "state_error.button_try_again": "Riprova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% di sconto",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Totale dovuto oggi",
  "state_present_offer.subscribe_to": "Abbonati a",
  "periods.perWeekFrequency": "a settimana",
  "periods.perMonthFrequency": "al mese",
  "periods.perYearFrequency": "all'anno",
  "periods.perDayFrequency": "al giorno",
  "state_needs_payment_info.trial_info": "Al termine del periodo di prova, ti verranno addebitati {{price}} {{perFrequency}} a partire dal {{renewalDate}}. Puoi annullare in qualsiasi momento prima di allora.",
  "navbar_header.details": "Dettagli",
  "navbar_header.back_button": "Indietro"
}, fl = {
  "periods.week": "{{amount}} أسبوع",
  "periods.month": "{{amount}} شهر",
  "periods.year": "{{amount}} سنة",
  "periods.day": "{{amount}} يوم",
  "periods.weekShort": "{{amount}}أسبوع",
  "periods.monthShort": "{{amount}}شهر",
  "periods.yearShort": "{{amount}}سنة",
  "periods.dayShort": "{{amount}}يوم",
  "periods.lifetime": "مدى الحياة",
  "periods.weekPlural": "{{amount}} أسابيع",
  "periods.monthPlural": "{{amount}} أشهر",
  "periods.yearPlural": "{{amount}} سنوات",
  "periods.dayPlural": "{{amount}} أيام",
  "periods.weekFrequency": "أسبوعيًا",
  "periods.monthFrequency": "شهريًا",
  "periods.yearFrequency": "سنويًا",
  "periods.dayFrequency": "يوميًا",
  "periods.unknownFrequency": "غير معروف",
  "periods.weekFrequencyPlural": "كل {{amount}} أسابيع",
  "periods.monthFrequencyPlural": "كل {{amount}} أشهر",
  "periods.yearFrequencyPlural": "كل {{amount}} سنوات",
  "periods.dayFrequencyPlural": "كل {{amount}} أيام",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} تجربة مجانية",
  "state_present_offer.price_after_free_trial": "بعد انتهاء التجربة، في {{renewalDate}}",
  "state_present_offer.renewal_frequency": "يتم التجديد {{frequency}}",
  "state_present_offer.continues_until_cancelled": "يستمر حتى يتم إلغاؤه",
  "state_present_offer.cancel_anytime": "يمكن الإلغاء في أي وقت",
  "state_needs_auth_info.email_step_title": "ما هو بريدك الإلكتروني؟",
  "state_needs_auth_info.email_input_label": "البريد الإلكتروني",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "متابعة",
  "state_needs_payment_info.payment_step_title": "الدفع الآمن عبر RevenueCat",
  "state_needs_payment_info.terms_info": "بتقديم معلومات بطاقتك، فإنك تسمح لـ {{appName}} بتحصيل الرسوم من بطاقتك مقابل المدفوعات المستقبلية وفقًا لشروطها.",
  "state_needs_payment_info.button_pay": "ادفع الآن",
  "state_needs_payment_info.button_start_trial": "ابدأ التجربة",
  "state_success.purchase_successful": "تم الدفع بنجاح",
  "state_success.subscription_now_active": "اشتراكك نشط الآن",
  "state_success.button_close": "متابعة",
  "state_error.if_error_persists": "إذا استمرت المشكلة، يرجى الاتصال بـ ",
  "state_error.error_title_already_subscribed": "مشترك بالفعل",
  "state_error.error_title_already_purchased": "تم الشراء بالفعل",
  "state_error.error_title_other_errors": "حدث خطأ ما",
  "state_error.error_message_already_subscribed": "أنت مشترك بالفعل في هذا المنتج.",
  "state_error.error_message_already_purchased": "لقد قمت بالفعل بشراء هذا المنتج.",
  "state_error.error_message_missing_email_error": "يُطلب البريد الإلكتروني لإتمام عملية الشراء.",
  "state_error.error_message_network_error": "خطأ في الشبكة. يرجى التحقق من اتصال الإنترنت.",
  "state_error.error_message_error_charging_payment": "فشل الدفع.",
  "state_error.error_message_error_setting_up_purchase": "لم يبدأ الشراء بسبب خطأ. رمز الخطأ: {{errorCode}}",
  "state_error.error_message_unknown_error": "حدث خطأ غير معروف. رمز الخطأ: {{errorCode}}",
  "state_error.button_try_again": "حاول مرة أخرى",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% خصم",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "إجمالي المبلغ المستحق اليوم",
  "state_present_offer.subscribe_to": "اشترك في",
  "periods.perWeekFrequency": "في الأسبوع",
  "periods.perMonthFrequency": "في الشهر",
  "periods.perYearFrequency": "في السنة",
  "periods.perDayFrequency": "في اليوم",
  "state_needs_payment_info.trial_info": "بعد انتهاء الفترة التجريبية، سيتم محاسبتك بمبلغ {{price}} {{perFrequency}} بدءًا من {{renewalDate}}. يمكنك الإلغاء دائمًا قبل ذلك.",
  "navbar_header.details": "تفاصيل",
  "navbar_header.back_button": "عودة"
}, ml = {
  "periods.week": "{{amount}} setmana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} any",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}set",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}any",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de per vida",
  "periods.weekPlural": "{{amount}} setmanes",
  "periods.monthPlural": "{{amount}} mesos",
  "periods.yearPlural": "{{amount}} anys",
  "periods.dayPlural": "{{amount}} dies",
  "periods.weekFrequency": "setmanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diari",
  "periods.unknownFrequency": "desconeguda",
  "periods.weekFrequencyPlural": "cada {{amount}} setmanes",
  "periods.monthFrequencyPlural": "cada {{amount}} mesos",
  "periods.yearFrequencyPlural": "cada {{amount}} anys",
  "periods.dayFrequencyPlural": "cada {{amount}} dies",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} de prova gratuïta",
  "state_present_offer.price_after_free_trial": "Després del període de prova, el {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Es renova {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Continua fins que es cancel·li",
  "state_present_offer.cancel_anytime": "Cancel·la en qualsevol moment",
  "state_needs_auth_info.email_step_title": "Quin és el teu correu electrònic?",
  "state_needs_auth_info.email_input_label": "Correu electrònic",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Continua",
  "state_needs_payment_info.payment_step_title": "Pagament segur amb RevenueCat",
  "state_needs_payment_info.terms_info": "En proporcionar la teva informació de targeta, permets a {{appName}} carregar la teva targeta per a futurs pagaments d'acord amb els seus termes.",
  "state_needs_payment_info.button_pay": "Paga ara",
  "state_needs_payment_info.button_start_trial": "Comença la prova",
  "state_success.purchase_successful": "Pagament complet",
  "state_success.subscription_now_active": "La teva subscripció ja està activa",
  "state_success.button_close": "Continua",
  "state_error.if_error_persists": "Si l'error persisteix, contacta amb ",
  "state_error.error_title_already_subscribed": "Ja subscrit",
  "state_error.error_title_already_purchased": "Ja comprat",
  "state_error.error_title_other_errors": "Alguna cosa ha anat malament",
  "state_error.error_message_already_subscribed": "Ja estàs subscrit a aquest producte.",
  "state_error.error_message_already_purchased": "Ja has comprat aquest producte.",
  "state_error.error_message_missing_email_error": "Es necessita un correu electrònic per completar la compra.",
  "state_error.error_message_network_error": "Error de xarxa. Comprova la teva connexió a internet.",
  "state_error.error_message_error_charging_payment": "El pagament ha fallat.",
  "state_error.error_message_error_setting_up_purchase": "La compra no s'ha iniciat a causa d'un error. Codi d'error: {{errorCode}}",
  "state_error.error_message_unknown_error": "S'ha produït un error desconegut. Codi d'error: {{errorCode}}",
  "state_error.button_try_again": "Torna a intentar-ho",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de descompte",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Total a pagar avui",
  "state_present_offer.subscribe_to": "Subscriu-te a",
  "periods.perWeekFrequency": "per setmana",
  "periods.perMonthFrequency": "per mes",
  "periods.perYearFrequency": "per any",
  "periods.perDayFrequency": "per dia",
  "state_needs_payment_info.trial_info": "Un cop finalitzi el període de prova, se us cobrarà {{price}} {{perFrequency}} a partir del {{renewalDate}}. Sempre podeu cancel·lar abans d'aquesta data.",
  "navbar_header.details": "Detalls",
  "navbar_header.back_button": "Enrere"
}, hl = {
  "periods.week": "{{amount}} 周",
  "periods.month": "{{amount}} 月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}周",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "终身",
  "periods.weekPlural": "{{amount}} 周",
  "periods.monthPlural": "{{amount}} 个月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每周",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 周",
  "periods.monthFrequencyPlural": "每 {{amount}} 个月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} 天免费试用",
  "state_present_offer.price_after_free_trial": "试用期结束后，于 {{renewalDate}}",
  "state_present_offer.renewal_frequency": "续订 {{frequency}}",
  "state_present_offer.continues_until_cancelled": "持续到取消",
  "state_present_offer.cancel_anytime": "随时取消",
  "state_needs_auth_info.email_step_title": "您的邮箱地址是什么？",
  "state_needs_auth_info.email_input_label": "邮箱",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "继续",
  "state_needs_payment_info.payment_step_title": "RevenueCat 安全结账",
  "state_needs_payment_info.terms_info": "通过提供您的卡信息，您允许 {{appName}} 根据其条款向您的卡收取未来付款。",
  "state_needs_payment_info.button_pay": "立即支付",
  "state_needs_payment_info.button_start_trial": "开始试用",
  "state_success.purchase_successful": "支付完成",
  "state_success.subscription_now_active": "您的订阅现已生效",
  "state_success.button_close": "继续",
  "state_error.if_error_persists": "如果错误仍然存在，请联系 ",
  "state_error.error_title_already_subscribed": "已订阅",
  "state_error.error_title_already_purchased": "已购买",
  "state_error.error_title_other_errors": "出现错误",
  "state_error.error_message_already_subscribed": "您已订阅此产品。",
  "state_error.error_message_already_purchased": "您已购买此产品。",
  "state_error.error_message_missing_email_error": "完成购买需要邮箱地址。",
  "state_error.error_message_network_error": "网络错误。请检查您的互联网连接。",
  "state_error.error_message_error_charging_payment": "支付失败。",
  "state_error.error_message_error_setting_up_purchase": "由于错误，未开始购买。错误代码：{{errorCode}}",
  "state_error.error_message_unknown_error": "发生未知错误。错误代码：{{errorCode}}",
  "state_error.button_try_again": "重试",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% 折扣",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "今天应付总额",
  "state_present_offer.subscribe_to": "订阅",
  "periods.perWeekFrequency": "每周",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "state_needs_payment_info.trial_info": "试用期结束后，您将被收取 {{price}} {{perFrequency}}，从 {{renewalDate}} 开始。您可以随时在此之前取消。",
  "navbar_header.details": "详情",
  "navbar_header.back_button": "返回"
}, gl = {
  "periods.week": "{{amount}} 週",
  "periods.month": "{{amount}} 個月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "終身",
  "periods.weekPlural": "{{amount}} 週",
  "periods.monthPlural": "{{amount}} 個月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每週",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 週",
  "periods.monthFrequencyPlural": "每 {{amount}} 個月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} 天免費試用",
  "state_present_offer.price_after_free_trial": "試用期結束後，於 {{renewalDate}}",
  "state_present_offer.renewal_frequency": "每 {{frequency}} 續約",
  "state_present_offer.continues_until_cancelled": "持續到取消",
  "state_present_offer.cancel_anytime": "隨時取消",
  "state_needs_auth_info.email_step_title": "您的電子郵件地址？",
  "state_needs_auth_info.email_input_label": "電子郵件",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "繼續",
  "state_needs_payment_info.payment_step_title": "RevenueCat 安全結帳",
  "state_needs_payment_info.terms_info": "提供您的卡號即表示您允許 {{appName}} 依照其條款向您的卡收取未來付款。",
  "state_needs_payment_info.button_pay": "立即付款",
  "state_needs_payment_info.button_start_trial": "開始試用",
  "state_success.purchase_successful": "付款完成",
  "state_success.subscription_now_active": "您的訂閱現已啟用",
  "state_success.button_close": "繼續",
  "state_error.if_error_persists": "如果錯誤持續存在，請聯絡 ",
  "state_error.error_title_already_subscribed": "已訂閱",
  "state_error.error_title_already_purchased": "已購買",
  "state_error.error_title_other_errors": "發生錯誤",
  "state_error.error_message_already_subscribed": "您已訂閱此產品。",
  "state_error.error_message_already_purchased": "您已購買此產品。",
  "state_error.error_message_missing_email_error": "完成購買需要電子郵件地址。",
  "state_error.error_message_network_error": "網路錯誤。請檢查您的網路連線。",
  "state_error.error_message_error_charging_payment": "付款失敗。",
  "state_error.error_message_error_setting_up_purchase": "因錯誤而未開始購買。錯誤碼：{{errorCode}}",
  "state_error.error_message_unknown_error": "發生未知錯誤。錯誤碼：{{errorCode}}",
  "state_error.button_try_again": "再試一次",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% 折扣",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "今日應付總額",
  "state_present_offer.subscribe_to": "訂閱",
  "periods.perWeekFrequency": "每週",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "state_needs_payment_info.trial_info": "在您的試用期結束後，您將從 {{renewalDate}} 開始被收取 {{price}} {{perFrequency}} 的費用。您隨時可以在此之前取消。",
  "navbar_header.details": "詳細資訊",
  "navbar_header.back_button": "返回"
}, yl = {
  "periods.week": "{{amount}} tjedan",
  "periods.month": "{{amount}} mjesec",
  "periods.year": "{{amount}} godina",
  "periods.day": "{{amount}} dan",
  "periods.weekShort": "{{amount}}tj",
  "periods.monthShort": "{{amount}}mj",
  "periods.yearShort": "{{amount}}g",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotno",
  "periods.weekPlural": "{{amount}} tjedana",
  "periods.monthPlural": "{{amount}} mjeseci",
  "periods.yearPlural": "{{amount}} godina",
  "periods.dayPlural": "{{amount}} dana",
  "periods.weekFrequency": "tjedno",
  "periods.monthFrequency": "mjesečno",
  "periods.yearFrequency": "godišnje",
  "periods.dayFrequency": "dnevno",
  "periods.unknownFrequency": "nepoznato",
  "periods.weekFrequencyPlural": "svakih {{amount}} tjedana",
  "periods.monthFrequencyPlural": "svakih {{amount}} mjeseci",
  "periods.yearFrequencyPlural": "svakih {{amount}} godina",
  "periods.dayFrequencyPlural": "svakih {{amount}} dana",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} besplatno probno razdoblje",
  "state_present_offer.price_after_free_trial": "Nakon isteka probnog razdoblja, {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Obnavlja se {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Nastavlja se dok se ne otkaže",
  "state_present_offer.cancel_anytime": "Otkažite u bilo kojem trenutku",
  "state_needs_auth_info.email_step_title": "Vaša e-pošta?",
  "state_needs_auth_info.email_input_label": "E-pošta",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Nastavi",
  "state_needs_payment_info.payment_step_title": "Sigurna naplata putem RevenueCat",
  "state_needs_payment_info.terms_info": "Davanjem podataka o kartici dopuštate {{appName}} naplatu s vaše kartice za buduće uplate u skladu s njihovim uvjetima.",
  "state_needs_payment_info.button_pay": "Plati sada",
  "state_needs_payment_info.button_start_trial": "Počni probno razdoblje",
  "state_success.purchase_successful": "Uplata je uspješna",
  "state_success.subscription_now_active": "Vaša pretplata je sada aktivna",
  "state_success.button_close": "Nastavi",
  "state_error.if_error_persists": "Ako se pogreška nastavi, obratite se ",
  "state_error.error_title_already_subscribed": "Već pretplaćeni",
  "state_error.error_title_already_purchased": "Već kupljeno",
  "state_error.error_title_other_errors": "Nešto je pošlo po zlu",
  "state_error.error_message_already_subscribed": "Već ste pretplaćeni na ovaj proizvod.",
  "state_error.error_message_already_purchased": "Već ste kupili ovaj proizvod.",
  "state_error.error_message_missing_email_error": "E-pošta je potrebna za dovršetak kupnje.",
  "state_error.error_message_network_error": "Mrežna pogreška. Provjerite internetsku vezu.",
  "state_error.error_message_error_charging_payment": "Plaćanje nije uspjelo.",
  "state_error.error_message_error_setting_up_purchase": "Kupnja nije započela zbog pogreške. Šifra pogreške: {{errorCode}}",
  "state_error.error_message_unknown_error": "Dogodila se nepoznata pogreška. Šifra pogreške: {{errorCode}}",
  "state_error.button_try_again": "Pokušaj ponovno",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% popusta",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Ukupno dospijeće danas",
  "state_present_offer.subscribe_to": "Pretplatite se",
  "periods.perWeekFrequency": "tjedno",
  "periods.perMonthFrequency": "mjesečno",
  "periods.perYearFrequency": "godišnje",
  "periods.perDayFrequency": "dnevno",
  "state_needs_payment_info.trial_info": "Nakon završetka probnog razdoblja, bit će vam naplaćeno {{price}} {{perFrequency}} počevši od {{renewalDate}}. Uvijek možete otkazati prije toga.",
  "navbar_header.details": "Detalji",
  "navbar_header.back_button": "Natrag"
}, bl = {
  "periods.week": "{{amount}} týden",
  "periods.month": "{{amount}} měsíc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} den",
  "periods.weekShort": "{{amount}}týd",
  "periods.monthShort": "{{amount}}měs",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotně",
  "periods.weekPlural": "{{amount}} týdnů",
  "periods.monthPlural": "{{amount}} měsíců",
  "periods.yearPlural": "{{amount}} let",
  "periods.dayPlural": "{{amount}} dnů",
  "periods.weekFrequency": "týdně",
  "periods.monthFrequency": "měsíčně",
  "periods.yearFrequency": "ročně",
  "periods.dayFrequency": "denně",
  "periods.unknownFrequency": "neznámé",
  "periods.weekFrequencyPlural": "každých {{amount}} týdnů",
  "periods.monthFrequencyPlural": "každých {{amount}} měsíců",
  "periods.yearFrequencyPlural": "každých {{amount}} let",
  "periods.dayFrequencyPlural": "každých {{amount}} dnů",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} zkušební verze zdarma",
  "state_present_offer.price_after_free_trial": "Po skončení zkušební verze, {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Obnovuje se {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Pokračuje, dokud není zrušeno",
  "state_present_offer.cancel_anytime": "Zrušit kdykoli",
  "state_needs_auth_info.email_step_title": "Jaká je vaše e-mailová adresa?",
  "state_needs_auth_info.email_input_label": "E-mail",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Pokračovat",
  "state_needs_payment_info.payment_step_title": "Bezpečné placení přes RevenueCat",
  "state_needs_payment_info.terms_info": "Poskytnutím informací o vaší kartě umožňujete aplikaci {{appName}} účtovat vaši kartu za budoucí platby v souladu s jejich podmínkami.",
  "state_needs_payment_info.button_pay": "Platit nyní",
  "state_needs_payment_info.button_start_trial": "Spustit zkušební verzi",
  "state_success.purchase_successful": "Platba dokončena",
  "state_success.subscription_now_active": "Vaše předplatné je nyní aktivní",
  "state_success.button_close": "Pokračovat",
  "state_error.if_error_persists": "Pokud chyba přetrvává, kontaktujte ",
  "state_error.error_title_already_subscribed": "Již přihlášen k odběru",
  "state_error.error_title_already_purchased": "Již zakoupeno",
  "state_error.error_title_other_errors": "Něco se pokazilo",
  "state_error.error_message_already_subscribed": "Již jste přihlášeni k odběru tohoto produktu.",
  "state_error.error_message_already_purchased": "Tento produkt jste již zakoupili.",
  "state_error.error_message_missing_email_error": "Pro dokončení nákupu je vyžadován e-mail.",
  "state_error.error_message_network_error": "Síťová chyba. Zkontrolujte prosím své internetové připojení.",
  "state_error.error_message_error_charging_payment": "Platba selhala.",
  "state_error.error_message_error_setting_up_purchase": "Nákup nebyl zahájen kvůli chybě. Kód chyby: {{errorCode}}",
  "state_error.error_message_unknown_error": "Došlo k neznámé chybě. Kód chyby: {{errorCode}}",
  "state_error.button_try_again": "Zkusit znovu",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% sleva",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Celkem dnes k zaplacení",
  "state_present_offer.subscribe_to": "Předplatit",
  "periods.perWeekFrequency": "týdně",
  "periods.perMonthFrequency": "měsíčně",
  "periods.perYearFrequency": "ročně",
  "periods.perDayFrequency": "denně",
  "state_needs_payment_info.trial_info": "Po skončení zkušební verze vám bude účtováno {{price}} {{perFrequency}} počínaje {{renewalDate}}. Předtím můžete kdykoli zrušit.",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Zpět"
}, vl = {
  "periods.week": "{{amount}} uge",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}ug",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uger",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dage",
  "periods.weekFrequency": "ugentligt",
  "periods.monthFrequency": "månedligt",
  "periods.yearFrequency": "årligt",
  "periods.dayFrequency": "dagligt",
  "periods.unknownFrequency": "ukendt",
  "periods.weekFrequencyPlural": "hver {{amount}} uger",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dage",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "state_present_offer.price_after_free_trial": "Efter prøveperioden slutter, den {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Fornyes {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Fortsætter indtil annulleret",
  "state_present_offer.cancel_anytime": "Annuller når som helst",
  "state_needs_auth_info.email_step_title": "Hvad er din email?",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Fortsæt",
  "state_needs_payment_info.payment_step_title": "Sikker betaling via RevenueCat",
  "state_needs_payment_info.terms_info": "Ved at angive dine kortinformationer giver du {{appName}} tilladelse til at trække beløb på dit kort for fremtidige betalinger i overensstemmelse med deres vilkår.",
  "state_needs_payment_info.button_pay": "Betal nu",
  "state_needs_payment_info.button_start_trial": "Start prøveperiode",
  "state_success.purchase_successful": "Betaling gennemført",
  "state_success.subscription_now_active": "Dit abonnement er nu aktivt",
  "state_success.button_close": "Fortsæt",
  "state_error.if_error_persists": "Hvis fejlen fortsætter, kontakt venligst ",
  "state_error.error_title_already_subscribed": "Allerede abonneret",
  "state_error.error_title_already_purchased": "Allerede købt",
  "state_error.error_title_other_errors": "Noget gik galt",
  "state_error.error_message_already_subscribed": "Du er allerede abonneret på dette produkt.",
  "state_error.error_message_already_purchased": "Du har allerede købt dette produkt.",
  "state_error.error_message_missing_email_error": "Email er påkrævet for at gennemføre købet.",
  "state_error.error_message_network_error": "Netværksfejl. Kontroller din internetforbindelse.",
  "state_error.error_message_error_charging_payment": "Betalingen mislykkedes.",
  "state_error.error_message_error_setting_up_purchase": "Købet blev ikke startet på grund af en fejl. Fejlkode: {{errorCode}}",
  "state_error.error_message_unknown_error": "En ukendt fejl opstod. Fejlkode: {{errorCode}}",
  "state_error.button_try_again": "Prøv igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% rabat",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Samlet beløb for i dag",
  "state_present_offer.subscribe_to": "Abonner på",
  "periods.perWeekFrequency": "pr. uge",
  "periods.perMonthFrequency": "pr. måned",
  "periods.perYearFrequency": "pr. år",
  "periods.perDayFrequency": "pr. dag",
  "state_needs_payment_info.trial_info": "Efter din prøveperiode slutter, vil du blive opkrævet {{price}} {{perFrequency}} fra {{renewalDate}}. Du kan altid opsige før da.",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbage"
}, kl = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} maand",
  "periods.year": "{{amount}} jaar",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}maand",
  "periods.yearShort": "{{amount}}jr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "levenslang",
  "periods.weekPlural": "{{amount}} weken",
  "periods.monthPlural": "{{amount}} maanden",
  "periods.yearPlural": "{{amount}} jaren",
  "periods.dayPlural": "{{amount}} dagen",
  "periods.weekFrequency": "wekelijks",
  "periods.monthFrequency": "maandelijks",
  "periods.yearFrequency": "jaarlijks",
  "periods.dayFrequency": "dagelijks",
  "periods.unknownFrequency": "onbekend",
  "periods.weekFrequencyPlural": "elke {{amount}} weken",
  "periods.monthFrequencyPlural": "elke {{amount}} maanden",
  "periods.yearFrequencyPlural": "elke {{amount}} jaren",
  "periods.dayFrequencyPlural": "elke {{amount}} dagen",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} gratis proefperiode",
  "state_present_offer.price_after_free_trial": "Na afloop van de proefperiode, op {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Wordt verlengd {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Wordt voortgezet tot annulering",
  "state_present_offer.cancel_anytime": "Annuleer op elk gewenst moment",
  "state_needs_auth_info.email_step_title": "Wat is uw e-mailadres?",
  "state_needs_auth_info.email_input_label": "E-mailadres",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Doorgaan",
  "state_needs_payment_info.payment_step_title": "Veilige afrekening via RevenueCat",
  "state_needs_payment_info.terms_info": "Door uw kaartgegevens te verstrekken, staat u {{appName}} toe om uw kaart te belasten voor toekomstige betalingen in overeenstemming met hun voorwaarden.",
  "state_needs_payment_info.button_pay": "Nu betalen",
  "state_needs_payment_info.button_start_trial": "Start proefperiode",
  "state_success.purchase_successful": "Betaling voltooid",
  "state_success.subscription_now_active": "Uw abonnement is nu actief",
  "state_success.button_close": "Doorgaan",
  "state_error.if_error_persists": "Neem contact op met  als de fout aanhoudt",
  "state_error.error_title_already_subscribed": "Al geabonneerd",
  "state_error.error_title_already_purchased": "Al gekocht",
  "state_error.error_title_other_errors": "Er is iets misgegaan",
  "state_error.error_message_already_subscribed": "U bent al geabonneerd op dit product.",
  "state_error.error_message_already_purchased": "U heeft dit product al gekocht.",
  "state_error.error_message_missing_email_error": "Een e-mailadres is vereist om de aankoop te voltooien.",
  "state_error.error_message_network_error": "Netwerkfout. Controleer uw internetverbinding.",
  "state_error.error_message_error_charging_payment": "Betaling mislukt.",
  "state_error.error_message_error_setting_up_purchase": "Aankoop niet gestart vanwege een fout. Foutcode: {{errorCode}}",
  "state_error.error_message_unknown_error": "Er is een onbekende fout opgetreden. Foutcode: {{errorCode}}",
  "state_error.button_try_again": "Opnieuw proberen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% korting",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Totaal te betalen vandaag",
  "state_present_offer.subscribe_to": "Abonneren op",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per maand",
  "periods.perYearFrequency": "per jaar",
  "periods.perDayFrequency": "per dag",
  "state_needs_payment_info.trial_info": "Na afloop van je proefperiode wordt {{price}} {{perFrequency}} in rekening gebracht vanaf {{renewalDate}}. Je kunt altijd eerder annuleren.",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Terug"
}, wl = {
  "periods.week": "{{amount}} viikko",
  "periods.month": "{{amount}} kuukausi",
  "periods.year": "{{amount}} vuosi",
  "periods.day": "{{amount}} päivä",
  "periods.weekShort": "{{amount}}vk",
  "periods.monthShort": "{{amount}}kk",
  "periods.yearShort": "{{amount}}v",
  "periods.dayShort": "{{amount}}p",
  "periods.lifetime": "elämäaika",
  "periods.weekPlural": "{{amount}} viikkoa",
  "periods.monthPlural": "{{amount}} kuukautta",
  "periods.yearPlural": "{{amount}} vuotta",
  "periods.dayPlural": "{{amount}} päivää",
  "periods.weekFrequency": "viikoittain",
  "periods.monthFrequency": "kuukausittain",
  "periods.yearFrequency": "vuosittain",
  "periods.dayFrequency": "päivittäin",
  "periods.unknownFrequency": "tuntematon",
  "periods.weekFrequencyPlural": "joka {{amount}} viikko",
  "periods.monthFrequencyPlural": "joka {{amount}} kuukausi",
  "periods.yearFrequencyPlural": "joka {{amount}} vuosi",
  "periods.dayFrequencyPlural": "joka {{amount}} päivä",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} ilmainen kokeilujakso",
  "state_present_offer.price_after_free_trial": "Kokeilujakson päätyttyä, {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Uusiutuu {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Jatkuu, kunnes peruutetaan",
  "state_present_offer.cancel_anytime": "Peruuta milloin tahansa",
  "state_needs_auth_info.email_step_title": "Mikä on sähköpostiosoitteesi?",
  "state_needs_auth_info.email_input_label": "Sähköposti",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Jatka",
  "state_needs_payment_info.payment_step_title": "Suojautunut kassatoiminto RevenueCatin kautta",
  "state_needs_payment_info.terms_info": "Antamalla korttitietosi annat {{appName}} -sovellukselle luvan veloittaa korttiasi tulevien maksujen osalta heidän ehtojensa mukaisesti.",
  "state_needs_payment_info.button_pay": "Maksa nyt",
  "state_needs_payment_info.button_start_trial": "Aloita kokeilujakso",
  "state_success.purchase_successful": "Maksaminen onnistui",
  "state_success.subscription_now_active": "Tilauksesi on nyt aktiivinen",
  "state_success.button_close": "Jatka",
  "state_error.if_error_persists": "Jos virhe jatkuu, ota yhteyttä ",
  "state_error.error_title_already_subscribed": "Jo tilaaja",
  "state_error.error_title_already_purchased": "Jo ostettu",
  "state_error.error_title_other_errors": "Jokin meni pieleen",
  "state_error.error_message_already_subscribed": "Olet jo tilannut tämän tuotteen.",
  "state_error.error_message_already_purchased": "Olet jo ostanut tämän tuotteen.",
  "state_error.error_message_missing_email_error": "Sähköpostiosoite tarvitaan ostoksen loppuun saattamiseksi.",
  "state_error.error_message_network_error": "Verkkovirhe. Tarkista internet-yhteytesi.",
  "state_error.error_message_error_charging_payment": "Maksaminen epäonnistui.",
  "state_error.error_message_error_setting_up_purchase": "Ostoa ei aloitettu virheen vuoksi. Virhekoodi: {{errorCode}}",
  "state_error.error_message_unknown_error": "Tuntematon virhe tapahtui. Virhekoodi: {{errorCode}}",
  "state_error.button_try_again": "Yritä uudelleen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% alennus",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Maksettava summa tänään",
  "state_present_offer.subscribe_to": "Tilaa",
  "periods.perWeekFrequency": "viikossa",
  "periods.perMonthFrequency": "kuukaudessa",
  "periods.perYearFrequency": "vuodessa",
  "periods.perDayFrequency": "päivässä",
  "state_needs_payment_info.trial_info": "Kokeilujakson päätyttyä sinulta veloitetaan {{price}} {{perFrequency}} alkaen {{renewalDate}}. Voit peruuttaa tilauksen milloin tahansa ennen sitä.",
  "navbar_header.details": "Yksityiskohdat",
  "navbar_header.back_button": "Takaisin"
}, Pl = {
  "periods.week": "{{amount}} semaine",
  "periods.month": "{{amount}} mois",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} jour",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mois",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}j",
  "periods.lifetime": "à vie",
  "periods.weekPlural": "{{amount}} semaines",
  "periods.monthPlural": "{{amount}} mois",
  "periods.yearPlural": "{{amount}} ans",
  "periods.dayPlural": "{{amount}} jours",
  "periods.weekFrequency": "hebdomadaire",
  "periods.monthFrequency": "mensuel",
  "periods.yearFrequency": "annuel",
  "periods.dayFrequency": "quotidien",
  "periods.unknownFrequency": "inconnu",
  "periods.weekFrequencyPlural": "toutes les {{amount}} semaines",
  "periods.monthFrequencyPlural": "tous les {{amount}} mois",
  "periods.yearFrequencyPlural": "tous les {{amount}} ans",
  "periods.dayFrequencyPlural": "tous les {{amount}} jours",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} essai gratuit",
  "state_present_offer.price_after_free_trial": "Après la fin de l'essai, le {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Renouvellement {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Continue jusqu'à annulation",
  "state_present_offer.cancel_anytime": "Annulez à tout moment",
  "state_needs_auth_info.email_step_title": "Quelle est votre adresse e-mail?",
  "state_needs_auth_info.email_input_label": "E-mail",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Continuer",
  "state_needs_payment_info.payment_step_title": "Paiement sécurisé par RevenueCat",
  "state_needs_payment_info.terms_info": "En fournissant vos informations de carte, vous autorisez {{appName}} à débiter votre carte pour les paiements futurs conformément à ses conditions.",
  "state_needs_payment_info.button_pay": "Payer maintenant",
  "state_needs_payment_info.button_start_trial": "Commencer l'essai",
  "state_success.purchase_successful": "Paiement effectué",
  "state_success.subscription_now_active": "Votre abonnement est maintenant actif",
  "state_success.button_close": "Continuer",
  "state_error.if_error_persists": "Si l'erreur persiste, veuillez contacter ",
  "state_error.error_title_already_subscribed": "Déjà abonné",
  "state_error.error_title_already_purchased": "Déjà acheté",
  "state_error.error_title_other_errors": "Une erreur s'est produite",
  "state_error.error_message_already_subscribed": "Vous êtes déjà abonné à ce produit.",
  "state_error.error_message_already_purchased": "Vous avez déjà acheté ce produit.",
  "state_error.error_message_missing_email_error": "L'adresse e-mail est requise pour effectuer l'achat.",
  "state_error.error_message_network_error": "Erreur réseau. Veuillez vérifier votre connexion Internet.",
  "state_error.error_message_error_charging_payment": "Échec du paiement.",
  "state_error.error_message_error_setting_up_purchase": "Achat non démarré en raison d'une erreur. Code d'erreur : {{errorCode}}",
  "state_error.error_message_unknown_error": "Une erreur inconnue s'est produite. Code d'erreur : {{errorCode}}",
  "state_error.button_try_again": "Réessayer",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de réduction",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Total dû aujourd'hui",
  "state_present_offer.subscribe_to": "S'abonner à",
  "periods.perWeekFrequency": "par semaine",
  "periods.perMonthFrequency": "par mois",
  "periods.perYearFrequency": "par an",
  "periods.perDayFrequency": "par jour",
  "state_needs_payment_info.trial_info": "Après la fin de votre essai, vous serez facturé {{price}} {{perFrequency}} à partir du {{renewalDate}}. Vous pouvez annuler à tout moment avant cette date.",
  "navbar_header.details": "Détails",
  "navbar_header.back_button": "Retour"
}, xl = {
  "periods.week": "{{amount}} Woche",
  "periods.month": "{{amount}} Monat",
  "periods.year": "{{amount}} Jahr",
  "periods.day": "{{amount}} Tag",
  "periods.weekShort": "{{amount}}Wo",
  "periods.monthShort": "{{amount}}Mo",
  "periods.yearShort": "{{amount}}J",
  "periods.dayShort": "{{amount}}T",
  "periods.lifetime": "lebenslang",
  "periods.weekPlural": "{{amount}} Wochen",
  "periods.monthPlural": "{{amount}} Monate",
  "periods.yearPlural": "{{amount}} Jahre",
  "periods.dayPlural": "{{amount}} Tage",
  "periods.weekFrequency": "wöchentlich",
  "periods.monthFrequency": "monatlich",
  "periods.yearFrequency": "jährlich",
  "periods.dayFrequency": "täglich",
  "periods.unknownFrequency": "unbekannt",
  "periods.weekFrequencyPlural": "alle {{amount}} Wochen",
  "periods.monthFrequencyPlural": "alle {{amount}} Monate",
  "periods.yearFrequencyPlural": "alle {{amount}} Jahre",
  "periods.dayFrequencyPlural": "alle {{amount}} Tage",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} kostenlose Testversion",
  "state_present_offer.price_after_free_trial": "Nach Ablauf der Testversion, am {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Verlängert sich {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Läuft bis zur Kündigung",
  "state_present_offer.cancel_anytime": "Jederzeit kündbar",
  "state_needs_auth_info.email_step_title": "Wie lautet Ihre E-Mail-Adresse?",
  "state_needs_auth_info.email_input_label": "E-Mail",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Weiter",
  "state_needs_payment_info.payment_step_title": "Sicherer Checkout über RevenueCat",
  "state_needs_payment_info.terms_info": "Durch die Angabe Ihrer Karteninformationen erlauben Sie {{appName}}, Ihre Karte gemäß deren Bedingungen für zukünftige Zahlungen zu belasten.",
  "state_needs_payment_info.button_pay": "Jetzt bezahlen",
  "state_needs_payment_info.button_start_trial": "Testversion starten",
  "state_success.purchase_successful": "Zahlung abgeschlossen",
  "state_success.subscription_now_active": "Ihr Abonnement ist jetzt aktiv",
  "state_success.button_close": "Weiter",
  "state_error.if_error_persists": "Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an ",
  "state_error.error_title_already_subscribed": "Bereits abonniert",
  "state_error.error_title_already_purchased": "Bereits gekauft",
  "state_error.error_title_other_errors": "Etwas ist schief gelaufen",
  "state_error.error_message_already_subscribed": "Sie haben dieses Produkt bereits abonniert.",
  "state_error.error_message_already_purchased": "Sie haben dieses Produkt bereits gekauft.",
  "state_error.error_message_missing_email_error": "Für den Kauf ist eine E-Mail-Adresse erforderlich.",
  "state_error.error_message_network_error": "Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.",
  "state_error.error_message_error_charging_payment": "Zahlung fehlgeschlagen.",
  "state_error.error_message_error_setting_up_purchase": "Der Kauf konnte aufgrund eines Fehlers nicht gestartet werden. Fehlercode: {{errorCode}}",
  "state_error.error_message_unknown_error": "Ein unbekannter Fehler ist aufgetreten. Fehlercode: {{errorCode}}",
  "state_error.button_try_again": "Erneut versuchen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% Rabatt",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Heute fälliger Gesamtbetrag",
  "state_present_offer.subscribe_to": "Abonnieren",
  "periods.perWeekFrequency": "pro Woche",
  "periods.perMonthFrequency": "pro Monat",
  "periods.perYearFrequency": "pro Jahr",
  "periods.perDayFrequency": "pro Tag",
  "state_needs_payment_info.trial_info": "Nach Ablauf Ihres Testzeitraums werden Ihnen {{price}} {{perFrequency}} ab dem {{renewalDate}} berechnet. Sie können jederzeit vorher kündigen.",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Zurück"
}, Sl = {
  "periods.week": "{{amount}} εβδομάδα",
  "periods.month": "{{amount}} μήνας",
  "periods.year": "{{amount}} χρόνος",
  "periods.day": "{{amount}} ημέρα",
  "periods.weekShort": "{{amount}} εβδ.",
  "periods.monthShort": "{{amount}} μήν.",
  "periods.yearShort": "{{amount}} έτ.",
  "periods.dayShort": "{{amount}} ημ.",
  "periods.lifetime": "διάρκεια ζωής",
  "periods.weekPlural": "{{amount}} εβδομάδες",
  "periods.monthPlural": "{{amount}} μήνες",
  "periods.yearPlural": "{{amount}} χρόνια",
  "periods.dayPlural": "{{amount}} ημέρες",
  "periods.weekFrequency": "εβδομαδιαία",
  "periods.monthFrequency": "μηνιαία",
  "periods.yearFrequency": "ετήσια",
  "periods.dayFrequency": "καθημερινά",
  "periods.perWeekFrequency": "ανά εβδομάδα",
  "periods.perMonthFrequency": "ανά μήνα",
  "periods.perYearFrequency": "ανά έτος",
  "periods.perDayFrequency": "ανά ημέρα",
  "periods.unknownFrequency": "άγνωστο",
  "periods.weekFrequencyPlural": "κάθε {{amount}} εβδομάδες",
  "periods.monthFrequencyPlural": "κάθε {{amount}} μήνες",
  "periods.yearFrequencyPlural": "κάθε {{amount}} χρόνια",
  "periods.dayFrequencyPlural": "κάθε {{amount}} ημέρες",
  "state_present_offer.subscribe_to": "Εγγραφείτε στο",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "Δωρεάν για {{trialDuration}}",
  "state_present_offer.price_after_free_trial": "Μετά τη λήξη της δοκιμής, στις {{renewalDate}}",
  "state_present_offer.total_due_today": "Σύνολο πληρωτέο σήμερα",
  "state_present_offer.renewal_frequency": "Ανανεώνεται {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Συνεχίζεται μέχρι την ακύρωση",
  "state_present_offer.cancel_anytime": "Ακύρωση ανά πάσα στιγμή",
  "state_needs_auth_info.email_step_title": "Ποιο είναι το email σας;",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Συνέχεια",
  "state_needs_payment_info.payment_step_title": "Ασφαλής ολοκλήρωση αγοράς από την RevenueCat",
  "state_needs_payment_info.terms_info": "Με την παροχή των στοιχείων της κάρτας σας, επιτρέπετε στην {{appName}} να χρεώσει την κάρτα σας για μελλοντικές πληρωμές σύμφωνα με τους όρους της.",
  "state_needs_payment_info.button_pay": "Πληρωμή τώρα",
  "state_needs_payment_info.button_start_trial": "Έναρξη δοκιμής",
  "state_success.purchase_successful": "Η πληρωμή ολοκληρώθηκε",
  "state_success.subscription_now_active": "Η συνδρομή σας είναι πλέον ενεργή",
  "state_success.button_close": "Συνέχεια",
  "state_error.if_error_persists": "Εάν το σφάλμα παραμένει, επικοινωνήστε με ",
  "state_error.error_title_already_subscribed": "Έχετε ήδη εγγραφεί",
  "state_error.error_title_already_purchased": "Έχετε ήδη αγοράσει",
  "state_error.error_title_other_errors": "Κάτι πήγε στραβά",
  "state_error.error_message_already_subscribed": "Έχετε ήδη εγγραφεί σε αυτό το προϊόν.",
  "state_error.error_message_already_purchased": "Έχετε ήδη αγοράσει αυτό το προϊόν.",
  "state_error.error_message_missing_email_error": "Απαιτείται email για την ολοκλήρωση της αγοράς.",
  "state_error.error_message_network_error": "Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο.",
  "state_error.error_message_error_charging_payment": "Η πληρωμή απέτυχε.",
  "state_error.error_message_error_setting_up_purchase": "Η αγορά δεν ξεκίνησε λόγω σφάλματος. Κωδικός σφάλματος: {{errorCode}}",
  "state_error.error_message_unknown_error": "Παρουσιάστηκε άγνωστο σφάλμα. Κωδικός σφάλματος: {{errorCode}}",
  "state_error.button_try_again": "Προσπαθήστε ξανά",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% έκπτωση",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_needs_payment_info.trial_info": "Μετά τη λήξη της δοκιμαστικής περιόδου, θα χρεωθείτε {{price}} {{perFrequency}} ξεκινώντας από {{renewalDate}}. Μπορείτε να ακυρώσετε ανά πάσα στιγμή πριν από αυτό.",
  "navbar_header.details": "Λεπτομέρειες",
  "navbar_header.back_button": "Πίσω"
}, El = {
  "periods.week": "{{amount}} שבוע",
  "periods.month": "{{amount}} חודש",
  "periods.year": "{{amount}} שנה",
  "periods.day": "{{amount}} יום",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "למשך כל החיים",
  "periods.weekPlural": "{{amount}} שבועות",
  "periods.monthPlural": "{{amount}} חודשים",
  "periods.yearPlural": "{{amount}} שנים",
  "periods.dayPlural": "{{amount}} ימים",
  "periods.weekFrequency": "שבועי",
  "periods.monthFrequency": "חודשי",
  "periods.yearFrequency": "שנתי",
  "periods.dayFrequency": "יומי",
  "periods.unknownFrequency": "לא ידוע",
  "periods.weekFrequencyPlural": "כל {{amount}} שבועות",
  "periods.monthFrequencyPlural": "כל {{amount}} חודשים",
  "periods.yearFrequencyPlural": "כל {{amount}} שנים",
  "periods.dayFrequencyPlural": "כל {{amount}} ימים",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} ניסיון חינם",
  "state_present_offer.price_after_free_trial": "לאחר סיום הניסיון, ב-{{renewalDate}}",
  "state_present_offer.renewal_frequency": "מתחדש {{frequency}}",
  "state_present_offer.continues_until_cancelled": "נמשך עד ביטול",
  "state_present_offer.cancel_anytime": "ניתן לבטל בכל עת",
  "state_needs_auth_info.email_step_title": 'מה כתובת הדוא"ל שלך?',
  "state_needs_auth_info.email_input_label": 'דוא"ל',
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "המשך",
  "state_needs_payment_info.payment_step_title": "קופה מאובטחת באמצעות RevenueCat",
  "state_needs_payment_info.terms_info": "על ידי מתן פרטי הכרטיס שלך אתה מאפשר ל-{{appName}} לחייב את הכרטיס שלך עבור תשלומים עתידיים בהתאם לתנאים שלהם.",
  "state_needs_payment_info.button_pay": "שלם עכשיו",
  "state_needs_payment_info.button_start_trial": "התחל ניסיון",
  "state_success.purchase_successful": "התשלום הושלם",
  "state_success.subscription_now_active": "המנוי שלך פעיל כעת",
  "state_success.button_close": "המשך",
  "state_error.if_error_persists": "אם השגיאה נמשכת, אנא פנה אל ",
  "state_error.error_title_already_subscribed": "מנוי קיים",
  "state_error.error_title_already_purchased": "רכישה קיימת",
  "state_error.error_title_other_errors": "משהו השתבש",
  "state_error.error_message_already_subscribed": "אתה כבר מנוי למוצר זה.",
  "state_error.error_message_already_purchased": "כבר רכשת מוצר זה.",
  "state_error.error_message_missing_email_error": 'דוא"ל נדרש כדי להשלים את הרכישה.',
  "state_error.error_message_network_error": "שגיאת רשת. אנא בדוק את חיבור האינטרנט שלך.",
  "state_error.error_message_error_charging_payment": "התשלום נכשל.",
  "state_error.error_message_error_setting_up_purchase": "הרכישה לא התחילה עקב שגיאה. קוד שגיאה: {{errorCode}}",
  "state_error.error_message_unknown_error": "אירעה שגיאה לא ידועה. קוד שגיאה: {{errorCode}}",
  "state_error.button_try_again": "נסה שוב",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% הנחה",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": 'סה"כ לתשלום היום',
  "state_present_offer.subscribe_to": "הירשם כמנוי ל-",
  "periods.perWeekFrequency": "לשבוע",
  "periods.perMonthFrequency": "לחודש",
  "periods.perYearFrequency": "לשנה",
  "periods.perDayFrequency": "ליום",
  "state_needs_payment_info.trial_info": "לאחר סיום תקופת הניסיון שלך, תחויב בסך {{price}} {{perFrequency}} החל מ-{{renewalDate}}. תמיד תוכל לבטל לפני כן.",
  "navbar_header.details": "פרטים",
  "navbar_header.back_button": "חזרה"
}, ql = {
  "periods.week": "{{amount}} सप्ताह",
  "periods.month": "{{amount}} महीना",
  "periods.year": "{{amount}} वर्ष",
  "periods.day": "{{amount}} दिन",
  "periods.weekShort": "{{amount}}सप्ताह",
  "periods.monthShort": "{{amount}}महीना",
  "periods.yearShort": "{{amount}}वर्ष",
  "periods.dayShort": "{{amount}}दिन",
  "periods.lifetime": "लाइफ़टाइम",
  "periods.weekPlural": "{{amount}} सप्ताह",
  "periods.monthPlural": "{{amount}} महीने",
  "periods.yearPlural": "{{amount}} वर्ष",
  "periods.dayPlural": "{{amount}} दिन",
  "periods.weekFrequency": "साप्ताहिक",
  "periods.monthFrequency": "मासिक",
  "periods.yearFrequency": "वार्षिक",
  "periods.dayFrequency": "दैनिक",
  "periods.unknownFrequency": "अज्ञात",
  "periods.weekFrequencyPlural": "प्रत्येक {{amount}} सप्ताह",
  "periods.monthFrequencyPlural": "प्रत्येक {{amount}} महीने",
  "periods.yearFrequencyPlural": "प्रत्येक {{amount}} वर्ष",
  "periods.dayFrequencyPlural": "प्रत्येक {{amount}} दिन",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} निःशुल्क परीक्षण",
  "state_present_offer.price_after_free_trial": "परीक्षण समाप्त होने के बाद, {{renewalDate}} को",
  "state_present_offer.renewal_frequency": "{{frequency}} पर नवीनीकृत होता है",
  "state_present_offer.continues_until_cancelled": "रद्द होने तक जारी रहता है",
  "state_present_offer.cancel_anytime": "किसी भी समय रद्द करें",
  "state_needs_auth_info.email_step_title": "आपका ईमेल क्या है?",
  "state_needs_auth_info.email_input_label": "ईमेल",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "जारी रखें",
  "state_needs_payment_info.payment_step_title": "RevenueCat द्वारा सुरक्षित चेकआउट",
  "state_needs_payment_info.terms_info": "अपनी कार्ड जानकारी प्रदान करके आप {{appName}} को उनकी शर्तों के अनुसार भविष्य के भुगतानों के लिए आपके कार्ड से शुल्क लेने की अनुमति देते हैं।",
  "state_needs_payment_info.button_pay": "अभी भुगतान करें",
  "state_needs_payment_info.button_start_trial": "परीक्षण प्रारंभ करें",
  "state_success.purchase_successful": "भुगतान पूर्ण",
  "state_success.subscription_now_active": "आपकी सदस्यता अब सक्रिय है",
  "state_success.button_close": "जारी रखें",
  "state_error.if_error_persists": "यदि त्रुटि बनी रहती है, तो कृपया संपर्क करें ",
  "state_error.error_title_already_subscribed": "पहले से ही सदस्यता प्राप्त है",
  "state_error.error_title_already_purchased": "पहले से ही खरीदा गया है",
  "state_error.error_title_other_errors": "कुछ गलत हो गया",
  "state_error.error_message_already_subscribed": "आप पहले से ही इस उत्पाद की सदस्यता ले चुके हैं।",
  "state_error.error_message_already_purchased": "आप पहले ही इस उत्पाद को खरीद चुके हैं।",
  "state_error.error_message_missing_email_error": "खरीद को पूरा करने के लिए ईमेल आवश्यक है।",
  "state_error.error_message_network_error": "नेटवर्क त्रुटि। कृपया अपना इंटरनेट कनेक्शन जांचें।",
  "state_error.error_message_error_charging_payment": "भुगतान विफल।",
  "state_error.error_message_error_setting_up_purchase": "त्रुटि के कारण खरीद शुरू नहीं हुई। त्रुटि कोड: {{errorCode}}",
  "state_error.error_message_unknown_error": "एक अज्ञात त्रुटि हुई। त्रुटि कोड: {{errorCode}}",
  "state_error.button_try_again": "फिर से कोशिश करें",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% छूट",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "आज देय कुल राशि",
  "state_present_offer.subscribe_to": "सदस्यता लें",
  "periods.perWeekFrequency": "प्रति सप्ताह",
  "periods.perMonthFrequency": "प्रति माह",
  "periods.perYearFrequency": "प्रति वर्ष",
  "periods.perDayFrequency": "प्रति दिन",
  "state_needs_payment_info.trial_info": "आपकी परीक्षण अवधि समाप्त होने के बाद, आपसे {{renewalDate}} से शुरू होकर {{price}} {{perFrequency}} शुल्क लिया जाएगा. आप तब से पहले हमेशा रद्द कर सकते हैं.",
  "navbar_header.details": "विवरण",
  "navbar_header.back_button": "वापस"
}, Fl = {
  "periods.week": "{{amount}} hét",
  "periods.month": "{{amount}} hónap",
  "periods.year": "{{amount}} év",
  "periods.day": "{{amount}} nap",
  "periods.weekShort": "{{amount}}hét",
  "periods.monthShort": "{{amount}}hó",
  "periods.yearShort": "{{amount}}év",
  "periods.dayShort": "{{amount}}n",
  "periods.lifetime": "életre szóló",
  "periods.weekPlural": "{{amount}} hét",
  "periods.monthPlural": "{{amount}} hónap",
  "periods.yearPlural": "{{amount}} év",
  "periods.dayPlural": "{{amount}} nap",
  "periods.weekFrequency": "heti",
  "periods.monthFrequency": "havi",
  "periods.yearFrequency": "éves",
  "periods.dayFrequency": "napi",
  "periods.unknownFrequency": "ismeretlen",
  "periods.weekFrequencyPlural": "minden {{amount}} hétben",
  "periods.monthFrequencyPlural": "minden {{amount}} hónapban",
  "periods.yearFrequencyPlural": "minden {{amount}} évben",
  "periods.dayFrequencyPlural": "minden {{amount}} napban",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} próbaidőszak",
  "state_present_offer.price_after_free_trial": "A próbaidőszak vége után, {{renewalDate}}-kor",
  "state_present_offer.renewal_frequency": "{{frequency}} gyakorisággal megújul",
  "state_present_offer.continues_until_cancelled": "Folytatódik, amíg le nem mondják",
  "state_present_offer.cancel_anytime": "Bármikor lemondható",
  "state_needs_auth_info.email_step_title": "Mi az email címed?",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Tovább",
  "state_needs_payment_info.payment_step_title": "Biztonságos fizetés a RevenueCat-en keresztül",
  "state_needs_payment_info.terms_info": "A kártyaadataid megadásával engedélyezed a {{appName}} számára, hogy a feltételeiknek megfelelően a jövőbeni fizetésekhez terhelje a kártyádat.",
  "state_needs_payment_info.button_pay": "Fizetés most",
  "state_needs_payment_info.button_start_trial": "Próbaidőszak indítása",
  "state_success.purchase_successful": "Fizetés sikeres",
  "state_success.subscription_now_active": "Az előfizetésed aktív",
  "state_success.button_close": "Tovább",
  "state_error.if_error_persists": "Ha a hiba továbbra is fennáll, kérjük, vedd fel a kapcsolatot ",
  "state_error.error_title_already_subscribed": "Már előfizettél",
  "state_error.error_title_already_purchased": "Már megvetted",
  "state_error.error_title_other_errors": "Valami hiba történt",
  "state_error.error_message_already_subscribed": "Már előfizettél erre a termékre.",
  "state_error.error_message_already_purchased": "Már megvetted ezt a terméket.",
  "state_error.error_message_missing_email_error": "Az email cím szükséges a vásárlás befejezéséhez.",
  "state_error.error_message_network_error": "Hálózati hiba. Kérjük, ellenőrizd az internetkapcsolatodat.",
  "state_error.error_message_error_charging_payment": "A fizetés sikertelen volt.",
  "state_error.error_message_error_setting_up_purchase": "A vásárlás nem indult el egy hiba miatt. Hibakód: {{errorCode}}",
  "state_error.error_message_unknown_error": "Ismeretlen hiba történt. Hibakód: {{errorCode}}",
  "state_error.button_try_again": "Újrapróbálkozás",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% kedvezmény",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Ma fizetendő összesen",
  "state_present_offer.subscribe_to": "Feliratkozás erre:",
  "periods.perWeekFrequency": "hetente",
  "periods.perMonthFrequency": "havonta",
  "periods.perYearFrequency": "évente",
  "periods.perDayFrequency": "naponta",
  "state_needs_payment_info.trial_info": "A próbaidőszak lejárta után {{price}} {{perFrequency}} összeget számítunk fel {{renewalDate}} napjától kezdődően. Bármikor lemondhatja addig.",
  "navbar_header.details": "Részletek",
  "navbar_header.back_button": "Vissza"
}, Il = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} uji coba gratis",
  "state_present_offer.price_after_free_trial": "Setelah uji coba berakhir, pada {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Diperbarui {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Berlanjut hingga dibatalkan",
  "state_present_offer.cancel_anytime": "Batalkan kapan saja",
  "state_needs_auth_info.email_step_title": "Apa email Anda?",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Lanjutkan",
  "state_needs_payment_info.payment_step_title": "Pembayaran aman oleh RevenueCat",
  "state_needs_payment_info.terms_info": "Dengan memberikan informasi kartu Anda, Anda mengizinkan {{appName}} untuk menagih kartu Anda untuk pembayaran di masa mendatang sesuai dengan ketentuan mereka.",
  "state_needs_payment_info.button_pay": "Bayar sekarang",
  "state_needs_payment_info.button_start_trial": "Mulai Uji Coba",
  "state_success.purchase_successful": "Pembayaran selesai",
  "state_success.subscription_now_active": "Langganan Anda sekarang aktif",
  "state_success.button_close": "Lanjutkan",
  "state_error.if_error_persists": "Jika kesalahan berlanjut, silakan hubungi ",
  "state_error.error_title_already_subscribed": "Sudah Berlangganan",
  "state_error.error_title_already_purchased": "Sudah Dibeli",
  "state_error.error_title_other_errors": "Terjadi kesalahan",
  "state_error.error_message_already_subscribed": "Anda sudah berlangganan produk ini.",
  "state_error.error_message_already_purchased": "Anda sudah membeli produk ini.",
  "state_error.error_message_missing_email_error": "Email diperlukan untuk menyelesaikan pembelian.",
  "state_error.error_message_network_error": "Kesalahan jaringan. Periksa koneksi internet Anda.",
  "state_error.error_message_error_charging_payment": "Pembayaran gagal.",
  "state_error.error_message_error_setting_up_purchase": "Pembelian tidak dimulai karena kesalahan. Kode kesalahan: {{errorCode}}",
  "state_error.error_message_unknown_error": "Terjadi kesalahan yang tidak diketahui. Kode kesalahan: {{errorCode}}",
  "state_error.button_try_again": "Coba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% diskon",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Total yang harus dibayar hari ini",
  "state_present_offer.subscribe_to": "Berlangganan ke",
  "periods.perWeekFrequency": "per minggu",
  "periods.perMonthFrequency": "per bulan",
  "periods.perYearFrequency": "per tahun",
  "periods.perDayFrequency": "per hari",
  "state_needs_payment_info.trial_info": "Setelah masa percobaan Anda berakhir, Anda akan dikenakan biaya {{price}} {{perFrequency}} mulai {{renewalDate}}. Anda selalu dapat membatalkan sebelum itu.",
  "navbar_header.details": "Detail",
  "navbar_header.back_button": "Kembali"
}, Tl = {
  "periods.week": "{{amount}}週間",
  "periods.month": "{{amount}}ヶ月",
  "periods.year": "{{amount}}年",
  "periods.day": "{{amount}}日",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}ヶ月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}日",
  "periods.lifetime": "生涯",
  "periods.weekPlural": "{{amount}}週間",
  "periods.monthPlural": "{{amount}}ヶ月",
  "periods.yearPlural": "{{amount}}年",
  "periods.dayPlural": "{{amount}}日",
  "periods.weekFrequency": "毎週",
  "periods.monthFrequency": "毎月",
  "periods.yearFrequency": "毎年",
  "periods.dayFrequency": "毎日",
  "periods.unknownFrequency": "不明",
  "periods.weekFrequencyPlural": "{{amount}}週間ごと",
  "periods.monthFrequencyPlural": "{{amount}}ヶ月ごと",
  "periods.yearFrequencyPlural": "{{amount}}年ごと",
  "periods.dayFrequencyPlural": "{{amount}}日ごと",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}}日間無料トライアル",
  "state_present_offer.price_after_free_trial": "トライアル終了後、{{renewalDate}}に",
  "state_present_offer.renewal_frequency": "{{frequency}}で更新",
  "state_present_offer.continues_until_cancelled": "キャンセルされるまで継続されます",
  "state_present_offer.cancel_anytime": "いつでもキャンセルできます",
  "state_needs_auth_info.email_step_title": "メールアドレスを入力してください",
  "state_needs_auth_info.email_input_label": "メールアドレス",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "続行",
  "state_needs_payment_info.payment_step_title": "RevenueCatによる安全なチェックアウト",
  "state_needs_payment_info.terms_info": "カード情報を入力することにより、{{appName}}が利用規約に従って今後の支払いを請求することを許可します。",
  "state_needs_payment_info.button_pay": "今すぐ支払う",
  "state_needs_payment_info.button_start_trial": "トライアルを開始",
  "state_success.purchase_successful": "支払いが完了しました",
  "state_success.subscription_now_active": "購読が有効になりました",
  "state_success.button_close": "続行",
  "state_error.if_error_persists": "エラーが続く場合は、ご連絡ください。",
  "state_error.error_title_already_subscribed": "既に購読済みです",
  "state_error.error_title_already_purchased": "既に購入済みです",
  "state_error.error_title_other_errors": "エラーが発生しました",
  "state_error.error_message_already_subscribed": "この製品は既に購読されています。",
  "state_error.error_message_already_purchased": "この製品は既に購入されています。",
  "state_error.error_message_missing_email_error": "購入を完了するにはメールアドレスが必要です。",
  "state_error.error_message_network_error": "ネットワークエラーです。インターネット接続を確認してください。",
  "state_error.error_message_error_charging_payment": "支払いに失敗しました。",
  "state_error.error_message_error_setting_up_purchase": "エラーのため購入が開始されませんでした。エラーコード：{{errorCode}}",
  "state_error.error_message_unknown_error": "不明なエラーが発生しました。エラーコード：{{errorCode}}",
  "state_error.button_try_again": "再試行",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%オフ",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "本日のお支払い合計",
  "state_present_offer.subscribe_to": "購読する",
  "periods.perWeekFrequency": "週ごと",
  "periods.perMonthFrequency": "月ごと",
  "periods.perYearFrequency": "年ごと",
  "periods.perDayFrequency": "日ごと",
  "state_needs_payment_info.trial_info": "{{renewalDate}}から{{price}} {{perFrequency}}で開始され、トライアル終了後に請求されます。いつでもキャンセルできます。",
  "navbar_header.details": "詳細",
  "navbar_header.back_button": "戻る"
}, Dl = {
  "periods.week": "{{amount}}주",
  "periods.month": "{{amount}}개월",
  "periods.year": "{{amount}}년",
  "periods.day": "{{amount}}일",
  "periods.weekShort": "{{amount}}주",
  "periods.monthShort": "{{amount}}개월",
  "periods.yearShort": "{{amount}}년",
  "periods.dayShort": "{{amount}}일",
  "periods.lifetime": "평생",
  "periods.weekPlural": "{{amount}}주",
  "periods.monthPlural": "{{amount}}개월",
  "periods.yearPlural": "{{amount}}년",
  "periods.dayPlural": "{{amount}}일",
  "periods.weekFrequency": "매주",
  "periods.monthFrequency": "매달",
  "periods.yearFrequency": "매년",
  "periods.dayFrequency": "매일",
  "periods.unknownFrequency": "알 수 없음",
  "periods.weekFrequencyPlural": "{{amount}}주마다",
  "periods.monthFrequencyPlural": "{{amount}}개월마다",
  "periods.yearFrequencyPlural": "{{amount}}년마다",
  "periods.dayFrequencyPlural": "{{amount}}일마다",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}}일 무료 체험",
  "state_present_offer.price_after_free_trial": "체험 종료 후, {{renewalDate}}에",
  "state_present_offer.renewal_frequency": "{{frequency}}마다 갱신",
  "state_present_offer.continues_until_cancelled": "취소될 때까지 계속됩니다.",
  "state_present_offer.cancel_anytime": "언제든지 취소 가능",
  "state_needs_auth_info.email_step_title": "이메일 주소는 무엇입니까?",
  "state_needs_auth_info.email_input_label": "이메일",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "계속",
  "state_needs_payment_info.payment_step_title": "RevenueCat을 통한 안전한 결제",
  "state_needs_payment_info.terms_info": "{{appName}}의 약관에 따라 향후 결제를 위해 귀하의 카드 정보를 제공함으로써 귀하의 카드에 요금을 청구할 수 있도록 허용합니다.",
  "state_needs_payment_info.button_pay": "지금 결제",
  "state_needs_payment_info.button_start_trial": "체험 시작",
  "state_success.purchase_successful": "결제가 완료되었습니다.",
  "state_success.subscription_now_active": "구독이 활성화되었습니다.",
  "state_success.button_close": "계속",
  "state_error.if_error_persists": "오류가 지속되면 다음으로 문의하십시오.",
  "state_error.error_title_already_subscribed": "이미 구독됨",
  "state_error.error_title_already_purchased": "이미 구매됨",
  "state_error.error_title_other_errors": "문제가 발생했습니다.",
  "state_error.error_message_already_subscribed": "이미 이 상품을 구독하고 있습니다.",
  "state_error.error_message_already_purchased": "이미 이 상품을 구매했습니다.",
  "state_error.error_message_missing_email_error": "구매를 완료하려면 이메일이 필요합니다.",
  "state_error.error_message_network_error": "네트워크 오류입니다. 인터넷 연결을 확인하십시오.",
  "state_error.error_message_error_charging_payment": "결제에 실패했습니다.",
  "state_error.error_message_error_setting_up_purchase": "오류로 인해 구매가 시작되지 않았습니다. 오류 코드: {{errorCode}}",
  "state_error.error_message_unknown_error": "알 수 없는 오류가 발생했습니다. 오류 코드: {{errorCode}}",
  "state_error.button_try_again": "다시 시도",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% 할인",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "오늘 총 결제 금액",
  "state_present_offer.subscribe_to": "구독하기",
  "periods.perWeekFrequency": "주당",
  "periods.perMonthFrequency": "월별",
  "periods.perYearFrequency": "연간",
  "periods.perDayFrequency": "매일",
  "state_needs_payment_info.trial_info": "체험 기간이 종료되면 {{renewalDate}}부터 {{price}} {{perFrequency}}가 청구됩니다. 그 전에 언제든지 취소할 수 있습니다.",
  "navbar_header.details": "세부 정보",
  "navbar_header.back_button": "뒤로"
}, Al = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} percubaan percuma",
  "state_present_offer.price_after_free_trial": "Selepas tamat percubaan, pada {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Diperbaharui {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Berterusan sehingga dibatalkan",
  "state_present_offer.cancel_anytime": "Batal bila-bila masa",
  "state_needs_auth_info.email_step_title": "Apakah emel anda?",
  "state_needs_auth_info.email_input_label": "Emel",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Teruskan",
  "state_needs_payment_info.payment_step_title": "Pembayaran selamat oleh RevenueCat",
  "state_needs_payment_info.terms_info": "Dengan memberikan maklumat kad anda, anda membenarkan {{appName}} untuk mengenakan bayaran pada kad anda untuk pembayaran masa hadapan mengikut terma mereka.",
  "state_needs_payment_info.button_pay": "Bayar sekarang",
  "state_needs_payment_info.button_start_trial": "Mula Percubaan",
  "state_success.purchase_successful": "Pembayaran selesai",
  "state_success.subscription_now_active": "Langganan anda kini aktif",
  "state_success.button_close": "Teruskan",
  "state_error.if_error_persists": "Jika ralat berterusan, sila hubungi ",
  "state_error.error_title_already_subscribed": "Sudah Langgan",
  "state_error.error_title_already_purchased": "Sudah Dibeli",
  "state_error.error_title_other_errors": "Ada sesuatu yang tidak kena",
  "state_error.error_message_already_subscribed": "Anda sudah melanggan produk ini.",
  "state_error.error_message_already_purchased": "Anda sudah membeli produk ini.",
  "state_error.error_message_missing_email_error": "Emel diperlukan untuk menyelesaikan pembelian.",
  "state_error.error_message_network_error": "Ralat rangkaian. Sila semak sambungan internet anda.",
  "state_error.error_message_error_charging_payment": "Pembayaran gagal.",
  "state_error.error_message_error_setting_up_purchase": "Pembelian tidak bermula disebabkan ralat. Kod ralat: {{errorCode}}",
  "state_error.error_message_unknown_error": "Ralat tidak diketahui berlaku. Kod ralat: {{errorCode}}",
  "state_error.button_try_again": "Cuba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% diskaun",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Jumlah yang perlu dibayar hari ini",
  "state_present_offer.subscribe_to": "Langgan",
  "periods.perWeekFrequency": "setiap minggu",
  "periods.perMonthFrequency": "setiap bulan",
  "periods.perYearFrequency": "setiap tahun",
  "periods.perDayFrequency": "setiap hari",
  "state_needs_payment_info.trial_info": "Selepas tempoh percubaan anda tamat, anda akan dikenakan bayaran sebanyak {{price}} {{perFrequency}} bermula {{renewalDate}}. Anda sentiasa boleh membatalkan sebelum itu.",
  "navbar_header.details": "Butiran",
  "navbar_header.back_button": "Kembali"
}, Cl = {
  "periods.week": "{{amount}} uke",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}uk",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uker",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dager",
  "periods.weekFrequency": "ukentlig",
  "periods.monthFrequency": "månedlig",
  "periods.yearFrequency": "årlig",
  "periods.dayFrequency": "daglig",
  "periods.unknownFrequency": "ukjent",
  "periods.weekFrequencyPlural": "hver {{amount}} uker",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dager",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "state_present_offer.price_after_free_trial": "Etter prøveperioden slutter, den {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Fornyes {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Varer til den avbestilles",
  "state_present_offer.cancel_anytime": "Avbestille når som helst",
  "state_needs_auth_info.email_step_title": "Hva er e-postadressen din?",
  "state_needs_auth_info.email_input_label": "E-post",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Fortsett",
  "state_needs_payment_info.payment_step_title": "Sikker betaling via RevenueCat",
  "state_needs_payment_info.terms_info": "Ved å oppgi kortinformasjonen din, tillater du {{appName}} å belaste kortet ditt for fremtidige betalinger i henhold til deres vilkår.",
  "state_needs_payment_info.button_pay": "Betal nå",
  "state_needs_payment_info.button_start_trial": "Start prøveperiode",
  "state_success.purchase_successful": "Betalingen er fullført",
  "state_success.subscription_now_active": "Abonnementet ditt er nå aktivt",
  "state_success.button_close": "Fortsett",
  "state_error.if_error_persists": "Hvis feilen vedvarer, vennligst kontakt ",
  "state_error.error_title_already_subscribed": "Allerede abonnert",
  "state_error.error_title_already_purchased": "Allerede kjøpt",
  "state_error.error_title_other_errors": "Noe gikk galt",
  "state_error.error_message_already_subscribed": "Du er allerede abonnert på dette produktet.",
  "state_error.error_message_already_purchased": "Du har allerede kjøpt dette produktet.",
  "state_error.error_message_missing_email_error": "E-post er nødvendig for å fullføre kjøpet.",
  "state_error.error_message_network_error": "Nettverksfeil. Vennligst sjekk internettforbindelsen din.",
  "state_error.error_message_error_charging_payment": "Betalingen mislyktes.",
  "state_error.error_message_error_setting_up_purchase": "Kjøpet ble ikke startet på grunn av en feil. Feilkode: {{errorCode}}",
  "state_error.error_message_unknown_error": "En ukjent feil oppstod. Feilkode: {{errorCode}}",
  "state_error.button_try_again": "Prøv igjen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% rabatt",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Totalt forfaller i dag",
  "state_present_offer.subscribe_to": "Abonner på",
  "periods.perWeekFrequency": "per uke",
  "periods.perMonthFrequency": "per måned",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "state_needs_payment_info.trial_info": "Etter at prøveperioden din er over, blir du belastet {{price}} {{perFrequency}} fra og med {{renewalDate}}. Du kan når som helst kansellere før det.",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbake"
}, Ml = {
  "periods.week": "{{amount}} tydzień",
  "periods.month": "{{amount}} miesiąc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} dzień",
  "periods.weekShort": "{{amount}}tydz",
  "periods.monthShort": "{{amount}}mies",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "dożywotnio",
  "periods.weekPlural": "{{amount}} tygodni",
  "periods.monthPlural": "{{amount}} miesięcy",
  "periods.yearPlural": "{{amount}} lat",
  "periods.dayPlural": "{{amount}} dni",
  "periods.weekFrequency": "tygodniowo",
  "periods.monthFrequency": "miesięcznie",
  "periods.yearFrequency": "rocznie",
  "periods.dayFrequency": "dziennie",
  "periods.unknownFrequency": "nieznany",
  "periods.weekFrequencyPlural": "co {{amount}} tygodni",
  "periods.monthFrequencyPlural": "co {{amount}} miesięcy",
  "periods.yearFrequencyPlural": "co {{amount}} lat",
  "periods.dayFrequencyPlural": "co {{amount}} dni",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} dni próbnych",
  "state_present_offer.price_after_free_trial": "Po zakończeniu okresu próbnego, dnia {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Odnawialny co {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Kontynuowane do momentu anulowania",
  "state_present_offer.cancel_anytime": "Możesz anulować w dowolnym momencie",
  "state_needs_auth_info.email_step_title": "Podaj swój adres e-mail",
  "state_needs_auth_info.email_input_label": "E-mail",
  "state_needs_auth_info.email_input_placeholder": "jan@kowalski.pl",
  "state_needs_auth_info.button_continue": "Kontynuuj",
  "state_needs_payment_info.payment_step_title": "Bezpieczna płatność przez RevenueCat",
  "state_needs_payment_info.terms_info": "Podając dane swojej karty, zezwalasz {{appName}} na obciążanie Twojej karty za przyszłe płatności zgodnie z ich regulaminem.",
  "state_needs_payment_info.button_pay": "Zapłać teraz",
  "state_needs_payment_info.button_start_trial": "Rozpocznij okres próbny",
  "state_success.purchase_successful": "Płatność zakończona",
  "state_success.subscription_now_active": "Twoja subskrypcja jest już aktywna",
  "state_success.button_close": "Kontynuuj",
  "state_error.if_error_persists": "Jeśli błąd będzie się powtarzał, skontaktuj się z ",
  "state_error.error_title_already_subscribed": "Już subskrybowany",
  "state_error.error_title_already_purchased": "Już zakupiony",
  "state_error.error_title_other_errors": "Coś poszło nie tak",
  "state_error.error_message_already_subscribed": "Jesteś już subskrybentem tego produktu.",
  "state_error.error_message_already_purchased": "Już zakupiłeś ten produkt.",
  "state_error.error_message_missing_email_error": "Adres e-mail jest wymagany do dokonania zakupu.",
  "state_error.error_message_network_error": "Błąd sieci. Sprawdź połączenie internetowe.",
  "state_error.error_message_error_charging_payment": "Płatność nieudana.",
  "state_error.error_message_error_setting_up_purchase": "Zakupu nie rozpoczęto z powodu błędu. Kod błędu: {{errorCode}}",
  "state_error.error_message_unknown_error": "Wystąpił nieznany błąd. Kod błędu: {{errorCode}}",
  "state_error.button_try_again": "Spróbuj ponownie",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% zniżki",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Do zapłaty dzisiaj",
  "state_present_offer.subscribe_to": "Subskrybuj",
  "periods.perWeekFrequency": "na tydzień",
  "periods.perMonthFrequency": "na miesiąc",
  "periods.perYearFrequency": "na rok",
  "periods.perDayFrequency": "na dzień",
  "state_needs_payment_info.trial_info": "Po zakończeniu okresu próbnego zostanie pobrana opłata w wysokości {{price}} {{perFrequency}} począwszy od {{renewalDate}}. Zawsze możesz anulować wcześniej.",
  "navbar_header.details": "Szczegóły",
  "navbar_header.back_button": "Wstecz"
}, jl = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mês",
  "periods.year": "{{amount}} ano",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mês",
  "periods.yearShort": "{{amount}}ano",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "vitalício",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} anos",
  "periods.dayPlural": "{{amount}} dias",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensal",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diário",
  "periods.unknownFrequency": "desconhecido",
  "periods.weekFrequencyPlural": "a cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "a cada {{amount}} meses",
  "periods.yearFrequencyPlural": "a cada {{amount}} anos",
  "periods.dayFrequencyPlural": "a cada {{amount}} dias",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} teste grátis",
  "state_present_offer.price_after_free_trial": "Após o término do teste, em {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Renova {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Continua até ser cancelado",
  "state_present_offer.cancel_anytime": "Cancelar a qualquer momento",
  "state_needs_auth_info.email_step_title": "Qual o seu email?",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Continuar",
  "state_needs_payment_info.payment_step_title": "Pagamento seguro pela RevenueCat",
  "state_needs_payment_info.terms_info": "Ao fornecer suas informações de cartão, você permite que o {{appName}} cobre seu cartão para pagamentos futuros de acordo com seus termos.",
  "state_needs_payment_info.button_pay": "Pagar agora",
  "state_needs_payment_info.button_start_trial": "Iniciar Teste",
  "state_success.purchase_successful": "Pagamento concluído",
  "state_success.subscription_now_active": "Sua assinatura está ativa",
  "state_success.button_close": "Continuar",
  "state_error.if_error_persists": "Se o erro persistir, entre em contato com ",
  "state_error.error_title_already_subscribed": "Já Inscrito",
  "state_error.error_title_already_purchased": "Já Comprado",
  "state_error.error_title_other_errors": "Algo deu errado",
  "state_error.error_message_already_subscribed": "Você já está inscrito neste produto.",
  "state_error.error_message_already_purchased": "Você já comprou este produto.",
  "state_error.error_message_missing_email_error": "Email é necessário para concluir a compra.",
  "state_error.error_message_network_error": "Erro de rede. Verifique sua conexão com a internet.",
  "state_error.error_message_error_charging_payment": "Pagamento falhou.",
  "state_error.error_message_error_setting_up_purchase": "Compra não iniciada devido a um erro. Código do erro: {{errorCode}}",
  "state_error.error_message_unknown_error": "Ocorreu um erro desconhecido. Código do erro: {{errorCode}}",
  "state_error.button_try_again": "Tentar novamente",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% de desconto",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Total a pagar hoje",
  "state_present_offer.subscribe_to": "Subscrever",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mês",
  "periods.perYearFrequency": "por ano",
  "periods.perDayFrequency": "por dia",
  "state_needs_payment_info.trial_info": "Após o término do seu período de avaliação, será cobrado o valor de {{price}} {{perFrequency}} a partir de {{renewalDate}}. Você pode cancelar a qualquer momento antes disso.",
  "navbar_header.details": "Detalhes",
  "navbar_header.back_button": "Voltar"
}, Nl = {
  "periods.week": "{{amount}} săptămână",
  "periods.month": "{{amount}} lună",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} zi",
  "periods.weekShort": "{{amount}}săpt",
  "periods.monthShort": "{{amount}}lun",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}z",
  "periods.lifetime": "pe viață",
  "periods.weekPlural": "{{amount}} săptămâni",
  "periods.monthPlural": "{{amount}} luni",
  "periods.yearPlural": "{{amount}} ani",
  "periods.dayPlural": "{{amount}} zile",
  "periods.weekFrequency": "săptămânal",
  "periods.monthFrequency": "lunar",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "zilnic",
  "periods.unknownFrequency": "necunoscut",
  "periods.weekFrequencyPlural": "la fiecare {{amount}} săptămâni",
  "periods.monthFrequencyPlural": "la fiecare {{amount}} luni",
  "periods.yearFrequencyPlural": "la fiecare {{amount}} ani",
  "periods.dayFrequencyPlural": "la fiecare {{amount}} zile",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} perioadă de probă gratuită",
  "state_present_offer.price_after_free_trial": "După terminarea perioadei de probă, pe {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Se reînnoiește {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Continuă până la anulare",
  "state_present_offer.cancel_anytime": "Anulare oricând",
  "state_needs_auth_info.email_step_title": "Care este adresa dvs. de e-mail?",
  "state_needs_auth_info.email_input_label": "E-mail",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Continuă",
  "state_needs_payment_info.payment_step_title": "Plata securizată prin RevenueCat",
  "state_needs_payment_info.terms_info": "Prin furnizarea informațiilor dvs. despre card, permiteți aplicației {{appName}} să vă încarce cardul pentru plăți viitoare, în conformitate cu termenii acesteia.",
  "state_needs_payment_info.button_pay": "Plătește acum",
  "state_needs_payment_info.button_start_trial": "Începe perioada de probă",
  "state_success.purchase_successful": "Plata efectuată",
  "state_success.subscription_now_active": "Abonamentul dvs. este acum activ",
  "state_success.button_close": "Continuă",
  "state_error.if_error_persists": "Dacă eroarea persistă, vă rugăm să contactați ",
  "state_error.error_title_already_subscribed": "Deja abonat",
  "state_error.error_title_already_purchased": "Deja achiziționat",
  "state_error.error_title_other_errors": "A apărut o eroare",
  "state_error.error_message_already_subscribed": "Sunteți deja abonat la acest produs.",
  "state_error.error_message_already_purchased": "Ați achiziționat deja acest produs.",
  "state_error.error_message_missing_email_error": "Adresa de e-mail este necesară pentru a finaliza achiziția.",
  "state_error.error_message_network_error": "Eroare de rețea. Verificați conexiunea la internet.",
  "state_error.error_message_error_charging_payment": "Plata a eșuat.",
  "state_error.error_message_error_setting_up_purchase": "Achiziția nu a început din cauza unei erori. Codul erorii: {{errorCode}}",
  "state_error.error_message_unknown_error": "A apărut o eroare necunoscută. Codul erorii: {{errorCode}}",
  "state_error.button_try_again": "Încearcă din nou",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% reducere",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Total de plată astăzi",
  "state_present_offer.subscribe_to": "Abonare la",
  "periods.perWeekFrequency": "pe săptămână",
  "periods.perMonthFrequency": "pe lună",
  "periods.perYearFrequency": "pe an",
  "periods.perDayFrequency": "pe zi",
  "state_needs_payment_info.trial_info": "După ce perioada de probă se termină, veți fi taxat cu {{price}} {{perFrequency}} începând cu {{renewalDate}}. Puteți anula oricând înainte de această dată.",
  "navbar_header.details": "Detalii",
  "navbar_header.back_button": "Înapoi"
}, Ol = {
  "periods.week": "{{amount}} неделя",
  "periods.month": "{{amount}} месяц",
  "periods.year": "{{amount}} год",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}нед",
  "periods.monthShort": "{{amount}}мес",
  "periods.yearShort": "{{amount}}г",
  "periods.dayShort": "{{amount}}д",
  "periods.lifetime": "пожизненно",
  "periods.weekPlural": "{{amount}} недель",
  "periods.monthPlural": "{{amount}} месяцев",
  "periods.yearPlural": "{{amount}} лет",
  "periods.dayPlural": "{{amount}} дней",
  "periods.weekFrequency": "еженедельно",
  "periods.monthFrequency": "ежемесячно",
  "periods.yearFrequency": "ежегодно",
  "periods.dayFrequency": "ежедневно",
  "periods.unknownFrequency": "неизвестно",
  "periods.weekFrequencyPlural": "каждые {{amount}} недель",
  "periods.monthFrequencyPlural": "каждые {{amount}} месяцев",
  "periods.yearFrequencyPlural": "каждые {{amount}} лет",
  "periods.dayFrequencyPlural": "каждые {{amount}} дней",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} бесплатная пробная версия",
  "state_present_offer.price_after_free_trial": "После окончания пробного периода, {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Продлевается {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Продолжается до отмены",
  "state_present_offer.cancel_anytime": "Отменить в любое время",
  "state_needs_auth_info.email_step_title": "Укажите вашу электронную почту",
  "state_needs_auth_info.email_input_label": "Электронная почта",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Продолжить",
  "state_needs_payment_info.payment_step_title": "Безопасная оплата через RevenueCat",
  "state_needs_payment_info.terms_info": "Предоставляя данные вашей карты, вы разрешаете {{appName}} списывать средства с вашей карты для будущих платежей в соответствии с их условиями.",
  "state_needs_payment_info.button_pay": "Оплатить сейчас",
  "state_needs_payment_info.button_start_trial": "Начать пробный период",
  "state_success.purchase_successful": "Оплата завершена",
  "state_success.subscription_now_active": "Ваша подписка теперь активна",
  "state_success.button_close": "Продолжить",
  "state_error.if_error_persists": "Если ошибка сохраняется, пожалуйста, свяжитесь с ",
  "state_error.error_title_already_subscribed": "Уже подписаны",
  "state_error.error_title_already_purchased": "Уже приобретено",
  "state_error.error_title_other_errors": "Что-то пошло не так",
  "state_error.error_message_already_subscribed": "Вы уже подписаны на этот продукт.",
  "state_error.error_message_already_purchased": "Вы уже приобрели этот продукт.",
  "state_error.error_message_missing_email_error": "Для завершения покупки необходим адрес электронной почты.",
  "state_error.error_message_network_error": "Ошибка сети. Проверьте ваше интернет-соединение.",
  "state_error.error_message_error_charging_payment": "Оплата не прошла.",
  "state_error.error_message_error_setting_up_purchase": "Покупка не началась из-за ошибки. Код ошибки: {{errorCode}}",
  "state_error.error_message_unknown_error": "Произошла неизвестная ошибка. Код ошибки: {{errorCode}}",
  "state_error.button_try_again": "Повторить попытку",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% скидки",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Всего к оплате сегодня",
  "state_present_offer.subscribe_to": "Подписаться",
  "periods.perWeekFrequency": "в неделю",
  "periods.perMonthFrequency": "в месяц",
  "periods.perYearFrequency": "в год",
  "periods.perDayFrequency": "в день",
  "state_needs_payment_info.trial_info": "После окончания пробного периода с вас будет взиматься {{price}} {{perFrequency}} начиная с {{renewalDate}}. Вы всегда можете отменить подписку до этого времени.",
  "navbar_header.details": "Детали",
  "navbar_header.back_button": "Назад"
}, Rl = {
  "periods.week": "{{amount}} týždeň",
  "periods.month": "{{amount}} mesiac",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} deň",
  "periods.weekShort": "{{amount}}týž",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotne",
  "periods.weekPlural": "{{amount}} týždňov",
  "periods.monthPlural": "{{amount}} mesiacov",
  "periods.yearPlural": "{{amount}} rokov",
  "periods.dayPlural": "{{amount}} dní",
  "periods.weekFrequency": "týždenne",
  "periods.monthFrequency": "mesačne",
  "periods.yearFrequency": "ročne",
  "periods.dayFrequency": "denne",
  "periods.unknownFrequency": "neznáme",
  "periods.weekFrequencyPlural": "každých {{amount}} týždňov",
  "periods.monthFrequencyPlural": "každých {{amount}} mesiacov",
  "periods.yearFrequencyPlural": "každých {{amount}} rokov",
  "periods.dayFrequencyPlural": "každých {{amount}} dní",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} bezplatné skúšobné obdobie",
  "state_present_offer.price_after_free_trial": "Po skončení skúšobného obdobia, dňa {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Obnovuje sa {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Pokračuje, kým sa nezruší",
  "state_present_offer.cancel_anytime": "Kedykoľvek zrušiť",
  "state_needs_auth_info.email_step_title": "Aký je váš e-mail?",
  "state_needs_auth_info.email_input_label": "E-mail",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Pokračovať",
  "state_needs_payment_info.payment_step_title": "Bezpečný nákup prostredníctvom RevenueCat",
  "state_needs_payment_info.terms_info": "Poskytnutím údajov o vašej karte povoľujete {{appName}} účtovať vašu kartu za budúce platby v súlade s ich podmienkami.",
  "state_needs_payment_info.button_pay": "Zaplatiť teraz",
  "state_needs_payment_info.button_start_trial": "Spustiť skúšobné obdobie",
  "state_success.purchase_successful": "Platba dokončená",
  "state_success.subscription_now_active": "Vaše predplatné je teraz aktívne",
  "state_success.button_close": "Pokračovať",
  "state_error.if_error_persists": "Ak chyba pretrváva, kontaktujte ",
  "state_error.error_title_already_subscribed": "Už ste prihlásení k odberu",
  "state_error.error_title_already_purchased": "Už ste si to kúpili",
  "state_error.error_title_other_errors": "Niečo sa pokazilo",
  "state_error.error_message_already_subscribed": "Už ste prihlásení k odberu tohto produktu.",
  "state_error.error_message_already_purchased": "Tento produkt ste si už kúpili.",
  "state_error.error_message_missing_email_error": "Na dokončenie nákupu je potrebný e-mail.",
  "state_error.error_message_network_error": "Chyba siete. Skontrolujte svoje internetové pripojenie.",
  "state_error.error_message_error_charging_payment": "Platba zlyhala.",
  "state_error.error_message_error_setting_up_purchase": "Nákup sa nespústil kvôli chybe. Kód chyby: {{errorCode}}",
  "state_error.error_message_unknown_error": "Nastala neznáma chyba. Kód chyby: {{errorCode}}",
  "state_error.button_try_again": "Skúsiť znova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% zľava",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Celková suma splatná dnes",
  "state_present_offer.subscribe_to": "Prihlásiť sa na odber",
  "periods.perWeekFrequency": "týždenne",
  "periods.perMonthFrequency": "mesačne",
  "periods.perYearFrequency": "ročne",
  "periods.perDayFrequency": "denne",
  "state_needs_payment_info.trial_info": "Po skončení skúšobného obdobia vám bude účtovaná suma {{price}} {{perFrequency}} počnúc dňom {{renewalDate}}. Predtým môžete kedykoľvek zrušiť.",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Späť"
}, Ll = {
  "periods.week": "{{amount}} vecka",
  "periods.month": "{{amount}} månad",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}v",
  "periods.monthShort": "{{amount}}mån",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} veckor",
  "periods.monthPlural": "{{amount}} månader",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dagar",
  "periods.weekFrequency": "veckovis",
  "periods.monthFrequency": "månadsvis",
  "periods.yearFrequency": "årligen",
  "periods.dayFrequency": "dagligen",
  "periods.unknownFrequency": "okänd",
  "periods.weekFrequencyPlural": "varje {{amount}} veckor",
  "periods.monthFrequencyPlural": "varje {{amount}} månader",
  "periods.yearFrequencyPlural": "varje {{amount}} år",
  "periods.dayFrequencyPlural": "varje {{amount}} dagar",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} gratis provperiod",
  "state_present_offer.price_after_free_trial": "Efter provperioden slutar, den {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Förnyas {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Gäller tills avbokad",
  "state_present_offer.cancel_anytime": "Avboka när som helst",
  "state_needs_auth_info.email_step_title": "Vad är din e-postadress?",
  "state_needs_auth_info.email_input_label": "E-post",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Fortsätt",
  "state_needs_payment_info.payment_step_title": "Säker betalning via RevenueCat",
  "state_needs_payment_info.terms_info": "Genom att ange dina kortuppgifter tillåter du {{appName}} att debitera ditt kort för framtida betalningar i enlighet med deras villkor.",
  "state_needs_payment_info.button_pay": "Betala nu",
  "state_needs_payment_info.button_start_trial": "Starta provperiod",
  "state_success.purchase_successful": "Betalningen är klar",
  "state_success.subscription_now_active": "Din prenumeration är nu aktiv",
  "state_success.button_close": "Fortsätt",
  "state_error.if_error_persists": "Om felet kvarstår, vänligen kontakta ",
  "state_error.error_title_already_subscribed": "Redan prenumerant",
  "state_error.error_title_already_purchased": "Redan köpt",
  "state_error.error_title_other_errors": "Något gick fel",
  "state_error.error_message_already_subscribed": "Du är redan prenumerant på denna produkt.",
  "state_error.error_message_already_purchased": "Du har redan köpt denna produkt.",
  "state_error.error_message_missing_email_error": "E-post krävs för att slutföra köpet.",
  "state_error.error_message_network_error": "Nätverksfel. Kontrollera din internetanslutning.",
  "state_error.error_message_error_charging_payment": "Betalningen misslyckades.",
  "state_error.error_message_error_setting_up_purchase": "Köpet kunde inte påbörjas på grund av ett fel. Felkod: {{errorCode}}",
  "state_error.error_message_unknown_error": "Ett okänt fel uppstod. Felkod: {{errorCode}}",
  "state_error.button_try_again": "Försök igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% rabatt",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Totalt att betala idag",
  "state_present_offer.subscribe_to": "Prenumerera på",
  "periods.perWeekFrequency": "per vecka",
  "periods.perMonthFrequency": "per månad",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "state_needs_payment_info.trial_info": "Efter din provperiod avslutas debiteras du {{price}} {{perFrequency}} från och med {{renewalDate}}. Du kan alltid avbryta innan dess.",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tillbaka"
}, zl = {
  "periods.week": "{{amount}} สัปดาห์",
  "periods.month": "{{amount}} เดือน",
  "periods.year": "{{amount}} ปี",
  "periods.day": "{{amount}} วัน",
  "periods.weekShort": "{{amount}} สัปดาห์",
  "periods.monthShort": "{{amount}} เดือน",
  "periods.yearShort": "{{amount}} ปี",
  "periods.dayShort": "{{amount}} วัน",
  "periods.lifetime": "ตลอดชีพ",
  "periods.weekPlural": "{{amount}} สัปดาห์",
  "periods.monthPlural": "{{amount}} เดือน",
  "periods.yearPlural": "{{amount}} ปี",
  "periods.dayPlural": "{{amount}} วัน",
  "periods.weekFrequency": "รายสัปดาห์",
  "periods.monthFrequency": "รายเดือน",
  "periods.yearFrequency": "รายปี",
  "periods.dayFrequency": "รายวัน",
  "periods.unknownFrequency": "ไม่รู้จัก",
  "periods.weekFrequencyPlural": "ทุกๆ {{amount}} สัปดาห์",
  "periods.monthFrequencyPlural": "ทุกๆ {{amount}} เดือน",
  "periods.yearFrequencyPlural": "ทุกๆ {{amount}} ปี",
  "periods.dayFrequencyPlural": "ทุกๆ {{amount}} วัน",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} ทดลองใช้ฟรี",
  "state_present_offer.price_after_free_trial": "หลังจากสิ้นสุดการทดลองใช้ ในวันที่ {{renewalDate}}",
  "state_present_offer.renewal_frequency": "ต่ออายุ {{frequency}}",
  "state_present_offer.continues_until_cancelled": "ต่อเนื่องจนกว่าจะยกเลิก",
  "state_present_offer.cancel_anytime": "ยกเลิกได้ตลอดเวลา",
  "state_needs_auth_info.email_step_title": "อีเมลของคุณคืออะไร?",
  "state_needs_auth_info.email_input_label": "อีเมล",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "ดำเนินการต่อ",
  "state_needs_payment_info.payment_step_title": "การชำระเงินอย่างปลอดภัยโดย RevenueCat",
  "state_needs_payment_info.terms_info": "โดยการให้ข้อมูลบัตรของคุณ คุณอนุญาตให้ {{appName}} เรียกเก็บเงินจากบัตรของคุณสำหรับการชำระเงินในอนาคตตามข้อกำหนดของพวกเขา",
  "state_needs_payment_info.button_pay": "ชำระเงินตอนนี้",
  "state_needs_payment_info.button_start_trial": "เริ่มทดลองใช้",
  "state_success.purchase_successful": "การชำระเงินเสร็จสมบูรณ์",
  "state_success.subscription_now_active": "การสมัครสมาชิกของคุณใช้งานได้แล้ว",
  "state_success.button_close": "ดำเนินการต่อ",
  "state_error.if_error_persists": "หากข้อผิดพลาดยังคงอยู่ โปรดติดต่อ ",
  "state_error.error_title_already_subscribed": "สมัครสมาชิกแล้ว",
  "state_error.error_title_already_purchased": "ซื้อแล้ว",
  "state_error.error_title_other_errors": "มีบางอย่างผิดพลาด",
  "state_error.error_message_already_subscribed": "คุณสมัครสมาชิกผลิตภัณฑ์นี้แล้ว",
  "state_error.error_message_already_purchased": "คุณซื้อผลิตภัณฑ์นี้แล้ว",
  "state_error.error_message_missing_email_error": "ต้องใช้อีเมลเพื่อทำการซื้อให้เสร็จสมบูรณ์",
  "state_error.error_message_network_error": "ข้อผิดพลาดของเครือข่าย โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ",
  "state_error.error_message_error_charging_payment": "การชำระเงินล้มเหลว",
  "state_error.error_message_error_setting_up_purchase": "การซื้อไม่เริ่มต้นเนื่องจากข้อผิดพลาด รหัสข้อผิดพลาด: {{errorCode}}",
  "state_error.error_message_unknown_error": "เกิดข้อผิดพลาดที่ไม่รู้จัก รหัสข้อผิดพลาด: {{errorCode}}",
  "state_error.button_try_again": "ลองอีกครั้ง",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% ลด",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "ยอดรวมที่ต้องชำระวันนี้",
  "state_present_offer.subscribe_to": "สมัครสมาชิก",
  "periods.perWeekFrequency": "ต่อสัปดาห์",
  "periods.perMonthFrequency": "ต่อเดือน",
  "periods.perYearFrequency": "ต่อปี",
  "periods.perDayFrequency": "ต่อวัน",
  "state_needs_payment_info.trial_info": "หลังจากช่วงทดลองใช้ของคุณสิ้นสุดลง คุณจะถูกเรียกเก็บเงิน {{price}} {{perFrequency}} โดยเริ่มในวันที่ {{renewalDate}} คุณสามารถยกเลิกได้ตลอดเวลาก่อนหน้านั้น",
  "navbar_header.details": "รายละเอียด",
  "navbar_header.back_button": "ย้อนกลับ"
}, Ul = {
  "periods.week": "{{amount}} hafta",
  "periods.month": "{{amount}} ay",
  "periods.year": "{{amount}} yıl",
  "periods.day": "{{amount}} gün",
  "periods.weekShort": "{{amount}}hf",
  "periods.monthShort": "{{amount}}ay",
  "periods.yearShort": "{{amount}}yl",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "ömür boyu",
  "periods.weekPlural": "{{amount}} hafta",
  "periods.monthPlural": "{{amount}} ay",
  "periods.yearPlural": "{{amount}} yıl",
  "periods.dayPlural": "{{amount}} gün",
  "periods.weekFrequency": "haftalık",
  "periods.monthFrequency": "aylık",
  "periods.yearFrequency": "yıllık",
  "periods.dayFrequency": "günlük",
  "periods.unknownFrequency": "bilinmiyor",
  "periods.weekFrequencyPlural": "her {{amount}} haftada",
  "periods.monthFrequencyPlural": "her {{amount}} ayda",
  "periods.yearFrequencyPlural": "her {{amount}} yılda",
  "periods.dayFrequencyPlural": "her {{amount}} günde",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} ücretsiz deneme",
  "state_present_offer.price_after_free_trial": "Deneme süresi sona erdiğinde, {{renewalDate}} tarihinde",
  "state_present_offer.renewal_frequency": "{{frequency}} sıklığında yenilenir",
  "state_present_offer.continues_until_cancelled": "İptal edilene kadar devam eder",
  "state_present_offer.cancel_anytime": "İstediğiniz zaman iptal edebilirsiniz",
  "state_needs_auth_info.email_step_title": "E-postanız nedir?",
  "state_needs_auth_info.email_input_label": "E-posta",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Devam et",
  "state_needs_payment_info.payment_step_title": "RevenueCat ile güvenli ödeme",
  "state_needs_payment_info.terms_info": "Kart bilgilerinizi vererek, {{appName}}'nin şartlarına uygun olarak gelecekteki ödemeler için kartınızdan ücret almasına izin verirsiniz.",
  "state_needs_payment_info.button_pay": "Şimdi öde",
  "state_needs_payment_info.button_start_trial": "Denemeyi başlat",
  "state_success.purchase_successful": "Ödeme tamamlandı",
  "state_success.subscription_now_active": "Aboneliğiniz şimdi aktif",
  "state_success.button_close": "Devam et",
  "state_error.if_error_persists": "Hata devam ederse lütfen iletişime geçin ",
  "state_error.error_title_already_subscribed": "Zaten Abone Oldunuz",
  "state_error.error_title_already_purchased": "Zaten Satın Aldınız",
  "state_error.error_title_other_errors": "Bir şeyler ters gitti",
  "state_error.error_message_already_subscribed": "Bu ürüne zaten abonesiniz.",
  "state_error.error_message_already_purchased": "Bu ürünü zaten satın aldınız.",
  "state_error.error_message_missing_email_error": "Satın almayı tamamlamak için e-posta gereklidir.",
  "state_error.error_message_network_error": "Ağ hatası. Lütfen internet bağlantınızı kontrol edin.",
  "state_error.error_message_error_charging_payment": "Ödeme başarısız oldu.",
  "state_error.error_message_error_setting_up_purchase": "Bir hata nedeniyle satın alma başlatılamadı. Hata kodu: {{errorCode}}",
  "state_error.error_message_unknown_error": "Bilinmeyen bir hata oluştu. Hata kodu: {{errorCode}}",
  "state_error.button_try_again": "Tekrar dene",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% indirim",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Bugün ödenecek toplam tutar",
  "state_present_offer.subscribe_to": "Abone Ol",
  "periods.perWeekFrequency": "haftada",
  "periods.perMonthFrequency": "ayda",
  "periods.perYearFrequency": "yılda",
  "periods.perDayFrequency": "günde",
  "state_needs_payment_info.trial_info": "Deneme süreniz sona erdikten sonra, {{renewalDate}} tarihinden itibaren {{price}} {{perFrequency}} ücretlendirileceksiniz. O zamana kadar istediğiniz zaman iptal edebilirsiniz.",
  "navbar_header.details": "Detaylar",
  "navbar_header.back_button": "Geri"
}, Bl = {
  "periods.week": "{{amount}} тиждень",
  "periods.month": "{{amount}} місяць",
  "periods.year": "{{amount}} рік",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}тиж",
  "periods.monthShort": "{{amount}}міс",
  "periods.yearShort": "{{amount}}рік",
  "periods.dayShort": "{{amount}}дн",
  "periods.lifetime": "пожиттєво",
  "periods.weekPlural": "{{amount}} тижнів",
  "periods.monthPlural": "{{amount}} місяців",
  "periods.yearPlural": "{{amount}} років",
  "periods.dayPlural": "{{amount}} днів",
  "periods.weekFrequency": "щотижня",
  "periods.monthFrequency": "щомісяця",
  "periods.yearFrequency": "щороку",
  "periods.dayFrequency": "щодня",
  "periods.unknownFrequency": "невідомо",
  "periods.weekFrequencyPlural": "кожні {{amount}} тижнів",
  "periods.monthFrequencyPlural": "кожні {{amount}} місяців",
  "periods.yearFrequencyPlural": "кожні {{amount}} років",
  "periods.dayFrequencyPlural": "кожні {{amount}} днів",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} безкоштовний пробний період",
  "state_present_offer.price_after_free_trial": "Після закінчення пробного періоду, {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Продовжується {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Триває до скасування",
  "state_present_offer.cancel_anytime": "Можна скасувати в будь-який час",
  "state_needs_auth_info.email_step_title": "Яка ваша електронна пошта?",
  "state_needs_auth_info.email_input_label": "Електронна пошта",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Продовжити",
  "state_needs_payment_info.payment_step_title": "Безпечна оплата через RevenueCat",
  "state_needs_payment_info.terms_info": "Надаючи дані вашої картки, ви дозволяєте {{appName}} стягувати кошти з вашої картки для майбутніх платежів відповідно до їхніх умов.",
  "state_needs_payment_info.button_pay": "Оплатити зараз",
  "state_needs_payment_info.button_start_trial": "Розпочати пробний період",
  "state_success.purchase_successful": "Оплата завершена",
  "state_success.subscription_now_active": "Ваша підписка активна",
  "state_success.button_close": "Продовжити",
  "state_error.if_error_persists": "Якщо помилка повторюється, зверніться до ",
  "state_error.error_title_already_subscribed": "Вже підписано",
  "state_error.error_title_already_purchased": "Вже придбано",
  "state_error.error_title_other_errors": "Щось пішло не так",
  "state_error.error_message_already_subscribed": "Ви вже підписані на цей продукт.",
  "state_error.error_message_already_purchased": "Ви вже придбали цей продукт.",
  "state_error.error_message_missing_email_error": "Для завершення покупки потрібна електронна пошта.",
  "state_error.error_message_network_error": "Помилка мережі. Перевірте підключення до інтернету.",
  "state_error.error_message_error_charging_payment": "Оплата не пройшла.",
  "state_error.error_message_error_setting_up_purchase": "Покупка не розпочалась через помилку. Код помилки: {{errorCode}}",
  "state_error.error_message_unknown_error": "Сталася невідома помилка. Код помилки: {{errorCode}}",
  "state_error.button_try_again": "Спробувати ще раз",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% знижки",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Всього до сплати сьогодні",
  "state_present_offer.subscribe_to": "Підписатися на",
  "periods.perWeekFrequency": "на тиждень",
  "periods.perMonthFrequency": "на місяць",
  "periods.perYearFrequency": "на рік",
  "periods.perDayFrequency": "на день",
  "state_needs_payment_info.trial_info": "Після закінчення вашого пробного періоду з вас буде стягнуто {{price}} {{perFrequency}}, починаючи з {{renewalDate}}. Ви завжди можете скасувати підписку до цього часу.",
  "navbar_header.details": "Деталі",
  "navbar_header.back_button": "Назад"
}, Vl = {
  "periods.week": "{{amount}} tuần",
  "periods.month": "{{amount}} tháng",
  "periods.year": "{{amount}} năm",
  "periods.day": "{{amount}} ngày",
  "periods.weekShort": "{{amount}}tuần",
  "periods.monthShort": "{{amount}}tháng",
  "periods.yearShort": "{{amount}}năm",
  "periods.dayShort": "{{amount}}ngày",
  "periods.lifetime": "trọn đời",
  "periods.weekPlural": "{{amount}} tuần",
  "periods.monthPlural": "{{amount}} tháng",
  "periods.yearPlural": "{{amount}} năm",
  "periods.dayPlural": "{{amount}} ngày",
  "periods.weekFrequency": "hàng tuần",
  "periods.monthFrequency": "hàng tháng",
  "periods.yearFrequency": "hàng năm",
  "periods.dayFrequency": "hàng ngày",
  "periods.unknownFrequency": "không xác định",
  "periods.weekFrequencyPlural": "cứ {{amount}} tuần",
  "periods.monthFrequencyPlural": "cứ {{amount}} tháng",
  "periods.yearFrequencyPlural": "cứ {{amount}} năm",
  "periods.dayFrequencyPlural": "cứ {{amount}} ngày",
  "state_present_offer.product_title": "{{productTitle}}",
  "state_present_offer.product_description": "{{productDescription}}",
  "state_present_offer.product_price": "{{productPrice}}",
  "state_present_offer.free_trial_duration": "{{trialDuration}} dùng thử miễn phí",
  "state_present_offer.price_after_free_trial": "Sau khi dùng thử kết thúc, vào {{renewalDate}}",
  "state_present_offer.renewal_frequency": "Gia hạn {{frequency}}",
  "state_present_offer.continues_until_cancelled": "Tiếp tục cho đến khi hủy",
  "state_present_offer.cancel_anytime": "Hủy bất cứ lúc nào",
  "state_needs_auth_info.email_step_title": "Email của bạn là gì?",
  "state_needs_auth_info.email_input_label": "Email",
  "state_needs_auth_info.email_input_placeholder": "john@appleseed.com",
  "state_needs_auth_info.button_continue": "Tiếp tục",
  "state_needs_payment_info.payment_step_title": "Thanh toán an toàn bởi RevenueCat",
  "state_needs_payment_info.terms_info": "Bằng cách cung cấp thông tin thẻ của bạn, bạn cho phép {{appName}} tính phí thẻ của bạn cho các khoản thanh toán trong tương lai theo các điều khoản của họ.",
  "state_needs_payment_info.button_pay": "Thanh toán ngay",
  "state_needs_payment_info.button_start_trial": "Bắt đầu dùng thử",
  "state_success.purchase_successful": "Thanh toán hoàn tất",
  "state_success.subscription_now_active": "Đã kích hoạt đăng ký của bạn",
  "state_success.button_close": "Tiếp tục",
  "state_error.if_error_persists": "Nếu lỗi vẫn tiếp diễn, vui lòng liên hệ ",
  "state_error.error_title_already_subscribed": "Đã đăng ký",
  "state_error.error_title_already_purchased": "Đã mua",
  "state_error.error_title_other_errors": "Có lỗi xảy ra",
  "state_error.error_message_already_subscribed": "Bạn đã đăng ký sản phẩm này.",
  "state_error.error_message_already_purchased": "Bạn đã mua sản phẩm này.",
  "state_error.error_message_missing_email_error": "Email bắt buộc để hoàn tất việc mua hàng.",
  "state_error.error_message_network_error": "Lỗi mạng. Vui lòng kiểm tra kết nối internet của bạn.",
  "state_error.error_message_error_charging_payment": "Thanh toán thất bại.",
  "state_error.error_message_error_setting_up_purchase": "Không bắt đầu mua hàng do lỗi. Mã lỗi: {{errorCode}}",
  "state_error.error_message_unknown_error": "Đã xảy ra lỗi không xác định. Mã lỗi: {{errorCode}}",
  "state_error.button_try_again": "Thử lại",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}% giảm",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "state_present_offer.total_due_today": "Tổng số tiền phải trả hôm nay",
  "state_present_offer.subscribe_to": "Đăng ký",
  "periods.perWeekFrequency": "mỗi tuần",
  "periods.perMonthFrequency": "mỗi tháng",
  "periods.perYearFrequency": "mỗi năm",
  "periods.perDayFrequency": "mỗi ngày",
  "state_needs_payment_info.trial_info": "Sau khi thời gian dùng thử của bạn kết thúc, bạn sẽ bị tính phí {{price}} {{perFrequency}} bắt đầu từ {{renewalDate}}. Bạn luôn có thể hủy trước thời điểm đó.",
  "navbar_header.details": "Chi tiết",
  "navbar_header.back_button": "Quay lại"
};
var z = /* @__PURE__ */ ((e) => (e.PeriodsWeek = "periods.week", e.PeriodsMonth = "periods.month", e.PeriodsYear = "periods.year", e.PeriodsDay = "periods.day", e.PeriodsWeekShort = "periods.weekShort", e.PeriodsMonthShort = "periods.monthShort", e.PeriodsYearShort = "periods.yearShort", e.PeriodsDayShort = "periods.dayShort", e.PeriodsLifetime = "periods.lifetime", e.PeriodsWeekPlural = "periods.weekPlural", e.PeriodsMonthPlural = "periods.monthPlural", e.PeriodsYearPlural = "periods.yearPlural", e.PeriodsDayPlural = "periods.dayPlural", e.PeriodsWeekFrequency = "periods.weekFrequency", e.PeriodsMonthFrequency = "periods.monthFrequency", e.PeriodsYearFrequency = "periods.yearFrequency", e.PeriodsDayFrequency = "periods.dayFrequency", e.PeriodsPerWeekFrequency = "periods.perWeekFrequency", e.PeriodsPerMonthFrequency = "periods.perMonthFrequency", e.PeriodsPerYearFrequency = "periods.perYearFrequency", e.PeriodsPerDayFrequency = "periods.perDayFrequency", e.PeriodsUnknownFrequency = "periods.unknownFrequency", e.PeriodsWeekFrequencyPlural = "periods.weekFrequencyPlural", e.PeriodsMonthFrequencyPlural = "periods.monthFrequencyPlural", e.PeriodsYearFrequencyPlural = "periods.yearFrequencyPlural", e.PeriodsDayFrequencyPlural = "periods.dayFrequencyPlural", e.ProductInfoProductTitle = "state_present_offer.product_title", e.ProductInfoProductDescription = "state_present_offer.product_description", e.ProductInfoProductPrice = "state_present_offer.product_price", e.ProductInfoFreeTrialDuration = "state_present_offer.free_trial_duration", e.ProductInfoPriceAfterFreeTrial = "state_present_offer.price_after_free_trial", e.ProductInfoPriceTotalDueToday = "state_present_offer.total_due_today", e.ProductInfoSubscribeTo = "state_present_offer.subscribe_to", e.ProductInfoRenewalFrequency = "state_present_offer.renewal_frequency", e.ProductInfoContinuesUntilCancelled = "state_present_offer.continues_until_cancelled", e.ProductInfoCancelAnytime = "state_present_offer.cancel_anytime", e.StateNeedsAuthInfoEmailStepTitle = "state_needs_auth_info.email_step_title", e.StateNeedsAuthInfoEmailInputLabel = "state_needs_auth_info.email_input_label", e.StateNeedsAuthInfoEmailInputPlaceholder = "state_needs_auth_info.email_input_placeholder", e.StateNeedsAuthInfoButtonContinue = "state_needs_auth_info.button_continue", e.StateNeedsPaymentInfoPaymentStepTitle = "state_needs_payment_info.payment_step_title", e.StateNeedsPaymentInfoTermsInfo = "state_needs_payment_info.terms_info", e.StateNeedsPaymentInfoTrialInfo = "state_needs_payment_info.trial_info", e.StateNeedsPaymentInfoButtonPay = "state_needs_payment_info.button_pay", e.StateNeedsPaymentInfoButtonStartTrial = "state_needs_payment_info.button_start_trial", e.StateSuccessPurchaseSuccessful = "state_success.purchase_successful", e.StateSuccessSubscriptionNowActive = "state_success.subscription_now_active", e.StateSuccessButtonClose = "state_success.button_close", e.StateErrorIfErrorPersists = "state_error.if_error_persists", e.StateErrorErrorTitleAlreadySubscribed = "state_error.error_title_already_subscribed", e.StateErrorErrorTitleAlreadyPurchased = "state_error.error_title_already_purchased", e.StateErrorErrorTitleOtherErrors = "state_error.error_title_other_errors", e.StateErrorErrorMessageAlreadySubscribed = "state_error.error_message_already_subscribed", e.StateErrorErrorMessageAlreadyPurchased = "state_error.error_message_already_purchased", e.StateErrorErrorMessageMissingEmailError = "state_error.error_message_missing_email_error", e.StateErrorErrorMessageNetworkError = "state_error.error_message_network_error", e.StateErrorErrorMessageErrorChargingPayment = "state_error.error_message_error_charging_payment", e.StateErrorErrorMessageErrorSettingUpPurchase = "state_error.error_message_error_setting_up_purchase", e.StateErrorErrorMessageUnknownError = "state_error.error_message_unknown_error", e.StateErrorButtonTryAgain = "state_error.button_try_again", e.PaywallVariablesPricePerPeriod = "paywall_variables.price_per_period", e.PaywallVariablesSubRelativeDiscount = "paywall_variables.sub_relative_discount", e.PaywallVariablesTotalPriceAndPerMonth = "paywall_variables.total_price_and_per_month", e.NavbarHeaderDetails = "navbar_header.details", e.NavbarBackButton = "navbar_header.back_button", e))(z || {});
const Wl = {
  en: dl,
  es: _l,
  it: pl,
  ar: fl,
  ca: ml,
  zh_Hans: hl,
  zh_Hant: gl,
  hr: yl,
  cs: bl,
  da: vl,
  nl: kl,
  fi: wl,
  fr: Pl,
  de: xl,
  el: Sl,
  he: El,
  hi: ql,
  hu: Fl,
  id: Il,
  ja: Tl,
  ko: Dl,
  ms: Al,
  no: Cl,
  pl: Ml,
  pt: jl,
  ro: Nl,
  ru: Ol,
  sk: Rl,
  sv: Ll,
  th: zl,
  tr: Ul,
  uk: Bl,
  vi: Vl
}, Yl = (e) => e / 1e6, tt = (e, r, t, n = {}) => {
  const a = Yl(e), o = {
    style: "currency",
    currency: r,
    currencyDisplay: "symbol",
    ...n,
    // Some browsers require minimumFractionDigits to be set if maximumFractionDigits is set.
    minimumFractionDigits: n.maximumFractionDigits
  };
  return new Intl.NumberFormat(t, o).format(a).replace("US$", "$");
}, Hl = (e, r) => {
  const t = zo(e);
  return t ? r.translatePeriod(t.number, t.unit) || `${t.number} ${t.unit}s` : e;
};
var Gl = /* @__PURE__ */ ((e) => (e.Unknown = "unknown", e.Custom = "custom", e.Lifetime = "$rc_lifetime", e.Annual = "$rc_annual", e.SixMonth = "$rc_six_month", e.ThreeMonth = "$rc_three_month", e.TwoMonth = "$rc_two_month", e.Monthly = "$rc_monthly", e.Weekly = "$rc_weekly", e))(Gl || {}), Re = /* @__PURE__ */ ((e) => (e.Subscription = "subscription", e.Consumable = "consumable", e.NonConsumable = "non_consumable", e))(Re || {});
const Bo = (e) => ({
  amount: e.amount_micros / 1e4,
  amountMicros: e.amount_micros,
  currency: e.currency,
  formattedPrice: tt(e.amount_micros, e.currency)
}), ja = (e) => {
  const r = e.period_duration;
  return {
    periodDuration: r,
    period: r ? zo(r) : null,
    cycleCount: e.cycle_count,
    price: e.price ? Bo(e.price) : null
  };
}, Xl = (e) => e.base == null ? (H.debugLog("Missing base phase for subscription option. Ignoring."), null) : {
  id: e.id,
  priceId: e.price_id,
  base: ja(e.base),
  trial: e.trial ? ja(e.trial) : null
}, Jl = (e) => e.base_price == null ? (H.debugLog(
  "Missing base price for non-subscription option. Ignoring."
), null) : {
  id: e.id,
  priceId: e.price_id,
  basePrice: Bo(e.base_price)
}, Ql = (e, r) => {
  const t = e.product_type;
  return t === "subscription" ? Kl(
    e,
    r,
    t
  ) : Zl(
    e,
    r,
    t
  );
}, Zl = (e, r, t) => {
  const n = {};
  if (Object.entries(e.purchase_options).forEach(
    ([i, s]) => {
      const l = Jl(
        s
      );
      l != null && (n[i] = l);
    }
  ), Object.keys(n).length === 0)
    return H.debugLog(
      `Product ${e.identifier} has no purchase options. Ignoring.`
    ), null;
  const a = e.default_purchase_option_id, o = a && a in e.purchase_options ? n[a] : null;
  return o == null ? (H.debugLog(
    `Product ${e.identifier} has no default purchase option. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: o.basePrice,
    normalPeriodDuration: null,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: null,
    subscriptionOptions: {},
    defaultNonSubscriptionOption: o
  };
}, Kl = (e, r, t) => {
  const n = {};
  if (Object.entries(e.purchase_options).forEach(
    ([s, l]) => {
      const c = Xl(l);
      c != null && (n[s] = c);
    }
  ), Object.keys(n).length === 0)
    return H.debugLog(
      `Product ${e.identifier} has no subscription options. Ignoring.`
    ), null;
  const a = e.default_purchase_option_id, o = a && a in n ? n[a] : null;
  if (o == null)
    return H.debugLog(
      `Product ${e.identifier} has no default subscription option. Ignoring.`
    ), null;
  const i = o.base.price;
  return i == null ? (H.debugLog(
    `Product ${e.identifier} default option has no base price. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: i,
    normalPeriodDuration: o.base.periodDuration,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: o,
    subscriptionOptions: n,
    defaultNonSubscriptionOption: null
  };
}, $l = (e, r, t) => {
  const n = t[r.platform_product_identifier];
  if (n === void 0) return null;
  const a = Ql(n, e);
  return a === null ? null : {
    identifier: r.identifier,
    rcBillingProduct: a,
    webBillingProduct: a,
    packageType: rc(r.identifier)
  };
}, ec = (e, r, t, n) => {
  const a = {
    offeringIdentifier: r.identifier,
    targetingContext: e && n ? {
      ruleId: n.rule_id,
      revision: n.revision
    } : null,
    placementIdentifier: null
  }, o = r.packages.map(
    (s) => $l(a, s, t)
  ).filter(ul), i = {};
  for (const s of o)
    s != null && (i[s.identifier] = s);
  return o.length == 0 ? null : {
    identifier: r.identifier,
    serverDescription: r.description,
    metadata: r.metadata,
    packagesById: i,
    availablePackages: o,
    lifetime: i.$rc_lifetime ?? null,
    annual: i.$rc_annual ?? null,
    sixMonth: i.$rc_six_month ?? null,
    threeMonth: i.$rc_three_month ?? null,
    twoMonth: i.$rc_two_month ?? null,
    monthly: i.$rc_monthly ?? null,
    weekly: i.$rc_weekly ?? null,
    paywall_components: r.paywall_components ? r.paywall_components : null
  };
};
function rc(e) {
  switch (e) {
    case "$rc_lifetime":
      return "$rc_lifetime";
    case "$rc_annual":
      return "$rc_annual";
    case "$rc_six_month":
      return "$rc_six_month";
    case "$rc_three_month":
      return "$rc_three_month";
    case "$rc_two_month":
      return "$rc_two_month";
    case "$rc_monthly":
      return "$rc_monthly";
    case "$rc_weekly":
      return "$rc_weekly";
    default:
      return e.startsWith("$rc_") ? "unknown" : "custom";
  }
}
function tc(e) {
  var r;
  return e.operation.redemption_info ? {
    redeemUrl: ((r = e.operation.redemption_info) == null ? void 0 : r.redeem_url) ?? null
  } : null;
}
var de = /* @__PURE__ */ ((e) => (e[e.ErrorSettingUpPurchase = 0] = "ErrorSettingUpPurchase", e[e.ErrorChargingPayment = 1] = "ErrorChargingPayment", e[e.UnknownError = 2] = "UnknownError", e[e.NetworkError = 3] = "NetworkError", e[e.MissingEmailError = 4] = "MissingEmailError", e[e.AlreadyPurchasedError = 5] = "AlreadyPurchasedError", e))(de || {});
class re extends Error {
  constructor(r, t, n, a, o) {
    super(t), this.errorCode = r, this.underlyingErrorMessage = n, this.purchasesErrorCode = a, this.extra = o;
  }
  isRecoverable() {
    switch (this.errorCode) {
      case 3:
      case 4:
        return !0;
      case 0:
      case 1:
      case 5:
      case 2:
        return !1;
    }
  }
  getErrorCode() {
    var r;
    return ((r = this.extra) == null ? void 0 : r.backendErrorCode) ?? this.purchasesErrorCode ?? this.errorCode;
  }
  getPublicErrorMessage(r) {
    var n;
    const t = ((n = this.extra) == null ? void 0 : n.backendErrorCode) ?? this.purchasesErrorCode ?? this.errorCode;
    switch (this.errorCode) {
      // TODO: Localize these messages
      case 2:
        return `An unknown error occurred. Error code: ${t}.`;
      case 0:
        return `Purchase not started due to an error. Error code: ${t}.`;
      case 1:
        return "Payment failed.";
      case 3:
        return "Network error. Please check your internet connection.";
      case 4:
        return "Email is required to complete the purchase.";
      case 5:
        return (r == null ? void 0 : r.productType) === Re.Subscription ? "You are already subscribed to this product." : "You have already purchased this product.";
    }
  }
  static fromPurchasesError(r, t) {
    let n;
    return r.errorCode === ye.ProductAlreadyPurchasedError ? n = 5 : r.errorCode === ye.InvalidEmailError ? n = 4 : r.errorCode === ye.NetworkError ? n = 3 : n = t, new re(
      n,
      r.message,
      r.underlyingErrorMessage,
      r.errorCode,
      r.extra
    );
  }
}
class nc {
  constructor(r, t, n = 10) {
    q(this, "operationSessionId", null);
    q(this, "backend");
    q(this, "eventsTracker");
    q(this, "maxNumberAttempts");
    q(this, "waitMSBetweenAttempts", 1e3);
    this.backend = r, this.eventsTracker = t, this.maxNumberAttempts = n;
  }
  async checkoutStart(r, t, n, a, o, i) {
    try {
      const s = this.eventsTracker.getTraceId(), l = await this.backend.postCheckoutStart(
        r,
        t,
        a,
        n,
        s,
        o,
        i
      );
      return this.operationSessionId = l.operation_session_id, l;
    } catch (s) {
      if (s instanceof pe)
        throw re.fromPurchasesError(
          s,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const l = "Unknown error starting purchase: " + String(s);
        throw H.errorLog(l), new re(
          2,
          l
        );
      }
    }
  }
  async checkoutCalculateTaxes(r, t) {
    const n = this.operationSessionId;
    if (!n)
      throw new re(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutCalculateTaxes(
        n,
        r,
        t
      );
    } catch (a) {
      if (a instanceof pe)
        throw re.fromPurchasesError(
          a,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const o = "Unknown error calculating taxes: " + String(a);
        throw H.errorLog(o), new re(
          2,
          o
        );
      }
    }
  }
  async checkoutComplete(r) {
    const t = this.operationSessionId;
    if (!t)
      throw new re(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutComplete(
        t,
        r
      );
    } catch (n) {
      if (n instanceof pe)
        throw re.fromPurchasesError(
          n,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const a = "Unknown error starting purchase: " + String(n);
        throw H.errorLog(a), new re(
          2,
          a
        );
      }
    }
  }
  async pollCurrentPurchaseForCompletion() {
    const r = this.operationSessionId;
    if (!r)
      throw new re(
        0,
        "No purchase in progress"
      );
    return new Promise((t, n) => {
      const a = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          this.clearPurchaseInProgress(), n(
            new re(
              2,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(r).then((i) => {
          switch (i.operation.status) {
            case Kr.Started:
            case Kr.InProgress:
              setTimeout(
                () => a(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case Kr.Succeeded:
              this.clearPurchaseInProgress(), t({
                redemptionInfo: tc(i),
                operationSessionId: r
              });
              return;
            case Kr.Failed:
              this.clearPurchaseInProgress(), this.handlePaymentError(
                i.operation.error,
                n
              );
          }
        }).catch((i) => {
          const s = re.fromPurchasesError(
            i,
            3
            /* NetworkError */
          );
          n(s);
        });
      };
      a();
    });
  }
  clearPurchaseInProgress() {
    this.operationSessionId = null;
  }
  handlePaymentError(r, t) {
    if (r == null) {
      t(
        new re(
          2,
          "Got an error status but error field is empty."
        )
      );
      return;
    }
    switch (r.code) {
      case jr.SetupIntentCreationFailed:
        t(
          new re(
            0,
            "Setup intent creation failed"
          )
        );
        return;
      case jr.PaymentMethodCreationFailed:
        t(
          new re(
            0,
            "Payment method creation failed"
          )
        );
        return;
      case jr.PaymentChargeFailed:
        t(
          new re(
            1,
            "Payment charge failed"
          )
        );
        return;
      case jr.SetupIntentCompletionFailed:
        t(
          new re(
            0,
            "Setup intent completion failed"
          )
        );
        return;
      case jr.AlreadyPurchased:
        t(
          new re(
            5,
            "Purchased was already completed"
          )
        );
        return;
      default:
        t(
          new re(
            2,
            "Unknown error code received"
          )
        );
        return;
    }
  }
}
const ac = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.5)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.005)",
  "input-background": "white",
  background: "white"
}, oc = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.5)",
  "grey-ui-dark": "rgba(0,0,0,0.25)",
  "grey-ui-light": "rgba(0,0,0,0.005)",
  "input-background": "white",
  background: "#EFF3FA"
}, Vo = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, ic = {
  ...Vo,
  "input-background": "color_form_bg",
  background: "color_form_bg"
}, sc = {
  ...Vo,
  "input-background": "color_product_info_bg",
  background: "color_product_info_bg"
}, Wo = {
  "input-border-radius": "4px",
  "input-button-border-radius": "8px"
}, lc = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px"
}, cc = {
  "input-border-radius": "12px",
  "input-button-border-radius": "9999px"
}, Na = Wo, Sn = "-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif", En = {
  titleXXLarge: {
    desktop: { fontSize: "32px", lineHeight: "140%", fontWeight: "500" },
    mobile: { fontSize: "28px", lineHeight: "140%", fontWeight: "500" }
  },
  titleXLarge: {
    desktop: { fontSize: "36px", lineHeight: "140%", fontWeight: "500" },
    mobile: { fontSize: "24px", lineHeight: "140%", fontWeight: "500" }
  },
  titleLarge: {
    desktop: { fontSize: "28px", lineHeight: "140%", fontWeight: "500" },
    mobile: { fontSize: "20px", lineHeight: "140%", fontWeight: "500" }
  },
  titleMedium: {
    desktop: { fontSize: "24px", lineHeight: "140%", fontWeight: "500" },
    mobile: { fontSize: "17px", lineHeight: "140%", fontWeight: "500" }
  },
  // sm font on figma
  body1: {
    desktop: { fontSize: "16px", lineHeight: "140%", fontWeight: "400" },
    mobile: { fontSize: "16px", lineHeight: "140%", fontWeight: "400" }
  },
  caption: {
    desktop: { fontSize: "14px", lineHeight: "140%", fontWeight: "400" },
    mobile: { fontSize: "12px", lineHeight: "140%", fontWeight: "400" }
  },
  largeCaption: {
    desktop: { fontSize: "14px", lineHeight: "140%", fontWeight: "400" },
    mobile: { fontSize: "14px", lineHeight: "140%", fontWeight: "400" }
  }
}, it = (e) => e.length == 7 ? {
  r: parseInt(e.slice(1, 3), 16),
  g: parseInt(e.slice(3, 5), 16),
  b: parseInt(e.slice(5, 7), 16)
} : e.length == 4 ? {
  r: parseInt(e[1], 16),
  g: parseInt(e[2], 16),
  b: parseInt(e[3], 16)
} : null, Qn = ({
  r: e,
  g: r,
  b: t,
  luminanceThreshold: n
}) => {
  const a = (i) => (i = i / 255, i <= 0.03928 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4));
  return 0.2126 * a(e) + 0.7152 * a(r) + 0.0722 * a(t) > n;
}, Zn = 0.37, uc = (e, r = Zn) => {
  const t = Qn({ ...e, luminanceThreshold: r }) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgb(${t})`,
    "grey-text-light": `rgba(${t},0.50)`,
    "grey-ui-dark": `rgba(${t},0.3)`,
    "grey-ui-light": `rgba(${t},0.05)`
  };
};
function dc(e, r, t) {
  const n = it(e) || { r: 0, g: 0, b: 0 }, a = it(r) || { r: 255, g: 255, b: 255 }, o = Math.round(a.r * t + n.r * (1 - t)), i = Math.round(a.g * t + n.g * (1 - t)), s = Math.round(a.b * t + n.b * (1 - t));
  return `#${cn(o)}${cn(i)}${cn(s)}`;
}
function Oa(e, r) {
  const t = { r: 255, g: 255, b: 255 }, n = Math.max(0, Math.min(1, r));
  let a = e, o = it(e) || t;
  (isNaN(o.r) || isNaN(o.g) || isNaN(o.b)) && (o = t, a = "#FFFFFF");
  const s = Qn({
    ...o,
    luminanceThreshold: Zn
  }) ? "#000000" : "#FFFFFF";
  return dc(a, s, n);
}
function cn(e) {
  return e.toString(16).padStart(2, "0").toUpperCase();
}
const _c = (e, r, t, n = Zn) => {
  const a = {
    "grey-text-dark": t["grey-text-dark"],
    "grey-text-light": t["grey-text-light"],
    "grey-ui-dark": t["grey-ui-dark"],
    "grey-ui-light": t["grey-ui-light"],
    "primary-text": t["primary-text"]
  };
  if (e != null && e.startsWith("#")) {
    const o = it(e);
    o !== null && Object.assign(a, uc(o));
  }
  if (r != null && r.startsWith("#")) {
    const o = it(r);
    o !== null && (a["primary-text"] = Qn({ ...o, luminanceThreshold: n }) ? "black" : "white");
  }
  return a;
}, pc = (e) => ({
  "primary-hover": Oa(e, 0.1),
  "primary-pressed": Oa(e, 0.15)
}), fc = (e, r) => e || r, mc = (e, r, t) => {
  const n = Object.entries(e).map(([a, o]) => [
    a,
    fc(
      t ? t[o] : null,
      r[a]
    )
  ]);
  return Object.fromEntries(n);
}, Yo = (e, r, t) => {
  const n = mc(
    e,
    r,
    t
  );
  return t ? {
    ...r,
    ...n,
    ..._c(
      n.background,
      n.primary,
      r
    ),
    ...pc(n.primary)
  } : { ...r };
}, hc = (e) => Yo(
  sc,
  oc,
  e
), Ho = (e) => Yo(
  ic,
  ac,
  e
), Kn = (e) => {
  if (!e)
    return Na;
  switch (e.shapes) {
    case "rounded":
      return Wo;
    case "rectangle":
      return lc;
    case "pill":
      return cc;
    default:
      return Na;
  }
}, Mt = (e = "", r) => r.map(([t, n]) => `--rc-${e}-${t}: ${n}`).join("; "), Go = (e) => {
  const r = Mt(
    "color",
    Object.entries(hc(e))
  ), t = Mt(
    "shape",
    Object.entries(Kn(e))
  );
  return [r, t].join("; ");
}, gc = (e) => {
  const r = Mt(
    "color",
    Object.entries(Ho(e))
  ), t = Mt(
    "shape",
    Object.entries(Kn(e))
  );
  return [r, t].join("; ");
}, yc = (e = "", r) => Object.entries(r).flatMap(([t, { desktop: n, mobile: a }]) => [
  `--rc-${e}-${t}-desktop: normal normal ${n.fontWeight} ${n.fontSize}/${n.lineHeight} ${Sn}`,
  `--rc-${e}-${t}-mobile: normal normal ${a.fontWeight} ${a.fontSize}/${a.lineHeight} ${Sn}`,
  `--rc-${e}-${t}-desktop-font-size: ${n.fontSize}`,
  `--rc-${e}-${t}-mobile-font-size: ${a.fontSize}`
]).join("; "), bc = (e = "", r) => Object.entries(r).map(
  ([t, { mobile: n, tablet: a, desktop: o }]) => `--rc-${e}-${t}-mobile: ${n};  --rc-${e}-${t}-tablet: ${a};  --rc-${e}-${t}-desktop: ${o};`
).join(" "), hr = "rcb-ui-translator", ur = "en", vc = (e) => {
  try {
    return e.charAt(0).toUpperCase() + e.slice(1);
  } catch {
    return e;
  }
}, Nr = {
  noWhitespace: !1,
  short: !1
}, Xo = {
  useMultipleWords: !1
};
class Jt {
  constructor(r = {}, t = ur, n = ur) {
    q(this, "locales", {});
    this.selectedLocale = t, this.defaultLocale = n;
    const a = {};
    Object.entries(Wl).forEach(([o, i]) => {
      a[o] = new Ra(i, o);
    }), this.locales = a, r && this.override(r);
  }
  static fallback() {
    return new Jt();
  }
  override(r) {
    Object.entries(r).forEach(([t, n]) => {
      this.locales[t] = new Ra(
        {
          ...this.locales[t].labels || {},
          ...n
        },
        this.getLanguageCodeString(t)
      );
    });
  }
  formatPrice(r, t) {
    const n = { currencyDisplay: "narrowSymbol" };
    r === 0 && (n.maximumFractionDigits = 0);
    try {
      return tt(
        r,
        t,
        this.locale,
        n
      );
    } catch {
      H.errorLog(
        `Failed to create a price formatter for locale: ${this.locale}`
      );
    }
    try {
      return tt(
        r,
        t,
        this.fallbackLocale,
        n
      );
    } catch {
      H.errorLog(
        `Failed to create a price formatter for locale: ${this.fallbackLocale}`
      );
    }
    return tt(
      r,
      t,
      ur,
      n
    );
  }
  get locale() {
    var r;
    return ((r = this.getLocaleInstance(this.selectedLocale)) == null ? void 0 : r.localeKey) || this.getLanguageCodeString(this.selectedLocale);
  }
  get fallbackLocale() {
    var r;
    return ((r = this.getLocaleInstance(this.defaultLocale)) == null ? void 0 : r.localeKey) || this.getLanguageCodeString(this.defaultLocale);
  }
  getLanguageCodeString(r) {
    return r.split("_")[0].split("-")[0];
  }
  getLocaleInstance(r) {
    const t = this.getLanguageCodeString(r);
    return this.locales[r] || this.locales[t];
  }
  translate(r, t) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translate(r, t)) || (a == null ? void 0 : a.translate(r, t)) || "";
  }
  translatePeriod(r, t, n = Nr) {
    const a = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translatePeriod(r, t, n)) || (o == null ? void 0 : o.translatePeriod(r, t, n));
  }
  translatePeriodUnit(r, t = Nr) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translatePeriodUnit(r, t)) || (a == null ? void 0 : a.translatePeriodUnit(r, t));
  }
  translatePeriodFrequency(r, t, n = Xo) {
    const a = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translatePeriodFrequency(r, t, n)) || (o == null ? void 0 : o.translatePeriodFrequency(r, t, n));
  }
  translateDate(r, t = {}) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translateDate(r, t)) || (a == null ? void 0 : a.translateDate(r, t));
  }
}
class Ra {
  constructor(r = {}, t) {
    this.labels = r, this.localeKey = t;
  }
  replaceVariables(r, t) {
    return Object.entries(t).reduce(
      (n, [a, o]) => n.replace(
        `{{${a}}}`,
        `${o ?? ""}`
      ),
      r
    );
  }
  translate(r, t) {
    const n = this.labels[r];
    if (n)
      return this.replaceVariables(n, t || {});
  }
  translatePeriod(r, t, n = Nr) {
    var s;
    const { noWhitespace: a, short: o } = {
      ...Nr,
      ...n
    }, i = o ? `periods.${t}Short` : Math.abs(r) === 1 ? `periods.${t}` : `periods.${t}Plural`;
    return (s = this.translate(i, {
      amount: r.toString()
    })) == null ? void 0 : s.replace(" ", a ? "" : " ");
  }
  translatePeriodUnit(r, t = Nr) {
    var i;
    const { noWhitespace: n, short: a } = {
      ...Nr,
      ...t
    }, o = `periods.${r}${a ? "Short" : ""}`;
    return (i = this.translate(o, { amount: "" })) == null ? void 0 : i.replace(
      " ",
      n ? "" : " "
    );
  }
  translatePeriodFrequency(r, t, n = Xo) {
    const a = n == null ? void 0 : n.useMultipleWords, o = Math.abs(r) === 1 ? `periods.${a === !0 ? "per" : ""}${a ? vc(t.toString()) : t}Frequency` : `periods.${t}FrequencyPlural`;
    return this.translate(o, {
      amount: r.toString()
    });
  }
  translateDate(r, t = {}) {
    return r.toLocaleDateString(this.localeKey, t);
  }
}
const kc = {
  outerPadding: {
    mobile: "clamp(1.3125rem, 5.6vw, 1.5rem)",
    tablet: "clamp(1.40625rem, 7.52vw, 3.25rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  outerPaddingSmall: {
    mobile: "clamp(0.75rem, 4.2vw, 1rem)",
    tablet: "clamp(0.75rem, 4.2vw, 1rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  gapSmall: {
    mobile: "0.25rem",
    tablet: "0.375rem",
    desktop: "0.375rem"
  },
  gapMedium: {
    mobile: "0.5rem",
    tablet: "0.75rem",
    desktop: "0.75rem"
  },
  gapLarge: {
    mobile: "0.75rem",
    tablet: "0.75rem",
    desktop: "0.75rem"
  },
  gapXLarge: {
    mobile: "1rem",
    tablet: "1.5rem",
    desktop: "1.5rem"
  },
  gapXXLarge: {
    mobile: "1.25rem",
    tablet: "2.25rem",
    desktop: "2.25rem"
  },
  gapXXXLarge: {
    mobile: "2.25rem",
    tablet: "4.5rem",
    desktop: "4.5rem"
  },
  inputHeight: {
    mobile: "3rem",
    tablet: "3rem",
    desktop: "3rem"
  }
};
class Lr {
  constructor(r) {
    q(this, "brandingAppearance");
    r ? this.brandingAppearance = r : this.brandingAppearance = void 0;
  }
  get shape() {
    return Kn(this.brandingAppearance);
  }
  get formColors() {
    return Ho(this.brandingAppearance);
  }
  get formStyleVars() {
    return gc(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return Go(this.brandingAppearance);
  }
  get spacing() {
    return kc;
  }
  get textStyles() {
    return En;
  }
  get textStyleVars() {
    return yc("text", this.textStyles);
  }
  get spacingStyleVars() {
    return bc("spacing", this.spacing);
  }
}
var wc = /* @__PURE__ */ F('<div class="rcb-ui-container svelte-1wfvwot"><!></div>');
const Pc = {
  hash: "svelte-1wfvwot",
  code: `.rcb-ui-container.svelte-1wfvwot {display:flex;flex-direction:column;inset:0;color-scheme:none;font-size:16px;line-height:1.5em;font-weight:400;font-family:-apple-system,
      BlinkMacSystemFont,
      avenir next,
      avenir,
      segoe ui,
      helvetica neue,
      helvetica,
      Cantarell,
      Ubuntu,
      roboto,
      noto,
      arial,
      sans-serif;overflow-x:hidden;overflow-y:auto;}.rcb-ui-container.fullscreen.svelte-1wfvwot {position:fixed;top:0;left:0;right:0;bottom:0;overscroll-behavior:none;z-index:1000001;}.rcb-ui-container.inside.svelte-1wfvwot {position:relative;width:100%;z-index:unset;height:100%;top:0;left:0;}`
};
function xc(e, r) {
  V(r, !1), U(e, Pc);
  const t = ie(), n = ie(), a = ie();
  let o = v(r, "brandingAppearance", 8, void 0), i = v(r, "isInElement", 8, !1), s = v(r, "children", 8);
  Oe(
    () => xr(o()),
    () => {
      A(t, new Lr(o()).textStyleVars);
    }
  ), Oe(
    () => xr(o()),
    () => {
      A(n, new Lr(o()).spacingStyleVars);
    }
  ), Oe(() => (f(t), f(n)), () => {
    A(a, [f(t), f(n)].join("; "));
  }), dt(), oe();
  var l = wc(), c = E(l);
  be(c, () => s() ?? se), N(() => {
    Z(l, "style", f(a)), qr(l, "fullscreen", !i()), qr(l, "inside", i());
  }), P(e, l), W();
}
var Sc = /* @__PURE__ */ F('<div id="layout-query-container" class="svelte-1x4ow5d"><div class="rcb-ui-layout svelte-1x4ow5d"><!></div></div>');
const Ec = {
  hash: "svelte-1x4ow5d",
  code: `#layout-query-container.svelte-1x4ow5d {width:100%;height:100%;container-type:size;container-name:layout-query-container;overflow-y:auto;overscroll-behavior:none;}.rcb-ui-layout.svelte-1x4ow5d {width:100%;min-height:100%;display:flex;box-sizing:border-box;flex-direction:column;overflow-y:auto;overscroll-behavior:none;}

  @container layout-query-container (width < 768px) {.rcb-ui-layout.svelte-1x4ow5d {flex-grow:1;}
  }

  @container layout-query-container (width >= 768px) {.rcb-ui-layout.svelte-1x4ow5d {flex-direction:row;}
  }`
};
function qc(e, r) {
  V(r, !1), U(e, Ec);
  let t = v(r, "style", 8, ""), n = v(r, "children", 8);
  oe();
  var a = Sc(), o = E(a), i = E(o);
  be(i, () => n() ?? se), N(() => Z(o, "style", t())), P(e, a), W();
}
const Fc = {
  hash: "svelte-1bzqb13",
  code: ".rcb-modal-section.svelte-1bzqb13 {padding:8px 0px;display:flex;}section.rcb-modal-section.svelte-1bzqb13 {flex-grow:1;}.rcb-modal-section.svelte-1bzqb13:last-of-type {padding:0;}"
};
function $n(e, r) {
  V(r, !1), U(e, Fc);
  let t = v(r, "as", 8, "section"), n = v(r, "children", 8);
  oe();
  var a = ae(), o = J(a);
  At(o, t, !1, (i, s) => {
    Ct(i, null, { class: "rcb-modal-section" }, "svelte-1bzqb13", i.namespaceURI === nt, i.nodeName.includes("-"));
    var l = ae(), c = J(l);
    be(c, () => n() ?? se), P(s, l);
  }), P(e, a), W();
}
const Ic = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="mdi_close">
<path id="Vector" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
      fill="currentColor"/>
</g>
</svg>
`;
var Tc = /* @__PURE__ */ F('<button class="rcb-close-button svelte-ox5fjf" data-testid="close-button"><!></button>');
const Dc = {
  hash: "svelte-ox5fjf",
  code: ".rcb-close-button.svelte-ox5fjf {border:none;cursor:pointer;background-color:transparent;padding:0;height:24px;width:24px;padding:4px;border-radius:50%;color:inherit;display:flex;align-items:center;justify-content:center;}.rcb-close-button.svelte-ox5fjf:active {transition:outline 0.1s ease-in-out;outline:2px solid var(--rc-color-focus);}.rcb-close-button.svelte-ox5fjf:hover {color:var(--rc-color-grey-text-dark);}"
};
function Jo(e, r) {
  U(e, Dc);
  let t = v(r, "disabled", 8, !1);
  var n = Tc(), a = E(n);
  ft(a, () => Ic), N(() => n.disabled = t()), Sr("click", n, function(o) {
    Jn.call(this, r, o);
  }), P(e, n);
}
var Ac = /* @__PURE__ */ Us('<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.94 5.72656L8 8.7799L11.06 5.72656L12 6.66656L8 10.6666L4 6.66656L4.94 5.72656Z" class="arrow-fill svelte-m1l6c3" fill-opacity="0.7"></path></svg>');
const Cc = {
  hash: "svelte-m1l6c3",
  code: ".arrow.svelte-m1l6c3 {transition:transform 0.3s ease;}.arrow-fill.svelte-m1l6c3 {fill:var(--rc-color-grey-text-dark);}.arrow.expanded.svelte-m1l6c3 {transform:rotate(-180deg);}.arrow.collapsed.svelte-m1l6c3 {transform:rotate(0deg);}.arrow.back.svelte-m1l6c3 {transform:rotate(90deg);}"
};
function Qo(e, r) {
  U(e, Cc);
  let t = v(r, "className", 8, "");
  var n = Ac();
  N(() => Qs(n, `arrow ${t() ?? ""} svelte-m1l6c3`)), P(e, n);
}
function he(e, r) {
  V(r, !0);
  const t = ar(), n = () => nr(o, "$translator", t), a = v(r, "key", 3, ""), o = We(hr), i = /* @__PURE__ */ O(() => a() ? n().translate(a() || "", r.variables) : void 0);
  var s = ae(), l = J(s);
  {
    var c = (u) => {
      var p = Rr();
      N(() => Se(p, f(i))), P(u, p);
    }, d = (u) => {
      var p = ae(), _ = J(p);
      be(_, () => r.children ?? se), P(u, p);
    };
    j(l, (u) => {
      f(i) ? u(c) : u(d, !1);
    });
  }
  P(e, s), W();
}
var Mc = /* @__PURE__ */ F('<button class="rcb-back-button svelte-irl107" data-testid="close-button"><!> <!></button>');
const jc = {
  hash: "svelte-irl107",
  code: `.rcb-back-button.svelte-irl107 {border:none;cursor:pointer;background-color:transparent;padding:0;border-radius:50%;color:var(--rc-color-grey-text-dark);
    /* This button is only shown in desktop layout*/font:var(--rc-text-body1-desktop);display:flex;align-items:center;justify-content:center;}`
};
function Nc(e, r) {
  V(r, !1), U(e, jc);
  let t = v(r, "disabled", 8, !1);
  oe();
  var n = Mc(), a = E(n);
  Qo(a, { className: "back" });
  var o = M(a, 2);
  he(o, {
    get key() {
      return z.NavbarBackButton;
    }
  }), N(() => n.disabled = t()), Sr("click", n, function(i) {
    Jn.call(this, r, i);
  }), P(e, n), W();
}
var Oc = /* @__PURE__ */ F('<div class="rcb-back svelte-1411ys1"><!></div>'), Rc = /* @__PURE__ */ F('<button type="button" class="rcb-header-details svelte-1411ys1" aria-controls="rcb-header-details-content"><!> <!></button>'), Lc = /* @__PURE__ */ F('<div class="rcb-close svelte-1411ys1"><!></div>'), zc = /* @__PURE__ */ F('<div class="rcb-header-multiline-layout svelte-1411ys1"><!> <div class="rcb-header-layout svelte-1411ys1"><!> <!> <!></div></div>');
const Uc = {
  hash: "svelte-1411ys1",
  code: `.rcb-header-multiline-layout.svelte-1411ys1 {all:unset;display:flex;flex-direction:column;width:100%;}button.rcb-header-details.svelte-1411ys1 {all:unset;display:flex;align-items:center;cursor:pointer;font:var(--rc-text-largeCaption-mobile);gap:var(--rc-spacing-gapSmall-mobile);color:var(--rc-color-grey-text-light);padding:var(--rc-spacing-gapMedium-mobile);}.rcb-header-details.svelte-1411ys1 {font:var(--rc-text-largeCaption-mobile);display:flex;align-items:center;gap:var(--rc-spacing-gapSmall-mobile);}.rcb-header-layout.svelte-1411ys1 {display:flex;justify-content:space-between;align-items:center;width:100%;font:var(--rc-text-titleXLarge-mobile);margin:0;}.rcb-back.svelte-1411ys1 {display:none;}.rcb-close.svelte-1411ys1 {display:inline-block;}

  @container layout-query-container (width >= 768px) {button.rcb-header-details.svelte-1411ys1 {display:none;}.rcb-header-layout.svelte-1411ys1 {width:auto;}.rcb-back.svelte-1411ys1 {display:block;}.rcb-close.svelte-1411ys1 {display:none;}.rcb-header-multiline-layout.svelte-1411ys1 {gap:var(--rc-spacing-gapXLarge-desktop);}
  }`
};
function Bc(e, r) {
  V(r, !1), U(e, Uc);
  let t = v(r, "children", 8), n = v(r, "shouldShowDetailsButton", 8, !1), a = v(r, "expanded", 8, !1), o = v(r, "toggle", 8), i = v(r, "showCloseButton", 8), s = v(r, "onClose", 8, void 0);
  oe(), $n(e, {
    as: "header",
    children: (l, c) => {
      var d = zc(), u = E(d);
      {
        var p = (k) => {
          var w = Oc(), x = E(w);
          Nc(x, {
            $$events: {
              click: () => {
                s() && s()();
              }
            }
          }), P(k, w);
        };
        j(u, (k) => {
          i() && k(p);
        });
      }
      var _ = M(u, 2), m = E(_);
      be(m, () => t() ?? se);
      var h = M(m, 2);
      {
        var b = (k) => {
          var w = Rc(), x = E(w);
          he(x, {
            get key() {
              return z.NavbarHeaderDetails;
            }
          });
          var S = M(x, 2), D = /* @__PURE__ */ te(() => a() ? "expanded" : "collapsed");
          Qo(S, {
            get className() {
              return f(D);
            }
          }), N(() => Z(w, "aria-expanded", a())), Sr("click", w, function(...I) {
            var T;
            (T = o()) == null || T.apply(this, I);
          }), Sr("keydown", w, (I) => (I.key === "Enter" || I.key === " ") && o()()), P(k, w);
        };
        j(h, (k) => {
          n() && k(b);
        });
      }
      var y = M(h, 2);
      {
        var g = (k) => {
          var w = Lc(), x = E(w);
          Jo(x, {
            $$events: {
              click: () => {
                s() && s()();
              }
            }
          }), P(k, w);
        };
        j(y, (k) => {
          i() && k(g);
        });
      }
      P(l, d);
    },
    $$slots: { default: !0 }
  }), W();
}
const Vc = (e) => e;
function Wc(e) {
  const r = e - 1;
  return r * r * r + 1;
}
function La(e) {
  const r = typeof e == "string" && e.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return r ? [parseFloat(r[1]), r[2] || "px"] : [
    /** @type {number} */
    e,
    "px"
  ];
}
function Yc(e, { delay: r = 0, duration: t = 400, easing: n = Vc } = {}) {
  const a = +getComputedStyle(e).opacity;
  return {
    delay: r,
    duration: t,
    easing: n,
    css: (o) => `opacity: ${o * a}`
  };
}
function Hc(e, { delay: r = 0, duration: t = 400, easing: n = Wc, x: a = 0, y: o = 0, opacity: i = 0 } = {}) {
  const s = getComputedStyle(e), l = +s.opacity, c = s.transform === "none" ? "" : s.transform, d = l * (1 - i), [u, p] = La(a), [_, m] = La(o);
  return {
    delay: r,
    duration: t,
    easing: n,
    css: (h, b) => `
			transform: ${c} translate(${(1 - h) * u}${p}, ${(1 - h) * _}${m});
			opacity: ${l - d * b}`
  };
}
var Gc = /* @__PURE__ */ F('<div class="layout-wrapper svelte-6feuuw"><div class="layout-content svelte-6feuuw"><!> <!></div></div>'), Xc = /* @__PURE__ */ F('<div class="layout-wrapper-outer svelte-6feuuw"><!></div>');
const Jc = {
  hash: "svelte-6feuuw",
  code: `.layout-wrapper-outer.svelte-6feuuw {flex:1;display:flex;background-color:var(--rc-color-background);}.layout-wrapper.svelte-6feuuw {width:100%;}.layout-content.svelte-6feuuw {box-sizing:border-box;background-color:var(--rc-color-background);color:var(--rc-color-grey-text-dark);display:flex;flex-direction:column;padding:var(--rc-spacing-outerPadding-mobile);}

  @container layout-query-container (width >= 768px) {.layout-wrapper.svelte-6feuuw {min-height:100vh;flex-basis:600px;}
  }

  @container layout-query-container (width >= 768px) and (width <= 1024px) {.layout-content.svelte-6feuuw {padding:var(--rc-spacing-outerPadding-tablet);}
  }

  @container layout-query-container (width > 1024px) {.layout-content.svelte-6feuuw {padding:var(--rc-spacing-outerPadding-desktop);}
  }

  @container layout-query-container (width < 768px) {.layout-wrapper.svelte-6feuuw {width:100%;min-width:300px;display:flex;flex-grow:1;}.layout-content.svelte-6feuuw {flex-grow:1;height:100%;}
  }`
};
function Zo(e, r) {
  V(r, !1), U(e, Jc);
  let t = v(r, "show", 8, !0), n = v(r, "layoutStyle", 8, void 0), a = v(r, "header", 8, null), o = v(r, "body", 8, null);
  oe();
  var i = Xc(), s = E(i);
  {
    var l = (c) => {
      var d = Gc(), u = E(d), p = E(u);
      {
        var _ = (b) => {
          var y = ae(), g = J(y);
          be(g, a), P(b, y);
        };
        j(p, (b) => {
          a() && b(_);
        });
      }
      var m = M(p, 2);
      {
        var h = (b) => {
          var y = ae(), g = J(y);
          be(g, o), P(b, y);
        };
        j(m, (b) => {
          o() && b(h);
        });
      }
      Oo(3, u, () => Yc, () => ({ duration: 500, delay: 50 })), P(c, d);
    };
    j(s, (c) => {
      t() && c(l);
    });
  }
  N(() => Z(i, "style", n())), P(e, i), W();
}
var Qc = /* @__PURE__ */ F('<div class="rcb-ui-navbar svelte-853yun"><!></div>');
const Zc = {
  hash: "svelte-853yun",
  code: `.rcb-ui-navbar.svelte-853yun {width:100%;max-width:none;flex-shrink:0;background-color:var(--rc-color-background);}

  @container layout-query-container (width >= 768px) {.rcb-ui-navbar.svelte-853yun {width:50vw;display:flex;justify-content:flex-end;}
  }`
};
function Kc(e, r) {
  V(r, !1), U(e, Zc);
  const t = ie();
  let n = v(r, "brandingAppearance", 8, void 0), a = v(r, "headerContent", 8), o = v(r, "bodyContent", 8), i = v(r, "shouldShowDetailsButton", 8, !1), s = v(r, "showCloseButton", 8), l = v(r, "onClose", 8, void 0), c = ie(!1);
  function d() {
    A(c, !f(c));
  }
  Oe(
    () => xr(n()),
    () => {
      A(t, new Lr(n()).productInfoStyleVars);
    }
  ), dt(), oe();
  var u = Qc(), p = E(u);
  Zo(p, {
    layoutStyle: "justify-content: flex-end;",
    header: (h) => {
      Bc(h, {
        get expanded() {
          return f(c);
        },
        toggle: d,
        get showCloseButton() {
          return s();
        },
        get onClose() {
          return l();
        },
        get shouldShowDetailsButton() {
          return i();
        },
        children: (b, y) => {
          var g = ae(), k = J(g);
          be(k, () => a() ?? se), P(b, g);
        },
        $$slots: { default: !0 }
      });
    },
    body: (h) => {
      var b = ae(), y = J(b);
      be(y, () => o() ?? se, () => f(c)), P(h, b);
    },
    $$slots: { header: !0, body: !0 }
  }), N(() => Z(u, "style", f(t))), P(e, u), W();
}
var $c = /* @__PURE__ */ F('<div class="rcb-ui-sandbox-banner svelte-18sg9fy"><span class="rcb-sandbox-banner-text">Sandbox</span> <div class="rcb-sandbox-banner-close-button-wrapper svelte-18sg9fy"><!></div></div>');
const eu = {
  hash: "svelte-18sg9fy",
  code: `.rcb-ui-sandbox-banner.svelte-18sg9fy {position:fixed;top:0;z-index:1000002;left:0;width:100%;background-color:var(--rc-color-warning);color:rgba(0, 0, 0, 1);font:var(--rc-text-caption-mobile);font-weight:bold;text-transform:uppercase;padding:var(--rc-spacing-gapSmall-mobile);display:flex;justify-content:center;align-items:center;}.rcb-ui-sandbox-banner.isInElement.svelte-18sg9fy {position:absolute;}.rcb-sandbox-banner-close-button-wrapper.svelte-18sg9fy {position:absolute;right:var(--rc-spacing-gapMedium-mobile);top:50%;transform:translateY(-50%);color:black;}.rcb-sandbox-banner-close-button-icon {color:black;height:var(--rc-text-caption-mobile-font-size);}

  @container layout-query-container (width >= 768px) {.rcb-sandbox-banner-close-button-icon {height:var(--rc-text-caption-desktop-font-size);}.rcb-ui-sandbox-banner.svelte-18sg9fy {padding:var(--rc-spacing-gapMedium-desktop);font:var(--rc-text-caption-desktop);font-weight:bold;}.rcb-sandbox-banner-close-button-wrapper.svelte-18sg9fy {right:var(--rc-spacing-gapMedium-desktop);}
  }`
};
function ru(e, r) {
  V(r, !1), U(e, eu);
  let t = v(r, "style", 8, ""), n = v(r, "isInElement", 8, !1), a = ie(!0);
  function o() {
    H.debugLog("closeBanner"), A(a, !1);
  }
  oe();
  var i = ae(), s = J(i);
  {
    var l = (c) => {
      var d = $c(), u = M(E(d), 2), p = E(u);
      Jo(p, { $$events: { click: o } }), N(() => {
        Z(d, "style", t()), qr(d, "isInElement", n());
      }), Oo(2, d, () => Hc, () => ({ y: -100, duration: 300 })), P(c, d);
    };
    j(s, (c) => {
      f(a) && c(l);
    });
  }
  P(e, i), W();
}
var tu = /* @__PURE__ */ F('<div class="rcb-ui-main svelte-nr408n"><!></div>');
const nu = {
  hash: "svelte-nr408n",
  code: ".rcb-ui-main.svelte-nr408n {flex:1;display:flex;background-color:var(--rc-color-background);}"
};
function au(e, r) {
  V(r, !1), U(e, nu);
  const t = ie();
  let n = v(r, "brandingAppearance", 8, void 0), a = v(r, "body", 8), o = v(r, "header", 8, null), i = ie(!0);
  tr(() => {
    setTimeout(() => A(i, !0), 10);
  }), Oe(
    () => xr(n()),
    () => {
      A(t, new Lr(n()).formStyleVars);
    }
  ), dt(), oe();
  var s = tu(), l = E(s);
  Zo(l, {
    get show() {
      return f(i);
    },
    layoutStyle: "",
    get header() {
      return o();
    },
    get body() {
      return a();
    }
  }), N(() => Z(s, "style", f(t))), P(e, s), W();
}
var ou = /* @__PURE__ */ F('<div class="rcb-processing svelte-2j2b59"></div>');
const iu = {
  hash: "svelte-2j2b59",
  code: `.rcb-processing.svelte-2j2b59 {width:var(--width, 12px);aspect-ratio:1;border-radius:50%;
    animation: svelte-2j2b59-l5 1.5s infinite linear;}

  @keyframes svelte-2j2b59-l5 {
    0% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    25% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #ffff;
      background: #fff2;
    }
    50% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #ffff;
    }
    75% {
      box-shadow:
        var(--shadow-offset) 0 #ffff,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    100% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
  }`
};
function su(e, r) {
  U(e, iu);
  let t = v(r, "size", 8, "medium");
  const n = {
    small: { width: "8px", offset: "10px" },
    medium: { width: "12px", offset: "20px" },
    large: { width: "16px", offset: "30px" }
  };
  var a = ou();
  N(() => Z(a, "style", `--shadow-offset: ${n[t()].offset ?? ""}; --width: ${n[t()].width ?? ""};`)), P(e, a);
}
var lu = /* @__PURE__ */ F("<button><!></button>");
const cu = {
  hash: "svelte-1uig1bc",
  code: `button.svelte-1uig1bc {border:none;border-radius:var(--rc-shape-input-button-border-radius);font-size:16px;cursor:pointer;height:var(--rc-spacing-inputHeight-mobile);color:var(--rc-color-grey-text-dark);background-color:var(--rc-color-grey-ui-dark);display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:rgba(0, 0, 0, 0);-webkit-tap-highlight-color:transparent;transition:background-color 0.15s ease-in-out;user-select:none;}

  @container layout-query-container (width >= 768px) {button.svelte-1uig1bc {height:var(--rc-spacing-inputHeight-desktop);}
  }

  /* focus-visible is triggered only when focused with keyboard/reader */button.svelte-1uig1bc:focus-visible {outline:2px solid var(--rc-color-focus);}button.intent-primary.svelte-1uig1bc {background-color:var(--rc-color-primary);color:var(--rc-color-primary-text);font-size:16px;}button.svelte-1uig1bc:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);outline:none;}button.intent-primary.svelte-1uig1bc:not(:disabled):hover {background-color:var(--rc-color-primary-hover);}button.intent-primary.svelte-1uig1bc:not(:disabled):active,
  button.svelte-1uig1bc:active {background-color:var(--rc-color-primary-pressed);outline:none;}button.intent-primary.svelte-1uig1bc:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);}`
};
function ea(e, r) {
  V(r, !1), U(e, cu);
  let t = v(r, "intent", 8, "primary"), n = v(r, "disabled", 8, !1), a = v(r, "testId", 8, void 0), o = v(r, "type", 8, void 0), i = v(r, "loading", 8, !1), s = v(r, "children", 8);
  oe();
  var l = lu(), c = E(l);
  {
    var d = (p) => {
      su(p, { size: "small" });
    }, u = (p) => {
      var _ = ae(), m = J(_);
      be(m, () => s() ?? se), P(p, _);
    };
    j(c, (p) => {
      i() ? p(d) : p(u, !1);
    });
  }
  N(() => {
    Xt(l, `${`intent-${t()}` ?? ""} svelte-1uig1bc`), l.disabled = n(), Z(l, "data-testid", a()), Z(l, "type", o());
  }), Sr("click", l, function(p) {
    Jn.call(this, r, p);
  }), P(e, l), W();
}
const uu = `<svg width="40" height="40" viewBox="0 0 124 124" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="currentColor"/>
    <path d="M87.6668 41.504L82.4968 36.334L62.0002 56.8307L41.5035 36.334L36.3335 41.504L56.8302 62.0006L36.3335 82.4973L41.5035 87.6673L62.0002 67.1706L82.4968 87.6673L87.6668 82.4973L67.1702 62.0006L87.6668 41.504Z"
          fill="white"/>
</svg>
`;
var du = /* @__PURE__ */ F('<div style="color:var(--rc-color-primary);" class="rcb-ui-asset-icon svelte-4yc1p3"><!></div>');
const _u = {
  hash: "svelte-4yc1p3",
  code: ".rcb-ui-asset-icon.svelte-4yc1p3 {width:40px;height:40px;margin:0 auto;}"
};
function Ko(e) {
  U(e, _u);
  var r = du(), t = E(r);
  ft(t, () => uu), P(e, r);
}
var pu = /* @__PURE__ */ F('<footer class="rcb-modal-footer svelte-1f9z0o8"><!></footer>');
const fu = {
  hash: "svelte-1f9z0o8",
  code: "footer.svelte-1f9z0o8 {display:flex;flex-direction:column;}"
};
function $o(e, r) {
  V(r, !1), U(e, fu);
  let t = v(r, "children", 8);
  oe();
  var n = pu(), a = E(n);
  be(a, () => t() ?? se), P(e, n), W();
}
var mu = /* @__PURE__ */ F("<div><!></div>");
const hu = {
  hash: "svelte-uscdhg",
  code: `.rcb-column.svelte-uscdhg {display:flex;flex-direction:column;justify-content:flex-start;flex-grow:1;}.rcb-column.align-center.svelte-uscdhg {justify-content:center;}.rcb-column.align-end.svelte-uscdhg {justify-content:flex-end;}.rcb-column.gap-small.svelte-uscdhg {gap:var(--rc-spacing-gapSmall-mobile);}.rcb-column.gap-medium.svelte-uscdhg {gap:var(--rc-spacing-gapMedium-mobile);}.rcb-column.gap-large.svelte-uscdhg {gap:var(--rc-spacing-gapXXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-column.gap-small.svelte-uscdhg {gap:var(--rc-spacing-gapSmall-desktop);}.rcb-column.gap-medium.svelte-uscdhg {gap:var(--rc-spacing-gapMedium-desktop);}.rcb-column.gap-large.svelte-uscdhg {gap:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function xt(e, r) {
  V(r, !1), U(e, hu);
  let t = v(r, "gap", 8, "small"), n = v(r, "align", 8, "start"), a = v(r, "children", 8);
  oe();
  var o = mu(), i = E(o);
  be(i, () => a() ?? se), N(() => Xt(o, `rcb-column gap-${t() ?? ""} align-${n() ?? ""} svelte-uscdhg`)), P(e, o), W();
}
var gu = /* @__PURE__ */ F('<span class="rcb-title svelte-ybvuk3"> </span>'), yu = /* @__PURE__ */ F('<span class="rcb-subtitle svelte-ybvuk3"><!></span>'), bu = /* @__PURE__ */ F("<!> <!> <!>", 1), vu = /* @__PURE__ */ F('<div class="rcb-modal-message svelte-ybvuk3"><!></div>'), ku = /* @__PURE__ */ F('<div class="message-layout svelte-ybvuk3"><div class="message-layout-content svelte-ybvuk3"><!></div> <div class="message-layout-footer svelte-ybvuk3"><!></div></div>');
const wu = {
  hash: "svelte-ybvuk3",
  code: `.message-layout.svelte-ybvuk3 {display:flex;flex-direction:column;}.message-layout-content.svelte-ybvuk3 {flex-grow:1;display:flex;flex-direction:column;justify-content:center;}.rcb-modal-message.svelte-ybvuk3 {width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;}.rcb-modal-message[data-has-title="false"].svelte-ybvuk3 {margin-top:var(--rc-spacing-gapXXLarge-mobile);}.rcb-title.svelte-ybvuk3 {font:var(--rc-text-titleLarge-mobile);}.rcb-subtitle.svelte-ybvuk3 {font:var(--rc-text-body1-mobile);}

  @container layout-query-container (width < 768px) {.message-layout.svelte-ybvuk3 {flex-grow:1;}
  }

  @container layout-query-container (width >= 768px) {.message-layout.svelte-ybvuk3 {min-height:440px;}.message-layout-content.svelte-ybvuk3 {justify-content:flex-start;flex-grow:1;}.message-layout-footer.svelte-ybvuk3 {margin-top:var(--rc-spacing-gapXXLarge-desktop);}.rcb-modal-message[data-has-title="false"].svelte-ybvuk3 {margin-top:var(--rc-spacing-gapXXLarge-desktop);}.rcb-title.svelte-ybvuk3 {font:var(--rc-text-titleLarge-desktop);}.rcb-subtitle.svelte-ybvuk3 {font:var(--rc-text-body1-desktop);}
  }`
};
function ra(e, r) {
  V(r, !1), U(e, wu);
  let t = v(r, "onContinue", 8), n = v(r, "title", 8, null), a = v(r, "type", 8), o = v(r, "closeButtonTitle", 8, "Go back to app"), i = v(r, "icon", 8, null), s = v(r, "message", 8);
  function l() {
    t()();
  }
  oe();
  var c = ku(), d = E(c), u = E(d);
  xt(u, {
    gap: "large",
    children: (m, h) => {
      $n(m, {
        children: (b, y) => {
          var g = vu(), k = E(g);
          xt(k, {
            gap: "large",
            align: "center",
            children: (w, x) => {
              xt(w, {
                gap: "large",
                align: "center",
                children: (S, D) => {
                  var I = bu(), T = J(I);
                  {
                    var Y = (C) => {
                      var G = ae(), L = J(G);
                      be(L, i), P(C, G);
                    };
                    j(T, (C) => {
                      i() && C(Y);
                    });
                  }
                  var K = M(T, 2);
                  {
                    var ne = (C) => {
                      var G = gu(), L = E(G);
                      N(() => Se(L, n())), P(C, G);
                    };
                    j(K, (C) => {
                      n() && C(ne);
                    });
                  }
                  var le = M(K, 2);
                  {
                    var X = (C) => {
                      var G = yu(), L = E(G);
                      be(L, s), P(C, G);
                    };
                    j(le, (C) => {
                      s() && C(X);
                    });
                  }
                  P(S, I);
                },
                $$slots: { default: !0 }
              });
            },
            $$slots: { default: !0 }
          }), N(() => {
            Z(g, "data-type", a()), Z(g, "data-has-title", !!n());
          }), P(b, g);
        },
        $$slots: { default: !0 }
      });
    },
    $$slots: { default: !0 }
  });
  var p = M(d, 2), _ = E(p);
  $o(_, {
    children: (m, h) => {
      ea(m, {
        type: "submit",
        $$events: { click: l },
        children: (b, y) => {
          var g = Rr();
          N(() => Se(g, o())), P(b, g);
        },
        $$slots: { default: !0 }
      });
    },
    $$slots: { default: !0 }
  }), P(e, c), W();
}
var Pu = /* @__PURE__ */ F('<p class="footer-caption svelte-1jp0uw4"> </p>'), xu = /* @__PURE__ */ F('<p class="footer-caption svelte-1jp0uw4"> </p>'), Su = /* @__PURE__ */ F('<div class="footer-caption-container svelte-1jp0uw4"><!> <!> <p class="footer-caption svelte-1jp0uw4"><!></p></div>');
const Eu = {
  hash: "svelte-1jp0uw4",
  code: `.footer-caption-container.svelte-1jp0uw4 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);}.footer-caption.svelte-1jp0uw4 {font:var(--rc-text-caption-mobile);color:var(--rc-color-grey-text-light);text-align:center;font-weight:500;margin:0;}

  @container layout-query-container (width >= 768px) {.footer-caption.svelte-1jp0uw4 {font:var(--rc-text-caption-desktop);}.footer-caption-container.svelte-1jp0uw4 {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function ei(e, r) {
  V(r, !1), U(e, Eu);
  let t = v(r, "termsInfo", 8, null), n = v(r, "trialInfo", 8, null);
  oe();
  var a = Su(), o = E(a);
  {
    var i = (u) => {
      var p = Pu(), _ = E(p);
      N(() => Se(_, t())), P(u, p);
    };
    j(o, (u) => {
      t() && u(i);
    });
  }
  var s = M(o, 2);
  {
    var l = (u) => {
      var p = xu(), _ = E(p);
      N(() => Se(_, n())), P(u, p);
    };
    j(s, (u) => {
      n() && u(l);
    });
  }
  var c = M(s, 2), d = E(c);
  he(d, {
    get key() {
      return z.StateNeedsPaymentInfoPaymentStepTitle;
    }
  }), P(e, a), W();
}
var ri = "https://js.stripe.com/v3", qu = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var Fu = function() {
  for (var r = document.querySelectorAll('script[src^="'.concat(ri, '"]')), t = 0; t < r.length; t++) {
    var n = r[t];
    if (qu.test(n.src))
      return n;
  }
  return null;
}, za = function(r) {
  var t = "", n = document.createElement("script");
  n.src = "".concat(ri).concat(t);
  var a = document.head || document.body;
  if (!a)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return a.appendChild(n), n;
}, Iu = function(r, t) {
  !r || !r._registerWrapper || r._registerWrapper({
    name: "stripe-js",
    version: "4.6.0",
    startTime: t
  });
}, Jr = null, kt = null, wt = null, Tu = function(r) {
  return function() {
    r(new Error("Failed to load Stripe.js"));
  };
}, Du = function(r, t) {
  return function() {
    window.Stripe ? r(window.Stripe) : t(new Error("Stripe.js not available"));
  };
}, Au = function(r) {
  return Jr !== null ? Jr : (Jr = new Promise(function(t, n) {
    if (typeof window > "u" || typeof document > "u") {
      t(null);
      return;
    }
    if (window.Stripe) {
      t(window.Stripe);
      return;
    }
    try {
      var a = Fu();
      if (!(a && r)) {
        if (!a)
          a = za(r);
        else if (a && wt !== null && kt !== null) {
          var o;
          a.removeEventListener("load", wt), a.removeEventListener("error", kt), (o = a.parentNode) === null || o === void 0 || o.removeChild(a), a = za(r);
        }
      }
      wt = Du(t, n), kt = Tu(n), a.addEventListener("load", wt), a.addEventListener("error", kt);
    } catch (i) {
      n(i);
      return;
    }
  }), Jr.catch(function(t) {
    return Jr = null, Promise.reject(t);
  }));
}, Cu = function(r, t, n) {
  if (r === null)
    return null;
  var a = r.apply(void 0, t);
  return Iu(a, n), a;
}, Qr, ti = !1, ni = function() {
  return Qr || (Qr = Au(null).catch(function(r) {
    return Qr = null, Promise.reject(r);
  }), Qr);
};
Promise.resolve().then(function() {
  return ni();
}).catch(function(e) {
  ti || console.warn(e);
});
var Mu = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  ti = !0;
  var a = Date.now();
  return ni().then(function(o) {
    return Cu(o, t, a);
  });
};
class St {
  static async initializeStripe(r, t, n, a, o) {
    const i = r.gateway_params, s = i.publishable_api_key, l = i.stripe_account_id, c = i.elements_configuration;
    if (!s || !l || !c)
      throw new Error("Stripe configuration is missing");
    const d = await Mu(s, {
      stripeAccount: l
    });
    if (!d)
      throw new Error("Stripe client not found");
    const u = new Lr(t == null ? void 0 : t.appearance), p = u.shape, _ = u.formColors, m = u.textStyles, h = En.body1[o].fontSize || En.body1.mobile.fontSize, b = d.elements({
      loader: "always",
      locale: n,
      mode: c.mode,
      paymentMethodTypes: c.payment_method_types,
      setupFutureUsage: c.setup_future_usage,
      amount: c.amount,
      currency: c.currency,
      appearance: {
        theme: "stripe",
        labels: "floating",
        variables: {
          borderRadius: p["input-border-radius"],
          fontLineHeight: "10px",
          focusBoxShadow: "none",
          colorDanger: _.error,
          colorTextPlaceholder: _["grey-text-light"],
          colorText: _["grey-text-dark"],
          colorTextSecondary: _["grey-text-light"],
          fontSizeBase: h,
          ...a
        },
        rules: {
          ".Input": {
            boxShadow: "none",
            paddingTop: "6px",
            paddingBottom: "6px",
            fontSize: h,
            border: `1px solid ${_["grey-ui-dark"]}`,
            backgroundColor: _["input-background"],
            color: _["grey-text-dark"]
          },
          ".Input:focus": {
            border: `1px solid ${_.focus}`,
            outline: "none"
          },
          ".Label": {
            fontWeight: m.body1[o].fontWeight,
            lineHeight: "22px",
            color: _["grey-text-dark"]
          },
          ".Label--floating": {
            opacity: "1"
          },
          ".Input--invalid": {
            boxShadow: "none"
          },
          ".TermsText": {
            fontSize: m.caption[o].fontSize,
            lineHeight: m.caption[o].lineHeight
          },
          ".Tab": {
            boxShadow: "none",
            backgroundColor: "transparent",
            color: _["grey-text-light"],
            border: `1px solid ${_["grey-ui-dark"]}`
          },
          ".Tab:hover, .Tab:focus, .Tab--selected, .Tab--selected:hover, .Tab--selected:focus": {
            boxShadow: "none",
            color: _["grey-text-dark"]
          },
          ".Tab:focus, .Tab--selected, .Tab--selected:hover, .Tab--selected:focus": {
            border: `1px solid ${_.focus}`
          },
          ".TabIcon": {
            fill: _["grey-text-light"]
          },
          ".TabIcon--selected": {
            fill: _["grey-text-dark"]
          },
          ".Block": {
            boxShadow: "none",
            backgroundColor: "transparent",
            border: `1px solid ${_["grey-ui-dark"]}`
          }
        }
      }
    });
    return { stripe: d, elements: b };
  }
  static isStripeHandledCardError(r) {
    return !!(r.type === "card_error" && r.code && this.FORM_VALIDATED_CARD_ERROR_CODES.includes(r.code));
  }
  static createPaymentElement(r, t) {
    return r.create("payment", {
      business: t ? { name: t } : void 0,
      layout: {
        type: "tabs"
      },
      terms: {
        applePay: "never",
        auBecsDebit: "never",
        bancontact: "never",
        card: "never",
        cashapp: "never",
        googlePay: "never",
        ideal: "never",
        paypal: "never",
        sepaDebit: "never",
        sofort: "never",
        usBankAccount: "never"
      }
    });
  }
}
q(St, "FORM_VALIDATED_CARD_ERROR_CODES", [
  "card_declined",
  "expired_card",
  "incorrect_cvc",
  "incorrect_number"
]);
const Qt = "rcb-ui-events-tracker";
var ve = /* @__PURE__ */ ((e) => (e.SDKInitialized = "sdk_initialized", e.CheckoutSessionStart = "checkout_session_start", e.CheckoutSessionEnd = "checkout_session_end", e.CheckoutFlowError = "checkout_flow_error", e.CheckoutBillingFormImpression = "checkout_billing_form_impression", e.CheckoutBillingFormDismiss = "checkout_billing_form_dismiss", e.CheckoutBillingFormSubmit = "checkout_billing_form_submit", e.CheckoutBillingFormSuccess = "checkout_billing_form_success", e.CheckoutBillingFormError = "checkout_billing_form_error", e.CheckoutPaymentFormImpression = "checkout_payment_form_impression", e.CheckoutPaymentFormDismiss = "checkout_payment_form_dismiss", e.CheckoutPaymentFormSubmit = "checkout_payment_form_submit", e.CheckoutPaymentFormGatewayError = "checkout_payment_form_gateway_error", e.CheckoutPurchaseSuccessfulImpression = "checkout_purchase_successful_impression", e.CheckoutPurchaseSuccessfulDismiss = "checkout_purchase_successful_dismiss", e))(ve || {});
function ju({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: ve.CheckoutFlowError,
    properties: {
      errorCode: e,
      errorMessage: r
    }
  };
}
function Nu({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: ve.CheckoutBillingFormError,
    properties: {
      errorCode: e,
      errorMessage: r
    }
  };
}
function Ou({
  appearance: e,
  rcPackage: r,
  purchaseOptionToUse: t,
  customerEmail: n
}) {
  return {
    eventName: ve.CheckoutSessionStart,
    properties: {
      customizationColorButtonsPrimary: (e == null ? void 0 : e.color_buttons_primary) ?? null,
      customizationColorAccent: (e == null ? void 0 : e.color_accent) ?? null,
      customizationColorError: (e == null ? void 0 : e.color_error) ?? null,
      customizationColorProductInfoBg: (e == null ? void 0 : e.color_product_info_bg) ?? null,
      customizationColorFormBg: (e == null ? void 0 : e.color_form_bg) ?? null,
      customizationColorPageBg: (e == null ? void 0 : e.color_page_bg) ?? null,
      customizationFont: (e == null ? void 0 : e.font) ?? null,
      customizationShapes: (e == null ? void 0 : e.shapes) ?? null,
      customizationShowProductDescription: (e == null ? void 0 : e.show_product_description) ?? null,
      productInterval: r.webBillingProduct.normalPeriodDuration,
      productPrice: r.webBillingProduct.currentPrice.amountMicros,
      productCurrency: r.webBillingProduct.currentPrice.currency,
      selectedProductId: r.webBillingProduct.identifier,
      selectedPackageId: r.identifier,
      selectedPurchaseOption: t.id,
      customerEmailProvidedByDeveloper: !!n
    }
  };
}
function Ru({
  redemptionInfo: e
}) {
  return {
    eventName: ve.CheckoutSessionEnd,
    properties: {
      outcome: "finished",
      withRedemptionInfo: !!e
    }
  };
}
function Lu() {
  return {
    eventName: ve.CheckoutSessionEnd,
    properties: {
      outcome: "closed"
    }
  };
}
function zu({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: ve.CheckoutSessionEnd,
    properties: {
      outcome: "errored",
      errorCode: e,
      errorMessage: r
    }
  };
}
function Uu({
  selectedPaymentMethod: e
}) {
  return {
    eventName: ve.CheckoutPaymentFormSubmit,
    properties: {
      selectedPaymentMethod: e ?? null
    }
  };
}
function Bu({
  errorCode: e,
  errorMessage: r
}) {
  return {
    eventName: ve.CheckoutPaymentFormGatewayError,
    properties: {
      errorCode: e,
      errorMessage: r
    }
  };
}
const Vu = `<svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <g transform="scale(0.5)" transform-origin="center">
  <path d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 11.5858 20.8358 11.25 21.25 11.25C21.6642 11.25 22 11.5858 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.4142 2 12.75 2.33579 12.75 2.75C12.75 3.16421 12.4142 3.5 12 3.5Z" fill="currentColor"/>
  </g>
</svg>`;
var Wu = /* @__PURE__ */ F('<div style="color:var(--rc-color-accent);" class="rcb-ui-asset-icon svelte-1sxpw7o"><!></div>');
const Yu = {
  hash: "svelte-1sxpw7o",
  code: `
  @-webkit-keyframes svelte-1sxpw7o-rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes svelte-1sxpw7o-rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }div.svelte-1sxpw7o {width:80px;height:80px;
    -webkit-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    -moz-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    -ms-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    -o-animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;
    animation: svelte-1sxpw7o-rotating 2s ease-in-out infinite;}`
};
function Hu(e) {
  U(e, Yu);
  var r = Wu(), t = E(r);
  ft(t, () => Vu), P(e, r);
}
var Gu = /* @__PURE__ */ F('<div class="rcb-modal-loader svelte-102edf4"><!></div>');
const Xu = {
  hash: "svelte-102edf4",
  code: `.rcb-modal-loader.svelte-102edf4 {width:100%;flex-grow:1;display:flex;justify-content:center;align-items:center;}

  @container layout-query-container (width >= 768px) {.rcb-modal-loader.svelte-102edf4 {align-items:flex-start;margin-top:calc(var(--rc-spacing-gapXXLarge-desktop) * 6);}
  }`
};
function qn(e) {
  U(e, Xu);
  var r = Gu(), t = E(r);
  Hu(t), P(e, r);
}
var Ju = /* @__PURE__ */ F('<div class="rc-checkout-container svelte-e5x97"><!> <form data-testid="payment-form" class="rc-checkout-form svelte-e5x97"><div class="rc-checkout-form-container svelte-e5x97"><div class="rc-payment-element-container svelte-e5x97"><div id="payment-element" class="svelte-e5x97"></div></div> <div class="rc-checkout-pay-container svelte-e5x97"><!> <div class="rc-checkout-secure-container svelte-e5x97"><!></div></div></div> <!></form></div>');
const Qu = {
  hash: "svelte-e5x97",
  code: `.rc-checkout-secure-container.svelte-e5x97 {margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-container.svelte-e5x97 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);user-select:none;}.rc-checkout-pay-container.svelte-e5x97 {display:flex;flex-direction:column;margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-form-container.svelte-e5x97 {width:100%;}.rc-payment-element-container.svelte-e5x97 {
    /* The standard height of the payment form from Stripe */
    /* Added to avoid the card getting smaller while loading */min-height:210px;}.hidden.svelte-e5x97 {visibility:hidden;}

  @container layout-query-container (width <= 767px) {.rc-checkout-pay-container.svelte-e5x97 {flex-grow:1;justify-content:flex-end;}.rc-checkout-form.svelte-e5x97 {flex-grow:1;}.rc-checkout-form-container.svelte-e5x97 {height:100%;display:flex;flex-direction:column;}.rc-checkout-container.svelte-e5x97 {flex-grow:1;}
  }

  @container layout-query-container (width >= 768px) {.rc-checkout-secure-container.svelte-e5x97 {margin-top:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-container.svelte-e5x97 {gap:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-pay-container.svelte-e5x97 {margin-top:var(--rc-spacing-gapXLarge-desktop);}
  }`
};
function Zu(e, r) {
  var sa;
  V(r, !1), U(e, Qu);
  const t = ar(), n = () => nr(X, "$translator", t), a = ie(), o = ie();
  let i = v(r, "onContinue", 8), s = v(r, "paymentInfoCollectionMetadata", 8), l = v(r, "processing", 12, !1), c = v(r, "productDetails", 8), d = v(r, "purchaseOption", 8), u = v(r, "brandingInfo", 8), p = v(r, "purchaseOperationHelper", 8), _ = null, m = ie(), h = ie(), b = null, y = ie(void 0), g = ie(!1), k, w, x = ie(!0);
  const S = (sa = c().subscriptionOptions) == null ? void 0 : sa[d().id], D = We(Qt);
  let I = new Lr().spacing, T, Y = "mobile";
  function K() {
    window.matchMedia && window.matchMedia("(max-width: 767px)").matches ? Y = "mobile" : Y = "desktop", T = {
      fontSizeBase: "14px",
      fontFamily: Sn,
      spacingGridRow: I.gapXLarge[Y]
    };
  }
  let ne;
  function le() {
    clearTimeout(ne), ne = setTimeout(
      () => {
        K();
      },
      150
    );
  }
  const X = We(hr), C = (R) => {
    if (["ca", "hi", "uk"].includes(R))
      return "auto";
    const ue = { zh_Hans: "zh", zh_Hant: "zh" };
    return Object.keys(ue).includes(R) ? ue[R] : R;
  };
  tr(() => (K(), window.addEventListener("resize", le), () => {
    window.removeEventListener("resize", le);
  })), tr(() => {
    let R = !0;
    return D.trackSDKEvent({
      eventName: ve.CheckoutPaymentFormImpression
    }), (async () => {
      var fe;
      try {
        const {
          stripe: ue,
          elements: Ne
        } = await St.initializeStripe(s(), u(), f(o), T, Y);
        if (!R) return;
        _ = ue, A(m, Ne), b = St.createPaymentElement(f(m), (fe = u()) == null ? void 0 : fe.app_name), b.mount("#payment-element"), b.on("ready", () => {
          A(x, !1);
        }), b.on("change", (ce) => {
          A(g, ce.complete), f(g) && (w = ce.value.type);
        }), b.on("loaderror", (ce) => {
          R = !1;
          const Qe = new re(de.ErrorSettingUpPurchase, "Failed to load payment form", ce.error instanceof Error ? ce.error.message : String(ce.error));
          L(Qe);
        });
      } catch (ue) {
        if (!R) return;
        A(x, !1);
        const Ne = new re(de.ErrorSettingUpPurchase, "Failed to initialize payment form", ue instanceof Error ? ue.message : String(ue));
        L(Ne);
      }
    })(), () => {
      R && (R = !1, b == null || b.destroy());
    };
  });
  const G = async () => {
    if (l() || !_ || !f(h)) return;
    const R = Uu({
      selectedPaymentMethod: w ?? null
    });
    D.trackSDKEvent(R), l(!0);
    const { error: fe } = await f(h).submit();
    if (fe)
      L(fe);
    else {
      const ue = await _e(_);
      ue ? L(ue) : i()();
    }
  };
  function L(R) {
    var ue;
    l(!1);
    const fe = Bu({
      errorCode: R instanceof re ? (ue = R.errorCode) == null ? void 0 : ue.toString() : R.code ?? null,
      errorMessage: R.message ?? ""
    });
    D.trackSDKEvent(fe), R instanceof re ? R.isRecoverable() ? A(y, R.getPublicErrorMessage(c())) : i()({ error: R }) : St.isStripeHandledCardError(R) || A(y, R.message);
  }
  const _e = async (R) => {
    var Ne;
    if (!k)
      try {
        const ce = await p().checkoutComplete();
        if (k = (Ne = ce == null ? void 0 : ce.gateway_params) == null ? void 0 : Ne.client_secret, !k)
          throw new Error("Failed to complete checkout");
      } catch (ce) {
        return ce;
      }
    const fe = k.startsWith("seti_");
    return (await R[fe ? "confirmSetup" : "confirmPayment"]({
      elements: f(h),
      clientSecret: k,
      redirect: "if_required"
    })).error;
  }, Ye = () => {
    A(y, void 0);
  };
  Oe(() => n(), () => {
    A(a, n().locale || n().fallbackLocale);
  }), Oe(() => f(a), () => {
    A(o, C(f(a)));
  }), Oe(() => f(m), () => {
    f(m) && f(m)._elements.length > 0 && A(h, f(m));
  }), dt(), oe();
  var je = Ju(), He = E(je);
  {
    var Ge = (R) => {
      qn(R);
    };
    j(He, (R) => {
      (f(x) || l()) && R(Ge);
    });
  }
  var Xe = M(He, 2), De = E(Xe), Ir = E(De), gr = E(Ir), Tr = M(Ir, 2), Hr = E(Tr);
  {
    var Kt = (R) => {
      var fe = /* @__PURE__ */ te(() => l() || !f(g) || f(x));
      ea(R, {
        get disabled() {
          return f(fe);
        },
        testId: "PayButton",
        children: (ue, Ne) => {
          var ce = ae(), Qe = J(ce);
          {
            var gt = (Ze) => {
              he(Ze, {
                get key() {
                  return z.StateNeedsPaymentInfoButtonStartTrial;
                }
              });
            }, yt = (Ze) => {
              he(Ze, {
                get key() {
                  return z.StateNeedsPaymentInfoButtonPay;
                }
              });
            };
            j(Qe, (Ze) => {
              S != null && S.trial ? Ze(gt) : Ze(yt, !1);
            });
          }
          P(ue, ce);
        },
        $$slots: { default: !0 }
      });
    };
    j(Hr, (R) => {
      f(y) || R(Kt);
    });
  }
  var $t = M(Hr, 2), en = E($t), ee = /* @__PURE__ */ te(() => {
    var R;
    return n().translate(z.StateNeedsPaymentInfoTermsInfo, { appName: (R = u()) == null ? void 0 : R.app_name });
  }), Je = /* @__PURE__ */ te(() => {
    var R, fe, ue, Ne, ce, Qe, gt, yt, Ze, la, ca;
    return (R = S == null ? void 0 : S.base) != null && R.price && ((fe = S == null ? void 0 : S.trial) != null && fe.period) && ((ue = S == null ? void 0 : S.base) != null && ue.period) && ((ce = (Ne = S == null ? void 0 : S.base) == null ? void 0 : Ne.period) != null && ce.unit) ? n().translate(z.StateNeedsPaymentInfoTrialInfo, {
      price: tt((Qe = S == null ? void 0 : S.base) == null ? void 0 : Qe.price.amountMicros, (gt = S == null ? void 0 : S.base) == null ? void 0 : gt.price.currency, f(o)),
      perFrequency: n().translatePeriodFrequency(((Ze = (yt = S == null ? void 0 : S.base) == null ? void 0 : yt.period) == null ? void 0 : Ze.number) || 1, (ca = (la = S == null ? void 0 : S.base) == null ? void 0 : la.period) == null ? void 0 : ca.unit, { useMultipleWords: !0 }),
      renewalDate: n().translateDate(Uo(/* @__PURE__ */ new Date(), S.trial.period || S.base.period), {
        year: "numeric",
        month: "long",
        day: "numeric"
      })
    }) : null;
  });
  ei(en, {
    get termsInfo() {
      return f(ee);
    },
    get trialInfo() {
      return f(Je);
    }
  });
  var Dr = M(De, 2);
  {
    var yr = (R) => {
      var fe = /* @__PURE__ */ te(() => n().translate(z.StateErrorButtonTryAgain));
      ra(R, {
        title: null,
        type: "error",
        get closeButtonTitle() {
          return f(fe);
        },
        onContinue: Ye,
        icon: (ce) => {
          Ko(ce);
        },
        message: (ce) => {
          var Qe = Rr();
          N(() => Se(Qe, f(y))), P(ce, Qe);
        },
        $$slots: { icon: !0, message: !0 }
      });
    };
    j(Dr, (R) => {
      f(y) && R(yr);
    });
  }
  N(() => {
    qr(Xe, "hidden", f(x) || l()), De.hidden = !!f(y), qr(gr, "hidden", f(x));
  }), Sr("submit", Xe, Ro(G)), P(e, je), W();
}
function Ku(e) {
  return e.trim() === "" ? "You need to provide your email address to continue." : e.match(/^[^@]+@[^@]+\.[^@]+$/) ? null : "Email is not valid. Please provide a valid email address.";
}
function $u(e) {
  if (e && !e.match(/^[A-Z]{3}$/)) {
    const r = `Currency code ${e} is not valid. Please provide a valid ISO 4217 currency code.`;
    throw H.errorLog(r), new pe(ye.ConfigurationError, r);
  }
}
var ed = /* @__PURE__ */ F('<div class="rcb-form-error svelte-6gh7as"> </div>'), rd = /* @__PURE__ */ F('<div class="rcb-form-container svelte-6gh7as"><div><input id="email" name="email" inputmode="email" autocapitalize="off" autocomplete="email" data-testid="email" class="svelte-6gh7as"></div> <!></div>'), td = /* @__PURE__ */ F('<!> <div class="secure-checkout-container svelte-6gh7as"><!></div>', 1), nd = /* @__PURE__ */ F('<div class="rcb-state-container svelte-6gh7as"><span class="rcb-auth-info-title svelte-6gh7as"><label for="email"><!></label></span> <form class="svelte-6gh7as"><!> <!></form></div>');
const ad = {
  hash: "svelte-6gh7as",
  code: `.rcb-auth-info-title.svelte-6gh7as {font:var(--rc-text-titleLarge-mobile);}.secure-checkout-container.svelte-6gh7as {margin-top:var(--rc-spacing-gapXXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-auth-info-title.svelte-6gh7as {font:var(--rc-text-titleLarge-desktop);}.secure-checkout-container.svelte-6gh7as {margin-top:var(--rc-spacing-gapXXLarge-desktop);}
  }.rcb-state-container.svelte-6gh7as {display:flex;flex-direction:column;flex-grow:1;user-select:none;}form.svelte-6gh7as {display:flex;flex-direction:column;flex-grow:1;}.rcb-form-container.svelte-6gh7as {display:flex;flex-direction:column;width:100%;margin-top:var(--rc-spacing-gapXLarge-desktop);margin-bottom:var(--rc-spacing-gapXLarge-desktop);}

  @media screen and (max-width: 767px) {.rcb-form-container.svelte-6gh7as {margin-top:var(--rc-spacing-gapXLarge-mobile);margin-bottom:var(--rc-spacing-gapXLarge-mobile);}
  }.rcb-form-label.svelte-6gh7as {margin-top:var(--rc-spacing-gapSmall-desktop);margin-bottom:var(--rc-spacing-gapSmall-desktop);font:var(--rc-text-body1-mobile);display:block;}

  @container layout-query-container (width >= 768px) {.rcb-form-label.svelte-6gh7as {font:var(--rc-text-body1-desktop);}
  }.rcb-form-input.error.svelte-6gh7as input:where(.svelte-6gh7as) {border-color:var(--rc-color-error);}.rcb-form-error.svelte-6gh7as {margin-top:var(--rc-spacing-gapSmall-desktop);font:var(--rc-text-body1-mobile);color:var(--rc-color-error);}

  @container layout-query-container (width >= 768px) {.rcb-form-error.svelte-6gh7as {font:var(--rc-text-body1-desktop);}
  }input.svelte-6gh7as {width:100%;box-sizing:border-box;border:1px solid var(--rc-color-grey-ui-dark);border-radius:var(--rc-shape-input-border-radius);font:var(--rc-text-body1-mobile);height:var(--rc-spacing-inputHeight-desktop);background:var(--rc-color-input-background);color:inherit;}

  @container layout-query-container (width < 768px) {input.svelte-6gh7as {padding-left:var(--rc-spacing-gapLarge-mobile);height:var(--rc-spacing-inputHeight-mobile);}
  }

  @container layout-query-container (width >= 768px) {input.svelte-6gh7as {font:var(--rc-text-body1-desktop);padding-left:var(--rc-spacing-gapLarge-desktop);}.rcb-state-container.svelte-6gh7as {max-width:50vw;flex-grow:0;}
  }input.svelte-6gh7as:focus {outline:none;border:1px solid var(--rc-color-focus);}input.svelte-6gh7as::placeholder {color:var(--rc-color-grey-ui-dark);}`
};
function od(e, r) {
  V(r, !1), U(e, ad);
  const t = ar(), n = () => nr(p, "$translator", t), a = ie(), o = ie(), i = ie();
  let s = v(r, "onContinue", 8), l = v(r, "processing", 8), c = v(r, "lastError", 8);
  const d = We(Qt), u = async () => {
    if (A(o, Ku(f(a)) ?? ""), f(o) !== "") {
      const w = Nu({
        errorCode: null,
        errorMessage: f(o)
      });
      d.trackSDKEvent(w);
    } else
      d.trackSDKEvent({
        eventName: ve.CheckoutBillingFormSubmit
      }), s()({ authInfo: { email: f(a) } });
  };
  tr(() => {
    d.trackSDKEvent({
      eventName: ve.CheckoutBillingFormImpression
    });
  });
  const p = We(hr);
  Oe(() => {
  }, () => {
    A(a, "");
  }), Oe(() => xr(c()), () => {
    var w;
    A(o, ((w = c()) == null ? void 0 : w.message) || "");
  }), Oe(
    () => (xr(c()), f(o)),
    () => {
      var w;
      A(i, (((w = c()) == null ? void 0 : w.message) ?? f(o)) !== "" ? "error" : "");
    }
  ), dt(), oe();
  var _ = nd(), m = E(_), h = E(m), b = E(h);
  he(b, {
    get key() {
      return z.StateNeedsAuthInfoEmailStepTitle;
    }
  });
  var y = M(m, 2), g = E(y);
  $n(g, {
    children: (w, x) => {
      var S = rd(), D = E(S), I = E(D);
      N(() => Z(I, "placeholder", n().translate(z.StateNeedsAuthInfoEmailInputPlaceholder)));
      var T = M(D, 2);
      {
        var Y = (K) => {
          var ne = ed(), le = E(ne);
          N(() => Se(le, f(o))), P(K, ne);
        };
        j(T, (K) => {
          f(o) !== "" && K(Y);
        });
      }
      N(() => Xt(D, `rcb-form-input ${f(i) ?? ""} svelte-6gh7as`)), rl(I, () => f(a), (K) => A(a, K)), P(w, S);
    },
    $$slots: { default: !0 }
  });
  var k = M(g, 2);
  $o(k, {
    children: (w, x) => {
      var S = td(), D = J(S);
      xt(D, {
        children: (Y, K) => {
          ea(Y, {
            get disabled() {
              return l();
            },
            type: "submit",
            get loading() {
              return l();
            },
            children: (ne, le) => {
              he(ne, {
                get key() {
                  return z.StateNeedsAuthInfoButtonContinue;
                }
              });
            },
            $$slots: { default: !0 }
          });
        },
        $$slots: { default: !0 }
      });
      var I = M(D, 2), T = E(I);
      ei(T, {}), P(w, S);
    },
    $$slots: { default: !0 }
  }), Sr("submit", y, Ro(u)), P(e, _), W();
}
var id = /* @__PURE__ */ F('<br> <!> <a class="svelte-mv9iks"> </a>.', 1), sd = /* @__PURE__ */ F(" <!>", 1);
const ld = {
  hash: "svelte-mv9iks",
  code: "a.svelte-mv9iks {color:var(--rc-color-primary);}"
};
function cd(e, r) {
  V(r, !1), U(e, ld);
  const t = ar(), n = () => nr(l, "$translator", t);
  let a = v(r, "lastError", 8), o = v(r, "supportEmail", 8, null), i = v(r, "productDetails", 8, null), s = v(r, "onContinue", 8);
  const l = We(hr);
  tr(() => {
    H.errorLog(`Displayed error: ${de[a().errorCode]}. Message: ${a().message ?? "None"}. Underlying error: ${a().underlyingErrorMessage ?? "None"}`);
  });
  function c() {
    var _;
    switch (a().errorCode) {
      case de.AlreadyPurchasedError:
        return ((_ = i()) == null ? void 0 : _.productType) === Re.Subscription ? n().translate(z.StateErrorErrorTitleAlreadySubscribed) : n().translate(z.StateErrorErrorTitleAlreadyPurchased);
      default:
        return n().translate(z.StateErrorErrorTitleOtherErrors);
    }
  }
  function d() {
    var m;
    const _ = a().getErrorCode();
    switch (a().errorCode) {
      case de.UnknownError:
        return n().translate(z.StateErrorErrorMessageUnknownError, { errorCode: _ });
      case de.ErrorSettingUpPurchase:
        return n().translate(z.StateErrorErrorMessageErrorSettingUpPurchase, { errorCode: _ });
      case de.ErrorChargingPayment:
        return n().translate(z.StateErrorErrorMessageErrorChargingPayment, { errorCode: _ });
      case de.NetworkError:
        return n().translate(z.StateErrorErrorMessageNetworkError, { errorCode: _ });
      case de.MissingEmailError:
        return n().translate(z.StateErrorErrorMessageMissingEmailError, { errorCode: _ });
      case de.AlreadyPurchasedError:
        return ((m = i()) == null ? void 0 : m.productType) === Re.Subscription ? n().translate(z.StateErrorErrorMessageAlreadySubscribed, { errorCode: _ }) : n().translate(z.StateErrorErrorMessageAlreadyPurchased, { errorCode: _ });
    }
  }
  oe();
  var u = /* @__PURE__ */ te(c), p = /* @__PURE__ */ te(() => n().translate(z.StateErrorButtonTryAgain));
  ra(e, {
    get title() {
      return f(u);
    },
    get onContinue() {
      return s();
    },
    type: "error",
    get closeButtonTitle() {
      return f(p);
    },
    icon: (h) => {
      Ko(h);
    },
    message: (h) => {
      var b = sd(), y = J(b);
      N(() => Se(y, `${d() ?? ""} `));
      var g = M(y);
      {
        var k = (w) => {
          var x = id(), S = M(J(x), 2);
          he(S, {
            get key() {
              return z.StateErrorIfErrorPersists;
            }
          });
          var D = M(S, 2), I = E(D);
          N(() => {
            Z(D, "href", `mailto:${o() ?? ""}`), Se(I, o());
          }), P(w, x);
        };
        j(g, (w) => {
          o() && w(k);
        });
      }
      P(h, b);
    },
    $$slots: { icon: !0, message: !0 }
  }), W();
}
const ud = `<svg width="40" height="40" viewBox="0 0 124 124" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="currentColor"/>
    <rect x="44.1116" y="56" width="27.5" height="11" transform="rotate(45 44.1116 56)" fill="white"/>
    <rect x="79.1133" y="44.334" width="11" height="44" transform="rotate(45 79.1133 44.334)" fill="white"/>
</svg>
`;
var dd = /* @__PURE__ */ F('<div style="color:var(--rc-color-primary);" class="rcb-ui-asset-icon svelte-4yc1p3"><!></div>');
const _d = {
  hash: "svelte-4yc1p3",
  code: ".rcb-ui-asset-icon.svelte-4yc1p3 {width:40px;height:40px;margin:0 auto;}"
};
function pd(e) {
  U(e, _d);
  var r = dd(), t = E(r);
  ft(t, () => ud), P(e, r);
}
function fd(e, r) {
  var p;
  V(r, !1);
  const t = ar(), n = () => nr(s, "$translator", t);
  let a = v(r, "productDetails", 8, null), o = v(r, "onContinue", 8);
  const i = ((p = a()) == null ? void 0 : p.productType) === Re.Subscription, s = We(hr), l = We(Qt);
  function c() {
    l.trackSDKEvent({
      eventName: ve.CheckoutPurchaseSuccessfulDismiss,
      properties: { ui_element: "go_back_to_app" }
    }), o()();
  }
  tr(() => {
    l.trackSDKEvent({
      eventName: ve.CheckoutPurchaseSuccessfulImpression
    });
  }), oe();
  var d = /* @__PURE__ */ te(() => n().translate(z.StateSuccessPurchaseSuccessful)), u = /* @__PURE__ */ te(() => n().translate(z.StateSuccessButtonClose));
  ra(e, {
    type: "success",
    get title() {
      return f(d);
    },
    onContinue: c,
    get closeButtonTitle() {
      return f(u);
    },
    icon: (h) => {
      pd(h);
    },
    message: (h) => {
      var b = ae(), y = J(b);
      {
        var g = (k) => {
          he(k, {
            get key() {
              return z.StateSuccessSubscriptionNowActive;
            }
          });
        };
        j(y, (k) => {
          i && k(g);
        });
      }
      P(h, b);
    },
    $$slots: { icon: !0, message: !0 }
  }), W();
}
var md = /* @__PURE__ */ F('<div class="rcb-subscribe-to only-desktop svelte-1r4y9xn"><!></div>'), hd = /* @__PURE__ */ F('<span class="rcb-product-description svelte-1r4y9xn"><!></span>'), gd = /* @__PURE__ */ F('<div class="rcb-pricing-info-header svelte-1r4y9xn"><!> <div class="rcb-product-title svelte-1r4y9xn"><!></div> <!></div>');
const yd = {
  hash: "svelte-1r4y9xn",
  code: `.rcb-pricing-info-header.svelte-1r4y9xn {display:flex;flex-direction:column;gap:var(--rc-spacing-gapSmall-desktop);}.rcb-product-title.svelte-1r4y9xn {color:var(--rc-color-grey-text-dark);font:var(--rc-text-titleXLarge-mobile);}.rcb-product-description.svelte-1r4y9xn {font:var(--rc-text-body1-mobile);color:var(--rc-color-grey-text-dark);}.rcb-subscribe-to.svelte-1r4y9xn {font:var(--rc-text-body1-desktop);}.only-desktop.svelte-1r4y9xn {display:none;}

  @container layout-query-container (width >= 768px) {.only-desktop.svelte-1r4y9xn {display:block;}.rcb-pricing-info-header.svelte-1r4y9xn {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-desktop);}.rcb-product-title.svelte-1r4y9xn {font:var(--rc-text-titleXLarge-desktop);}.rcb-product-description.svelte-1r4y9xn {font:var(--rc-text-body1-desktop);}
  }`
};
function bd(e, r) {
  V(r, !1), U(e, yd);
  let t = v(r, "productDetails", 8), n = v(r, "showProductDescription", 8);
  const a = t().productType === Re.Subscription;
  oe();
  var o = gd(), i = E(o);
  {
    var s = (_) => {
      var m = md(), h = E(m), b = /* @__PURE__ */ te(() => ({ productTitle: t().title }));
      he(h, {
        get key() {
          return z.ProductInfoSubscribeTo;
        },
        get variables() {
          return f(b);
        }
      }), P(_, m);
    };
    j(i, (_) => {
      a && _(s);
    });
  }
  var l = M(i, 2), c = E(l), d = /* @__PURE__ */ te(() => ({ productTitle: t().title }));
  he(c, {
    get key() {
      return z.ProductInfoProductTitle;
    },
    get variables() {
      return f(d);
    }
  });
  var u = M(l, 2);
  {
    var p = (_) => {
      var m = hd(), h = E(m), b = /* @__PURE__ */ te(() => ({
        productDescription: t().description
      }));
      he(h, {
        get key() {
          return z.ProductInfoProductDescription;
        },
        get variables() {
          return f(b);
        }
      }), P(_, m);
    };
    j(u, (_) => {
      n() && t().description && _(p);
    });
  }
  P(e, o), W();
}
var vd = /* @__PURE__ */ F('<span class="rcb-product-price svelte-2p6w7e"><!></span>');
const kd = {
  hash: "svelte-2p6w7e",
  code: `.rcb-product-price.svelte-2p6w7e {color:var(--rc-color-grey-text-dark);font:var(--rc-text-titleMedium-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-product-price.svelte-2p6w7e {font:var(--rc-text-titleMedium-desktop);}
  }`
};
function wd(e, r) {
  var d;
  V(r, !1), U(e, kd);
  const t = ar(), n = () => nr(i, "$translator", t), o = (d = v(r, "purchaseOption", 8)()) == null ? void 0 : d.basePrice, i = We(hr), s = o && n().formatPrice(o.amountMicros, o.currency);
  oe();
  var l = vd(), c = E(l);
  he(c, {
    get key() {
      return z.ProductInfoProductPrice;
    },
    variables: {
      productPrice: s
    }
  }), P(e, l), W();
}
var Pd = /* @__PURE__ */ F('<div class="rcb-product-trial svelte-16xlj2"><!></div>'), xd = /* @__PURE__ */ F('<span class="rcb-product-price svelte-16xlj2"><!></span>'), Sd = /* @__PURE__ */ F('<span class="rcb-product-price-frequency svelte-16xlj2"><span class="rcb-product-price-frequency-text svelte-16xlj2"> </span></span>'), Ed = /* @__PURE__ */ F('<div class="rcb-product-trial-explanation svelte-16xlj2"><div class="rcb-after-trial-ends rcb-text-dark svelte-16xlj2"><!></div> <div class="rcb-after-trial-ends rcb-text-dark svelte-16xlj2"></div></div> <div class="rcb-product-trial-explanation svelte-16xlj2"><div class="rcb-text-dark rcb-total-due-today svelte-16xlj2"><!></div> <div class="rcb-text-dark rcb-total-due-today svelte-16xlj2"></div></div>', 1), qd = /* @__PURE__ */ F('<div class="rcb-product-price-container"><!> <div><!> <!></div></div> <div class="rcb-product-details expanded svelte-16xlj2"><div class="rcb-product-details-padding svelte-16xlj2"><!></div></div>', 1);
const Fd = {
  hash: "svelte-16xlj2",
  code: `.rcb-product-price.svelte-16xlj2 {color:var(--rc-color-grey-text-dark);font:var(--rc-text-titleMedium-mobile);}.rcb-product-trial.svelte-16xlj2 {color:var(--rc-color-grey-text-dark);font:var(--rc-text-titleLarge-mobile);}.rcb-product-price-frequency.svelte-16xlj2 {color:var(--rc-color-grey-text-dark);font:var(--rc-text-body1-mobile);}.rcb-product-price-frequency-text.svelte-16xlj2 {white-space:nowrap;}.rcb-product-details.svelte-16xlj2 {color:var(--rc-color-grey-text-light);margin:0;overflow:hidden;transition:max-height 0.2s ease-in-out;}.rcb-product-details-padding.svelte-16xlj2 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapSmall-mobile);}.rcb-product-trial-explanation.svelte-16xlj2 {display:flex;flex-direction:row;align-items:center;justify-content:space-between;}.rcb-text-dark.svelte-16xlj2 {color:var(--rc-color-grey-text-dark);font-weight:500;}

  @container layout-query-container (width >= 768px) {.rcb-product-price.svelte-16xlj2 {font:var(--rc-text-titleMedium-desktop);}.rcb-product-price-frequency.svelte-16xlj2 {font:var(--rc-text-body1-desktop);}.rcb-product-details.svelte-16xlj2 {max-height:500px;gap:var(--rc-spacing-gapXLarge-desktop);}.rcb-product-details-padding.svelte-16xlj2 {gap:var(--rc-spacing-gapMedium-desktop);}.rcb-total-due-today.svelte-16xlj2 {font:var(--rc-text-titleMedium-desktop);}.rcb-after-trial-ends.svelte-16xlj2 {font:var(--rc-text-body1-desktop);}.rcb-product-trial.svelte-16xlj2 {font:var(--rc-text-titleLarge-desktop);}
  }`
};
function Id(e, r) {
  var I, T, Y, K, ne, le;
  V(r, !1), U(e, Fd);
  const t = ar(), n = () => nr(i, "$translator", t);
  let a = v(r, "purchaseOption", 8);
  const o = (T = (I = a()) == null ? void 0 : I.base) == null ? void 0 : T.price, i = We(hr);
  let s = ie(null);
  const l = ((K = (Y = a()) == null ? void 0 : Y.trial) == null ? void 0 : K.period) || ((le = (ne = a()) == null ? void 0 : ne.base) == null ? void 0 : le.period);
  l && A(s, Uo(/* @__PURE__ */ new Date(), l));
  const c = o && n().formatPrice(o.amountMicros, o.currency), d = o && n().formatPrice(0, o.currency);
  oe();
  var u = qd(), p = J(u), _ = E(p);
  {
    var m = (X) => {
      var C = Pd(), G = E(C), L = /* @__PURE__ */ te(() => ({
        trialDuration: Hl(a().trial.periodDuration || "", n())
      }));
      he(G, {
        get key() {
          return z.ProductInfoFreeTrialDuration;
        },
        get variables() {
          return f(L);
        }
      }), P(X, C);
    };
    j(_, (X) => {
      var C, G;
      (G = (C = a()) == null ? void 0 : C.trial) != null && G.periodDuration && X(m);
    });
  }
  var h = M(_, 2), b = E(h);
  {
    var y = (X) => {
      var C = xd(), G = E(C);
      he(G, {
        get key() {
          return z.ProductInfoProductPrice;
        },
        variables: { productPrice: c }
      }), P(X, C);
    };
    j(b, (X) => {
      o && X(y);
    });
  }
  var g = M(b, 2);
  {
    var k = (X) => {
      var C = Sd(), G = E(C), L = E(G);
      N(() => Se(L, n().translatePeriodFrequency(a().base.period.number, a().base.period.unit, { useMultipleWords: !0 }))), P(X, C);
    };
    j(g, (X) => {
      var C, G;
      (G = (C = a()) == null ? void 0 : C.base) != null && G.period && X(k);
    });
  }
  var w = M(p, 2), x = E(w), S = E(x);
  {
    var D = (X) => {
      var C = Ed(), G = J(C), L = E(G), _e = E(L), Ye = /* @__PURE__ */ te(() => ({
        renewalDate: f(s) && n().translateDate(f(s), { dateStyle: "medium" })
      }));
      he(_e, {
        get key() {
          return z.ProductInfoPriceAfterFreeTrial;
        },
        get variables() {
          return f(Ye);
        }
      });
      var je = M(L, 2);
      je.textContent = c;
      var He = M(G, 2), Ge = E(He), Xe = E(Ge);
      he(Xe, {
        get key() {
          return z.ProductInfoPriceTotalDueToday;
        }
      });
      var De = M(Ge, 2);
      De.textContent = d, P(X, C);
    };
    j(S, (X) => {
      var C, G;
      (G = (C = a()) == null ? void 0 : C.trial) != null && G.periodDuration && X(D);
    });
  }
  P(e, u), W();
}
function Td(e, r) {
  V(r, !1);
  let t = v(r, "productDetails", 8), n = v(r, "purchaseOption", 8);
  const a = t().productType === Re.Subscription;
  oe();
  var o = ae(), i = J(o);
  {
    var s = (c) => {
      Id(c, {
        get purchaseOption() {
          return n();
        }
      });
    }, l = (c) => {
      wd(c, {
        get purchaseOption() {
          return n();
        }
      });
    };
    j(i, (c) => {
      a ? c(s) : c(l, !1);
    });
  }
  P(e, o), W();
}
var Dd = /* @__PURE__ */ F('<section><div class="rcb-pricing-info svelte-1bpq36x"><!> <!></div></section>');
const Ad = {
  hash: "svelte-1bpq36x",
  code: `.rcb-pricing-info.svelte-1bpq36x {display:flex;flex-direction:column;font:var(--rc-text-body1-mobile);gap:var(--rc-spacing-gapLarge-mobile);user-select:none;}.rcb-pricing-info.svelte-1bpq36x {gap:var(--rc-spacing-gapXXLarge-mobile);}

  @container layout-query-container (width < 768px) {.rcb-pricing-info.svelte-1bpq36x {margin-top:var(--rc-spacing-gapXLarge-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-pricing-info.svelte-1bpq36x {margin-top:calc(var(--rc-spacing-gapXXLarge-desktop) * 2);gap:var(--rc-spacing-gapXXXLarge-desktop);}.rcb-pricing-info.has-expanded-details.svelte-1bpq36x {gap:var(--rc-spacing-gapXXXLarge-desktop);}
  }`
};
function Ua(e, r) {
  V(r, !1), U(e, Ad);
  let t = v(r, "productDetails", 8), n = v(r, "purchaseOption", 8), a = v(r, "showProductDescription", 8);
  const o = t().productType === Re.Subscription;
  oe();
  var i = Dd(), s = E(i);
  qr(s, "has-expanded-details", o);
  var l = E(s);
  bd(l, {
    get productDetails() {
      return t();
    },
    get showProductDescription() {
      return a();
    }
  });
  var c = M(l, 2);
  Td(c, {
    get productDetails() {
      return t();
    },
    get purchaseOption() {
      return n();
    }
  }), P(e, i), W();
}
var Cd = /* @__PURE__ */ F('<picture class="rcb-app-icon-picture-container svelte-44qpq9"><source type="image/webp"> <img class="rcb-app-icon svelte-44qpq9" alt="App icon"></picture>'), Md = /* @__PURE__ */ F('<div class="rcb-app-icon loading svelte-44qpq9"></div>');
const jd = {
  hash: "svelte-44qpq9",
  code: ".rcb-app-icon.svelte-44qpq9 {width:40px;height:40px;border-radius:12px;box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);margin-right:16px;}.rcb-app-icon-picture-container.svelte-44qpq9 {height:40px;}.rcb-app-icon.loading.svelte-44qpq9 {background-color:gray;}"
};
function Nd(e, r) {
  U(e, jd);
  let t = v(r, "src", 8, null), n = v(r, "srcWebp", 8, null);
  var a = ae(), o = J(a);
  {
    var i = (l) => {
      var c = Cd(), d = E(c), u = M(d, 2);
      N(() => {
        Z(d, "srcset", n()), Z(u, "src", t());
      }), P(l, c);
    }, s = (l) => {
      var c = Md();
      P(l, c);
    };
    j(o, (l) => {
      t() !== null ? l(i) : l(s, !1);
    });
  }
  P(e, a);
}
const Ba = (e) => `https://da08ctfrofx1b.cloudfront.net/${e}`;
var Od = /* @__PURE__ */ F('<div class="rcb-header-layout__business-info svelte-mtrmkt"><!> <div class="rcb-app-name svelte-mtrmkt"> </div></div>');
const Rd = {
  hash: "svelte-mtrmkt",
  code: `.rcb-header-layout__business-info.svelte-mtrmkt {display:flex;align-items:center;}.rcb-app-name.svelte-mtrmkt {font:var(--rc-text-titleMedium-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-app-name.svelte-mtrmkt {font:var(--rc-text-titleLarge-desktop);}
  }`
};
function Ld(e, r) {
  var u, p;
  V(r, !1), U(e, Rd);
  let t = v(r, "brandingInfo", 8, null);
  const n = (_) => _ == null || _ == null || _ == "" ? null : _, a = n((u = t()) == null ? void 0 : u.app_icon), o = n((p = t()) == null ? void 0 : p.app_icon_webp);
  oe();
  var i = Od(), s = E(i);
  {
    var l = (_) => {
      var m = /* @__PURE__ */ te(() => Ba(a)), h = /* @__PURE__ */ te(() => Ba(o));
      Nd(_, {
        get src() {
          return f(m);
        },
        get srcWebp() {
          return f(h);
        }
      });
    };
    j(s, (_) => {
      a !== null && o !== null && _(l);
    });
  }
  var c = M(s, 2), d = E(c);
  N(() => {
    var _;
    return Se(d, (_ = t()) == null ? void 0 : _.app_name);
  }), P(e, i), W();
}
var zd = /* @__PURE__ */ F("<!> <!> <!> <!> <!> <!> <!>", 1), Ud = /* @__PURE__ */ F("<!> <!>", 1), Bd = /* @__PURE__ */ F("<!> <!>", 1);
function Vd(e, r) {
  V(r, !1);
  let t = v(r, "currentView", 8), n = v(r, "brandingInfo", 8), a = v(r, "productDetails", 8), o = v(r, "purchaseOptionToUse", 8), i = v(r, "colorVariables", 8, ""), s = v(r, "isSandbox", 8, !1), l = v(r, "handleContinue", 8), c = v(r, "closeWithError", 8), d = v(r, "onClose", 8, void 0), u = v(r, "lastError", 8), p = v(r, "paymentInfoCollectionMetadata", 8), _ = v(r, "purchaseOperationHelper", 8), m = v(r, "isInElement", 8, !1);
  const h = !1, b = [
    "present-offer",
    "needs-auth-info",
    "processing-auth-info",
    "needs-payment-info",
    "polling-purchase-status",
    "loading",
    "success",
    "error"
  ];
  oe();
  var y = /* @__PURE__ */ te(() => {
    var g;
    return (g = n()) == null ? void 0 : g.appearance;
  });
  xc(e, {
    get brandingAppearance() {
      return f(y);
    },
    get isInElement() {
      return m();
    },
    children: (g, k) => {
      var w = Bd(), x = J(w);
      {
        var S = (I) => {
          ru(I, {
            get style() {
              return i();
            },
            get isInElement() {
              return m();
            }
          });
        };
        j(x, (I) => {
          s() && I(S);
        });
      }
      var D = M(x, 2);
      qc(D, {
        get style() {
          return i();
        },
        children: (I, T) => {
          var Y = Ud(), K = J(Y);
          {
            var ne = (C) => {
              var G = /* @__PURE__ */ te(() => {
                var _e;
                return (_e = n()) == null ? void 0 : _e.appearance;
              }), L = /* @__PURE__ */ te(() => !m());
              Kc(C, {
                get brandingAppearance() {
                  return f(G);
                },
                get onClose() {
                  return d();
                },
                get showCloseButton() {
                  return f(L);
                },
                shouldShowDetailsButton: h,
                headerContent: (je) => {
                  Ld(je, {
                    get brandingInfo() {
                      return n();
                    }
                  });
                },
                bodyContent: (je) => {
                  var He = ae(), Ge = J(He);
                  {
                    var Xe = (De) => {
                      var Ir = /* @__PURE__ */ te(() => {
                        var gr, Tr;
                        return ((Tr = (gr = n()) == null ? void 0 : gr.appearance) == null ? void 0 : Tr.show_product_description) ?? !1;
                      });
                      Ua(De, {
                        get productDetails() {
                          return a();
                        },
                        get purchaseOption() {
                          return o();
                        },
                        get showProductDescription() {
                          return f(Ir);
                        }
                      });
                    };
                    j(Ge, (De) => {
                      a() && o() && De(Xe);
                    });
                  }
                  P(je, He);
                },
                $$slots: { headerContent: !0, bodyContent: !0 }
              });
            };
            j(K, (C) => {
              b.includes(t()) && C(ne);
            });
          }
          var le = M(K, 2), X = /* @__PURE__ */ te(() => {
            var C;
            return (C = n()) == null ? void 0 : C.appearance;
          });
          au(le, {
            get brandingAppearance() {
              return f(X);
            },
            body: (G) => {
              var L = zd(), _e = J(L);
              {
                var Ye = (ee) => {
                  var Je = /* @__PURE__ */ te(() => {
                    var Dr, yr;
                    return ((yr = (Dr = n()) == null ? void 0 : Dr.appearance) == null ? void 0 : yr.show_product_description) ?? !1;
                  });
                  Ua(ee, {
                    get productDetails() {
                      return a();
                    },
                    get purchaseOption() {
                      return o();
                    },
                    get showProductDescription() {
                      return f(Je);
                    }
                  });
                };
                j(_e, (ee) => {
                  t() === "present-offer" && a() && o() && ee(Ye);
                });
              }
              var je = M(_e, 2);
              {
                var He = (ee) => {
                  qn(ee);
                };
                j(je, (ee) => {
                  t() === "present-offer" && !a() && ee(He);
                });
              }
              var Ge = M(je, 2);
              {
                var Xe = (ee) => {
                  var Je = /* @__PURE__ */ te(() => t() === "processing-auth-info");
                  od(ee, {
                    get onContinue() {
                      return l();
                    },
                    get processing() {
                      return f(Je);
                    },
                    get lastError() {
                      return u();
                    }
                  });
                };
                j(Ge, (ee) => {
                  (t() === "needs-auth-info" || t() === "processing-auth-info") && ee(Xe);
                });
              }
              var De = M(Ge, 2);
              {
                var Ir = (ee) => {
                  var Je = /* @__PURE__ */ te(() => t() === "polling-purchase-status");
                  Zu(ee, {
                    get paymentInfoCollectionMetadata() {
                      return p();
                    },
                    get onContinue() {
                      return l();
                    },
                    get processing() {
                      return f(Je);
                    },
                    get productDetails() {
                      return a();
                    },
                    get purchaseOption() {
                      return o();
                    },
                    get brandingInfo() {
                      return n();
                    },
                    get purchaseOperationHelper() {
                      return _();
                    }
                  });
                };
                j(De, (ee) => {
                  p() && (t() === "needs-payment-info" || t() === "polling-purchase-status") && a() && o() && ee(Ir);
                });
              }
              var gr = M(De, 2);
              {
                var Tr = (ee) => {
                  qn(ee);
                };
                j(gr, (ee) => {
                  t() === "loading" && ee(Tr);
                });
              }
              var Hr = M(gr, 2);
              {
                var Kt = (ee) => {
                  var Je = /* @__PURE__ */ te(() => u() ?? new re(de.UnknownError, "Unknown error without state set.")), Dr = /* @__PURE__ */ te(() => {
                    var yr;
                    return (yr = n()) == null ? void 0 : yr.support_email;
                  });
                  cd(ee, {
                    get lastError() {
                      return f(Je);
                    },
                    get supportEmail() {
                      return f(Dr);
                    },
                    get productDetails() {
                      return a();
                    },
                    get onContinue() {
                      return c();
                    }
                  });
                };
                j(Hr, (ee) => {
                  t() === "error" && ee(Kt);
                });
              }
              var $t = M(Hr, 2);
              {
                var en = (ee) => {
                  fd(ee, {
                    get productDetails() {
                      return a();
                    },
                    get onContinue() {
                      return l();
                    }
                  });
                };
                j($t, (ee) => {
                  t() === "success" && ee(en);
                });
              }
              P(G, L);
            },
            $$slots: { body: !0 }
          }), P(I, Y);
        },
        $$slots: { default: !0 }
      }), P(g, w);
    },
    $$slots: { default: !0 }
  }), W();
}
const Cr = [];
function Wd(e, r) {
  return {
    subscribe: ai(e, r).subscribe
  };
}
function ai(e, r = se) {
  let t = null;
  const n = /* @__PURE__ */ new Set();
  function a(s) {
    if (so(e, s) && (e = s, t)) {
      const l = !Cr.length;
      for (const c of n)
        c[1](), Cr.push(c, e);
      if (l) {
        for (let c = 0; c < Cr.length; c += 2)
          Cr[c][0](Cr[c + 1]);
        Cr.length = 0;
      }
    }
  }
  function o(s) {
    a(s(
      /** @type {T} */
      e
    ));
  }
  function i(s, l = se) {
    const c = [s, l];
    return n.add(c), n.size === 1 && (t = r(a, o) || se), s(
      /** @type {T} */
      e
    ), () => {
      n.delete(c), n.size === 0 && t && (t(), t = null);
    };
  }
  return { set: a, update: o, subscribe: i };
}
function Yd(e, r) {
  V(r, !1);
  let t = v(r, "customerEmail", 12), n = v(r, "appUserId", 8), a = v(r, "rcPackage", 8), o = v(r, "purchaseOption", 8), i = v(r, "metadata", 8), s = v(r, "brandingInfo", 8), l = v(r, "onFinished", 8), c = v(r, "onError", 8), d = v(r, "onClose", 8, void 0), u = v(r, "purchases", 8), p = v(r, "eventsTracker", 8), _ = v(r, "purchaseOperationHelper", 8), m = v(r, "selectedLocale", 8, ur), h = v(r, "defaultLocale", 8, ur), b = v(r, "customTranslations", 24, () => ({})), y = v(r, "isInElement", 8, !1), g = ie(""), k = ie(null), w = ie(null), x = ie(null);
  const S = a().webBillingProduct.identifier ?? null;
  let D = ie("present-offer"), I = null, T = null, Y = new Jt(b(), m(), h());
  var K = ai(Y);
  Sa(hr, K), tr(() => {
    y() || (document.documentElement.style.height = "100%", document.body.style.height = "100%", document.documentElement.style.overflow = "hidden");
  }), tl(() => {
    y() || (document.documentElement.style.height = "auto", document.body.style.height = "auto", document.documentElement.style.overflow = "auto");
  }), Sa(Qt, p()), tr(async () => {
    var L;
    if (A(k, a().webBillingProduct), A(g, Go((L = s()) == null ? void 0 : L.appearance)), f(D) === "present-offer") {
      t() ? ne() : A(D, "needs-auth-info");
      return;
    }
  });
  const ne = () => {
    if (S === null) {
      X(new re(de.ErrorSettingUpPurchase, "Product ID was not set before purchase."));
      return;
    } else f(D) === "present-offer" && A(D, "loading");
    if (!t()) {
      X(new re(de.MissingEmailError));
      return;
    }
    _().checkoutStart(n(), S, o(), a().webBillingProduct.presentedOfferingContext, t(), i()).then((L) => {
      A(x, null), A(D, "needs-payment-info"), A(w, L);
    }).catch((L) => {
      X(L);
    });
  }, le = (L = {}) => {
    if (L.error) {
      X(L.error);
      return;
    }
    if (f(D) === "needs-auth-info") {
      L.authInfo && (t(L.authInfo.email), A(D, "processing-auth-info")), ne();
      return;
    }
    if (f(D) === "needs-payment-info") {
      A(D, "polling-purchase-status"), _().pollCurrentPurchaseForCompletion().then((_e) => {
        A(D, "success"), I = _e.redemptionInfo, T = _e.operationSessionId;
      }).catch((_e) => {
        X(_e);
      });
      return;
    }
    if (f(D) === "success" || f(D) === "error") {
      l()(T, I);
      return;
    }
    A(D, "success");
  }, X = (L) => {
    const _e = ju({
      errorCode: L.getErrorCode().toString(),
      errorMessage: L.message
    });
    if (p().trackSDKEvent(_e), f(D) === "processing-auth-info" && L.isRecoverable()) {
      A(x, L), A(D, "needs-auth-info");
      return;
    }
    A(x, L), A(D, "error");
  }, C = () => {
    c()(f(x) ?? new re(de.UnknownError, "Unknown error without state set."));
  };
  oe();
  var G = /* @__PURE__ */ te(() => u().isSandbox());
  Vd(e, {
    get isSandbox() {
      return f(G);
    },
    get currentView() {
      return f(D);
    },
    get brandingInfo() {
      return s();
    },
    get productDetails() {
      return f(k);
    },
    get purchaseOptionToUse() {
      return o();
    },
    handleContinue: le,
    get lastError() {
      return f(x);
    },
    get paymentInfoCollectionMetadata() {
      return f(w);
    },
    get purchaseOperationHelper() {
      return _();
    },
    closeWithError: C,
    get colorVariables() {
      return f(g);
    },
    get isInElement() {
      return y();
    },
    get onClose() {
      return d();
    }
  }), W();
}
function Hd(e) {
  return e.expires_date == null ? !0 : new Date(e.expires_date) > /* @__PURE__ */ new Date();
}
function Gd(e, r, t, n) {
  const a = r.product_identifier;
  if (a in t)
    return Xd(
      e,
      r,
      t[a]
    );
  if (a in n)
    return Jd(
      e,
      r,
      n[a]
    );
  throw new pe(
    ye.CustomerInfoError,
    "Could not find entitlement product in subscriptions or non-subscriptions."
  );
}
function Xd(e, r, t) {
  return {
    identifier: e,
    isActive: Hd(r),
    willRenew: Kd(r, t),
    store: (t == null ? void 0 : t.store) ?? "unknown",
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(r.purchase_date),
    expirationDate: Et(r.expires_date),
    productIdentifier: r.product_identifier,
    unsubscribeDetectedAt: Et(
      t == null ? void 0 : t.unsubscribe_detected_at
    ),
    billingIssueDetectedAt: Et(
      t == null ? void 0 : t.billing_issues_detected_at
    ),
    isSandbox: (t == null ? void 0 : t.is_sandbox) ?? !1,
    periodType: (t == null ? void 0 : t.period_type) ?? "normal"
  };
}
function Jd(e, r, t) {
  return {
    identifier: e,
    isActive: !0,
    willRenew: !1,
    store: t.store,
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(
      t.original_purchase_date
    ),
    expirationDate: null,
    productIdentifier: r.product_identifier,
    unsubscribeDetectedAt: null,
    billingIssueDetectedAt: null,
    isSandbox: t.is_sandbox,
    periodType: "normal"
  };
}
function Qd(e, r, t) {
  const n = {}, a = {};
  for (const o in e) {
    const i = Gd(
      o,
      e[o],
      r,
      t
    );
    n[o] = i, i.isActive && (a[o] = i);
  }
  return {
    all: n,
    active: a
  };
}
function Et(e) {
  return e == null ? null : new Date(e);
}
function Zd(e) {
  const r = e_(e), t = e.subscriber, n = t_(
    t.non_subscriptions
  );
  return {
    entitlements: Qd(
      t.entitlements,
      t.subscriptions,
      n
    ),
    allExpirationDatesByProduct: r,
    allPurchaseDatesByProduct: $d(
      e,
      n
    ),
    activeSubscriptions: r_(r),
    managementURL: t.management_url,
    requestDate: new Date(e.request_date),
    firstSeenDate: new Date(t.first_seen),
    originalPurchaseDate: Et(
      t.original_purchase_date
    ),
    originalAppUserId: e.subscriber.original_app_user_id
  };
}
function Kd(e, r) {
  if (r == null) return !1;
  const t = r.store == "promotional", n = e.expires_date == null, a = r.unsubscribe_detected_at != null, o = r.billing_issues_detected_at != null;
  return !(t || n || a || o);
}
function $d(e, r) {
  const t = {};
  for (const n in e.subscriber.subscriptions) {
    const a = e.subscriber.subscriptions[n];
    t[n] = new Date(
      a.purchase_date
    );
  }
  for (const n in r) {
    const a = r[n].purchase_date;
    a == null ? t[n] = null : t[n] = new Date(a);
  }
  return t;
}
function e_(e) {
  const r = {};
  for (const t in e.subscriber.subscriptions) {
    const n = e.subscriber.subscriptions[t];
    n.expires_date == null ? r[t] = null : r[t] = new Date(
      n.expires_date
    );
  }
  return r;
}
function r_(e) {
  const r = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Date();
  for (const n in e) {
    const a = e[n];
    (a == null || a > t) && r.add(n);
  }
  return r;
}
function t_(e) {
  const r = {};
  for (const t in e) {
    if (e[t].length === 0) continue;
    const n = e[t].length;
    r[t] = e[t][n - 1];
  }
  return r;
}
const oi = "1.0.5", n_ = "https://api.revenuecat.com", a_ = "https://e.revenue.cat";
var jt;
(function(e) {
  e[e.CONTINUE = 100] = "CONTINUE", e[e.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", e[e.PROCESSING = 102] = "PROCESSING", e[e.EARLY_HINTS = 103] = "EARLY_HINTS", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.RESET_CONTENT = 205] = "RESET_CONTENT", e[e.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", e[e.MULTI_STATUS = 207] = "MULTI_STATUS", e[e.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", e[e.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", e[e.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", e[e.SEE_OTHER = 303] = "SEE_OTHER", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.USE_PROXY = 305] = "USE_PROXY", e[e.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", e[e.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", e[e.BAD_REQUEST = 400] = "BAD_REQUEST", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", e[e.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", e[e.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", e[e.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", e[e.CONFLICT = 409] = "CONFLICT", e[e.GONE = 410] = "GONE", e[e.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", e[e.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", e[e.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", e[e.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", e[e.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", e[e.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", e[e.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", e[e.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", e[e.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", e[e.METHOD_FAILURE = 420] = "METHOD_FAILURE", e[e.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", e[e.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", e[e.LOCKED = 423] = "LOCKED", e[e.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", e[e.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", e[e.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", e[e.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", e[e.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.BAD_GATEWAY = 502] = "BAD_GATEWAY", e[e.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", e[e.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", e[e.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", e[e.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", e[e.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(jt || (jt = {}));
function Fn(e) {
  return e ? e.startsWith("rcb_sb_") : !1;
}
async function or(e, r) {
  const { apiKey: t, body: n, headers: a, httpConfig: o } = r, s = `${(o == null ? void 0 : o.proxyURL) ?? n_}${e.urlPath()}`;
  try {
    const l = await fetch(s, {
      method: e.method,
      headers: _i(t, a, o == null ? void 0 : o.additionalHeaders),
      body: i_(n)
    });
    return await o_(l, e), await l.json();
  } catch (l) {
    throw l instanceof TypeError ? new pe(
      ye.NetworkError,
      rt.getPublicMessage(ye.NetworkError),
      l.message
    ) : l;
  }
}
async function o_(e, r) {
  const t = e.status;
  if (t >= jt.INTERNAL_SERVER_ERROR)
    un(r, t, await e.text());
  else if (t >= jt.BAD_REQUEST) {
    const n = await e.json(), a = n ? JSON.stringify(n) : null, o = n == null ? void 0 : n.code, i = n == null ? void 0 : n.message;
    if (o != null) {
      const s = rt.convertCodeToBackendErrorCode(o);
      if (s == null)
        un(
          r,
          t,
          a,
          o
        );
      else
        throw pe.getForBackendError(
          s,
          i
        );
    } else
      un(r, t, a);
  }
}
function un(e, r, t, n) {
  throw new pe(
    ye.UnknownBackendError,
    "Unknown backend error.",
    `Request: ${e.name}. Status code: ${r}. Body: ${t}.`,
    { backendErrorCode: n }
  );
}
function i_(e) {
  return e == null ? null : JSON.stringify(e);
}
const ii = "Authorization", si = "Content-Type", li = "Accept", ci = "X-Platform", ui = "X-Version", di = "X-Is-Sandbox", s_ = /* @__PURE__ */ new Set([
  ii,
  si,
  li,
  ci,
  ui,
  di
]);
function _i(e, r, t) {
  let n = {
    [ii]: `Bearer ${e}`,
    [si]: "application/json",
    [li]: "application/json",
    [ci]: "web",
    [ui]: oi,
    [di]: `${Fn(e)}`
  };
  return r && (n = { ...n, ...r }), t && (n = { ...t, ...n }), n;
}
const pi = "/v1/subscribers", Yr = "/rcbilling/v1";
class l_ {
  constructor(r) {
    q(this, "appUserId");
    q(this, "method", "GET");
    q(this, "name", "getOfferings");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${pi}/${r}/offerings`;
  }
}
class c_ {
  constructor(r, t, n) {
    q(this, "method", "GET");
    q(this, "name", "getProducts");
    q(this, "appUserId");
    q(this, "productIds");
    q(this, "currency");
    this.appUserId = r, this.productIds = t, this.currency = n;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId), t = this.productIds.map(encodeURIComponent).join("&id="), n = this.currency ? `&currency=${this.currency}` : "";
    return `${Yr}/subscribers/${r}/products?id=${t}${n}`;
  }
}
class u_ {
  constructor(r) {
    q(this, "method", "GET");
    q(this, "name", "getCustomerInfo");
    q(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${pi}/${r}`;
  }
}
class d_ {
  constructor() {
    q(this, "method", "GET");
    q(this, "name", "getBrandingInfo");
  }
  urlPath() {
    return `${Yr}/branding`;
  }
}
class __ {
  constructor() {
    q(this, "method", "POST");
    q(this, "name", "postCheckoutStart");
  }
  urlPath() {
    return `${Yr}/checkout/start`;
  }
}
class p_ {
  constructor(r) {
    q(this, "method", "POST");
    q(this, "name", "postCheckoutCalculateTaxes");
    q(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Yr}/checkout/${this.operationSessionId}/calculate_taxes`;
  }
}
class f_ {
  constructor(r) {
    q(this, "method", "POST");
    q(this, "name", "postCheckoutComplete");
    q(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Yr}/checkout/${this.operationSessionId}/complete`;
  }
}
class m_ {
  constructor(r) {
    q(this, "method", "GET");
    q(this, "name", "getCheckoutStatus");
    q(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Yr}/checkout/${this.operationSessionId}`;
  }
}
const In = {};
class h_ {
  constructor(r, t = In) {
    q(this, "API_KEY");
    q(this, "httpConfig");
    this.API_KEY = r, this.httpConfig = t;
  }
  async getOfferings(r) {
    return await or(
      new l_(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCustomerInfo(r) {
    return await or(
      new u_(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getProducts(r, t, n) {
    return await or(
      new c_(r, t, n),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getBrandingInfo() {
    return await or(
      new d_(),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutStart(r, t, n, a, o, i, s = void 0) {
    const l = {
      app_user_id: r,
      product_id: t,
      email: i,
      price_id: a.priceId,
      presented_offering_identifier: n.offeringIdentifier,
      trace_id: o
    };
    return s && (l.metadata = s), a.id !== "base_option" && (l.offer_id = a.id), n.targetingContext && (l.applied_targeting_rule = {
      rule_id: n.targetingContext.ruleId,
      revision: n.targetingContext.revision
    }), n.placementIdentifier && (l.presented_placement_identifier = n.placementIdentifier), await or(new __(), {
      apiKey: this.API_KEY,
      body: l,
      httpConfig: this.httpConfig
    });
  }
  async postCheckoutCalculateTaxes(r, t, n) {
    const a = {
      country_code: t,
      postal_code: n
    };
    return await or(new p_(r), {
      apiKey: this.API_KEY,
      body: a,
      httpConfig: this.httpConfig
    });
  }
  async postCheckoutComplete(r, t) {
    const n = {
      email: t
    };
    return await or(new f_(r), {
      apiKey: this.API_KEY,
      body: n,
      httpConfig: this.httpConfig
    });
  }
  async getCheckoutStatus(r) {
    return await or(
      new m_(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
}
function g_(e) {
  if (!/^rcb_[a-zA-Z0-9_.-]+$/.test(e))
    throw new pe(
      ye.InvalidCredentialsError,
      "Invalid API key. Use your Web Billing API key."
    );
}
function Va(e) {
  if ((/* @__PURE__ */ new Set([
    "no_user",
    "null",
    "none",
    "nil",
    "(null)",
    "NaN",
    "\\x00",
    "",
    "unidentified",
    "undefined",
    "unknown"
  ])).has(e) || e.includes("/"))
    throw new pe(
      ye.InvalidAppUserIdError,
      'Provided user id: "' + e + '" is not valid. See https://www.revenuecat.com/docs/customers/user-ids#tips-for-setting-app-user-ids for more information.'
    );
}
function y_(e) {
  if (e != null && e.endsWith("/"))
    throw new pe(
      ye.ConfigurationError,
      "Invalid proxy URL. The proxy URL should not end with a trailing slash."
    );
}
function b_(e) {
  if (e) {
    for (const r in e)
      if (s_.has(r))
        throw new pe(
          ye.ConfigurationError,
          "Invalid additional headers. Some headers are reserved for internal use."
        );
  }
}
var fi = /* @__PURE__ */ ((e) => (e.Current = "current", e))(fi || {});
function v_(e, r) {
  async function t(...n) {
    return await this.preload(), await e.call(this, ...n);
  }
  return t;
}
const mi = (e, r) => {
  const t = {
    ...e.webBillingProduct,
    presentedOfferingContext: {
      ...e.webBillingProduct.presentedOfferingContext,
      placementIdentifier: r
    }
  };
  return {
    ...e,
    webBillingProduct: t,
    rcBillingProduct: t
  };
}, br = (e, r) => e == null ? null : mi(e, r), k_ = (e, r, t) => {
  const n = e.offering_ids_by_placement ?? null;
  if (n == null)
    return null;
  const a = e.fallback_offering_id ?? null;
  let o;
  if (t in n) {
    const s = n[t] ?? null;
    if (s == null)
      return null;
    o = r[s], o == null && (o = r[a]);
  } else
    o = r[a];
  if (o == null)
    return null;
  const i = Object.fromEntries(
    Object.entries(o.packagesById).map(([s, l]) => [
      s,
      mi(l, t)
    ])
  );
  return {
    ...o,
    packagesById: i,
    availablePackages: Object.values(i),
    weekly: br(o.weekly, t),
    monthly: br(
      o.monthly,
      t
    ),
    twoMonth: br(
      o.twoMonth,
      t
    ),
    threeMonth: br(
      o.threeMonth,
      t
    ),
    sixMonth: br(
      o.sixMonth,
      t
    ),
    annual: br(o.annual, t),
    lifetime: br(
      o.lifetime,
      t
    )
  };
};
function w_(e, r) {
  const t = {};
  r.product_details.forEach((o) => {
    t[o.identifier] = o;
  });
  const n = {};
  e.offerings.forEach((o) => {
    const i = o.identifier === e.current_offering_id, s = ec(
      i,
      o,
      t,
      e.targeting
    );
    s != null && (n[o.identifier] = s);
  });
  const a = e.current_offering_id ? n[e.current_offering_id] ?? null : null;
  return Object.keys(n).length == 0 && H.debugLog(
    "Empty offerings. Please make sure you've configured offerings correctly in the RevenueCat dashboard and that the products are properly configured."
  ), {
    all: n,
    current: a
  };
}
var Tn;
(function(e) {
  e.body_s = "p", e.body_m = "p", e.body_l = "p", e.body_xl = "p", e.heading_xs = "h6", e.heading_s = "h5", e.heading_m = "h4", e.heading_l = "h3", e.heading_xl = "h2", e.heading_xxl = "h1";
})(Tn || (Tn = {}));
var Nt;
(function(e) {
  e[e.extra_light = 100] = "extra_light", e[e.thin = 200] = "thin", e[e.light = 300] = "light", e[e.regular = 400] = "regular", e[e.medium = 500] = "medium", e[e.semibold = 600] = "semibold", e[e.bold = 700] = "bold", e[e.extra_bold = 800] = "extra_bold", e[e.black = 900] = "black";
})(Nt || (Nt = {}));
var Ot;
(function(e) {
  e.body_s = "13px", e.body_m = "14px", e.body_l = "15px", e.body_xl = "16px", e.heading_xs = "14px", e.heading_s = "16px", e.heading_m = "18px", e.heading_l = "20px", e.heading_xl = "26px", e.heading_xxl = "32px";
})(Ot || (Ot = {}));
var Rt;
(function(e) {
  e.leading = "start", e.center = "center", e.trailing = "end";
})(Rt || (Rt = {}));
var Dn;
(function(e) {
  e.vertical = "column", e.horizontal = "row", e.zlayer = "zstack";
})(Dn || (Dn = {}));
var An;
(function(e) {
  e.top = "flex-start", e.leading = "flex-start", e.center = "center", e.bottom = "flex-end", e.trailing = "flex-end";
})(An || (An = {}));
var Cn;
(function(e) {
  e.space_between = "space-between", e.space_around = "space-around", e.space_evenly = "space-evenly", e.start = "flex-start", e.center = "center", e.end = "flex-end";
})(Cn || (Cn = {}));
const P_ = [
  "product_name",
  "price",
  "price_per_period",
  "price_per_period_full",
  "total_price_and_per_month",
  "total_price_and_per_month_full",
  "sub_price_per_month",
  "sub_price_per_week",
  "sub_duration",
  "sub_duration_in_months",
  "sub_period",
  "sub_period_length",
  "sub_period_abbreviated",
  "sub_offer_duration",
  "sub_offer_duration_2",
  "sub_offer_price",
  "sub_offer_price_2",
  "sub_relative_discount"
], x_ = ({ value: e = "", variableDictionary: r }) => r ? P_.reduce((t, n) => {
  var o;
  return t.replaceAll(`{{ ${n} }}`, ((o = r[n]) == null ? void 0 : o.toString()) || "N/A");
}, e) : e;
function hi(e, r, t, n) {
  var o;
  if (!e)
    return "";
  const a = (o = n[t]) == null ? void 0 : o[e];
  return (n[r] || {})[e] ? n[r][e] : a;
}
function ta({ text_lid: e, locale: r, defaultLocale: t, labels: n, variableDictionary: a }) {
  if (!e)
    return "";
  const o = hi(e, r, t, n);
  return x_({
    value: o,
    variableDictionary: a
  });
}
const gi = Wd(!1, (e) => {
  if (typeof window < "u") {
    const r = window.matchMedia("(prefers-color-scheme: dark)");
    e(r.matches);
    const t = (n) => e(n.matches);
    return r.addEventListener("change", t), () => r.removeEventListener("change", t);
  }
  return () => {
  };
});
function Wa(e, r) {
  const t = {
    [`--${r}-block-start`]: "0px",
    [`--${r}-inline-end`]: "0px",
    [`--${r}-block-end`]: "0px",
    [`--${r}-inline-start`]: "0px"
  };
  return !e || !r || Object.assign(t, {
    [`--${r}-block-start`]: `${e.top ?? 0}px`,
    [`--${r}-inline-end`]: `${e.trailing ?? 0}px`,
    [`--${r}-block-end`]: `${e.bottom ?? 0}px`,
    [`--${r}-inline-start`]: `${e.leading ?? 0}px`
  }), t;
}
function S_(e) {
  return Tn[e];
}
function er({ colorMap: e, colorMode: r = "light", fallback: t = "FFFFFF" }) {
  if (!e)
    return t;
  const n = e[r] || e.light;
  let a = "";
  switch (n.type) {
    case "hex":
    case "alias":
      return n.value ?? t;
    case "linear":
      return a = (n.points || []).map((o) => `${o.color} ${o.percent}%`).join(", "), `linear-gradient(${n.degrees}deg, ${a})`;
    case "radial":
      return a = (n.points || []).map((o) => `${o.color} ${o.percent}%`).join(", "), `radial-gradient(${a})`;
    default:
      return t;
  }
}
function yi(e, r = "light") {
  if (!e)
    return "";
  const t = er({ colorMap: e.color, colorMode: r });
  return `${e.width}px solid ${t}`;
}
function Lt(e) {
  return {
    "--border-start-start-radius": `${e.top_leading}px`,
    "--border-start-end-radius": `${e.top_trailing}px`,
    "--border-end-start-radius": `${e.bottom_leading}px`,
    "--border-end-end-radius": `${e.bottom_trailing}px`
  };
}
function Zt({ background_color: e, border: r, margin: t, padding: n, color: a, colorMode: o = "light", shape: i, shadow: s }) {
  const l = {
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "initial",
    "--text-color": "initial",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none"
  };
  return n && Object.assign(l, Wa(n, "padding")), t && Object.assign(l, Wa(t, "margin")), e && (l["--background"] = er({
    colorMap: e,
    colorMode: o,
    fallback: "transparent"
  })), a && (l["--text-color"] = er({
    colorMap: a,
    colorMode: o,
    fallback: "#000000"
  })), r && (l["--border"] = yi(r, o)), (i == null ? void 0 : i.type) === "rectangle" && i.corners && Object.assign(l, Lt(i.corners)), (i == null ? void 0 : i.type) === "pill" && Object.assign(l, Lt({
    bottom_leading: 9999,
    bottom_trailing: 9999,
    top_leading: 9999,
    top_trailing: 9999
  })), s && (l["--shadow"] = `${s.x}px ${s.y}px ${s.radius}px 
      ${er({ colorMap: s.color, colorMode: o, fallback: "#000000" })}`), l;
}
function Ya(e) {
  return e.type === "fixed" ? `${e.value}px` : e.type === "fit" ? "fit-content" : e.type === "fill" ? navigator.userAgent.match(/firefox|fxios/i) ? "-moz-available" : "-webkit-fill-available" : "initial";
}
function mt(e) {
  const r = {
    "--width": "initial",
    "--height": "initial",
    "--flex": "initial"
  }, t = Ya(e.width), n = Ya(e.height), a = e.width.type === "fill" || e.height.type === "fill";
  return Object.assign(r, {
    "--width": t,
    "--height": n,
    "--flex": a ? "initial" : "0 1 auto"
  }), r;
}
function E_(e, r) {
  return r ? {
    "--background": `linear-gradient(${r.map((t) => {
      var n;
      return ((n = t[e]) == null ? void 0 : n.value) || t.light.value;
    }).join(", ")})`
  } : { "--background": "none" };
}
const q_ = (e) => {
  const r = {
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--clip-path": "none"
  };
  return (e == null ? void 0 : e.type) === "circle" && Object.assign(r, {
    "--border-end-start-radius": "50%",
    "--border-end-end-radius": "50%",
    "--border-start-start-radius": "50%",
    "--border-start-end-radius": "50%"
  }), (e == null ? void 0 : e.type) === "rectangle" && e.corners && Object.assign(r, Lt(e.corners)), (e == null ? void 0 : e.type) === "convex" && Object.assign(r, {
    "--border-start-start-radius": "0%",
    "--border-start-end-radius": "0%",
    "--border-end-start-radius": "50%",
    "--border-end-end-radius": "50%"
  }), (e == null ? void 0 : e.type) === "concave" && Object.assign(r, {
    "--clip-path": "polygon(0 0, 100% 0, 100% 100%, 50% 110%, 0 100%);"
  }), r;
};
function bi(e) {
  const r = {
    "--inset": "initial",
    "--transform": "initial"
  };
  switch (e.alignment) {
    case "top_leading":
      r["--inset"] = "0 auto auto 0";
      break;
    case "top":
      r["--inset"] = "auto auto auto 50%", r["--transform"] = "translate(-50%, 0)";
      break;
    case "top_trailing":
      r["--inset"] = "0 0 auto auto";
      break;
    case "leading":
      r["--inset"] = "50% 0 50% 0", r["--transform"] = "translate(0, -50%)";
      break;
    case "center":
      r["--inset"] = "50% auto auto 50%", r["--transform"] = "translate(-50%, -50%)";
      break;
    case "trailing":
      r["--inset"] = "50% 0 50% auto", r["--transform"] = "translate(0, -50%)";
      break;
    case "bottom_leading":
      r["--inset"] = "auto auto 0 0";
      break;
    case "bottom":
      r["--inset"] = "auto 50% 0 auto", r["--transform"] = "translate(50%, 0)";
      break;
    case "bottom_trailing":
      r["--inset"] = "auto 0 0 auto";
      break;
  }
  return r;
}
function F_(e) {
  const r = {
    "--direction": "initial",
    "--alignment": "initial",
    "--distribution": "initial",
    "--position": "relative",
    "--inset": "initial",
    "--transform": "initial"
  };
  return e.type !== "zlayer" && (Object.assign(r, {
    "--direction": Dn[e.type],
    "--alignment": An[e.alignment]
  }), e.distribution && Object.assign(r, {
    "--distribution": Cn[e.distribution]
  })), r;
}
function I_(e, r = "light") {
  var l, c;
  const { font_size: t, horizontal_alignment: n, font_weight: a, font_name: o, color: i } = e, s = {
    "--text-align": "initial",
    "--font-weight": "initial",
    "--font-size": "initial",
    "--font-family": "sans-serif",
    "--background-clip": "none",
    "--text-fill-color": "none",
    "--background": "unset"
  };
  return Object.assign(s, {
    "--text-align": Rt[n] || Rt.leading,
    "--font-weight": Nt[a] || Nt.regular,
    "--font-size": Ot[t] || Ot.body_m,
    "--font-family": o || "sans-serif"
  }), i && (((l = i[r]) == null ? void 0 : l.type) === "linear" || ((c = i[r]) == null ? void 0 : c.type) === "radial") && Object.assign(s, {
    "--background-clip": "text",
    "--text-fill-color": "transparent",
    "--background": er({ colorMap: i, colorMode: r })
  }), s;
}
function Ee(e) {
  return Object.entries(e).map(([r, t]) => `${r}: ${t}`).join("; ");
}
function T_(e) {
  const r = (n) => {
    if (n.type === "package" && n.is_selected_by_default)
      return n;
    if (n.components && Array.isArray(n.components))
      for (const a of n.components) {
        const o = r(a);
        if (o)
          return o;
      }
    if (n.stack !== void 0) {
      const a = r(n.stack);
      if (a)
        return a;
    }
  }, t = r(e.components_config.base.stack);
  if (t !== void 0)
    return t.package_id;
}
const na = (e, r) => r ? D_(r).reduce((a, o) => {
  var i;
  if (e) {
    const s = ((i = e == null ? void 0 : e.states) == null ? void 0 : i[o]) || {};
    return { ...a, ...s };
  }
  return a;
}, {}) : {}, D_ = (e) => e ? Object.entries(e).reduce((t, [n, a]) => (a && t.push(n), t), []) : [];
function Te(e, r) {
  return e ? r ? Object.entries(e).reduce((t, [n, a]) => {
    const o = n.replace(/^--/, `${r}-`);
    return t[`--${o}`] = a, t;
  }, {}) : e : {};
}
const vi = {
  light: { type: "hex", value: "#000000" }
}, A_ = {
  light: { type: "hex", value: "#FFFFFF" }
}, aa = (e) => {
  const { font_size: r = "body_m", color: t = vi, background_color: n = A_, padding: a, margin: o, size: i, purchaseState: s } = e, l = {
    "--width": "unset",
    "--height": "unset",
    "--text-align": "initial",
    "--font-weight": "initial",
    "--font-size": "initial",
    "--font-family": "sans-serif",
    "--background-clip": "unset",
    "--text-fill-color": "unset",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "transparent",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--flex": "0 1 auto"
  }, c = na(e.overrides, e.componentState), d = S_(r), u = I_({ ...e, ...c }, s.colorMode), p = Zt({
    background_color: n,
    color: t,
    margin: o,
    padding: a,
    colorMode: s.colorMode,
    ...c
  }), _ = mt({ ...i, ...c }), m = {
    ...l,
    ...p,
    ...u,
    ..._
  };
  return {
    textStyles: Te(m, "text"),
    tagToRender: d
  };
};
function C_(e, r, t) {
  const n = {
    "--width": "unset",
    "--height": "unset",
    "--flex": "0 1 auto",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "transparent",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--position": "relative",
    "--inset": "0",
    "--transform": "initial"
  };
  Object.assign(n, Zt({
    background_color: t,
    ...e
  }), mt(r)), Object.assign(n, e.zStackChildStyles);
  const a = Te(n, "text");
  return Ee(a);
}
function M_(e) {
  const r = {
    "--text-margin-block-start": "0px",
    "--text-margin-inline-end": "0px",
    "--text-margin-block-end": "0px",
    "--text-margin-inline-start": "0px",
    "--text-padding-block-start": "0px",
    "--text-padding-inline-end": "0px",
    "--text-padding-block-end": "0px",
    "--text-padding-inline-start": "0px",
    "--text-background": "transparent",
    "--text-text-color": "inherit",
    "--text-border": "none",
    "--text-border-end-start-radius": "0px",
    "--text-border-end-end-radius": "0px",
    "--text-border-start-start-radius": "0px",
    "--text-border-start-end-radius": "0px",
    "--text-shadow": "none",
    "--text-text-align": "initial",
    "--text-font-weight": "initial",
    "--text-font-size": "initial",
    "--text-font-family": "sans-serif",
    "--text-background-clip": "initial",
    "--text-text-fill-color": "initial",
    "--text-width": "unset",
    "--text-height": "unset",
    "--text-flex": "0 1 auto"
  }, { tagToRender: t, textStyles: n } = aa(e);
  return Object.assign(r, n), { tagToRender: t, textStyles: Ee(r) };
}
function j_(e) {
  return e ? Object.values({
    newLine: { regexp: /\\\n/g, output: "<br/>" },
    bold: { regexp: /\*\*(.*?)\*\*/g, output: "<b>$1</b>" },
    italic: { regexp: /\*(.*?)\*/g, output: "<i>$1</i>" },
    strikethrough: { regexp: /~(.*?)~/g, output: "<s>$1</s>" },
    code: {
      regexp: /`(.*?)`/g,
      output: "<span style='font-family: monospace'>$1</span>"
    },
    link: {
      regexp: /\[(.*?)\]\((.*?)\)/g,
      output: "<a href=$2 target='_blank' rel='noopener noreferrer'>$1</a>"
    }
  }).reduce((t, { regexp: n, output: a }) => t.replaceAll(n, a), e) : "";
}
const N_ = {
  hash: "svelte-1wz4si8",
  code: ".rc-pw-text-block.svelte-1wz4si8 {display:block;padding-block-start:var(--text-padding-block-start, initial);padding-inline-end:var(--text-padding-inline-end, initial);padding-block-end:var(--text-padding-block-end, initial);padding-inline-start:var(--text-padding-inline-start, initial);margin-block-start:var(--text-margin-block-start, initial);margin-inline-end:var(--text-margin-inline-end, initial);margin-block-end:var(--text-margin-block-end, initial);margin-inline-start:var(--text-margin-inline-start, initial);color:var(--text-text-color, #ffffff);background:var(--text-background, none);font-size:var(--text-font-size, 1rem);font-weight:var(--text-font-weight, normal);text-align:var(--text-text-align, center);font-family:var(--text-font-family, sans-serif);-webkit-background-clip:var(--text-background-clip, initial);background-clip:var(--text-background-clip, initial);-webkit-text-fill-color:var(--text-text-fill-color, initial);}"
};
function ki(e, r) {
  V(r, !0), U(e, N_);
  const t = v(r, "styleVariables", 3, ""), n = v(r, "component", 3, "p");
  var a = ae(), o = J(a);
  At(o, n, !1, (i, s) => {
    let l;
    N(() => l = Ct(
      i,
      l,
      {
        id: r.id,
        style: t(),
        class: "rc-pw-text-block"
      },
      "svelte-1wz4si8",
      i.namespaceURI === nt,
      i.nodeName.includes("-")
    ));
    var c = ae(), d = J(c);
    be(d, () => r.children ?? se), P(s, c);
  }), P(e, a), W();
}
var O_ = /* @__PURE__ */ F('<span class="rc-pw-text-wrapper svelte-11gzifq"><!></span>');
const R_ = {
  hash: "svelte-11gzifq",
  code: ".rc-pw-text-wrapper.svelte-11gzifq {display:block;height:var(--text-height, initial);width:var(--text-width, initial);background:var(--text-background, none);position:var(--text-position, relative);inset:var(--text-inset, 0);transform:var(--text-transform, initial);}"
};
function L_(e, r) {
  V(r, !0), U(e, R_);
  const t = /* @__PURE__ */ mr(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "labels",
    "text_lid",
    "purchaseState",
    "variableDictionary",
    "background_color",
    "size"
  ]), n = /* @__PURE__ */ O(() => M_({
    id: r.id,
    labels: r.labels,
    text_lid: r.text_lid,
    purchaseState: r.purchaseState,
    background_color: r.background_color,
    size: r.size,
    ...t
  })), a = /* @__PURE__ */ O(() => f(n).tagToRender), o = /* @__PURE__ */ O(() => f(n).textStyles), i = /* @__PURE__ */ O(() => C_(t, r.size, r.background_color)), s = /* @__PURE__ */ O(() => ta({
    text_lid: r.text_lid,
    locale: r.purchaseState.locale,
    defaultLocale: r.purchaseState.defaultLocale,
    labels: r.labels,
    variableDictionary: r.variableDictionary
  })), l = /* @__PURE__ */ O(() => j_(f(s)));
  var c = O_(), d = E(c);
  ki(d, {
    get styleVariables() {
      return f(o);
    },
    get component() {
      return f(a);
    },
    get id() {
      return r.id;
    },
    children: (u, p) => {
      var _ = ae(), m = J(_);
      ft(m, () => f(l)), P(u, _);
    },
    $$slots: { default: !0 }
  }), N(() => Z(c, "style", f(i))), P(e, c), W();
}
const z_ = (e, r) => {
  var t;
  (t = r.onclick) == null || t.call(r);
};
var U_ = /* @__PURE__ */ F("<button><!></button>");
function wi(e, r) {
  V(r, !0);
  var t = U_();
  t.__click = [z_, r];
  var n = E(t);
  be(n, () => r.children ?? se), N(() => {
    Xt(t, Co(r.class)), t.disabled = !r.onclick, Z(t, "style", r.style);
  }), P(e, t), W();
}
Yn(["click"]);
const B_ = (e) => {
  const { background_color: r, margin: t, padding: n, spacing: a, size: o, border: i, shape: s, shadow: l, dimension: c, componentState: d, overrides: u, purchaseState: p, zStackChildStyles: _ } = e, m = {
    "--flex": "0 1 auto",
    "--height": "initial",
    "--width": "initial",
    "--spacing": `${a || 0}px`,
    "--direction": "unset",
    "--alignment": "unset",
    "--distribution": "flex-start",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "unset",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--position": "relative",
    "--transform": "initial",
    "--inset": "initial"
  }, h = na(u, d);
  Object.assign(m, Zt({
    background_color: r,
    margin: t,
    padding: n,
    border: i,
    colorMode: p.colorMode,
    shape: s,
    shadow: l,
    ...h
  }), F_({
    ...c,
    ...h
  }), mt({ ...o, ...h })), Object.assign(m, _);
  const b = Te(m, "stack");
  return Ee(b);
};
function V_(e) {
  var a, o, i, s, l, c;
  const { badge: r } = e;
  if (!r)
    return "";
  const t = {
    "--inset": "unset",
    "--transform": "unset",
    "--margin-block-start": "0px",
    "--margin-inline-end": "0px",
    "--margin-block-end": "0px",
    "--margin-inline-start": "0px",
    "--padding-block-start": "0px",
    "--padding-inline-end": "0px",
    "--padding-block-end": "0px",
    "--padding-inline-start": "0px",
    "--background": "unset",
    "--text-color": "inherit",
    "--border": "none",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--shadow": "none",
    "--badge-width": "unset",
    "--z-index": "unset"
  };
  if (Object.assign(t, bi({
    type: "zlayer",
    alignment: r.alignment
  }), Zt({
    ...r,
    background_color: r.background_color,
    color: r.color,
    colorMode: e.purchaseState.colorMode
  })), r.style === "overlay" && (t["--margin-block-start"] = "0px", t["--margin-block-end"] = "0px", t["--transform"] = Pt(r, 0, -(((a = e.border) == null ? void 0 : a.width) || 0))), r.style === "edge_to_edge")
    if (t["--margin-block-start"] = "0px", t["--margin-block-end"] = "0px", t["--margin-inline-start"] = "0px", t["--margin-inline-end"] = "0px", r.alignment === "top" || r.alignment === "bottom") {
      t["--badge-width"] = `calc(100% + ${(((o = e.border) == null ? void 0 : o.width) || 0) * 2}px)`, t["--z-index"] = "-1";
      const d = Math.max(((s = (i = e.shape) == null ? void 0 : i.corners) == null ? void 0 : s.top_leading) || 0, ((c = (l = e.shape) == null ? void 0 : l.corners) == null ? void 0 : c.top_trailing) || 0);
      r.alignment === "top" && (t["--padding-block-end"] = `${d + r.padding.bottom}px`, t["--transform"] = Pt(r, d)), r.alignment === "bottom" && (t["--padding-block-start"] = `${d + r.padding.top}px`, t["--transform"] = Pt(r, -d));
    } else
      t["--transform"] = Pt(r), Object.assign(t, W_(e));
  const n = Te(t, "stack-badge");
  return Ee(n);
}
const Ha = {
  top_leading: "bottom_trailing",
  top_trailing: "bottom_leading",
  bottom_leading: "top_trailing",
  bottom_trailing: "top_leading"
}, Ga = {
  top_leading: "--border-start-start-radius",
  top_trailing: "--border-start-end-radius",
  bottom_leading: "--border-end-start-radius",
  bottom_trailing: "--border-end-end-radius"
};
function W_(e) {
  var o, i, s;
  const r = {
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px"
  }, { badge: t } = e;
  if (!t)
    return r;
  const n = ((o = e.border) == null ? void 0 : o.width) || 0, a = t.alignment;
  return r[Ga[Ha[a]]] = `${(i = t.shape) == null ? void 0 : i.corners[Ha[a]]}px`, r[Ga[a]] = `${((s = e.shape) == null ? void 0 : s.corners[a]) - n}px`, r;
}
function Pt(e, r = 0, t = 0) {
  if (!e)
    return "";
  if (e.style === "overlay") {
    if (e.alignment === "top_leading")
      return `translate(${t}px, calc(-50% + ${r}px))`;
    if (e.alignment === "top_trailing")
      return `translate(calc(0% - ${t}px), calc(-50% + ${r}px))`;
    if (e.alignment === "bottom_leading")
      return `translate(${t}px, calc(50% + ${r}px))`;
    if (e.alignment === "bottom_trailing")
      return `translate(calc(0% - ${t}px), calc(50% + ${r}px))`;
    if (e.alignment === "top")
      return `translate(calc(-50% + ${t}px), calc(-50% + ${r}px))`;
    if (e.alignment === "bottom")
      return `translate(calc(50% + ${t}px), calc(50% + ${r}px))`;
  }
  if (e.style === "edge_to_edge") {
    if (e.alignment === "top")
      return `translate(calc(-50% + ${t}px), calc(-100% - ${r}px + 16px))`;
    if (e.alignment === "bottom")
      return `translate(calc(50% + ${t}px), calc(100% + ${r}px))`;
  }
  return "";
}
function Y_(e) {
  const { badge: r } = e;
  if (!r)
    return { tagToRender: "", textStyles: "" };
  const { tagToRender: t, textStyles: n } = aa({
    id: e.id,
    labels: e.labels,
    purchaseState: e.purchaseState,
    ...r,
    components: [],
    type: "text",
    size: {
      width: { type: "fit" },
      height: { type: "fit" }
    },
    color: r == null ? void 0 : r.color,
    name: e.name
  }), o = {
    ...n,
    ...{
      "--text-margin-block-start": "0px",
      "--text-margin-inline-end": "0px",
      "--text-margin-block-end": "0px",
      "--text-margin-inline-start": "0px",
      "--text-padding-block-start": "0px",
      "--text-padding-inline-end": "0px",
      "--text-padding-block-end": "0px",
      "--text-padding-inline-start": "0px"
    }
  }, i = Ee(o);
  return {
    tagToRender: t,
    textStyles: i
  };
}
function H_(e) {
  const { dimension: r } = e, t = {
    "--inset": "initial",
    "--transform": "initial",
    "--position": "relative"
  };
  if (r.type !== "zlayer")
    return;
  const n = bi({ ...r, type: "zlayer" });
  return Object.assign(t, { ...n, "--position": "absolute" }), t;
}
var G_ = /* @__PURE__ */ F('<span class="rc-pw-badge svelte-1b5bst5"><!></span>'), X_ = /* @__PURE__ */ F('<div class="rc-pw-stack-wrapper svelte-1b5bst5"><!> <div class="rc-pw-stack svelte-1b5bst5"></div></div>');
const J_ = {
  hash: "svelte-1b5bst5",
  code: `.rc-pw-stack-wrapper.svelte-1b5bst5 {display:block;box-sizing:border-box;width:var(--stack-width, unset);height:var(--stack-height, unset);box-shadow:var(--stack-shadow, none);background:var(--stack-background, unset);position:var(--stack-position, relative);transform:var(--stack-transform, initial);inset:var(--stack-inset, initial);margin-block-start:var(--stack-margin-block-start, 0);margin-inline-end:var(--stack-margin-inline-end, 0);margin-block-end:var(--stack-margin-block-end, 0);margin-inline-start:var(--stack-margin-inline-start, 0);border:var(--stack-border, none);border-end-start-radius:var(--stack-border-end-start-radius, 0px);border-end-end-radius:var(--stack-border-end-end-radius, 0px);border-start-start-radius:var(--stack-border-start-start-radius, 0px);border-start-end-radius:var(--stack-border-start-end-radius, 0px);}.rc-pw-stack.svelte-1b5bst5 {background:none;overflow:hidden;box-sizing:border-box;width:100%;height:100%;display:flex;gap:var(--stack-spacing, 0);flex:var(--stack-flex, 0 1 auto);flex-direction:var(--stack-direction, unset);justify-content:var(--stack-distribution, flex-start);align-items:var(--stack-alignment, flex-start);padding-block-start:var(--stack-padding-block-start, 0);padding-inline-end:var(--stack-padding-inline-end, 0);padding-block-end:var(--stack-padding-block-end, 0);padding-inline-start:var(--stack-padding-inline-start, 0);}.rc-pw-badge.svelte-1b5bst5 {box-sizing:border-box;font-family:var(--stack-badge-font-family, sans-serif);position:absolute;inset:var(--stack-badge-inset, unset);transform:var(--stack-badge-transform, initial);margin-block-start:var(--stack-badge-margin-block-start, 0px);margin-inline-end:var(--stack-badge-margin-inline-end, 0px);margin-block-end:var(--stack-badge-margin-block-end, 0px);margin-inline-start:var(--stack-badge-margin-inline-start, 0px);padding-block-start:var(--stack-badge-padding-block-start, 0px);padding-inline-end:var(--stack-badge-padding-inline-end, 0px);padding-block-end:var(--stack-badge-padding-block-end, 0px);padding-inline-start:var(--stack-badge-padding-inline-start, 0px);background:var(--stack-badge-background, initial);color:var(--stack-badge-text-color, inherit);border:var(--stack-badge-border, none);border-end-start-radius:var(--stack-badge-border-end-start-radius, 0px);border-end-end-radius:var(--stack-badge-border-end-end-radius, 0px);border-start-start-radius:var(
      --stack-badge-border-start-start-radius,
      0px
    );border-start-end-radius:var(--stack-badge-border-start-end-radius, 0px);box-shadow:var(--stack-badge-shadow, none);display:flex;align-items:center;justify-content:center;width:var(--stack-badge-badge-width, max-content);height:var(--stack-badge-badge-height, max-content);z-index:var(--stack-badge-z-index, 1);}`
};
function ht(e, r) {
  V(r, !0), U(e, J_);
  const t = /* @__PURE__ */ mr(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "components",
    "labels",
    "onAction",
    "purchaseState",
    "variableDictionary",
    "badge",
    "zStackChildStyles"
  ]), n = /* @__PURE__ */ O(() => B_({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    zStackChildStyles: r.zStackChildStyles,
    ...t
  })), a = /* @__PURE__ */ O(() => V_({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    badge: r.badge,
    ...t
  })), o = /* @__PURE__ */ O(() => H_({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    ...t
  })), i = /* @__PURE__ */ O(() => {
    var m;
    return ta({
      defaultLocale: r.purchaseState.defaultLocale,
      locale: r.purchaseState.locale,
      labels: r.labels,
      variableDictionary: r.variableDictionary,
      text_lid: (m = r.badge) == null ? void 0 : m.text_lid
    });
  }), s = /* @__PURE__ */ O(() => Y_({
    id: r.id,
    components: r.components,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    variableDictionary: r.variableDictionary,
    badge: r.badge,
    ...t
  })), l = /* @__PURE__ */ O(() => f(s).tagToRender), c = /* @__PURE__ */ O(() => f(s).textStyles);
  var d = X_(), u = E(d);
  {
    var p = (m) => {
      var h = G_(), b = E(h);
      ki(b, {
        get styleVariables() {
          return f(c);
        },
        get component() {
          return f(l);
        },
        children: (y, g) => {
          var k = Rr();
          N(() => Se(k, f(i))), P(y, k);
        },
        $$slots: { default: !0 }
      }), N(() => Z(h, "style", f(a))), P(m, h);
    };
    j(u, (m) => {
      r.badge && m(p);
    });
  }
  var _ = M(u, 2);
  Xn(_, 21, () => r.components, Gn, (m, h, b) => {
    var y = ae(), g = J(y);
    {
      var k = (x) => {
        var S = /* @__PURE__ */ O(() => b > 0 ? f(o) : void 0);
        zt(x, {
          get nodeData() {
            return f(h);
          },
          get labels() {
            return r.labels;
          },
          get onAction() {
            return r.onAction;
          },
          get purchaseState() {
            return r.purchaseState;
          },
          get variableDictionary() {
            return r.variableDictionary;
          },
          get componentState() {
            return r.componentState;
          },
          get zStackChildStyles() {
            return f(S);
          }
        });
      }, w = (x) => {
        zt(x, {
          get nodeData() {
            return f(h);
          },
          get labels() {
            return r.labels;
          },
          get onAction() {
            return r.onAction;
          },
          get purchaseState() {
            return r.purchaseState;
          },
          get variableDictionary() {
            return r.variableDictionary;
          },
          get componentState() {
            return r.componentState;
          }
        });
      };
      j(g, (x) => {
        f(o) ? x(k) : x(w, !1);
      });
    }
    P(m, y);
  }), N(() => {
    Z(d, "id", r.id), Z(d, "style", f(n));
  }), P(e, d), W();
}
function Q_({ stack: e, zStackChildStyles: r }) {
  var i, s;
  const t = ((s = (i = e == null ? void 0 : e.size) == null ? void 0 : i.width) == null ? void 0 : s.type) === "fill" ? "100%" : "fit-content", n = Te(r || {}, "button");
  return Ee({
    ...n,
    ...{
      position: "var(--button-position, relative)",
      inset: "var(--button-inset, 0)",
      transform: "var(--button-transform, initial)",
      width: t
    }
  });
}
const Z_ = { hash: "svelte-bq8o6o", code: "" };
function K_(e, r) {
  V(r, !0), U(e, Z_);
  const t = /* @__PURE__ */ mr(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "stack",
    "action",
    "onAction",
    "labels",
    "purchaseState",
    "variableDictionary"
  ]), n = () => {
    r.onAction && r.onAction(r.action);
  }, a = /* @__PURE__ */ O(() => Q_({
    stack: r.stack,
    action: r.action,
    onAction: r.onAction,
    labels: r.labels,
    purchaseState: r.purchaseState,
    variableDictionary: r.variableDictionary,
    ...t
  }));
  wi(e, {
    onclick: n,
    get style() {
      return f(a);
    },
    class: "rc-pw-button",
    children: (o, i) => {
      ht(o, _r(() => r.stack, {
        get labels() {
          return r.labels;
        },
        get purchaseState() {
          return r.purchaseState;
        },
        get variableDictionary() {
          return r.variableDictionary;
        }
      }));
    },
    $$slots: { default: !0 }
  }), W();
}
function zt(e, r) {
  V(r, !0);
  const t = ar(), n = () => nr(gi, "$prefersDarkMode", t), a = {
    stack: ht,
    text: L_,
    image: dp,
    button: K_,
    purchase_button: fp,
    package: yp,
    footer: Pi,
    timeline: Ep
  }, o = (p) => {
    if (a[p.type])
      return [a[p.type], p];
    const { fallback: _ } = p;
    if (_ && a[_ == null ? void 0 : _.type])
      return [a[_.type], _];
    throw new Error(`Invalid component type: ${p.type}`);
  }, i = /* @__PURE__ */ mr(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "nodeData",
    "labels",
    "onAction",
    "purchaseState",
    "variableDictionary",
    "zStackChildStyles"
  ]), s = /* @__PURE__ */ O(() => o(r.nodeData)), l = /* @__PURE__ */ O(() => f(s)[0]), c = /* @__PURE__ */ O(() => f(s)[1]);
  var d = ae(), u = J(d);
  return Gs(u, () => f(l), (p, _) => {
    _(p, _r(
      () => f(c) || {},
      {
        get labels() {
          return r.labels;
        },
        get prefersDarkMode() {
          return n();
        },
        get onAction() {
          return r.onAction;
        },
        get purchaseState() {
          return r.purchaseState;
        },
        get variableDictionary() {
          return r.variableDictionary;
        },
        get zStackChildStyles() {
          return r.zStackChildStyles;
        }
      },
      () => i,
      {
        children: (m, h) => {
          var b = ae(), y = J(b);
          Xn(y, 17, () => r.nodeData.components, Gn, (g, k) => {
            zt(g, _r(
              {
                get nodeData() {
                  return f(k);
                },
                get labels() {
                  return r.labels;
                },
                get onAction() {
                  return r.onAction;
                },
                get purchaseState() {
                  return r.purchaseState;
                },
                get variableDictionary() {
                  return r.variableDictionary;
                }
              },
              () => i
            ));
          }), P(m, b);
        },
        $$slots: { default: !0 }
      }
    ));
  }), P(e, d), W({ getComponentClass: o });
}
function $_({ background: e, colorMode: r }) {
  const t = { "--background": "initial" };
  (e == null ? void 0 : e.type) === "color" && Object.assign(t, {
    "--background": er({
      colorMap: e.value,
      colorMode: r,
      fallback: "transparent"
    })
  });
  const n = Te(t, "paywall");
  return Ee(n);
}
function ep(e, r) {
  var n, a, o, i;
  if (((a = (n = e.components_config.base) == null ? void 0 : n.background) == null ? void 0 : a.type) !== "image")
    return "";
  const t = e.components_config.base.background;
  return ((o = t.value[r]) == null ? void 0 : o.original) || ((i = t.value.light) == null ? void 0 : i.original);
}
var rp = /* @__PURE__ */ F('<div class="rc-pw-footer svelte-pg5jlz"><!></div>');
const tp = {
  hash: "svelte-pg5jlz",
  code: ".rc-pw-footer.svelte-pg5jlz {position:sticky;bottom:0;transform:translateY(50%);width:100%;}"
};
function Pi(e, r) {
  U(e, tp);
  var t = rp(), n = E(t);
  ht(n, _r(() => r.stack, {
    get labels() {
      return r.labels;
    },
    get purchaseState() {
      return r.purchaseState;
    },
    get variableDictionary() {
      return r.variableDictionary;
    },
    get onAction() {
      return r.onAction;
    }
  })), N(() => Z(t, "id", r.id)), P(e, t);
}
var np = /* @__PURE__ */ F('<div class="rc-pw-paywall-background svelte-bpa118"></div>'), ap = /* @__PURE__ */ F('<div class="rc-pw-paywall-background rc-pw-image-container svelte-bpa118"><img class="rc-pw-image svelte-bpa118" alt=""></div>'), op = /* @__PURE__ */ F('<div class="rc-pw-paywall svelte-bpa118"><!> <!> <!></div>');
const ip = {
  hash: "svelte-bpa118",
  code: `.rc-pw-paywall.svelte-bpa118 {position:relative;display:block;max-height:100%;}.rc-pw-paywall-background.svelte-bpa118 {position:absolute;top:0;left:0;width:100%;height:100%;background:var(--paywall-background, none);z-index:-1;}.rc-pw-image-container.svelte-bpa118 {overflow:hidden;background:none;}.rc-pw-image.svelte-bpa118 {width:100%;height:100%;object-fit:cover;display:block;}*,
    *::before,
    *::after {box-sizing:border-box;margin:0;padding:0;font-family:sans-serif;}body {line-height:1.5;-webkit-font-smoothing:antialiased;}img,
    picture,
    video,
    canvas,
    svg {display:block;max-width:100%;}input,
    button,
    textarea,
    select {font:inherit;}button {border:none;cursor:pointer;background:transparent;width:fit-content;}p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {overflow-wrap:break-word;}p {text-wrap:pretty;}h1,
    h2,
    h3,
    h4,
    h5,
    h6 {text-wrap:balance;}#root,
    #__next {isolation:isolate;}`
};
function sp(e, r) {
  V(r, !0), U(e, ip);
  const t = ar(), n = () => nr(gi, "$prefersDarkMode", t), a = v(r, "variablesPerPackage", 19, () => ({}));
  let o = Ke({
    selectedPackageId: T_(r.paywallData),
    locale: r.selectedLocale || r.paywallData.default_locale,
    defaultLocale: r.paywallData.default_locale,
    variablesPerPackage: a(),
    colorMode: r.preferredColorMode || (n() ? "dark" : "light")
  }), i = ys(Ke(a()[o.selectedPackageId || ""]));
  const s = (y, g) => {
    var k;
    (k = r.onRestorePurchasesClicked) == null || k.call(r);
  }, l = (y, g) => {
    var k;
    (k = r.onBackClicked) == null || k.call(r);
  }, c = (y, g) => {
    var w, x;
    if (y.destination === "customer_center" && ((w = r.onVisitCustomerCenterClicked) == null || w.call(r)), !y.url)
      return;
    const k = hi(y.url.url_lid, o.locale, o.defaultLocale, r.paywallData.components_localizations);
    k && ((x = r.onNavigateToUrlClicked) == null || x.call(r, k));
  }, d = (y, g) => {
    o.selectedPackageId = g == null ? void 0 : g.packageId, g != null && g.packageId && A(i, Ke(a()[g.packageId]));
  }, u = (y, g) => {
    var k;
    o.selectedPackageId !== void 0 && ((k = r.onPurchaseClicked) == null || k.call(r, o.selectedPackageId));
  }, p = (y, g) => {
    switch (y.type) {
      case "select_package":
        d(y, g);
        break;
      case "navigate_to":
        c(y);
        break;
      case "navigate_back":
        l();
        break;
      case "restore_purchases":
        s();
        break;
      case "purchase":
        u();
        break;
    }
  }, _ = /* @__PURE__ */ O(() => {
    var y;
    return $_({
      background: (y = r.paywallData.components_config.base) == null ? void 0 : y.background,
      colorMode: o.colorMode
    });
  }), m = /* @__PURE__ */ O(() => ep(r.paywallData, o.colorMode));
  var h = ae(), b = J(h);
  ll(
    b,
    {
      get onerror() {
        return r.onError;
      }
    },
    (y) => {
      var g = op(), k = E(g);
      zt(k, {
        onAction: p,
        get nodeData() {
          return r.paywallData.components_config.base.stack;
        },
        get labels() {
          return r.paywallData.components_localizations;
        },
        get purchaseState() {
          return o;
        },
        get variableDictionary() {
          return f(i);
        }
      });
      var w = M(k, 2);
      {
        var x = (T) => {
          Pi(T, _r(() => r.paywallData.components_config.base.sticky_footer, {
            get stack() {
              return r.paywallData.components_config.base.sticky_footer.stack;
            },
            get labels() {
              return r.paywallData.components_localizations;
            },
            get purchaseState() {
              return o;
            },
            get variableDictionary() {
              return f(i);
            },
            onAction: p
          }));
        };
        j(w, (T) => {
          r.paywallData.components_config.base.sticky_footer && T(x);
        });
      }
      var S = M(w, 2);
      {
        var D = (T) => {
          var Y = np();
          N(() => Z(Y, "style", f(_))), P(T, Y);
        }, I = (T) => {
          var Y = ae(), K = J(Y);
          {
            var ne = (le) => {
              var X = ap(), C = E(X);
              N(() => Z(C, "src", f(m))), P(le, X);
            };
            j(
              K,
              (le) => {
                var X;
                ((X = r.paywallData.components_config.base.background) == null ? void 0 : X.type) === "image" && le(ne);
              },
              !0
            );
          }
          P(T, Y);
        };
        j(S, (T) => {
          var Y;
          ((Y = r.paywallData.components_config.base.background) == null ? void 0 : Y.type) === "color" ? T(D) : T(I, !1);
        });
      }
      P(y, g);
    }
  ), P(e, h), W();
}
const lp = (e) => {
  const {
    gradient_colors: r,
    mask_shape: t,
    size: n,
    // max_height, // TODO: implement this. still waiting on spec
    // override_source_lid, // TODO: Implement this once structure is defined
    overrides: a,
    componentState: o,
    purchaseState: i,
    zStackChildStyles: s
  } = e, l = {
    "--height": "unset",
    "--width": "unset",
    "--clip-path": "none",
    "--border-end-start-radius": "unset",
    "--border-end-end-radius": "unset",
    "--border-start-start-radius": "unset",
    "--border-start-end-radius": "unset",
    "--position": "relative",
    "--inset": "0",
    "--transform": "initial"
  };
  Object.assign(l, s);
  const c = {
    "--background": "none"
  }, d = na(a, o);
  Object.assign(c, E_(i.colorMode, (d == null ? void 0 : d.gradient_colors) || r)), Object.assign(l, mt({ ...n, ...d })), Object.assign(l, q_({
    ...t,
    ...d
  }));
  const u = Te(l, "image"), p = Te(c, "image");
  return {
    imageStyles: Ee(u),
    gradientStyles: Ee(p)
  };
};
var cp = /* @__PURE__ */ F('<div class="rc-pw-image-container svelte-yv61ni"><img class="rc-pw-image svelte-yv61ni" alt=""> <span class="rc-pw-image-overlay svelte-yv61ni"></span></div>');
const up = {
  hash: "svelte-yv61ni",
  code: ".rc-pw-image-container.svelte-yv61ni {position:relative;overflow:hidden;border-end-start-radius:var(--image-border-end-start-radius, 0px);border-end-end-radius:var(--image-border-end-end-radius, 0px);border-start-start-radius:var(--image-border-start-start-radius, 0px);border-start-end-radius:var(--image-border-start-end-radius, 0px);clip-path:var(--image-clip-path, initial);display:flex;flex:var(--image-flex, 1 1 auto);position:var(--image-position, relative);inset:var(--image-inset, 0);transform:var(--image-transform, initial);height:var(--image-height, initial);width:var(--image-width, initial);}.rc-pw-image.svelte-yv61ni {width:100%;height:100%;object-fit:cover;display:block;}.rc-pw-image-overlay.svelte-yv61ni {position:absolute;inset:0;background:var(--image-background, none);}"
};
function dp(e, r) {
  V(r, !0), U(e, up);
  const t = /* @__PURE__ */ mr(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "id",
    "source",
    "purchaseState"
  ]), n = /* @__PURE__ */ O(() => lp({
    id: r.id,
    colorMode: r.purchaseState.colorMode,
    source: r.source,
    purchaseState: r.purchaseState,
    ...t
  })), a = /* @__PURE__ */ O(() => f(n).gradientStyles), o = /* @__PURE__ */ O(() => f(n).imageStyles), i = /* @__PURE__ */ O(() => {
    var u;
    const d = r.purchaseState.colorMode;
    return (u = r.source[d]) != null && u.original ? r.source[d].original : r.source.light.original;
  });
  var s = cp(), l = E(s), c = M(l, 2);
  N(() => {
    Z(s, "id", `rc-pw-image-container-${r.id}`), Z(s, "style", f(o)), Z(l, "src", f(i)), Z(l, "id", r.id), Z(c, "style", f(a));
  }), P(e, s), W();
}
function _p({ stack: e, zStackChildStyles: r }) {
  const t = e.size.width.type === "fill" ? "100%" : "fit-content", n = Te(r || {}, "purchase-button");
  return Ee({
    ...n,
    ...{
      position: "var(--purchase-button-position, relative)",
      inset: "var(--purchase-button-inset, 0)",
      transform: "var(--purchase-button-transform, initial)",
      width: t
    }
  });
}
const pp = { hash: "svelte-1x8zwdp", code: "" };
function fp(e, r) {
  V(r, !0), U(e, pp);
  const t = /* @__PURE__ */ mr(r, [
    "$$slots",
    "$$events",
    "$$legacy",
    "stack",
    "labels",
    "onAction",
    "purchaseState",
    "variableDictionary",
    "zStackChildStyles"
  ]), n = () => {
    r.onAction && r.onAction({ type: "purchase" });
  }, a = /* @__PURE__ */ O(() => _p({
    stack: r.stack,
    labels: r.labels,
    onAction: r.onAction,
    purchaseState: r.purchaseState,
    variableDictionary: r.variableDictionary,
    zStackChildStyles: r.zStackChildStyles,
    ...t
  }));
  wi(e, {
    onclick: n,
    class: "rc-pw-purchase-button",
    get style() {
      return f(a);
    },
    children: (o, i) => {
      ht(o, _r(() => r.stack, {
        get labels() {
          return r.labels;
        },
        get purchaseState() {
          return r.purchaseState;
        },
        get variableDictionary() {
          return r.variableDictionary;
        }
      }));
    },
    $$slots: { default: !0 }
  }), W();
}
const mp = (e, r) => {
  e.preventDefault(), e.stopPropagation(), r.onAction && r.onAction({ type: "select_package" }, { packageId: r.package_id });
};
var hp = /* @__PURE__ */ F('<button class="rc-pw-package svelte-123kamd"><!></button>');
const gp = {
  hash: "svelte-123kamd",
  code: ".rc-pw-package.svelte-123kamd {width:100%;display:flex;margin:0;padding:0;background:initial;border:initial;text-align:initial;position:var(--package-position, relative);inset:var(--package-inset, 0);transform:var(--package-transform, initial);}"
};
function yp(e, r) {
  V(r, !0), U(e, gp);
  const t = /* @__PURE__ */ O(() => {
    var s;
    return ((s = r.purchaseState.variablesPerPackage) == null ? void 0 : s[r.package_id]) || r.variableDictionary;
  }), n = /* @__PURE__ */ O(() => {
    var s;
    return {
      selected: ((s = r.purchaseState) == null ? void 0 : s.selectedPackageId) === r.package_id
    };
  }), a = /* @__PURE__ */ O(() => Ee(Te(r.zStackChildStyles, "package")));
  var o = hp();
  o.__click = [mp, r];
  var i = E(o);
  ht(i, _r(() => r.stack, {
    get labels() {
      return r.labels;
    },
    get onAction() {
      return r.onAction;
    },
    get purchaseState() {
      return r.purchaseState;
    },
    get componentState() {
      return f(n);
    },
    get variableDictionary() {
      return f(t);
    }
  })), N(() => {
    Z(o, "id", r.id), Z(o, "style", f(a)), qr(o, "selected", f(n).selected);
  }), P(e, o), W();
}
Yn(["click"]);
function bp(e) {
  const r = {
    "--item-spacing": `${e.item_spacing}px`,
    "--width": "initial",
    "--height": "initial",
    "--flex": "0 1 auto",
    "--position": "relative",
    "--inset": "0",
    "--transform": "initial"
  };
  Object.assign(r, mt(e.size)), Object.assign(r, e.zStackChildStyles);
  const t = Te(r, "timeline");
  return Ee(t);
}
function vp(e) {
  var n, a, o, i, s, l, c, d, u, p;
  const r = {
    "--icon-size": `${e.icon.width_and_height}px`,
    "--icon-padding": `${e.icon.padding}px`,
    "--icon-color": er({
      colorMap: e.icon.color,
      colorMode: (n = e.purchaseState) == null ? void 0 : n.colorMode
    }),
    "--icon-background-color": er({
      colorMap: (a = e.icon_background) == null ? void 0 : a.color,
      colorMode: e.purchaseState.colorMode
    }),
    "--icon-border": yi((o = e.icon_background) == null ? void 0 : o.border, (i = e.purchaseState) == null ? void 0 : i.colorMode),
    "--text-spacing": `${e.text_spacing}px`,
    "--border-start-start-radius": "0px",
    "--border-start-end-radius": "0px",
    "--border-end-start-radius": "0px",
    "--border-end-end-radius": "0px",
    "--connector-color": er({
      colorMap: (s = e.connector) == null ? void 0 : s.color,
      colorMode: e.purchaseState.colorMode
    }),
    "--connector-width": `${((l = e.connector) == null ? void 0 : l.width) || 0}px`,
    "--connector-top": "0px",
    "--connector-height": `${e.item_spacing}px`
  };
  if (Object.assign(r, ((d = (c = e.icon_background) == null ? void 0 : c.shape) == null ? void 0 : d.type) === "rectangle" ? Lt((p = (u = e.icon_background) == null ? void 0 : u.shape) == null ? void 0 : p.corners) : {
    "--border-start-start-radius": "50%",
    "--border-start-end-radius": "50%",
    "--border-end-start-radius": "50%",
    "--border-end-end-radius": "50%"
  }), e.connector) {
    const _ = e.connector.margin.top !== 0, m = e.connector.margin.bottom !== 0, h = e.icon.padding + e.icon.width_and_height / 2;
    !_ && !m && (r["--connector-height"] = `${e.item_spacing + h * 2}px`, r["--connector-top"] = "50%"), _ && m && (r["--connector-height"] = `${e.item_spacing - e.connector.margin.top - e.connector.margin.bottom}px`, r["--connector-top"] = `calc(100% + ${e.connector.margin.top}px)`), !_ && m && (r["--connector-height"] = `${e.item_spacing - e.connector.margin.bottom + h}px`, r["--connector-top"] = "50%"), _ && !m && (r["--connector-height"] = `${e.item_spacing + h}px`, r["--connector-top"] = `calc(100% + ${e.connector.margin.top}px)`);
  }
  const t = Te(r, "timeline-item");
  return Ee(t);
}
function Xa(e, r = "title") {
  var l, c, d, u, p;
  const t = {
    "--text-color": "inherit",
    "--text-font-size": "initial",
    "--text-font-weight": "initial",
    "--text-horizontal-alignment": "initial",
    "--text-margin-block-start": "0px",
    "--text-margin-inline-end": "0px",
    "--text-margin-block-end": "0px",
    "--text-margin-inline-start": "0px",
    "--text-padding-block-start": "0px",
    "--text-padding-inline-end": "0px",
    "--text-padding-block-end": "0px",
    "--text-padding-inline-start": "0px"
  }, n = {
    color: ((l = e[r]) == null ? void 0 : l.color) || vi,
    font_size: ((c = e[r]) == null ? void 0 : c.font_size) || "body_m",
    font_weight: ((d = e[r]) == null ? void 0 : d.font_weight) || "regular",
    horizontal_alignment: ((u = e[r]) == null ? void 0 : u.horizontal_alignment) || "leading"
  }, { tagToRender: a, textStyles: o } = aa({
    ...e,
    components: [],
    ...n,
    size: { width: { type: "fit" }, height: { type: "fit" } },
    type: "text",
    margin: { top: 0, bottom: 0, leading: 0, trailing: 0 },
    padding: { top: 0, bottom: 0, leading: 0, trailing: 0 },
    text_lid: ""
  });
  Object.assign(t, o);
  const i = Ee(Te(t, "timeline-item")), s = ta({
    text_lid: (p = e[r]) == null ? void 0 : p.text_lid,
    locale: e.purchaseState.locale,
    defaultLocale: e.purchaseState.defaultLocale,
    labels: e.labels,
    variableDictionary: e.variableDictionary
  });
  return {
    textStyles: i,
    tagToRender: a,
    textLabel: s
  };
}
var kp = /* @__PURE__ */ F('<div class="rc-pw-timeline-item svelte-gjmo4g"><div class="rc-pw-timeline-item-icon-container svelte-gjmo4g"><div class="rc-pw-timeline-item-icon svelte-gjmo4g"></div></div> <div class="rc-pw-timeline-item-content svelte-gjmo4g"><!> <!></div></div>');
const wp = {
  hash: "svelte-gjmo4g",
  code: `.rc-pw-timeline-item.svelte-gjmo4g {display:flex;align-items:center;gap:var(--timeline-item-spacing, 0px);}.rc-pw-timeline-item-icon-container.svelte-gjmo4g {position:relative;border-end-start-radius:var(--timeline-item-border-end-start-radius, 0px);border-end-end-radius:var(--timeline-item-border-end-end-radius, 0px);border-start-start-radius:var(
      --timeline-item-border-start-start-radius,
      0px
    );border-start-end-radius:var(--timeline-item-border-start-end-radius, 0px);width:var(--timeline-item-icon-size, 16px);height:var(--timeline-item-icon-size, 16px);flex-shrink:0;background-color:var(--timeline-item-icon-background-color, #ffffff);border:var(--timeline-item-icon-border, initial);display:flex;align-items:center;justify-content:center;padding:var(--timeline-item-icon-padding, 0px);box-sizing:content-box;}.rc-pw-timeline-item-icon-container.svelte-gjmo4g::before {position:absolute;content:"";z-index:-1;top:var(--timeline-item-connector-top, 0px);height:var(--timeline-item-connector-height, 0px);width:var(--timeline-item-connector-width, 0px);background:var(--timeline-item-connector-color, transparent);}.rc-pw-timeline-item-icon.svelte-gjmo4g {width:var(--timeline-item-icon-size, 10px);height:var(--timeline-item-icon-size, 10px);color:var(--timeline-item-icon-color, #ffffff);display:flex;align-items:center;justify-content:center;}.rc-pw-timeline-item-content.svelte-gjmo4g {display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;gap:var(--timeline-item-text-spacing, 0px);height:fit-content;}.rc-pw-timeline-item-content-title.svelte-gjmo4g,
  .rc-pw-timeline-item-content-description.svelte-gjmo4g {margin-block-start:var(--timeline-item-text-margin-block-start, 0px);margin-inline-end:var(--timeline-item-text-margin-inline-end, 0px);margin-block-end:var(--timeline-item-text-margin-block-end, 0px);margin-inline-start:var(--timeline-item-text-margin-inline-start, 0px);padding-block-start:var(--timeline-item-text-padding-block-start, 0);padding-inline-end:var(--timeline-item-text-padding-inline-end, 0);padding-block-end:var(--timeline-item-text-padding-block-end, 0);padding-inline-start:var(--timeline-item-text-padding-inline-start, 0);font-family:var(--timeline-item-text-font-family, sans-serif);}`
};
function Pp(e, r) {
  V(r, !0), U(e, wp);
  const t = /* @__PURE__ */ mr(r, ["$$slots", "$$events", "$$legacy"]), n = /* @__PURE__ */ O(() => vp(t)), a = /* @__PURE__ */ O(() => Xa(t, "title")), o = /* @__PURE__ */ O(() => f(a).tagToRender), i = /* @__PURE__ */ O(() => f(a).textStyles), s = /* @__PURE__ */ O(() => f(a).textLabel), l = /* @__PURE__ */ O(() => Xa(t, "description")), c = /* @__PURE__ */ O(() => f(l).tagToRender), d = /* @__PURE__ */ O(() => f(l).textStyles), u = /* @__PURE__ */ O(() => f(l).textLabel);
  var p = kp(), _ = M(E(p), 2), m = E(_);
  At(m, () => f(o), !1, (y, g) => {
    let k;
    N(() => k = Ct(
      y,
      k,
      {
        class: "rc-pw-timeline-item-content-title",
        style: f(i)
      },
      "svelte-gjmo4g",
      y.namespaceURI === nt,
      y.nodeName.includes("-")
    ));
    var w = Rr();
    N(() => Se(w, f(s))), P(g, w);
  });
  var h = M(m, 2);
  {
    var b = (y) => {
      var g = ae(), k = J(g);
      At(k, () => f(c), !1, (w, x) => {
        let S;
        N(() => S = Ct(
          w,
          S,
          {
            class: "rc-pw-timeline-item-content-description",
            style: f(d)
          },
          "svelte-gjmo4g",
          w.namespaceURI === nt,
          w.nodeName.includes("-")
        ));
        var D = Rr();
        N(() => Se(D, f(u))), P(x, D);
      }), P(y, g);
    };
    j(h, (y) => {
      f(u) && y(b);
    });
  }
  N(() => Z(p, "style", f(n))), P(e, p), W();
}
var xp = /* @__PURE__ */ F('<div class="rc-pw-timeline-container svelte-12g27vu"></div>');
const Sp = {
  hash: "svelte-12g27vu",
  code: ".rc-pw-timeline-container.svelte-12g27vu {display:flex;flex:var(--timeline-flex, 0 1 auto);flex-direction:column;gap:var(--timeline-item-spacing, 0);width:var(--timeline-width, initial);height:var(--timeline-height, initial);position:var(--timeline-position, relative);inset:var(--timeline-inset, 0);transform:var(--timeline-transform, initial);}"
};
function Ep(e, r) {
  V(r, !0), U(e, Sp);
  const t = /* @__PURE__ */ mr(r, ["$$slots", "$$events", "$$legacy", "items"]), n = /* @__PURE__ */ O(() => bp({ items: r.items, ...t }));
  var a = ae(), o = J(a);
  {
    var i = (s) => {
      var l = xp();
      Xn(l, 21, () => r.items, Gn, (c, d, u) => {
        var p = /* @__PURE__ */ O(() => `${r.id}-${u}`), _ = /* @__PURE__ */ O(() => `${r.name}-${u}`);
        Pp(c, _r(() => f(d), {
          get labels() {
            return r.labels;
          },
          get id() {
            return f(p);
          },
          get name() {
            return f(_);
          },
          type: "timeline",
          get purchaseState() {
            return r.purchaseState;
          },
          get text_spacing() {
            return r.text_spacing;
          },
          get item_spacing() {
            return r.item_spacing;
          }
        }));
      }), N(() => Z(l, "style", f(n))), P(s, l);
    };
    j(o, (s) => {
      r.items.length && s(i);
    });
  }
  P(e, a), W();
}
const qp = 1000001;
function Fp(e) {
  return e.webBillingProduct.defaultPurchaseOption;
}
function Ja(e, r, t, n = !1) {
  return t.translate(z.PaywallVariablesPricePerPeriod, {
    formattedPrice: e,
    period: r.base.period ? t.translatePeriod(
      r.base.period.number,
      r.base.period.unit,
      {
        noWhitespace: !0,
        short: !n
      }
    ) : ""
  });
}
function Ip(e, r) {
  return e.unit === "year" ? r.translatePeriod(e.number * 12, sr.Month) : r.translatePeriod(e.number, e.unit);
}
function Tp({
  price: e,
  period: r,
  translator: t
}) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === "year" ? t.formatPrice(e.amountMicros / 12 / 4, e.currency) : r.unit === "month" || r.unit === "week" && r.number > 1 ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : r.unit === "day" ? t.formatPrice(
    e.amountMicros * 7 / r.number,
    e.currency
  ) : n : n;
}
function Dp({
  price: e,
  period: r,
  translator: t
}) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return !r || !r.number ? n : r.unit === "year" ? t.formatPrice(e.amountMicros / 12, e.currency) : r.unit === "month" && r.number > 1 ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : r.unit === "week" ? t.formatPrice(
    e.amountMicros * 4 / r.number,
    e.currency
  ) : r.unit === "day" ? t.formatPrice(
    e.amountMicros * 30 / r.number,
    e.currency
  ) : n;
}
function Qa({
  price: e,
  period: r,
  full: t = !1,
  translator: n
}) {
  if (!r || !r.number || r.unit === sr.Month && r.number == 1)
    return n.formatPrice(e.amountMicros, e.currency);
  let a = "";
  switch (r.unit) {
    case sr.Year:
      a = n.formatPrice(
        e.amountMicros / 12,
        e.currency
      );
      break;
    case sr.Month:
      a = n.formatPrice(
        e.amountMicros / r.number,
        e.currency
      );
      break;
    case sr.Week:
      a = n.formatPrice(
        e.amountMicros * 4 / r.number,
        e.currency
      );
      break;
    case sr.Day:
      a = n.formatPrice(
        e.amountMicros * 30 / r.number,
        e.currency
      );
      break;
  }
  return n.translate(
    z.PaywallVariablesTotalPriceAndPerMonth,
    {
      formattedPrice: n.formatPrice(
        e.amountMicros,
        e.currency
      ),
      period: n.translatePeriod(r.number, r.unit, {
        noWhitespace: !0,
        short: !t
      }),
      formattedPricePerMonth: a,
      monthPeriod: n.translatePeriodUnit(sr.Month, {
        noWhitespace: !0,
        short: !t
      })
    }
  );
}
function Ap(e, r) {
  const t = e.availablePackages, n = t.reduce((a, o) => a.webBillingProduct.currentPrice.amountMicros > o.webBillingProduct.currentPrice.amountMicros ? a : o);
  return t.reduce(
    (a, o) => (a[o.identifier] = Cp(
      o,
      n,
      r
    ), a),
    {}
  );
}
function Cp(e, r, t) {
  const n = e.webBillingProduct, a = t.formatPrice(
    n.currentPrice.amountMicros,
    n.currentPrice.currency
  ), o = Fp(e), i = n.productType, s = {
    product_name: n.title,
    price: a,
    price_per_period: "",
    price_per_period_full: "",
    total_price_and_per_month: "",
    total_price_and_per_month_full: "",
    sub_price_per_month: "",
    sub_price_per_week: "",
    sub_duration: "",
    sub_duration_in_months: "",
    sub_period: "",
    sub_period_length: "",
    sub_period_abbreviated: "",
    sub_offer_duration: void 0,
    sub_offer_duration_2: void 0,
    // doesn't apply - only google play
    sub_offer_price: void 0,
    sub_offer_price_2: void 0,
    // doesn't apply - only google play
    sub_relative_discount: ""
  };
  if (i === Re.Subscription && o) {
    s.price_per_period = Ja(
      a,
      o,
      t
    ), s.price_per_period_full = Ja(
      a,
      o,
      t,
      !0
    );
    const l = o.base.period;
    s.total_price_and_per_month = Qa({
      price: n.currentPrice,
      period: l,
      translator: t
    }), s.total_price_and_per_month_full = Qa({
      price: n.currentPrice,
      period: l,
      full: !0,
      translator: t
    }), s.sub_price_per_month = Dp({
      price: n.currentPrice,
      period: l,
      translator: t
    }), s.sub_price_per_week = Tp({
      price: n.currentPrice,
      period: l,
      translator: t
    }), s.sub_duration = t.translatePeriod(
      l == null ? void 0 : l.number,
      l == null ? void 0 : l.unit
    ), s.sub_duration_in_months = Ip(
      l,
      t
    ), s.sub_period = t.translatePeriodFrequency(
      l == null ? void 0 : l.number,
      l == null ? void 0 : l.unit
    ), s.sub_period_length = l ? t.translatePeriodUnit(l.unit, {
      noWhitespace: !0
    }) : void 0, s.sub_period_abbreviated = l ? t.translatePeriodUnit(l.unit, {
      noWhitespace: !0,
      short: !0
    }) : void 0;
    const c = n.currentPrice.amountMicros, d = r.webBillingProduct.currentPrice.amountMicros, u = ((d - c) * 100 / d).toFixed(0);
    s.sub_relative_discount = c === d ? "" : t.translate(
      z.PaywallVariablesSubRelativeDiscount,
      {
        discount: u
      }
    );
  }
  return (i === Re.NonConsumable || i === Re.Consumable) && o && (s.price = a, s.price_per_period = a, s.price_per_period_full = a, s.total_price_and_per_month = a, s.sub_price_per_month = a, s.sub_duration = t.translate(
    z.PeriodsLifetime
  ), s.sub_duration_in_months = t.translate(
    z.PeriodsLifetime
  ), s.sub_period = t.translate(
    z.PeriodsLifetime
  ), s.sub_price_per_week = void 0, s.sub_relative_discount = void 0, s.price_per_period_full = a, s.total_price_and_per_month_full = a, s.sub_period_length = void 0, s.sub_period_abbreviated = void 0), s;
}
const me = [];
for (let e = 0; e < 256; ++e)
  me.push((e + 256).toString(16).slice(1));
function Mp(e, r = 0) {
  return (me[e[r + 0]] + me[e[r + 1]] + me[e[r + 2]] + me[e[r + 3]] + "-" + me[e[r + 4]] + me[e[r + 5]] + "-" + me[e[r + 6]] + me[e[r + 7]] + "-" + me[e[r + 8]] + me[e[r + 9]] + "-" + me[e[r + 10]] + me[e[r + 11]] + me[e[r + 12]] + me[e[r + 13]] + me[e[r + 14]] + me[e[r + 15]]).toLowerCase();
}
let dn;
const jp = new Uint8Array(16);
function Np() {
  if (!dn) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    dn = crypto.getRandomValues.bind(crypto);
  }
  return dn(jp);
}
const Op = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Za = { randomUUID: Op };
function xi(e, r, t) {
  var a;
  if (Za.randomUUID && !e)
    return Za.randomUUID();
  e = e || {};
  const n = e.random ?? ((a = e.rng) == null ? void 0 : a.call(e)) ?? Np();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Mp(n);
}
var Rp = /(%?)(%([sdijo]))/g;
function Lp(e, r) {
  switch (r) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const t = JSON.stringify(e);
      return t === "{}" || t === "[]" || /^\[object .+?\]$/.test(t) ? e : t;
    }
  }
}
function oa(e, ...r) {
  if (r.length === 0)
    return e;
  let t = 0, n = e.replace(
    Rp,
    (a, o, i, s) => {
      const l = r[t], c = Lp(l, s);
      return o ? a : (t++, c);
    }
  );
  return t < r.length && (n += ` ${r.slice(t).join(" ")}`), n = n.replace(/%{2,2}/g, "%"), n;
}
var zp = 2;
function Up(e) {
  if (!e.stack)
    return;
  const r = e.stack.split(`
`);
  r.splice(1, zp), e.stack = r.join(`
`);
}
var Bp = class extends Error {
  constructor(e, ...r) {
    super(e), this.message = e, this.name = "Invariant Violation", this.message = oa(e, ...r), Up(this);
  }
}, Si = (e, r, ...t) => {
  if (!e)
    throw new Bp(r, ...t);
};
Si.as = (e, r, t, ...n) => {
  if (!r) {
    const a = n.length === 0 ? t : oa(t, ...n);
    let o;
    try {
      o = Reflect.construct(e, [
        a
      ]);
    } catch {
      o = e(a);
    }
    throw o;
  }
};
const Vp = "[MSW]";
function ia(e, ...r) {
  const t = oa(e, ...r);
  return `${Vp} ${t}`;
}
function Wp(e, ...r) {
  console.warn(ia(e, ...r));
}
function Yp(e, ...r) {
  console.error(ia(e, ...r));
}
const Hp = {
  formatMessage: ia,
  warn: Wp,
  error: Yp
};
function Gp() {
  Si(
    typeof URL < "u",
    Hp.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
var Ei = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(Ei || {});
Gp();
class Xp {
  constructor(r, t, n, a) {
    q(this, "initialDelay");
    q(this, "maxDelay");
    q(this, "jitterPercent");
    q(this, "callback");
    q(this, "currentDelay");
    q(this, "timeoutId");
    q(this, "executingCallback", !1);
    this.initialDelay = r, this.currentDelay = r, this.maxDelay = t, this.jitterPercent = n, this.callback = a;
  }
  tryFlush() {
    if (this.backingOff()) {
      H.debugLog("Backing off, not flushing");
      return;
    }
    this.clearTimeout(), this.executeCallbackWithRetries();
  }
  stop() {
    this.clearTimeout();
  }
  schedule(r) {
    if (this.timeoutId !== void 0)
      return;
    const t = this.addJitter(r || this.currentDelay);
    this.timeoutId = setTimeout(() => {
      this.timeoutId = void 0, this.executeCallbackWithRetries();
    }, t);
  }
  backoff() {
    const r = this.currentDelay, t = Math.min(this.currentDelay * 2, this.maxDelay);
    H.debugLog(`Backing next off to ${r}ms delay`), this.clearTimeout(), this.currentDelay = t, this.schedule(r);
  }
  reset() {
    this.currentDelay !== this.initialDelay && (this.clearTimeout(), this.currentDelay = this.initialDelay);
  }
  async executeCallbackWithRetries() {
    if (this.executingCallback) {
      H.debugLog("Callback already running, rescheduling"), this.schedule();
      return;
    }
    this.executingCallback = !0;
    try {
      await this.callback(), this.reset();
    } catch {
      this.backoff();
    } finally {
      this.executingCallback = !1;
    }
  }
  backingOff() {
    return this.currentDelay > this.initialDelay;
  }
  clearTimeout() {
    clearTimeout(this.timeoutId), this.timeoutId = void 0;
  }
  addJitter(r) {
    const t = r * this.jitterPercent, n = r - t, a = r + t;
    return Math.floor(Math.random() * (a - n + 1) + n);
  }
}
function qi(e) {
  const r = {};
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const n = t.replace(/([A-Z])/g, "_$1").toLowerCase(), a = e[t];
      a && typeof a == "object" && !Array.isArray(a) ? r[n] = qi(
        a
      ) : r[n] = a;
    }
  return r;
}
class Jp {
  constructor(r) {
    q(this, "EVENT_TYPE", "web_billing");
    q(this, "id");
    q(this, "timestampMs");
    q(this, "data");
    this.id = xi(), this.timestampMs = Date.now(), this.data = r;
  }
  toJSON() {
    return qi({
      id: this.id,
      timestampMs: this.timestampMs,
      type: this.EVENT_TYPE,
      eventName: this.data.eventName,
      appUserId: this.data.appUserId,
      context: {
        ...this.data.context
      },
      properties: {
        ...this.data.properties,
        traceId: this.data.traceId
      }
    });
  }
}
function Qp(e) {
  const r = new URLSearchParams(window.location.search);
  return {
    libraryName: "purchases-js",
    libraryVersion: oi,
    locale: navigator.language,
    userAgent: navigator.userAgent,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screenWidth: screen.width,
    screenHeight: screen.height,
    utmSource: r.get("utm_source") ?? null,
    utmMedium: r.get("utm_medium") ?? null,
    utmCampaign: r.get("utm_campaign") ?? null,
    utmContent: r.get("utm_content") ?? null,
    utmTerm: r.get("utm_term") ?? null,
    pageReferrer: document.referrer,
    pageUrl: window.location.href,
    pageTitle: document.title,
    source: e
  };
}
const Zp = 2e3, Kp = 5 * 6e4, $p = 0.1;
class ef {
  constructor(r) {
    q(this, "apiKey");
    q(this, "eventsQueue", []);
    q(this, "eventsUrl");
    q(this, "flushManager");
    q(this, "traceId", xi());
    q(this, "appUserId");
    q(this, "isSilent");
    this.apiKey = r.apiKey, this.eventsUrl = `${a_}/v1/events`, this.appUserId = r.appUserId, this.isSilent = r.silent || !1, this.flushManager = new Xp(
      Zp,
      Kp,
      $p,
      this.flushEvents.bind(this)
    );
  }
  async updateUser(r) {
    this.appUserId = r;
  }
  getTraceId() {
    return this.traceId;
  }
  trackSDKEvent(r) {
    this.trackEvent({ ...r, source: "sdk" });
  }
  trackExternalEvent(r) {
    this.trackEvent({ ...r });
  }
  trackEvent(r) {
    if (this.isSilent) {
      H.verboseLog("Skipping event tracking, the EventsTracker is silent");
      return;
    }
    try {
      const t = new Jp({
        eventName: r.eventName,
        traceId: this.traceId,
        appUserId: this.appUserId,
        context: Qp(r.source),
        properties: r.properties || {}
      });
      this.eventsQueue.push(t), this.flushManager.tryFlush();
    } catch {
      H.errorLog(`Error while tracking event ${r.eventName}`);
    }
  }
  dispose() {
    this.flushManager.stop();
  }
  flushEvents() {
    if (this.eventsQueue.length === 0)
      return Promise.resolve();
    const r = [...this.eventsQueue];
    return fetch(this.eventsUrl, {
      method: Ei.POST,
      headers: _i(this.apiKey),
      body: JSON.stringify({ events: r })
    }).then((t) => {
      if (t.status === 200 || t.status === 201) {
        this.eventsQueue.splice(0, r.length);
        return;
      } else
        throw H.debugLog("Events failed to flush due to server error"), new Error("Events failed to flush due to server error");
    }).catch((t) => {
      throw H.debugLog("Error while flushing events"), t;
    });
  }
}
const rf = () => {
  const e = new URLSearchParams(window.location.search), r = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
  ], t = {};
  return r.forEach((n) => {
    const a = e.get(n);
    a !== null && (t[n] = a);
  }), t;
}, _n = {
  autoCollectUTMAsMetadata: !0,
  collectAnalyticsEvents: !0
};
function tf() {
  if (crypto && crypto.randomUUID)
    return crypto.randomUUID();
  const e = new Uint8Array(16);
  if (crypto && crypto.getRandomValues)
    crypto.getRandomValues(e);
  else
    for (let t = 0; t < 16; t++)
      e[t] = Math.floor(Math.random() * 256);
  e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128;
  const r = Array.from(e).map((t) => t.toString(16).padStart(2, "0"));
  return [
    r.slice(0, 4).join(""),
    r.slice(4, 6).join(""),
    r.slice(6, 8).join(""),
    r.slice(8, 10).join(""),
    r.slice(10, 16).join("")
  ].join("-");
}
const nf = "$RCAnonymousID:";
var $a, pn;
$a = [v_];
const we = class we {
  /** @internal */
  constructor(r, t, n = In, a = _n) {
    ga(pn, 5, this);
    /** @internal */
    q(this, "_API_KEY");
    /** @internal */
    q(this, "_appUserId");
    /** @internal */
    q(this, "_brandingInfo", null);
    /** @internal */
    q(this, "_loadingResourcesPromise", null);
    /** @internal */
    q(this, "_flags");
    /** @internal */
    q(this, "backend");
    /** @internal */
    q(this, "purchaseOperationHelper");
    /** @internal */
    q(this, "eventsTracker");
    this._API_KEY = r, this._appUserId = t, this._flags = { ..._n, ...a }, Fn(r) && H.debugLog("Initializing Purchases SDK with sandbox API Key"), this.eventsTracker = new ef({
      apiKey: this._API_KEY,
      appUserId: this._appUserId,
      silent: !this._flags.collectAnalyticsEvents
    }), this.backend = new h_(this._API_KEY, n), this.purchaseOperationHelper = new nc(
      this.backend,
      this.eventsTracker
    ), this.eventsTracker.trackSDKEvent({
      eventName: ve.SDKInitialized
    });
  }
  /**
   * Set the log level. Logs of the given level and below will be printed
   * in the console.
   * Default is `LogLevel.Silent` so no logs will be printed in the console.
   * @param logLevel - LogLevel to set.
   */
  static setLogLevel(r) {
    H.setLogLevel(r);
  }
  /**
   * Get the singleton instance of Purchases. It's preferred to use the instance
   * obtained from the {@link Purchases.configure} method when possible.
   * @throws {@link UninitializedPurchasesError} if the instance has not been initialized yet.
   */
  static getSharedInstance() {
    if (we.isConfigured())
      return we.instance;
    throw new cl();
  }
  /**
   * Returns whether the Purchases SDK is configured or not.
   */
  static isConfigured() {
    return we.instance !== void 0;
  }
  /**
   * Configures the Purchases SDK. This should be called as soon as your app
   * has a unique user id for your user. You should only call this once, and
   * keep the returned instance around for use throughout your application.
   * @param apiKey - RevenueCat API Key. Can be obtained from the RevenueCat dashboard.
   * @param appUserId - Your unique id for identifying the user.
   * @param httpConfig - Advanced http configuration to customise the SDK usage {@link HttpConfig}.
   * @param flags - Advanced functionality configuration {@link FlagsConfig}.
   * @throws {@link PurchasesError} if the API key or user id are invalid.
   */
  static configure(r, t, n = In, a = _n) {
    return we.instance !== void 0 && H.warnLog(
      "Purchases is already initialized. You normally should only configure Purchases once. Creating and returning new instance."
    ), g_(r), Va(t), y_(n.proxyURL), b_(n.additionalHeaders), we.instance = new we(r, t, n, a), we.getSharedInstance();
  }
  /**
   * Loads and caches some optional data in the Purchases SDK.
   * Currently only fetching branding information.
   * You can call this method after configuring the SDK to speed
   * up the first call to {@link Purchases.purchase}.
   */
  async preload() {
    if (this.hasLoadedResources()) {
      H.verboseLog("Purchases resources are loaded. Skipping.");
      return;
    }
    if (this._loadingResourcesPromise !== null) {
      H.verboseLog("Purchases resources are loading. Waiting."), await this._loadingResourcesPromise;
      return;
    }
    return this._loadingResourcesPromise = this.fetchAndCacheBrandingInfo().catch((r) => {
      let t = `${r}`;
      r instanceof pe && (t = `${r.message}. ${r.underlyingErrorMessage ? `Underlying error: ${r.underlyingErrorMessage}` : ""}`), H.errorLog(`Error fetching branding info: ${t}`);
    }).finally(() => {
      this._loadingResourcesPromise = null;
    }), this._loadingResourcesPromise;
  }
  /** @internal */
  fetchAndCacheBrandingInfo() {
    return this.backend.getBrandingInfo().then((r) => {
      this._brandingInfo = r;
    });
  }
  /** @internal */
  hasLoadedResources() {
    return this._brandingInfo !== null;
  }
  /**
   * Renders an RC Paywall and allows the user to purchase from it using Web Billing.
   * @experimental
   * @internal
   * @param paywallParams - The parameters object to customise the paywall render. Check {@link RenderPaywallParams}
   * @returns Promise<PurchaseResult>
   */
  async renderPaywall(r) {
    console.warn(
      "This method is @experimental, Paywalls are not generally available but they will come soon!"
    );
    let n = r.htmlTarget ?? document.getElementById("rcb-ui-pw-root");
    if (n === null) {
      const _ = document.createElement("div");
      _.id = "rcb-ui-pw-root", _.className = "rcb-ui-pw-root", _.style.zIndex = `${qp}`, document.body.appendChild(_), n = _;
    }
    if (n === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    const a = n;
    a.innerHTML = "";
    const o = r.offering;
    if (!o.paywall_components)
      throw new Error("You cannot use paywalls yet, they are coming soon!");
    const i = r.selectedLocale || navigator.language, s = new Jt(
      {},
      i,
      o.paywall_components.default_locale
    ), l = (_) => {
      var h;
      const m = o.availablePackages.find(
        (b) => b.identifier === _
      );
      if (m === void 0)
        throw new Error(`No package found for ${_}`);
      return this.purchase({
        rcPackage: m,
        htmlTarget: r.purchaseHtmlTarget,
        customerEmail: r.customerEmail,
        selectedLocale: i,
        defaultLocale: ((h = o.paywall_components) == null ? void 0 : h.default_locale) || ur
      });
    }, c = (_) => {
      var m;
      if (r.onNavigateToUrl) {
        r.onNavigateToUrl(_);
        return;
      }
      (m = window.open(_, "_blank")) == null || m.focus();
    }, d = () => {
    }, u = () => {
      if (r.onVisitCustomerCenter) {
        r.onVisitCustomerCenter();
        return;
      }
    }, p = Ap(
      o,
      s
    );
    return new Promise((_, m) => {
      Fa(sp, {
        target: a,
        props: {
          paywallData: o.paywall_components,
          selectedLocale: i,
          onNavigateToUrlClicked: c,
          onVisitCustomerCenterClicked: u,
          onBackClicked: () => {
            if (r.onBack) {
              r.onBack();
              return;
            }
            a.innerHTML = "", H.debugLog("Purchase cancelled by user"), m(new pe(ye.UserCancelledError));
          },
          onRestorePurchasesClicked: d,
          onPurchaseClicked: (h) => {
            l(h).then((b) => {
              _(b);
            }).catch((b) => m(b));
          },
          onError: (h) => m(h),
          variablesPerPackage: p
        }
      });
    });
  }
  /**
   * Fetch the configured offerings for this user. You can configure these
   * in the RevenueCat dashboard.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getOfferings(r) {
    $u(r == null ? void 0 : r.currency);
    const t = this._appUserId, n = await this.backend.getOfferings(t), a = (r == null ? void 0 : r.offeringIdentifier) === fi.Current ? n.current_offering_id : r == null ? void 0 : r.offeringIdentifier;
    return a && (n.offerings = n.offerings.filter(
      (o) => o.identifier === a
    )), await this.getAllOfferings(n, t, r);
  }
  /**
   * Retrieves a specific offering by a placement identifier.
   * For more info see https://www.revenuecat.com/docs/tools/targeting
   * @param placementIdentifier - The placement identifier to retrieve the offering for.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getCurrentOfferingForPlacement(r, t) {
    const n = this._appUserId, a = await this.backend.getOfferings(n), o = await this.getAllOfferings(
      a,
      n,
      t
    ), i = a.placements ?? null;
    return i == null ? null : k_(
      i,
      o.all,
      r
    );
  }
  async getAllOfferings(r, t, n) {
    const a = r.offerings.flatMap((i) => i.packages).map((i) => i.platform_product_identifier), o = await this.backend.getProducts(
      t,
      a,
      n == null ? void 0 : n.currency
    );
    return this.logMissingProductIds(a, o.product_details), w_(r, o);
  }
  /**
   * Convenience method to check whether a user is entitled to a specific
   * entitlement. This will use {@link Purchases.getCustomerInfo} under the hood.
   * @param entitlementIdentifier - The entitlement identifier you want to check.
   * @returns Whether the user is entitled to the specified entitlement
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   * @see {@link Purchases.getCustomerInfo}
   */
  async isEntitledTo(r) {
    const t = await this.getCustomerInfo();
    return r in t.entitlements.active;
  }
  /**
   * Method to perform a purchase for a given package. You can obtain the
   * package from {@link Purchases.getOfferings}. This method will present the purchase
   * form on your site, using the given HTML element as the mount point, if
   * provided, or as a modal if not.
   * @deprecated - please use .purchase
   * @param rcPackage - The package you want to purchase. Obtained from {@link Purchases.getOfferings}.
   * @param customerEmail - The email of the user. If undefined, RevenueCat will ask the customer for their email.
   * @param htmlTarget - The HTML element where the billing view should be added. If undefined, a new div will be created at the root of the page and appended to the body.
   * @returns a Promise for the customer info after the purchase is completed successfully.
   * @throws {@link PurchasesError} if there is an error while performing the purchase. If the {@link PurchasesError.errorCode} is {@link ErrorCode.UserCancelledError}, the user cancelled the purchase.
   */
  purchasePackage(r, t, n) {
    return this.purchase({
      rcPackage: r,
      customerEmail: t,
      htmlTarget: n
    });
  }
  purchase(r) {
    var k;
    const {
      rcPackage: t,
      purchaseOption: n,
      htmlTarget: a,
      customerEmail: o,
      selectedLocale: i = ur,
      defaultLocale: s = ur
    } = r;
    let l = a ?? document.getElementById("rcb-ui-root");
    if (l === null) {
      const w = document.createElement("div");
      w.className = "rcb-ui-root", document.body.appendChild(w), l = w;
    }
    if (l === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    const c = l, d = this._appUserId;
    H.debugLog(
      `Presenting purchase form for package ${t.identifier}`
    );
    const u = i || s, p = n ?? t.webBillingProduct.defaultPurchaseOption, _ = Ou({
      appearance: (k = this._brandingInfo) == null ? void 0 : k.appearance,
      rcPackage: t,
      purchaseOptionToUse: p,
      customerEmail: o
    });
    this.eventsTracker.trackSDKEvent(_);
    const h = { ...this._flags.autoCollectUTMAsMetadata ? rf() : {}, ...r.metadata || {} };
    let b = null;
    const y = this._brandingInfo;
    y && r.brandingAppearanceOverride && (y.appearance = r.brandingAppearanceOverride);
    const g = a !== void 0;
    return new Promise((w, x) => {
      g || window.history.pushState({ checkoutOpen: !0 }, "");
      const S = () => {
        const T = Lu();
        this.eventsTracker.trackSDKEvent(T), window.removeEventListener("popstate", S), b && on(b), c.innerHTML = "", H.debugLog("Purchase cancelled by user"), x(new pe(ye.UserCancelledError));
      };
      g || window.addEventListener("popstate", S), b = Fa(Yd, {
        target: c,
        props: {
          isInElement: g,
          appUserId: d,
          rcPackage: t,
          purchaseOption: p,
          customerEmail: o,
          onFinished: async (T, Y) => {
            const K = Ru({
              redemptionInfo: Y
            });
            this.eventsTracker.trackSDKEvent(K), H.debugLog("Purchase finished"), b && on(b), c.innerHTML = "";
            const ne = {
              customerInfo: await this._getCustomerInfoForUserId(d),
              redemptionInfo: Y,
              operationSessionId: T
            };
            w(ne);
          },
          onClose: S,
          onError: (T) => {
            var K;
            const Y = zu({
              errorCode: (K = T.errorCode) == null ? void 0 : K.toString(),
              errorMessage: T.message
            });
            this.eventsTracker.trackSDKEvent(Y), b && on(b), c.innerHTML = "", x(pe.getForPurchasesFlowError(T));
          },
          purchases: this,
          eventsTracker: this.eventsTracker,
          brandingInfo: this._brandingInfo,
          purchaseOperationHelper: this.purchaseOperationHelper,
          selectedLocale: u,
          metadata: h,
          defaultLocale: s
        }
      });
    });
  }
  /**
   * Gets latest available {@link CustomerInfo}.
   * @returns The latest {@link CustomerInfo}.
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   */
  async getCustomerInfo() {
    return await this._getCustomerInfoForUserId(this._appUserId);
  }
  /**
   * Gets the current app user id.
   */
  getAppUserId() {
    return this._appUserId;
  }
  /**
   * Change the current app user id. Returns the customer info for the new
   * user id.
   * @param newAppUserId - The user id to change to.
   */
  async changeUser(r) {
    return Va(r), this._appUserId = r, this.eventsTracker.updateUser(r), await this.getCustomerInfo();
  }
  /** @internal */
  logMissingProductIds(r, t) {
    const n = {};
    t.forEach(
      (o) => n[o.identifier] = o
    );
    const a = [];
    r.forEach((o) => {
      n[o] === void 0 && a.push(o);
    }), a.length > 0 && H.debugLog(
      `Could not find product data for product ids:
        ${a.join()}.
        Please check that your product configuration is correct.`
    );
  }
  /**
   * @returns Whether the SDK is using a sandbox API Key.
   */
  isSandbox() {
    return Fn(this._API_KEY);
  }
  /**
   * Closes the Purchases instance. You should never have to do this normally.
   */
  close() {
    we.instance === this ? (this.eventsTracker && this.eventsTracker.dispose(), we.instance = void 0) : H.warnLog(
      "Trying to close a Purchases instance that is not the current instance. Ignoring."
    );
  }
  /** @internal */
  async _getCustomerInfoForUserId(r) {
    const t = await this.backend.getCustomerInfo(r);
    return Zd(t);
  }
  /**
   * Generates an anonymous app user ID that follows RevenueCat's format.
   * This can be used when you don't have a user identifier system in place.
   * The generated ID will be in the format: $RCAnonymousID:\<UUID without dashes\>
   * Example: $RCAnonymousID:123e4567e89b12d3a456426614174000
   * @returns A new anonymous app user ID string
   * @public
   */
  static generateRevenueCatAnonymousAppUserId() {
    return `${nf}${tf().replace(/-/g, "")}`;
  }
  /**
   * Track an event.
   * @param props - The properties of the event.
   * @internal
   */
  _trackEvent(r) {
    this.eventsTracker.trackExternalEvent(r);
  }
};
pn = ma(null), ya(pn, 1, "purchase", $a, we), tn(pn, we), /** @internal */
q(we, "instance");
let Ka = we;
export {
  ye as ErrorCode,
  qe as LogLevel,
  fi as OfferingKeyword,
  Gl as PackageType,
  Re as ProductType,
  Ka as Purchases,
  pe as PurchasesError,
  cl as UninitializedPurchasesError
};
